var _get3 = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _getPrototypeOf = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _slicedToArray = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _objectSpread = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _createForOfIteratorHelper = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _possibleConstructorReturn = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _toConsumableArray = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _assertThisInitialized = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

/*! For license information please see algosdk.min.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.algosdk = t() : e.algosdk = t();
}(self, function () {
  return function () {
    var __webpack_modules__ = {
      5406: function _(e) {
        e.exports = function (e) {
          var t = {};

          function r(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
              i: n,
              l: !1,
              exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
          }

          return r.m = e, r.c = t, r.d = function (e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
              enumerable: !0,
              get: n
            });
          }, r.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(e, "__esModule", {
              value: !0
            });
          }, r.t = function (e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
              enumerable: !0,
              value: e
            }), 2 & t && "string" != typeof e) for (var o in e) {
              r.d(n, o, function (t) {
                return e[t];
              }.bind(null, o));
            }
            return n;
          }, r.n = function (e) {
            var t = e && e.__esModule ? function () {
              return e.default;
            } : function () {
              return e;
            };
            return r.d(t, "a", t), t;
          }, r.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }, r.p = "", r(r.s = 0);
        }([function (e, t, r) {
          "use strict";

          r.r(t), r.d(t, "encode", function () {
            return k;
          }), r.d(t, "decode", function () {
            return H;
          }), r.d(t, "decodeAsync", function () {
            return W;
          }), r.d(t, "decodeArrayStream", function () {
            return X;
          }), r.d(t, "decodeStream", function () {
            return Y;
          }), r.d(t, "Decoder", function () {
            return z;
          }), r.d(t, "Encoder", function () {
            return _;
          }), r.d(t, "ExtensionCodec", function () {
            return S;
          }), r.d(t, "ExtData", function () {
            return f;
          }), r.d(t, "EXT_TIMESTAMP", function () {
            return y;
          }), r.d(t, "encodeDateToTimeSpec", function () {
            return b;
          }), r.d(t, "encodeTimeSpecToTimestamp", function () {
            return m;
          }), r.d(t, "decodeTimestampToTimeSpec", function () {
            return A;
          }), r.d(t, "encodeTimestampExtension", function () {
            return w;
          }), r.d(t, "decodeTimestampExtension", function () {
            return v;
          });

          var n = function n(e, t) {
            var r = "function" == typeof Symbol && e[Symbol.iterator];
            if (!r) return e;
            var n,
                o,
                s = r.call(e),
                i = [];

            try {
              for (; (void 0 === t || t-- > 0) && !(n = s.next()).done;) {
                i.push(n.value);
              }
            } catch (e) {
              o = {
                error: e
              };
            } finally {
              try {
                n && !n.done && (r = s.return) && r.call(s);
              } finally {
                if (o) throw o.error;
              }
            }

            return i;
          },
              o = function o() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e = e.concat(n(arguments[t]));
            }

            return e;
          },
              s = "undefined" != typeof process && "undefined" != typeof TextEncoder && "undefined" != typeof TextDecoder;

          function i(e) {
            for (var t = e.length, r = 0, n = 0; n < t;) {
              var o = e.charCodeAt(n++);
              if (0 != (4294967168 & o)) {
                if (0 == (4294965248 & o)) r += 2;else {
                  if (o >= 55296 && o <= 56319 && n < t) {
                    var s = e.charCodeAt(n);
                    56320 == (64512 & s) && (++n, o = ((1023 & o) << 10) + (1023 & s) + 65536);
                  }

                  r += 0 == (4294901760 & o) ? 3 : 4;
                }
              } else r++;
            }

            return r;
          }

          var a = s ? new TextEncoder() : void 0,
              c = "undefined" != typeof process ? 200 : 0,
              u = (null == a ? void 0 : a.encodeInto) ? function (e, t, r) {
            a.encodeInto(e, t.subarray(r));
          } : function (e, t, r) {
            t.set(a.encode(e), r);
          };

          function l(e, t, r) {
            for (var n = t, s = n + r, i = [], a = ""; n < s;) {
              var c = e[n++];
              if (0 == (128 & c)) i.push(c);else if (192 == (224 & c)) {
                var u = 63 & e[n++];
                i.push((31 & c) << 6 | u);
              } else if (224 == (240 & c)) {
                u = 63 & e[n++];
                var l = 63 & e[n++];
                i.push((31 & c) << 12 | u << 6 | l);
              } else if (240 == (248 & c)) {
                var h = (7 & c) << 18 | (u = 63 & e[n++]) << 12 | (l = 63 & e[n++]) << 6 | 63 & e[n++];
                h > 65535 && (h -= 65536, i.push(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), i.push(h);
              } else i.push(c);
              i.length >= 4096 && (a += String.fromCharCode.apply(String, o(i)), i.length = 0);
            }

            return i.length > 0 && (a += String.fromCharCode.apply(String, o(i))), a;
          }

          var h = s ? new TextDecoder() : null,
              p = "undefined" != typeof process ? 200 : 0,
              f = function f(e, t) {
            this.type = e, this.data = t;
          };

          function d(e, t, r) {
            var n = Math.floor(r / 4294967296),
                o = r;
            e.setUint32(t, n), e.setUint32(t + 4, o);
          }

          function g(e, t) {
            var r = e.getInt32(t),
                n = e.getUint32(t + 4),
                o = r < Math.floor(Number.MIN_SAFE_INTEGER / 4294967296) || r === Math.floor(Number.MIN_SAFE_INTEGER / 4294967296) && 0 === n,
                s = r > Math.floor(Number.MAX_SAFE_INTEGER / 4294967296);
            return o || s ? BigInt(r) * BigInt(4294967296) + BigInt(n) : 4294967296 * r + n;
          }

          var y = -1;

          function m(e) {
            var t,
                r = e.sec,
                n = e.nsec;

            if (r >= 0 && n >= 0 && r <= 17179869183) {
              if (0 === n && r <= 4294967295) {
                var o = new Uint8Array(4);
                return (t = new DataView(o.buffer)).setUint32(0, r), o;
              }

              var s = r / 4294967296,
                  i = 4294967295 & r;
              return o = new Uint8Array(8), (t = new DataView(o.buffer)).setUint32(0, n << 2 | 3 & s), t.setUint32(4, i), o;
            }

            return o = new Uint8Array(12), (t = new DataView(o.buffer)).setUint32(0, n), d(t, 4, r), o;
          }

          function b(e) {
            var t = e.getTime(),
                r = Math.floor(t / 1e3),
                n = 1e6 * (t - 1e3 * r),
                o = Math.floor(n / 1e9);
            return {
              sec: r + o,
              nsec: n - 1e9 * o
            };
          }

          function w(e) {
            return e instanceof Date ? m(b(e)) : null;
          }

          function A(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength);

            switch (e.byteLength) {
              case 4:
                return {
                  sec: t.getUint32(0),
                  nsec: 0
                };

              case 8:
                var r = t.getUint32(0);
                return {
                  sec: 4294967296 * (3 & r) + t.getUint32(4),
                  nsec: r >>> 2
                };

              case 12:
                return {
                  sec: g(t, 4),
                  nsec: t.getUint32(0)
                };

              default:
                throw new Error("Unrecognized data size for timestamp: " + e.length);
            }
          }

          function v(e) {
            var t = A(e);
            return new Date(1e3 * t.sec + t.nsec / 1e6);
          }

          var x = {
            type: y,
            encode: w,
            decode: v
          },
              S = function () {
            function e() {
              this.builtInEncoders = [], this.builtInDecoders = [], this.encoders = [], this.decoders = [], this.register(x);
            }

            return e.prototype.register = function (e) {
              var t = e.type,
                  r = e.encode,
                  n = e.decode;
              if (t >= 0) this.encoders[t] = r, this.decoders[t] = n;else {
                var o = 1 + t;
                this.builtInEncoders[o] = r, this.builtInDecoders[o] = n;
              }
            }, e.prototype.tryToEncode = function (e, t) {
              for (var r = 0; r < this.builtInEncoders.length; r++) {
                if (null != (n = this.builtInEncoders[r]) && null != (o = n(e, t))) return new f(-1 - r, o);
              }

              for (r = 0; r < this.encoders.length; r++) {
                var n, o;
                if (null != (n = this.encoders[r]) && null != (o = n(e, t))) return new f(r, o);
              }

              return e instanceof f ? e : null;
            }, e.prototype.decode = function (e, t, r) {
              var n = t < 0 ? this.builtInDecoders[-1 - t] : this.decoders[t];
              return n ? n(e, t, r) : new f(t, e);
            }, e.defaultCodec = new e(), e;
          }();

          function E(e) {
            return e instanceof Uint8Array ? e : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer ? new Uint8Array(e) : Uint8Array.from(e);
          }

          var T = function T(e) {
            var t = "function" == typeof Symbol && Symbol.iterator,
                r = t && e[t],
                n = 0;
            if (r) return r.call(e);
            if (e && "number" == typeof e.length) return {
              next: function next() {
                return e && n >= e.length && (e = void 0), {
                  value: e && e[n++],
                  done: !e
                };
              }
            };
            throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
              _ = function () {
            function e(e, t, r, n, o, s, i, a) {
              void 0 === e && (e = S.defaultCodec), void 0 === t && (t = void 0), void 0 === r && (r = 100), void 0 === n && (n = 2048), void 0 === o && (o = !1), void 0 === s && (s = !1), void 0 === i && (i = !1), void 0 === a && (a = !1), this.extensionCodec = e, this.context = t, this.maxDepth = r, this.initialBufferSize = n, this.sortKeys = o, this.forceFloat32 = s, this.ignoreUndefined = i, this.forceIntegerToFloat = a, this.pos = 0, this.view = new DataView(new ArrayBuffer(this.initialBufferSize)), this.bytes = new Uint8Array(this.view.buffer);
            }

            return e.prototype.getUint8Array = function () {
              return this.bytes.subarray(0, this.pos);
            }, e.prototype.reinitializeState = function () {
              this.pos = 0;
            }, e.prototype.encode = function (e) {
              return this.reinitializeState(), this.doEncode(e, 1), this.getUint8Array();
            }, e.prototype.doEncode = function (e, t) {
              if (t > this.maxDepth) throw new Error("Too deep objects in depth " + t);
              null == e ? this.encodeNil() : "boolean" == typeof e ? this.encodeBoolean(e) : "number" == typeof e ? this.encodeNumber(e) : "string" == typeof e ? this.encodeString(e) : "bigint" == typeof e ? this.encodebigint(e) : this.encodeObject(e, t);
            }, e.prototype.ensureBufferSizeToWrite = function (e) {
              var t = this.pos + e;
              this.view.byteLength < t && this.resizeBuffer(2 * t);
            }, e.prototype.resizeBuffer = function (e) {
              var t = new ArrayBuffer(e),
                  r = new Uint8Array(t),
                  n = new DataView(t);
              r.set(this.bytes), this.view = n, this.bytes = r;
            }, e.prototype.encodeNil = function () {
              this.writeU8(192);
            }, e.prototype.encodeBoolean = function (e) {
              !1 === e ? this.writeU8(194) : this.writeU8(195);
            }, e.prototype.encodeNumber = function (e) {
              Number.isSafeInteger(e) && !this.forceIntegerToFloat ? e >= 0 ? e < 128 ? this.writeU8(e) : e < 256 ? (this.writeU8(204), this.writeU8(e)) : e < 65536 ? (this.writeU8(205), this.writeU16(e)) : e < 4294967296 ? (this.writeU8(206), this.writeU32(e)) : (this.writeU8(207), this.writeU64(e)) : e >= -32 ? this.writeU8(224 | e + 32) : e >= -128 ? (this.writeU8(208), this.writeI8(e)) : e >= -32768 ? (this.writeU8(209), this.writeI16(e)) : e >= -2147483648 ? (this.writeU8(210), this.writeI32(e)) : (this.writeU8(211), this.writeI64(e)) : this.forceFloat32 ? (this.writeU8(202), this.writeF32(e)) : (this.writeU8(203), this.writeF64(e));
            }, e.prototype.encodebigint = function (e) {
              e >= BigInt(0) ? e < BigInt(128) ? this.writeU8(Number(e)) : e < BigInt(256) ? (this.writeU8(204), this.writeU8(Number(e))) : e < BigInt(65536) ? (this.writeU8(205), this.writeU16(Number(e))) : e < BigInt(4294967296) ? (this.writeU8(206), this.writeU32(Number(e))) : (this.writeU8(207), this.writeBig64(e)) : e >= BigInt(-32) ? this.writeU8(224 | Number(e) + 32) : e >= BigInt(-128) ? (this.writeU8(208), this.writeI8(Number(e))) : e >= BigInt(-32768) ? (this.writeU8(209), this.writeI16(Number(e))) : e >= BigInt(-2147483648) ? (this.writeU8(210), this.writeI32(Number(e))) : (this.writeU8(211), this.writeBig64(e));
            }, e.prototype.writeStringHeader = function (e) {
              if (e < 32) this.writeU8(160 + e);else if (e < 256) this.writeU8(217), this.writeU8(e);else if (e < 65536) this.writeU8(218), this.writeU16(e);else {
                if (!(e < 4294967296)) throw new Error("Too long string: " + e + " bytes in UTF-8");
                this.writeU8(219), this.writeU32(e);
              }
            }, e.prototype.encodeString = function (e) {
              var t = e.length;

              if (s && t > c) {
                var r = i(e);
                this.ensureBufferSizeToWrite(5 + r), this.writeStringHeader(r), u(e, this.bytes, this.pos), this.pos += r;
              } else r = i(e), this.ensureBufferSizeToWrite(5 + r), this.writeStringHeader(r), function (e, t, r) {
                for (var n = e.length, o = r, s = 0; s < n;) {
                  var i = e.charCodeAt(s++);

                  if (0 != (4294967168 & i)) {
                    if (0 == (4294965248 & i)) t[o++] = i >> 6 & 31 | 192;else {
                      if (i >= 55296 && i <= 56319 && s < n) {
                        var a = e.charCodeAt(s);
                        56320 == (64512 & a) && (++s, i = ((1023 & i) << 10) + (1023 & a) + 65536);
                      }

                      0 == (4294901760 & i) ? (t[o++] = i >> 12 & 15 | 224, t[o++] = i >> 6 & 63 | 128) : (t[o++] = i >> 18 & 7 | 240, t[o++] = i >> 12 & 63 | 128, t[o++] = i >> 6 & 63 | 128);
                    }
                    t[o++] = 63 & i | 128;
                  } else t[o++] = i;
                }
              }(e, this.bytes, this.pos), this.pos += r;
            }, e.prototype.encodeObject = function (e, t) {
              var r = this.extensionCodec.tryToEncode(e, this.context);
              if (null != r) this.encodeExtension(r);else if (Array.isArray(e)) this.encodeArray(e, t);else if (ArrayBuffer.isView(e)) this.encodeBinary(e);else {
                if ("object" != typeof e) throw new Error("Unrecognized object: " + Object.prototype.toString.apply(e));
                this.encodeMap(e, t);
              }
            }, e.prototype.encodeBinary = function (e) {
              var t = e.byteLength;
              if (t < 256) this.writeU8(196), this.writeU8(t);else if (t < 65536) this.writeU8(197), this.writeU16(t);else {
                if (!(t < 4294967296)) throw new Error("Too large binary: " + t);
                this.writeU8(198), this.writeU32(t);
              }
              var r = E(e);
              this.writeU8a(r);
            }, e.prototype.encodeArray = function (e, t) {
              var r,
                  n,
                  o = e.length;
              if (o < 16) this.writeU8(144 + o);else if (o < 65536) this.writeU8(220), this.writeU16(o);else {
                if (!(o < 4294967296)) throw new Error("Too large array: " + o);
                this.writeU8(221), this.writeU32(o);
              }

              try {
                for (var s = T(e), i = s.next(); !i.done; i = s.next()) {
                  var a = i.value;
                  this.doEncode(a, t + 1);
                }
              } catch (e) {
                r = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (n = s.return) && n.call(s);
                } finally {
                  if (r) throw r.error;
                }
              }
            }, e.prototype.countWithoutUndefined = function (e, t) {
              var r,
                  n,
                  o = 0;

              try {
                for (var s = T(t), i = s.next(); !i.done; i = s.next()) {
                  void 0 !== e[i.value] && o++;
                }
              } catch (e) {
                r = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (n = s.return) && n.call(s);
                } finally {
                  if (r) throw r.error;
                }
              }

              return o;
            }, e.prototype.encodeMap = function (e, t) {
              var r,
                  n,
                  o = Object.keys(e);
              this.sortKeys && o.sort();
              var s = this.ignoreUndefined ? this.countWithoutUndefined(e, o) : o.length;
              if (s < 16) this.writeU8(128 + s);else if (s < 65536) this.writeU8(222), this.writeU16(s);else {
                if (!(s < 4294967296)) throw new Error("Too large map object: " + s);
                this.writeU8(223), this.writeU32(s);
              }

              try {
                for (var i = T(o), a = i.next(); !a.done; a = i.next()) {
                  var c = a.value,
                      u = e[c];
                  this.ignoreUndefined && void 0 === u || (this.encodeString(c), this.doEncode(u, t + 1));
                }
              } catch (e) {
                r = {
                  error: e
                };
              } finally {
                try {
                  a && !a.done && (n = i.return) && n.call(i);
                } finally {
                  if (r) throw r.error;
                }
              }
            }, e.prototype.encodeExtension = function (e) {
              var t = e.data.length;
              if (1 === t) this.writeU8(212);else if (2 === t) this.writeU8(213);else if (4 === t) this.writeU8(214);else if (8 === t) this.writeU8(215);else if (16 === t) this.writeU8(216);else if (t < 256) this.writeU8(199), this.writeU8(t);else if (t < 65536) this.writeU8(200), this.writeU16(t);else {
                if (!(t < 4294967296)) throw new Error("Too large extension object: " + t);
                this.writeU8(201), this.writeU32(t);
              }
              this.writeI8(e.type), this.writeU8a(e.data);
            }, e.prototype.writeU8 = function (e) {
              this.ensureBufferSizeToWrite(1), this.view.setUint8(this.pos, e), this.pos++;
            }, e.prototype.writeU8a = function (e) {
              var t = e.length;
              this.ensureBufferSizeToWrite(t), this.bytes.set(e, this.pos), this.pos += t;
            }, e.prototype.writeI8 = function (e) {
              this.ensureBufferSizeToWrite(1), this.view.setInt8(this.pos, e), this.pos++;
            }, e.prototype.writeU16 = function (e) {
              this.ensureBufferSizeToWrite(2), this.view.setUint16(this.pos, e), this.pos += 2;
            }, e.prototype.writeI16 = function (e) {
              this.ensureBufferSizeToWrite(2), this.view.setInt16(this.pos, e), this.pos += 2;
            }, e.prototype.writeU32 = function (e) {
              this.ensureBufferSizeToWrite(4), this.view.setUint32(this.pos, e), this.pos += 4;
            }, e.prototype.writeI32 = function (e) {
              this.ensureBufferSizeToWrite(4), this.view.setInt32(this.pos, e), this.pos += 4;
            }, e.prototype.writeF32 = function (e) {
              this.ensureBufferSizeToWrite(4), this.view.setFloat32(this.pos, e), this.pos += 4;
            }, e.prototype.writeF64 = function (e) {
              this.ensureBufferSizeToWrite(8), this.view.setFloat64(this.pos, e), this.pos += 8;
            }, e.prototype.writeU64 = function (e) {
              this.ensureBufferSizeToWrite(8), function (e, t, r) {
                var n = r / 4294967296,
                    o = r;
                e.setUint32(t, n), e.setUint32(t + 4, o);
              }(this.view, this.pos, e), this.pos += 8;
            }, e.prototype.writeI64 = function (e) {
              this.ensureBufferSizeToWrite(8), d(this.view, this.pos, e), this.pos += 8;
            }, e.prototype.writeBig64 = function (e) {
              this.ensureBufferSizeToWrite(8), function (e, t, r) {
                var n = Number(r / BigInt(4294967296)),
                    o = Number(r % BigInt(4294967296));
                n < 0 && 0 !== o && (n -= 1), e.setUint32(t, n), e.setUint32(t + 4, o);
              }(this.view, this.pos, e), this.pos += 8;
            }, e;
          }(),
              B = {};

          function k(e, t) {
            return void 0 === t && (t = B), new _(t.extensionCodec, t.context, t.maxDepth, t.initialBufferSize, t.sortKeys, t.forceFloat32, t.ignoreUndefined, t.forceIntegerToFloat).encode(e);
          }

          function I(e) {
            return (e < 0 ? "-" : "") + "0x" + Math.abs(e).toString(16).padStart(2, "0");
          }

          var U = function () {
            function e(e, t) {
              void 0 === e && (e = 16), void 0 === t && (t = 16), this.maxKeyLength = e, this.maxLengthPerKey = t, this.hit = 0, this.miss = 0, this.caches = [];

              for (var r = 0; r < this.maxKeyLength; r++) {
                this.caches.push([]);
              }
            }

            return e.prototype.canBeCached = function (e) {
              return e > 0 && e <= this.maxKeyLength;
            }, e.prototype.get = function (e, t, r) {
              var n = this.caches[r - 1],
                  o = n.length;

              e: for (var s = 0; s < o; s++) {
                for (var i = n[s], a = i.bytes, c = 0; c < r; c++) {
                  if (a[c] !== e[t + c]) continue e;
                }

                return i.value;
              }

              return null;
            }, e.prototype.store = function (e, t) {
              var r = this.caches[e.length - 1],
                  n = {
                bytes: e,
                value: t
              };
              r.length >= this.maxLengthPerKey ? r[Math.random() * r.length | 0] = n : r.push(n);
            }, e.prototype.decode = function (e, t, r) {
              var n = this.get(e, t, r);
              if (null != n) return this.hit++, n;
              this.miss++;
              var o = l(e, t, r),
                  s = Uint8Array.prototype.slice.call(e, t, t + r);
              return this.store(s, o), o;
            }, e;
          }(),
              C = function C(e, t) {
            var r,
                n,
                o,
                s,
                i = {
              label: 0,
              sent: function sent() {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
            return s = {
              next: a(0),
              throw: a(1),
              return: a(2)
            }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
              return this;
            }), s;

            function a(s) {
              return function (a) {
                return function (s) {
                  if (r) throw new TypeError("Generator is already executing.");

                  for (; i;) {
                    try {
                      if (r = 1, n && (o = 2 & s[0] ? n.return : s[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, s[1])).done) return o;

                      switch (n = 0, o && (s = [2 & s[0], o.value]), s[0]) {
                        case 0:
                        case 1:
                          o = s;
                          break;

                        case 4:
                          return i.label++, {
                            value: s[1],
                            done: !1
                          };

                        case 5:
                          i.label++, n = s[1], s = [0];
                          continue;

                        case 7:
                          s = i.ops.pop(), i.trys.pop();
                          continue;

                        default:
                          if (!((o = (o = i.trys).length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                            i = 0;
                            continue;
                          }

                          if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                            i.label = s[1];
                            break;
                          }

                          if (6 === s[0] && i.label < o[1]) {
                            i.label = o[1], o = s;
                            break;
                          }

                          if (o && i.label < o[2]) {
                            i.label = o[2], i.ops.push(s);
                            break;
                          }

                          o[2] && i.ops.pop(), i.trys.pop();
                          continue;
                      }

                      s = t.call(e, i);
                    } catch (e) {
                      s = [6, e], n = 0;
                    } finally {
                      r = o = 0;
                    }
                  }

                  if (5 & s[0]) throw s[1];
                  return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                  };
                }([s, a]);
              };
            }
          },
              R = function R(e) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var t,
                r = e[Symbol.asyncIterator];
            return r ? r.call(e) : (e = "function" == typeof __values ? __values(e) : e[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function () {
              return this;
            }, t);

            function n(r) {
              t[r] = e[r] && function (t) {
                return new Promise(function (n, o) {
                  !function (e, t, r, n) {
                    Promise.resolve(n).then(function (t) {
                      e({
                        value: t,
                        done: r
                      });
                    }, t);
                  }(n, o, (t = e[r](t)).done, t.value);
                });
              };
            }
          },
              O = function O(e) {
            return this instanceof O ? (this.v = e, this) : new O(e);
          },
              D = function D(e, t, r) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var n,
                o = r.apply(e, t || []),
                s = [];
            return n = {}, i("next"), i("throw"), i("return"), n[Symbol.asyncIterator] = function () {
              return this;
            }, n;

            function i(e) {
              o[e] && (n[e] = function (t) {
                return new Promise(function (r, n) {
                  s.push([e, t, r, n]) > 1 || a(e, t);
                });
              });
            }

            function a(e, t) {
              try {
                (r = o[e](t)).value instanceof O ? Promise.resolve(r.value.v).then(c, u) : l(s[0][2], r);
              } catch (e) {
                l(s[0][3], e);
              }

              var r;
            }

            function c(e) {
              a("next", e);
            }

            function u(e) {
              a("throw", e);
            }

            function l(e, t) {
              e(t), s.shift(), s.length && a(s[0][0], s[0][1]);
            }
          },
              N = new DataView(new ArrayBuffer(0)),
              P = new Uint8Array(N.buffer),
              L = function () {
            try {
              N.getInt8(0);
            } catch (e) {
              return e.constructor;
            }

            throw new Error("never reached");
          }(),
              F = new L("Insufficient data"),
              j = new U(),
              z = function () {
            function e(e, t, r, n, o, s, i, a) {
              void 0 === e && (e = S.defaultCodec), void 0 === t && (t = void 0), void 0 === r && (r = 4294967295), void 0 === n && (n = 4294967295), void 0 === o && (o = 4294967295), void 0 === s && (s = 4294967295), void 0 === i && (i = 4294967295), void 0 === a && (a = j), this.extensionCodec = e, this.context = t, this.maxStrLength = r, this.maxBinLength = n, this.maxArrayLength = o, this.maxMapLength = s, this.maxExtLength = i, this.keyDecoder = a, this.totalPos = 0, this.pos = 0, this.view = N, this.bytes = P, this.headByte = -1, this.stack = [];
            }

            return e.prototype.reinitializeState = function () {
              this.totalPos = 0, this.headByte = -1;
            }, e.prototype.setBuffer = function (e) {
              this.bytes = E(e), this.view = function (e) {
                if (e instanceof ArrayBuffer) return new DataView(e);
                var t = E(e);
                return new DataView(t.buffer, t.byteOffset, t.byteLength);
              }(this.bytes), this.pos = 0;
            }, e.prototype.appendBuffer = function (e) {
              if (-1 !== this.headByte || this.hasRemaining()) {
                var t = this.bytes.subarray(this.pos),
                    r = E(e),
                    n = new Uint8Array(t.length + r.length);
                n.set(t), n.set(r, t.length), this.setBuffer(n);
              } else this.setBuffer(e);
            }, e.prototype.hasRemaining = function (e) {
              return void 0 === e && (e = 1), this.view.byteLength - this.pos >= e;
            }, e.prototype.createNoExtraBytesError = function (e) {
              var t = this.view,
                  r = this.pos;
              return new RangeError("Extra " + (t.byteLength - r) + " of " + t.byteLength + " byte(s) found at buffer[" + e + "]");
            }, e.prototype.decode = function (e) {
              return this.reinitializeState(), this.setBuffer(e), this.doDecodeSingleSync();
            }, e.prototype.doDecodeSingleSync = function () {
              var e = this.doDecodeSync();
              if (this.hasRemaining()) throw this.createNoExtraBytesError(this.pos);
              return e;
            }, e.prototype.decodeAsync = function (e) {
              var t, r, n, o;
              return function (e, t, r, n) {
                return new (r || (r = Promise))(function (o, s) {
                  function i(e) {
                    try {
                      c(n.next(e));
                    } catch (e) {
                      s(e);
                    }
                  }

                  function a(e) {
                    try {
                      c(n.throw(e));
                    } catch (e) {
                      s(e);
                    }
                  }

                  function c(e) {
                    var t;
                    e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                      e(t);
                    })).then(i, a);
                  }

                  c((n = n.apply(e, t || [])).next());
                });
              }(this, void 0, void 0, function () {
                var s, i, a, c, u, l, h, p;
                return C(this, function (f) {
                  switch (f.label) {
                    case 0:
                      s = !1, f.label = 1;

                    case 1:
                      f.trys.push([1, 6, 7, 12]), t = R(e), f.label = 2;

                    case 2:
                      return [4, t.next()];

                    case 3:
                      if ((r = f.sent()).done) return [3, 5];
                      if (a = r.value, s) throw this.createNoExtraBytesError(this.totalPos);
                      this.appendBuffer(a);

                      try {
                        i = this.doDecodeSync(), s = !0;
                      } catch (e) {
                        if (!(e instanceof L)) throw e;
                      }

                      this.totalPos += this.pos, f.label = 4;

                    case 4:
                      return [3, 2];

                    case 5:
                      return [3, 12];

                    case 6:
                      return c = f.sent(), n = {
                        error: c
                      }, [3, 12];

                    case 7:
                      return f.trys.push([7,, 10, 11]), r && !r.done && (o = t.return) ? [4, o.call(t)] : [3, 9];

                    case 8:
                      f.sent(), f.label = 9;

                    case 9:
                      return [3, 11];

                    case 10:
                      if (n) throw n.error;
                      return [7];

                    case 11:
                      return [7];

                    case 12:
                      if (s) {
                        if (this.hasRemaining()) throw this.createNoExtraBytesError(this.totalPos);
                        return [2, i];
                      }

                      throw l = (u = this).headByte, h = u.pos, p = u.totalPos, new RangeError("Insufficient data in parcing " + I(l) + " at " + p + " (" + h + " in the current buffer)");
                  }
                });
              });
            }, e.prototype.decodeArrayStream = function (e) {
              return this.decodeMultiAsync(e, !0);
            }, e.prototype.decodeStream = function (e) {
              return this.decodeMultiAsync(e, !1);
            }, e.prototype.decodeMultiAsync = function (e, t) {
              return D(this, arguments, function () {
                var r, n, o, s, i, a, c, u, l;
                return C(this, function (h) {
                  switch (h.label) {
                    case 0:
                      r = t, n = -1, h.label = 1;

                    case 1:
                      h.trys.push([1, 13, 14, 19]), o = R(e), h.label = 2;

                    case 2:
                      return [4, O(o.next())];

                    case 3:
                      if ((s = h.sent()).done) return [3, 12];
                      if (i = s.value, t && 0 === n) throw this.createNoExtraBytesError(this.totalPos);
                      this.appendBuffer(i), r && (n = this.readArraySize(), r = !1, this.complete()), h.label = 4;

                    case 4:
                      h.trys.push([4, 9,, 10]), h.label = 5;

                    case 5:
                      return [4, O(this.doDecodeSync())];

                    case 6:
                      return [4, h.sent()];

                    case 7:
                      return h.sent(), 0 == --n ? [3, 8] : [3, 5];

                    case 8:
                      return [3, 10];

                    case 9:
                      if (!((a = h.sent()) instanceof L)) throw a;
                      return [3, 10];

                    case 10:
                      this.totalPos += this.pos, h.label = 11;

                    case 11:
                      return [3, 2];

                    case 12:
                      return [3, 19];

                    case 13:
                      return c = h.sent(), u = {
                        error: c
                      }, [3, 19];

                    case 14:
                      return h.trys.push([14,, 17, 18]), s && !s.done && (l = o.return) ? [4, O(l.call(o))] : [3, 16];

                    case 15:
                      h.sent(), h.label = 16;

                    case 16:
                      return [3, 18];

                    case 17:
                      if (u) throw u.error;
                      return [7];

                    case 18:
                      return [7];

                    case 19:
                      return [2];
                  }
                });
              });
            }, e.prototype.doDecodeSync = function () {
              e: for (;;) {
                var e = this.readHeadByte(),
                    t = void 0;
                if (e >= 224) t = e - 256;else if (e < 192) {
                  if (e < 128) t = e;else if (e < 144) {
                    if (0 != (n = e - 128)) {
                      this.pushMapState(n), this.complete();
                      continue e;
                    }

                    t = {};
                  } else if (e < 160) {
                    if (0 != (n = e - 144)) {
                      this.pushArrayState(n), this.complete();
                      continue e;
                    }

                    t = [];
                  } else {
                    var r = e - 160;
                    t = this.decodeUtf8String(r, 0);
                  }
                } else if (192 === e) t = null;else if (194 === e) t = !1;else if (195 === e) t = !0;else if (202 === e) t = this.readF32();else if (203 === e) t = this.readF64();else if (204 === e) t = this.readU8();else if (205 === e) t = this.readU16();else if (206 === e) t = this.readU32();else if (207 === e) t = this.readU64();else if (208 === e) t = this.readI8();else if (209 === e) t = this.readI16();else if (210 === e) t = this.readI32();else if (211 === e) t = this.readI64();else if (217 === e) r = this.lookU8(), t = this.decodeUtf8String(r, 1);else if (218 === e) r = this.lookU16(), t = this.decodeUtf8String(r, 2);else if (219 === e) r = this.lookU32(), t = this.decodeUtf8String(r, 4);else if (220 === e) {
                  if (0 !== (n = this.readU16())) {
                    this.pushArrayState(n), this.complete();
                    continue e;
                  }

                  t = [];
                } else if (221 === e) {
                  if (0 !== (n = this.readU32())) {
                    this.pushArrayState(n), this.complete();
                    continue e;
                  }

                  t = [];
                } else if (222 === e) {
                  if (0 !== (n = this.readU16())) {
                    this.pushMapState(n), this.complete();
                    continue e;
                  }

                  t = {};
                } else if (223 === e) {
                  if (0 !== (n = this.readU32())) {
                    this.pushMapState(n), this.complete();
                    continue e;
                  }

                  t = {};
                } else if (196 === e) {
                  var n = this.lookU8();
                  t = this.decodeBinary(n, 1);
                } else if (197 === e) n = this.lookU16(), t = this.decodeBinary(n, 2);else if (198 === e) n = this.lookU32(), t = this.decodeBinary(n, 4);else if (212 === e) t = this.decodeExtension(1, 0);else if (213 === e) t = this.decodeExtension(2, 0);else if (214 === e) t = this.decodeExtension(4, 0);else if (215 === e) t = this.decodeExtension(8, 0);else if (216 === e) t = this.decodeExtension(16, 0);else if (199 === e) n = this.lookU8(), t = this.decodeExtension(n, 1);else if (200 === e) n = this.lookU16(), t = this.decodeExtension(n, 2);else {
                  if (201 !== e) throw new Error("Unrecognized type byte: " + I(e));
                  n = this.lookU32(), t = this.decodeExtension(n, 4);
                }
                this.complete();

                for (var o = this.stack; o.length > 0;) {
                  var s = o[o.length - 1];

                  if (0 === s.type) {
                    if (s.array[s.position] = t, s.position++, s.position !== s.size) continue e;
                    o.pop(), t = s.array;
                  } else {
                    if (1 === s.type) {
                      if (void 0, "string" != (i = typeof t) && "number" !== i) throw new Error("The type of key must be string or number but " + typeof t);
                      s.key = t, s.type = 2;
                      continue e;
                    }

                    if (s.map[s.key] = t, s.readCount++, s.readCount !== s.size) {
                      s.key = null, s.type = 1;
                      continue e;
                    }

                    o.pop(), t = s.map;
                  }
                }

                return t;
              }

              var i;
            }, e.prototype.readHeadByte = function () {
              return -1 === this.headByte && (this.headByte = this.readU8()), this.headByte;
            }, e.prototype.complete = function () {
              this.headByte = -1;
            }, e.prototype.readArraySize = function () {
              var e = this.readHeadByte();

              switch (e) {
                case 220:
                  return this.readU16();

                case 221:
                  return this.readU32();

                default:
                  if (e < 160) return e - 144;
                  throw new Error("Unrecognized array type byte: " + I(e));
              }
            }, e.prototype.pushMapState = function (e) {
              if (e > this.maxMapLength) throw new Error("Max length exceeded: map length (" + e + ") > maxMapLengthLength (" + this.maxMapLength + ")");
              this.stack.push({
                type: 1,
                size: e,
                key: null,
                readCount: 0,
                map: {}
              });
            }, e.prototype.pushArrayState = function (e) {
              if (e > this.maxArrayLength) throw new Error("Max length exceeded: array length (" + e + ") > maxArrayLength (" + this.maxArrayLength + ")");
              this.stack.push({
                type: 0,
                size: e,
                array: new Array(e),
                position: 0
              });
            }, e.prototype.decodeUtf8String = function (e, t) {
              var r;
              if (e > this.maxStrLength) throw new Error("Max length exceeded: UTF-8 byte length (" + e + ") > maxStrLength (" + this.maxStrLength + ")");
              if (this.bytes.byteLength < this.pos + t + e) throw F;
              var n,
                  o = this.pos + t;
              return n = this.stateIsMapKey() && (null === (r = this.keyDecoder) || void 0 === r ? void 0 : r.canBeCached(e)) ? this.keyDecoder.decode(this.bytes, o, e) : s && e > p ? function (e, t, r) {
                var n = e.subarray(t, t + r);
                return h.decode(n);
              }(this.bytes, o, e) : l(this.bytes, o, e), this.pos += t + e, n;
            }, e.prototype.stateIsMapKey = function () {
              return this.stack.length > 0 && 1 === this.stack[this.stack.length - 1].type;
            }, e.prototype.decodeBinary = function (e, t) {
              if (e > this.maxBinLength) throw new Error("Max length exceeded: bin length (" + e + ") > maxBinLength (" + this.maxBinLength + ")");
              if (!this.hasRemaining(e + t)) throw F;
              var r = this.pos + t,
                  n = this.bytes.subarray(r, r + e);
              return this.pos += t + e, n;
            }, e.prototype.decodeExtension = function (e, t) {
              if (e > this.maxExtLength) throw new Error("Max length exceeded: ext length (" + e + ") > maxExtLength (" + this.maxExtLength + ")");
              var r = this.view.getInt8(this.pos + t),
                  n = this.decodeBinary(e, t + 1);
              return this.extensionCodec.decode(n, r, this.context);
            }, e.prototype.lookU8 = function () {
              return this.view.getUint8(this.pos);
            }, e.prototype.lookU16 = function () {
              return this.view.getUint16(this.pos);
            }, e.prototype.lookU32 = function () {
              return this.view.getUint32(this.pos);
            }, e.prototype.readU8 = function () {
              var e = this.view.getUint8(this.pos);
              return this.pos++, e;
            }, e.prototype.readI8 = function () {
              var e = this.view.getInt8(this.pos);
              return this.pos++, e;
            }, e.prototype.readU16 = function () {
              var e = this.view.getUint16(this.pos);
              return this.pos += 2, e;
            }, e.prototype.readI16 = function () {
              var e = this.view.getInt16(this.pos);
              return this.pos += 2, e;
            }, e.prototype.readU32 = function () {
              var e = this.view.getUint32(this.pos);
              return this.pos += 4, e;
            }, e.prototype.readI32 = function () {
              var e = this.view.getInt32(this.pos);
              return this.pos += 4, e;
            }, e.prototype.readU64 = function () {
              var e,
                  t,
                  r,
                  n,
                  o = (e = this.view, t = this.pos, r = e.getUint32(t), n = e.getUint32(t + 4), r > Math.floor(Number.MAX_SAFE_INTEGER / 4294967296) ? BigInt(r) * BigInt(4294967296) + BigInt(n) : 4294967296 * r + n);
              return this.pos += 8, o;
            }, e.prototype.readI64 = function () {
              var e = g(this.view, this.pos);
              return this.pos += 8, e;
            }, e.prototype.readF32 = function () {
              var e = this.view.getFloat32(this.pos);
              return this.pos += 4, e;
            }, e.prototype.readF64 = function () {
              var e = this.view.getFloat64(this.pos);
              return this.pos += 8, e;
            }, e;
          }(),
              M = {};

          function H(e, t) {
            return void 0 === t && (t = M), new z(t.extensionCodec, t.context, t.maxStrLength, t.maxBinLength, t.maxArrayLength, t.maxMapLength, t.maxExtLength).decode(e);
          }

          var G = function G(e, t) {
            var r,
                n,
                o,
                s,
                i = {
              label: 0,
              sent: function sent() {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
            return s = {
              next: a(0),
              throw: a(1),
              return: a(2)
            }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
              return this;
            }), s;

            function a(s) {
              return function (a) {
                return function (s) {
                  if (r) throw new TypeError("Generator is already executing.");

                  for (; i;) {
                    try {
                      if (r = 1, n && (o = 2 & s[0] ? n.return : s[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, s[1])).done) return o;

                      switch (n = 0, o && (s = [2 & s[0], o.value]), s[0]) {
                        case 0:
                        case 1:
                          o = s;
                          break;

                        case 4:
                          return i.label++, {
                            value: s[1],
                            done: !1
                          };

                        case 5:
                          i.label++, n = s[1], s = [0];
                          continue;

                        case 7:
                          s = i.ops.pop(), i.trys.pop();
                          continue;

                        default:
                          if (!((o = (o = i.trys).length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                            i = 0;
                            continue;
                          }

                          if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                            i.label = s[1];
                            break;
                          }

                          if (6 === s[0] && i.label < o[1]) {
                            i.label = o[1], o = s;
                            break;
                          }

                          if (o && i.label < o[2]) {
                            i.label = o[2], i.ops.push(s);
                            break;
                          }

                          o[2] && i.ops.pop(), i.trys.pop();
                          continue;
                      }

                      s = t.call(e, i);
                    } catch (e) {
                      s = [6, e], n = 0;
                    } finally {
                      r = o = 0;
                    }
                  }

                  if (5 & s[0]) throw s[1];
                  return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                  };
                }([s, a]);
              };
            }
          },
              K = function K(e) {
            return this instanceof K ? (this.v = e, this) : new K(e);
          },
              q = function q(e, t, r) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var n,
                o = r.apply(e, t || []),
                s = [];
            return n = {}, i("next"), i("throw"), i("return"), n[Symbol.asyncIterator] = function () {
              return this;
            }, n;

            function i(e) {
              o[e] && (n[e] = function (t) {
                return new Promise(function (r, n) {
                  s.push([e, t, r, n]) > 1 || a(e, t);
                });
              });
            }

            function a(e, t) {
              try {
                (r = o[e](t)).value instanceof K ? Promise.resolve(r.value.v).then(c, u) : l(s[0][2], r);
              } catch (e) {
                l(s[0][3], e);
              }

              var r;
            }

            function c(e) {
              a("next", e);
            }

            function u(e) {
              a("throw", e);
            }

            function l(e, t) {
              e(t), s.shift(), s.length && a(s[0][0], s[0][1]);
            }
          };

          function $(e) {
            if (null == e) throw new Error("Assertion Failure: value must not be null nor undefined");
          }

          function V(e) {
            return null != e[Symbol.asyncIterator] ? e : function (e) {
              return q(this, arguments, function () {
                var t, r, n, o;
                return G(this, function (s) {
                  switch (s.label) {
                    case 0:
                      t = e.getReader(), s.label = 1;

                    case 1:
                      s.trys.push([1,, 9, 10]), s.label = 2;

                    case 2:
                      return [4, K(t.read())];

                    case 3:
                      return r = s.sent(), n = r.done, o = r.value, n ? [4, K(void 0)] : [3, 5];

                    case 4:
                      return [2, s.sent()];

                    case 5:
                      return $(o), [4, K(o)];

                    case 6:
                      return [4, s.sent()];

                    case 7:
                      return s.sent(), [3, 2];

                    case 8:
                      return [3, 10];

                    case 9:
                      return t.releaseLock(), [7];

                    case 10:
                      return [2];
                  }
                });
              });
            }(e);
          }

          function W(e, t) {
            return void 0 === t && (t = M), function (e, t, r, n) {
              return new (r || (r = Promise))(function (o, s) {
                function i(e) {
                  try {
                    c(n.next(e));
                  } catch (e) {
                    s(e);
                  }
                }

                function a(e) {
                  try {
                    c(n.throw(e));
                  } catch (e) {
                    s(e);
                  }
                }

                function c(e) {
                  var t;
                  e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                    e(t);
                  })).then(i, a);
                }

                c((n = n.apply(e, t || [])).next());
              });
            }(this, void 0, void 0, function () {
              var r;
              return function (e, t) {
                var r,
                    n,
                    o,
                    s,
                    i = {
                  label: 0,
                  sent: function sent() {
                    if (1 & o[0]) throw o[1];
                    return o[1];
                  },
                  trys: [],
                  ops: []
                };
                return s = {
                  next: a(0),
                  throw: a(1),
                  return: a(2)
                }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
                  return this;
                }), s;

                function a(s) {
                  return function (a) {
                    return function (s) {
                      if (r) throw new TypeError("Generator is already executing.");

                      for (; i;) {
                        try {
                          if (r = 1, n && (o = 2 & s[0] ? n.return : s[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, s[1])).done) return o;

                          switch (n = 0, o && (s = [2 & s[0], o.value]), s[0]) {
                            case 0:
                            case 1:
                              o = s;
                              break;

                            case 4:
                              return i.label++, {
                                value: s[1],
                                done: !1
                              };

                            case 5:
                              i.label++, n = s[1], s = [0];
                              continue;

                            case 7:
                              s = i.ops.pop(), i.trys.pop();
                              continue;

                            default:
                              if (!((o = (o = i.trys).length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                i = 0;
                                continue;
                              }

                              if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                                i.label = s[1];
                                break;
                              }

                              if (6 === s[0] && i.label < o[1]) {
                                i.label = o[1], o = s;
                                break;
                              }

                              if (o && i.label < o[2]) {
                                i.label = o[2], i.ops.push(s);
                                break;
                              }

                              o[2] && i.ops.pop(), i.trys.pop();
                              continue;
                          }

                          s = t.call(e, i);
                        } catch (e) {
                          s = [6, e], n = 0;
                        } finally {
                          r = o = 0;
                        }
                      }

                      if (5 & s[0]) throw s[1];
                      return {
                        value: s[0] ? s[1] : void 0,
                        done: !0
                      };
                    }([s, a]);
                  };
                }
              }(this, function (n) {
                return r = V(e), [2, new z(t.extensionCodec, t.context, t.maxStrLength, t.maxBinLength, t.maxArrayLength, t.maxMapLength, t.maxExtLength).decodeAsync(r)];
              });
            });
          }

          function X(e, t) {
            void 0 === t && (t = M);
            var r = V(e);
            return new z(t.extensionCodec, t.context, t.maxStrLength, t.maxBinLength, t.maxArrayLength, t.maxMapLength, t.maxExtLength).decodeArrayStream(r);
          }

          function Y(e, t) {
            void 0 === t && (t = M);
            var r = V(e);
            return new z(t.extensionCodec, t.context, t.maxStrLength, t.maxBinLength, t.maxArrayLength, t.maxMapLength, t.maxExtLength).decodeStream(r);
          }
        }]);
      },
      5155: function _(e, t) {
        "use strict";

        t.byteLength = function (e) {
          var t = c(e),
              r = t[0],
              n = t[1];
          return 3 * (r + n) / 4 - n;
        }, t.toByteArray = function (e) {
          var t,
              r,
              s = c(e),
              i = s[0],
              a = s[1],
              u = new o(function (e, t, r) {
            return 3 * (t + r) / 4 - r;
          }(0, i, a)),
              l = 0,
              h = a > 0 ? i - 4 : i;

          for (r = 0; r < h; r += 4) {
            t = n[e.charCodeAt(r)] << 18 | n[e.charCodeAt(r + 1)] << 12 | n[e.charCodeAt(r + 2)] << 6 | n[e.charCodeAt(r + 3)], u[l++] = t >> 16 & 255, u[l++] = t >> 8 & 255, u[l++] = 255 & t;
          }

          return 2 === a && (t = n[e.charCodeAt(r)] << 2 | n[e.charCodeAt(r + 1)] >> 4, u[l++] = 255 & t), 1 === a && (t = n[e.charCodeAt(r)] << 10 | n[e.charCodeAt(r + 1)] << 4 | n[e.charCodeAt(r + 2)] >> 2, u[l++] = t >> 8 & 255, u[l++] = 255 & t), u;
        }, t.fromByteArray = function (e) {
          for (var t, n = e.length, o = n % 3, s = [], i = 16383, a = 0, c = n - o; a < c; a += i) {
            s.push(u(e, a, a + i > c ? c : a + i));
          }

          return 1 === o ? (t = e[n - 1], s.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === o && (t = (e[n - 2] << 8) + e[n - 1], s.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "=")), s.join("");
        };

        for (var r = [], n = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, a = s.length; i < a; ++i) {
          r[i] = s[i], n[s.charCodeAt(i)] = i;
        }

        function c(e) {
          var t = e.length;
          if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
          var r = e.indexOf("=");
          return -1 === r && (r = t), [r, r === t ? 0 : 4 - r % 4];
        }

        function u(e, t, n) {
          for (var o, s, i = [], a = t; a < n; a += 3) {
            o = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(r[(s = o) >> 18 & 63] + r[s >> 12 & 63] + r[s >> 6 & 63] + r[63 & s]);
          }

          return i.join("");
        }

        n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
      },
      5117: function _(e, t, r) {
        var n;
        !function (o) {
          "use strict";

          var s,
              i = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
              a = Math.ceil,
              c = Math.floor,
              u = "[BigNumber Error] ",
              l = u + "Number primitive has more than 15 significant digits: ",
              h = 1e14,
              p = 14,
              f = 9007199254740991,
              d = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
              g = 1e7,
              y = 1e9;

          function m(e) {
            var t = 0 | e;
            return e > 0 || e === t ? t : t - 1;
          }

          function b(e) {
            for (var t, r, n = 1, o = e.length, s = e[0] + ""; n < o;) {
              for (t = e[n++] + "", r = p - t.length; r--; t = "0" + t) {
                ;
              }

              s += t;
            }

            for (o = s.length; 48 === s.charCodeAt(--o);) {
              ;
            }

            return s.slice(0, o + 1 || 1);
          }

          function w(e, t) {
            var r,
                n,
                o = e.c,
                s = t.c,
                i = e.s,
                a = t.s,
                c = e.e,
                u = t.e;
            if (!i || !a) return null;
            if (r = o && !o[0], n = s && !s[0], r || n) return r ? n ? 0 : -a : i;
            if (i != a) return i;
            if (r = i < 0, n = c == u, !o || !s) return n ? 0 : !o ^ r ? 1 : -1;
            if (!n) return c > u ^ r ? 1 : -1;

            for (a = (c = o.length) < (u = s.length) ? c : u, i = 0; i < a; i++) {
              if (o[i] != s[i]) return o[i] > s[i] ^ r ? 1 : -1;
            }

            return c == u ? 0 : c > u ^ r ? 1 : -1;
          }

          function A(e, t, r, n) {
            if (e < t || e > r || e !== c(e)) throw Error(u + (n || "Argument") + ("number" == typeof e ? e < t || e > r ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
          }

          function v(e) {
            var t = e.c.length - 1;
            return m(e.e / p) == t && e.c[t] % 2 != 0;
          }

          function x(e, t) {
            return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
          }

          function S(e, t, r) {
            var n, o;

            if (t < 0) {
              for (o = r + "."; ++t; o += r) {
                ;
              }

              e = o + e;
            } else if (++t > (n = e.length)) {
              for (o = r, t -= n; --t; o += r) {
                ;
              }

              e += o;
            } else t < n && (e = e.slice(0, t) + "." + e.slice(t));

            return e;
          }

          (s = function e(t) {
            var r,
                n,
                o,
                s,
                E,
                T,
                _,
                B,
                k,
                I,
                U = G.prototype = {
              constructor: G,
              toString: null,
              valueOf: null
            },
                C = new G(1),
                R = 20,
                O = 4,
                D = -7,
                N = 21,
                P = -1e7,
                L = 1e7,
                F = !1,
                j = 1,
                z = 0,
                M = {
              prefix: "",
              groupSize: 3,
              secondaryGroupSize: 0,
              groupSeparator: ",",
              decimalSeparator: ".",
              fractionGroupSize: 0,
              fractionGroupSeparator: " ",
              suffix: ""
            },
                H = "0123456789abcdefghijklmnopqrstuvwxyz";

            function G(e, t) {
              var r,
                  s,
                  a,
                  u,
                  h,
                  d,
                  g,
                  y,
                  m = this;
              if (!(m instanceof G)) return new G(e, t);

              if (null == t) {
                if (e && !0 === e._isBigNumber) return m.s = e.s, void (!e.c || e.e > L ? m.c = m.e = null : e.e < P ? m.c = [m.e = 0] : (m.e = e.e, m.c = e.c.slice()));

                if ((d = "number" == typeof e) && 0 * e == 0) {
                  if (m.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
                    for (u = 0, h = e; h >= 10; h /= 10, u++) {
                      ;
                    }

                    return void (u > L ? m.c = m.e = null : (m.e = u, m.c = [e]));
                  }

                  y = String(e);
                } else {
                  if (!i.test(y = String(e))) return o(m, y, d);
                  m.s = 45 == y.charCodeAt(0) ? (y = y.slice(1), -1) : 1;
                }

                (u = y.indexOf(".")) > -1 && (y = y.replace(".", "")), (h = y.search(/e/i)) > 0 ? (u < 0 && (u = h), u += +y.slice(h + 1), y = y.substring(0, h)) : u < 0 && (u = y.length);
              } else {
                if (A(t, 2, H.length, "Base"), 10 == t) return V(m = new G(e), R + m.e + 1, O);

                if (y = String(e), d = "number" == typeof e) {
                  if (0 * e != 0) return o(m, y, d, t);
                  if (m.s = 1 / e < 0 ? (y = y.slice(1), -1) : 1, G.DEBUG && y.replace(/^0\.0*|\./, "").length > 15) throw Error(l + e);
                } else m.s = 45 === y.charCodeAt(0) ? (y = y.slice(1), -1) : 1;

                for (r = H.slice(0, t), u = h = 0, g = y.length; h < g; h++) {
                  if (r.indexOf(s = y.charAt(h)) < 0) {
                    if ("." == s) {
                      if (h > u) {
                        u = g;
                        continue;
                      }
                    } else if (!a && (y == y.toUpperCase() && (y = y.toLowerCase()) || y == y.toLowerCase() && (y = y.toUpperCase()))) {
                      a = !0, h = -1, u = 0;
                      continue;
                    }

                    return o(m, String(e), d, t);
                  }
                }

                d = !1, (u = (y = n(y, t, 10, m.s)).indexOf(".")) > -1 ? y = y.replace(".", "") : u = y.length;
              }

              for (h = 0; 48 === y.charCodeAt(h); h++) {
                ;
              }

              for (g = y.length; 48 === y.charCodeAt(--g);) {
                ;
              }

              if (y = y.slice(h, ++g)) {
                if (g -= h, d && G.DEBUG && g > 15 && (e > f || e !== c(e))) throw Error(l + m.s * e);
                if ((u = u - h - 1) > L) m.c = m.e = null;else if (u < P) m.c = [m.e = 0];else {
                  if (m.e = u, m.c = [], h = (u + 1) % p, u < 0 && (h += p), h < g) {
                    for (h && m.c.push(+y.slice(0, h)), g -= p; h < g;) {
                      m.c.push(+y.slice(h, h += p));
                    }

                    h = p - (y = y.slice(h)).length;
                  } else h -= g;

                  for (; h--; y += "0") {
                    ;
                  }

                  m.c.push(+y);
                }
              } else m.c = [m.e = 0];
            }

            function K(e, t, r, n) {
              var o, s, i, a, c;
              if (null == r ? r = O : A(r, 0, 8), !e.c) return e.toString();
              if (o = e.c[0], i = e.e, null == t) c = b(e.c), c = 1 == n || 2 == n && (i <= D || i >= N) ? x(c, i) : S(c, i, "0");else if (s = (e = V(new G(e), t, r)).e, a = (c = b(e.c)).length, 1 == n || 2 == n && (t <= s || s <= D)) {
                for (; a < t; c += "0", a++) {
                  ;
                }

                c = x(c, s);
              } else if (t -= i, c = S(c, s, "0"), s + 1 > a) {
                if (--t > 0) for (c += "."; t--; c += "0") {
                  ;
                }
              } else if ((t += s - a) > 0) for (s + 1 == a && (c += "."); t--; c += "0") {
                ;
              }
              return e.s < 0 && o ? "-" + c : c;
            }

            function q(e, t) {
              for (var r, n = 1, o = new G(e[0]); n < e.length; n++) {
                if (!(r = new G(e[n])).s) {
                  o = r;
                  break;
                }

                t.call(o, r) && (o = r);
              }

              return o;
            }

            function $(e, t, r) {
              for (var n = 1, o = t.length; !t[--o]; t.pop()) {
                ;
              }

              for (o = t[0]; o >= 10; o /= 10, n++) {
                ;
              }

              return (r = n + r * p - 1) > L ? e.c = e.e = null : r < P ? e.c = [e.e = 0] : (e.e = r, e.c = t), e;
            }

            function V(e, t, r, n) {
              var o,
                  s,
                  i,
                  u,
                  l,
                  f,
                  g,
                  y = e.c,
                  m = d;

              if (y) {
                e: {
                  for (o = 1, u = y[0]; u >= 10; u /= 10, o++) {
                    ;
                  }

                  if ((s = t - o) < 0) s += p, i = t, g = (l = y[f = 0]) / m[o - i - 1] % 10 | 0;else if ((f = a((s + 1) / p)) >= y.length) {
                    if (!n) break e;

                    for (; y.length <= f; y.push(0)) {
                      ;
                    }

                    l = g = 0, o = 1, i = (s %= p) - p + 1;
                  } else {
                    for (l = u = y[f], o = 1; u >= 10; u /= 10, o++) {
                      ;
                    }

                    g = (i = (s %= p) - p + o) < 0 ? 0 : l / m[o - i - 1] % 10 | 0;
                  }
                  if (n = n || t < 0 || null != y[f + 1] || (i < 0 ? l : l % m[o - i - 1]), n = r < 4 ? (g || n) && (0 == r || r == (e.s < 0 ? 3 : 2)) : g > 5 || 5 == g && (4 == r || n || 6 == r && (s > 0 ? i > 0 ? l / m[o - i] : 0 : y[f - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7)), t < 1 || !y[0]) return y.length = 0, n ? (t -= e.e + 1, y[0] = m[(p - t % p) % p], e.e = -t || 0) : y[0] = e.e = 0, e;
                  if (0 == s ? (y.length = f, u = 1, f--) : (y.length = f + 1, u = m[p - s], y[f] = i > 0 ? c(l / m[o - i] % m[i]) * u : 0), n) for (;;) {
                    if (0 == f) {
                      for (s = 1, i = y[0]; i >= 10; i /= 10, s++) {
                        ;
                      }

                      for (i = y[0] += u, u = 1; i >= 10; i /= 10, u++) {
                        ;
                      }

                      s != u && (e.e++, y[0] == h && (y[0] = 1));
                      break;
                    }

                    if (y[f] += u, y[f] != h) break;
                    y[f--] = 0, u = 1;
                  }

                  for (s = y.length; 0 === y[--s]; y.pop()) {
                    ;
                  }
                }

                e.e > L ? e.c = e.e = null : e.e < P && (e.c = [e.e = 0]);
              }

              return e;
            }

            function W(e) {
              var t,
                  r = e.e;
              return null === r ? e.toString() : (t = b(e.c), t = r <= D || r >= N ? x(t, r) : S(t, r, "0"), e.s < 0 ? "-" + t : t);
            }

            return G.clone = e, G.ROUND_UP = 0, G.ROUND_DOWN = 1, G.ROUND_CEIL = 2, G.ROUND_FLOOR = 3, G.ROUND_HALF_UP = 4, G.ROUND_HALF_DOWN = 5, G.ROUND_HALF_EVEN = 6, G.ROUND_HALF_CEIL = 7, G.ROUND_HALF_FLOOR = 8, G.EUCLID = 9, G.config = G.set = function (e) {
              var t, r;

              if (null != e) {
                if ("object" != typeof e) throw Error(u + "Object expected: " + e);
                if (e.hasOwnProperty(t = "DECIMAL_PLACES") && (A(r = e[t], 0, y, t), R = r), e.hasOwnProperty(t = "ROUNDING_MODE") && (A(r = e[t], 0, 8, t), O = r), e.hasOwnProperty(t = "EXPONENTIAL_AT") && ((r = e[t]) && r.pop ? (A(r[0], -y, 0, t), A(r[1], 0, y, t), D = r[0], N = r[1]) : (A(r, -y, y, t), D = -(N = r < 0 ? -r : r))), e.hasOwnProperty(t = "RANGE")) if ((r = e[t]) && r.pop) A(r[0], -y, -1, t), A(r[1], 1, y, t), P = r[0], L = r[1];else {
                  if (A(r, -y, y, t), !r) throw Error(u + t + " cannot be zero: " + r);
                  P = -(L = r < 0 ? -r : r);
                }

                if (e.hasOwnProperty(t = "CRYPTO")) {
                  if ((r = e[t]) !== !!r) throw Error(u + t + " not true or false: " + r);

                  if (r) {
                    if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw F = !r, Error(u + "crypto unavailable");
                    F = r;
                  } else F = r;
                }

                if (e.hasOwnProperty(t = "MODULO_MODE") && (A(r = e[t], 0, 9, t), j = r), e.hasOwnProperty(t = "POW_PRECISION") && (A(r = e[t], 0, y, t), z = r), e.hasOwnProperty(t = "FORMAT")) {
                  if ("object" != typeof (r = e[t])) throw Error(u + t + " not an object: " + r);
                  M = r;
                }

                if (e.hasOwnProperty(t = "ALPHABET")) {
                  if ("string" != typeof (r = e[t]) || /^.?$|[+\-.\s]|(.).*\1/.test(r)) throw Error(u + t + " invalid: " + r);
                  H = r;
                }
              }

              return {
                DECIMAL_PLACES: R,
                ROUNDING_MODE: O,
                EXPONENTIAL_AT: [D, N],
                RANGE: [P, L],
                CRYPTO: F,
                MODULO_MODE: j,
                POW_PRECISION: z,
                FORMAT: M,
                ALPHABET: H
              };
            }, G.isBigNumber = function (e) {
              if (!e || !0 !== e._isBigNumber) return !1;
              if (!G.DEBUG) return !0;
              var t,
                  r,
                  n = e.c,
                  o = e.e,
                  s = e.s;

              e: if ("[object Array]" == {}.toString.call(n)) {
                if ((1 === s || -1 === s) && o >= -y && o <= y && o === c(o)) {
                  if (0 === n[0]) {
                    if (0 === o && 1 === n.length) return !0;
                    break e;
                  }

                  if ((t = (o + 1) % p) < 1 && (t += p), String(n[0]).length == t) {
                    for (t = 0; t < n.length; t++) {
                      if ((r = n[t]) < 0 || r >= h || r !== c(r)) break e;
                    }

                    if (0 !== r) return !0;
                  }
                }
              } else if (null === n && null === o && (null === s || 1 === s || -1 === s)) return !0;

              throw Error(u + "Invalid BigNumber: " + e);
            }, G.maximum = G.max = function () {
              return q(arguments, U.lt);
            }, G.minimum = G.min = function () {
              return q(arguments, U.gt);
            }, G.random = (s = 9007199254740992, E = Math.random() * s & 2097151 ? function () {
              return c(Math.random() * s);
            } : function () {
              return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
            }, function (e) {
              var t,
                  r,
                  n,
                  o,
                  s,
                  i = 0,
                  l = [],
                  h = new G(C);
              if (null == e ? e = R : A(e, 0, y), o = a(e / p), F) if (crypto.getRandomValues) {
                for (t = crypto.getRandomValues(new Uint32Array(o *= 2)); i < o;) {
                  (s = 131072 * t[i] + (t[i + 1] >>> 11)) >= 9e15 ? (r = crypto.getRandomValues(new Uint32Array(2)), t[i] = r[0], t[i + 1] = r[1]) : (l.push(s % 1e14), i += 2);
                }

                i = o / 2;
              } else {
                if (!crypto.randomBytes) throw F = !1, Error(u + "crypto unavailable");

                for (t = crypto.randomBytes(o *= 7); i < o;) {
                  (s = 281474976710656 * (31 & t[i]) + 1099511627776 * t[i + 1] + 4294967296 * t[i + 2] + 16777216 * t[i + 3] + (t[i + 4] << 16) + (t[i + 5] << 8) + t[i + 6]) >= 9e15 ? crypto.randomBytes(7).copy(t, i) : (l.push(s % 1e14), i += 7);
                }

                i = o / 7;
              }
              if (!F) for (; i < o;) {
                (s = E()) < 9e15 && (l[i++] = s % 1e14);
              }

              for (o = l[--i], e %= p, o && e && (s = d[p - e], l[i] = c(o / s) * s); 0 === l[i]; l.pop(), i--) {
                ;
              }

              if (i < 0) l = [n = 0];else {
                for (n = -1; 0 === l[0]; l.splice(0, 1), n -= p) {
                  ;
                }

                for (i = 1, s = l[0]; s >= 10; s /= 10, i++) {
                  ;
                }

                i < p && (n -= p - i);
              }
              return h.e = n, h.c = l, h;
            }), G.sum = function () {
              for (var e = 1, t = arguments, r = new G(t[0]); e < t.length;) {
                r = r.plus(t[e++]);
              }

              return r;
            }, n = function () {
              var e = "0123456789";

              function t(e, t, r, n) {
                for (var o, s, i = [0], a = 0, c = e.length; a < c;) {
                  for (s = i.length; s--; i[s] *= t) {
                    ;
                  }

                  for (i[0] += n.indexOf(e.charAt(a++)), o = 0; o < i.length; o++) {
                    i[o] > r - 1 && (null == i[o + 1] && (i[o + 1] = 0), i[o + 1] += i[o] / r | 0, i[o] %= r);
                  }
                }

                return i.reverse();
              }

              return function (n, o, s, i, a) {
                var c,
                    u,
                    l,
                    h,
                    p,
                    f,
                    d,
                    g,
                    y = n.indexOf("."),
                    m = R,
                    w = O;

                for (y >= 0 && (h = z, z = 0, n = n.replace(".", ""), f = (g = new G(o)).pow(n.length - y), z = h, g.c = t(S(b(f.c), f.e, "0"), 10, s, e), g.e = g.c.length), l = h = (d = t(n, o, s, a ? (c = H, e) : (c = e, H))).length; 0 == d[--h]; d.pop()) {
                  ;
                }

                if (!d[0]) return c.charAt(0);
                if (y < 0 ? --l : (f.c = d, f.e = l, f.s = i, d = (f = r(f, g, m, w, s)).c, p = f.r, l = f.e), y = d[u = l + m + 1], h = s / 2, p = p || u < 0 || null != d[u + 1], p = w < 4 ? (null != y || p) && (0 == w || w == (f.s < 0 ? 3 : 2)) : y > h || y == h && (4 == w || p || 6 == w && 1 & d[u - 1] || w == (f.s < 0 ? 8 : 7)), u < 1 || !d[0]) n = p ? S(c.charAt(1), -m, c.charAt(0)) : c.charAt(0);else {
                  if (d.length = u, p) for (--s; ++d[--u] > s;) {
                    d[u] = 0, u || (++l, d = [1].concat(d));
                  }

                  for (h = d.length; !d[--h];) {
                    ;
                  }

                  for (y = 0, n = ""; y <= h; n += c.charAt(d[y++])) {
                    ;
                  }

                  n = S(n, l, c.charAt(0));
                }
                return n;
              };
            }(), r = function () {
              function e(e, t, r) {
                var n,
                    o,
                    s,
                    i,
                    a = 0,
                    c = e.length,
                    u = t % g,
                    l = t / g | 0;

                for (e = e.slice(); c--;) {
                  a = ((o = u * (s = e[c] % g) + (n = l * s + (i = e[c] / g | 0) * u) % g * g + a) / r | 0) + (n / g | 0) + l * i, e[c] = o % r;
                }

                return a && (e = [a].concat(e)), e;
              }

              function t(e, t, r, n) {
                var o, s;
                if (r != n) s = r > n ? 1 : -1;else for (o = s = 0; o < r; o++) {
                  if (e[o] != t[o]) {
                    s = e[o] > t[o] ? 1 : -1;
                    break;
                  }
                }
                return s;
              }

              function r(e, t, r, n) {
                for (var o = 0; r--;) {
                  e[r] -= o, o = e[r] < t[r] ? 1 : 0, e[r] = o * n + e[r] - t[r];
                }

                for (; !e[0] && e.length > 1; e.splice(0, 1)) {
                  ;
                }
              }

              return function (n, o, s, i, a) {
                var u,
                    l,
                    f,
                    d,
                    g,
                    y,
                    b,
                    w,
                    A,
                    v,
                    x,
                    S,
                    E,
                    T,
                    _,
                    B,
                    k,
                    I = n.s == o.s ? 1 : -1,
                    U = n.c,
                    C = o.c;

                if (!(U && U[0] && C && C[0])) return new G(n.s && o.s && (U ? !C || U[0] != C[0] : C) ? U && 0 == U[0] || !C ? 0 * I : I / 0 : NaN);

                for (A = (w = new G(I)).c = [], I = s + (l = n.e - o.e) + 1, a || (a = h, l = m(n.e / p) - m(o.e / p), I = I / p | 0), f = 0; C[f] == (U[f] || 0); f++) {
                  ;
                }

                if (C[f] > (U[f] || 0) && l--, I < 0) A.push(1), d = !0;else {
                  for (T = U.length, B = C.length, f = 0, I += 2, (g = c(a / (C[0] + 1))) > 1 && (C = e(C, g, a), U = e(U, g, a), B = C.length, T = U.length), E = B, x = (v = U.slice(0, B)).length; x < B; v[x++] = 0) {
                    ;
                  }

                  k = C.slice(), k = [0].concat(k), _ = C[0], C[1] >= a / 2 && _++;

                  do {
                    if (g = 0, (u = t(C, v, B, x)) < 0) {
                      if (S = v[0], B != x && (S = S * a + (v[1] || 0)), (g = c(S / _)) > 1) for (g >= a && (g = a - 1), b = (y = e(C, g, a)).length, x = v.length; 1 == t(y, v, b, x);) {
                        g--, r(y, B < b ? k : C, b, a), b = y.length, u = 1;
                      } else 0 == g && (u = g = 1), b = (y = C.slice()).length;
                      if (b < x && (y = [0].concat(y)), r(v, y, x, a), x = v.length, -1 == u) for (; t(C, v, B, x) < 1;) {
                        g++, r(v, B < x ? k : C, x, a), x = v.length;
                      }
                    } else 0 === u && (g++, v = [0]);

                    A[f++] = g, v[0] ? v[x++] = U[E] || 0 : (v = [U[E]], x = 1);
                  } while ((E++ < T || null != v[0]) && I--);

                  d = null != v[0], A[0] || A.splice(0, 1);
                }

                if (a == h) {
                  for (f = 1, I = A[0]; I >= 10; I /= 10, f++) {
                    ;
                  }

                  V(w, s + (w.e = f + l * p - 1) + 1, i, d);
                } else w.e = l, w.r = +d;

                return w;
              };
            }(), T = /^(-?)0([xbo])(?=\w[\w.]*$)/i, _ = /^([^.]+)\.$/, B = /^\.([^.]+)$/, k = /^-?(Infinity|NaN)$/, I = /^\s*\+(?=[\w.])|^\s+|\s+$/g, o = function o(e, t, r, n) {
              var o,
                  s = r ? t : t.replace(I, "");
              if (k.test(s)) e.s = isNaN(s) ? null : s < 0 ? -1 : 1;else {
                if (!r && (s = s.replace(T, function (e, t, r) {
                  return o = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != o ? e : t;
                }), n && (o = n, s = s.replace(_, "$1").replace(B, "0.$1")), t != s)) return new G(s, o);
                if (G.DEBUG) throw Error(u + "Not a" + (n ? " base " + n : "") + " number: " + t);
                e.s = null;
              }
              e.c = e.e = null;
            }, U.absoluteValue = U.abs = function () {
              var e = new G(this);
              return e.s < 0 && (e.s = 1), e;
            }, U.comparedTo = function (e, t) {
              return w(this, new G(e, t));
            }, U.decimalPlaces = U.dp = function (e, t) {
              var r,
                  n,
                  o,
                  s = this;
              if (null != e) return A(e, 0, y), null == t ? t = O : A(t, 0, 8), V(new G(s), e + s.e + 1, t);
              if (!(r = s.c)) return null;
              if (n = ((o = r.length - 1) - m(this.e / p)) * p, o = r[o]) for (; o % 10 == 0; o /= 10, n--) {
                ;
              }
              return n < 0 && (n = 0), n;
            }, U.dividedBy = U.div = function (e, t) {
              return r(this, new G(e, t), R, O);
            }, U.dividedToIntegerBy = U.idiv = function (e, t) {
              return r(this, new G(e, t), 0, 1);
            }, U.exponentiatedBy = U.pow = function (e, t) {
              var r,
                  n,
                  o,
                  s,
                  i,
                  l,
                  h,
                  f,
                  d = this;
              if ((e = new G(e)).c && !e.isInteger()) throw Error(u + "Exponent not an integer: " + W(e));
              if (null != t && (t = new G(t)), i = e.e > 14, !d.c || !d.c[0] || 1 == d.c[0] && !d.e && 1 == d.c.length || !e.c || !e.c[0]) return f = new G(Math.pow(+W(d), i ? 2 - v(e) : +W(e))), t ? f.mod(t) : f;

              if (l = e.s < 0, t) {
                if (t.c ? !t.c[0] : !t.s) return new G(NaN);
                (n = !l && d.isInteger() && t.isInteger()) && (d = d.mod(t));
              } else {
                if (e.e > 9 && (d.e > 0 || d.e < -1 || (0 == d.e ? d.c[0] > 1 || i && d.c[1] >= 24e7 : d.c[0] < 8e13 || i && d.c[0] <= 9999975e7))) return s = d.s < 0 && v(e) ? -0 : 0, d.e > -1 && (s = 1 / s), new G(l ? 1 / s : s);
                z && (s = a(z / p + 2));
              }

              for (i ? (r = new G(.5), l && (e.s = 1), h = v(e)) : h = (o = Math.abs(+W(e))) % 2, f = new G(C);;) {
                if (h) {
                  if (!(f = f.times(d)).c) break;
                  s ? f.c.length > s && (f.c.length = s) : n && (f = f.mod(t));
                }

                if (o) {
                  if (0 === (o = c(o / 2))) break;
                  h = o % 2;
                } else if (V(e = e.times(r), e.e + 1, 1), e.e > 14) h = v(e);else {
                  if (0 == (o = +W(e))) break;
                  h = o % 2;
                }

                d = d.times(d), s ? d.c && d.c.length > s && (d.c.length = s) : n && (d = d.mod(t));
              }

              return n ? f : (l && (f = C.div(f)), t ? f.mod(t) : s ? V(f, z, O, void 0) : f);
            }, U.integerValue = function (e) {
              var t = new G(this);
              return null == e ? e = O : A(e, 0, 8), V(t, t.e + 1, e);
            }, U.isEqualTo = U.eq = function (e, t) {
              return 0 === w(this, new G(e, t));
            }, U.isFinite = function () {
              return !!this.c;
            }, U.isGreaterThan = U.gt = function (e, t) {
              return w(this, new G(e, t)) > 0;
            }, U.isGreaterThanOrEqualTo = U.gte = function (e, t) {
              return 1 === (t = w(this, new G(e, t))) || 0 === t;
            }, U.isInteger = function () {
              return !!this.c && m(this.e / p) > this.c.length - 2;
            }, U.isLessThan = U.lt = function (e, t) {
              return w(this, new G(e, t)) < 0;
            }, U.isLessThanOrEqualTo = U.lte = function (e, t) {
              return -1 === (t = w(this, new G(e, t))) || 0 === t;
            }, U.isNaN = function () {
              return !this.s;
            }, U.isNegative = function () {
              return this.s < 0;
            }, U.isPositive = function () {
              return this.s > 0;
            }, U.isZero = function () {
              return !!this.c && 0 == this.c[0];
            }, U.minus = function (e, t) {
              var r,
                  n,
                  o,
                  s,
                  i = this,
                  a = i.s;
              if (t = (e = new G(e, t)).s, !a || !t) return new G(NaN);
              if (a != t) return e.s = -t, i.plus(e);
              var c = i.e / p,
                  u = e.e / p,
                  l = i.c,
                  f = e.c;

              if (!c || !u) {
                if (!l || !f) return l ? (e.s = -t, e) : new G(f ? i : NaN);
                if (!l[0] || !f[0]) return f[0] ? (e.s = -t, e) : new G(l[0] ? i : 3 == O ? -0 : 0);
              }

              if (c = m(c), u = m(u), l = l.slice(), a = c - u) {
                for ((s = a < 0) ? (a = -a, o = l) : (u = c, o = f), o.reverse(), t = a; t--; o.push(0)) {
                  ;
                }

                o.reverse();
              } else for (n = (s = (a = l.length) < (t = f.length)) ? a : t, a = t = 0; t < n; t++) {
                if (l[t] != f[t]) {
                  s = l[t] < f[t];
                  break;
                }
              }

              if (s && (o = l, l = f, f = o, e.s = -e.s), (t = (n = f.length) - (r = l.length)) > 0) for (; t--; l[r++] = 0) {
                ;
              }

              for (t = h - 1; n > a;) {
                if (l[--n] < f[n]) {
                  for (r = n; r && !l[--r]; l[r] = t) {
                    ;
                  }

                  --l[r], l[n] += h;
                }

                l[n] -= f[n];
              }

              for (; 0 == l[0]; l.splice(0, 1), --u) {
                ;
              }

              return l[0] ? $(e, l, u) : (e.s = 3 == O ? -1 : 1, e.c = [e.e = 0], e);
            }, U.modulo = U.mod = function (e, t) {
              var n,
                  o,
                  s = this;
              return e = new G(e, t), !s.c || !e.s || e.c && !e.c[0] ? new G(NaN) : !e.c || s.c && !s.c[0] ? new G(s) : (9 == j ? (o = e.s, e.s = 1, n = r(s, e, 0, 3), e.s = o, n.s *= o) : n = r(s, e, 0, j), (e = s.minus(n.times(e))).c[0] || 1 != j || (e.s = s.s), e);
            }, U.multipliedBy = U.times = function (e, t) {
              var r,
                  n,
                  o,
                  s,
                  i,
                  a,
                  c,
                  u,
                  l,
                  f,
                  d,
                  y,
                  b,
                  w,
                  A,
                  v = this,
                  x = v.c,
                  S = (e = new G(e, t)).c;
              if (!(x && S && x[0] && S[0])) return !v.s || !e.s || x && !x[0] && !S || S && !S[0] && !x ? e.c = e.e = e.s = null : (e.s *= v.s, x && S ? (e.c = [0], e.e = 0) : e.c = e.e = null), e;

              for (n = m(v.e / p) + m(e.e / p), e.s *= v.s, (c = x.length) < (f = S.length) && (b = x, x = S, S = b, o = c, c = f, f = o), o = c + f, b = []; o--; b.push(0)) {
                ;
              }

              for (w = h, A = g, o = f; --o >= 0;) {
                for (r = 0, d = S[o] % A, y = S[o] / A | 0, s = o + (i = c); s > o;) {
                  r = ((u = d * (u = x[--i] % A) + (a = y * u + (l = x[i] / A | 0) * d) % A * A + b[s] + r) / w | 0) + (a / A | 0) + y * l, b[s--] = u % w;
                }

                b[s] = r;
              }

              return r ? ++n : b.splice(0, 1), $(e, b, n);
            }, U.negated = function () {
              var e = new G(this);
              return e.s = -e.s || null, e;
            }, U.plus = function (e, t) {
              var r,
                  n = this,
                  o = n.s;
              if (t = (e = new G(e, t)).s, !o || !t) return new G(NaN);
              if (o != t) return e.s = -t, n.minus(e);
              var s = n.e / p,
                  i = e.e / p,
                  a = n.c,
                  c = e.c;

              if (!s || !i) {
                if (!a || !c) return new G(o / 0);
                if (!a[0] || !c[0]) return c[0] ? e : new G(a[0] ? n : 0 * o);
              }

              if (s = m(s), i = m(i), a = a.slice(), o = s - i) {
                for (o > 0 ? (i = s, r = c) : (o = -o, r = a), r.reverse(); o--; r.push(0)) {
                  ;
                }

                r.reverse();
              }

              for ((o = a.length) - (t = c.length) < 0 && (r = c, c = a, a = r, t = o), o = 0; t;) {
                o = (a[--t] = a[t] + c[t] + o) / h | 0, a[t] = h === a[t] ? 0 : a[t] % h;
              }

              return o && (a = [o].concat(a), ++i), $(e, a, i);
            }, U.precision = U.sd = function (e, t) {
              var r,
                  n,
                  o,
                  s = this;
              if (null != e && e !== !!e) return A(e, 1, y), null == t ? t = O : A(t, 0, 8), V(new G(s), e, t);
              if (!(r = s.c)) return null;

              if (n = (o = r.length - 1) * p + 1, o = r[o]) {
                for (; o % 10 == 0; o /= 10, n--) {
                  ;
                }

                for (o = r[0]; o >= 10; o /= 10, n++) {
                  ;
                }
              }

              return e && s.e + 1 > n && (n = s.e + 1), n;
            }, U.shiftedBy = function (e) {
              return A(e, -9007199254740991, f), this.times("1e" + e);
            }, U.squareRoot = U.sqrt = function () {
              var e,
                  t,
                  n,
                  o,
                  s,
                  i = this,
                  a = i.c,
                  c = i.s,
                  u = i.e,
                  l = R + 4,
                  h = new G("0.5");
              if (1 !== c || !a || !a[0]) return new G(!c || c < 0 && (!a || a[0]) ? NaN : a ? i : 1 / 0);
              if (0 == (c = Math.sqrt(+W(i))) || c == 1 / 0 ? (((t = b(a)).length + u) % 2 == 0 && (t += "0"), c = Math.sqrt(+t), u = m((u + 1) / 2) - (u < 0 || u % 2), n = new G(t = c == 1 / 0 ? "5e" + u : (t = c.toExponential()).slice(0, t.indexOf("e") + 1) + u)) : n = new G(c + ""), n.c[0]) for ((c = (u = n.e) + l) < 3 && (c = 0);;) {
                if (s = n, n = h.times(s.plus(r(i, s, l, 1))), b(s.c).slice(0, c) === (t = b(n.c)).slice(0, c)) {
                  if (n.e < u && --c, "9999" != (t = t.slice(c - 3, c + 1)) && (o || "4999" != t)) {
                    +t && (+t.slice(1) || "5" != t.charAt(0)) || (V(n, n.e + R + 2, 1), e = !n.times(n).eq(i));
                    break;
                  }

                  if (!o && (V(s, s.e + R + 2, 0), s.times(s).eq(i))) {
                    n = s;
                    break;
                  }

                  l += 4, c += 4, o = 1;
                }
              }
              return V(n, n.e + R + 1, O, e);
            }, U.toExponential = function (e, t) {
              return null != e && (A(e, 0, y), e++), K(this, e, t, 1);
            }, U.toFixed = function (e, t) {
              return null != e && (A(e, 0, y), e = e + this.e + 1), K(this, e, t);
            }, U.toFormat = function (e, t, r) {
              var n,
                  o = this;
              if (null == r) null != e && t && "object" == typeof t ? (r = t, t = null) : e && "object" == typeof e ? (r = e, e = t = null) : r = M;else if ("object" != typeof r) throw Error(u + "Argument not an object: " + r);

              if (n = o.toFixed(e, t), o.c) {
                var s,
                    i = n.split("."),
                    a = +r.groupSize,
                    c = +r.secondaryGroupSize,
                    l = r.groupSeparator || "",
                    h = i[0],
                    p = i[1],
                    f = o.s < 0,
                    d = f ? h.slice(1) : h,
                    g = d.length;

                if (c && (s = a, a = c, c = s, g -= s), a > 0 && g > 0) {
                  for (s = g % a || a, h = d.substr(0, s); s < g; s += a) {
                    h += l + d.substr(s, a);
                  }

                  c > 0 && (h += l + d.slice(s)), f && (h = "-" + h);
                }

                n = p ? h + (r.decimalSeparator || "") + ((c = +r.fractionGroupSize) ? p.replace(new RegExp("\\d{" + c + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : p) : h;
              }

              return (r.prefix || "") + n + (r.suffix || "");
            }, U.toFraction = function (e) {
              var t,
                  n,
                  o,
                  s,
                  i,
                  a,
                  c,
                  l,
                  h,
                  f,
                  g,
                  y,
                  m = this,
                  w = m.c;
              if (null != e && (!(c = new G(e)).isInteger() && (c.c || 1 !== c.s) || c.lt(C))) throw Error(u + "Argument " + (c.isInteger() ? "out of range: " : "not an integer: ") + W(c));
              if (!w) return new G(m);

              for (t = new G(C), h = n = new G(C), o = l = new G(C), y = b(w), i = t.e = y.length - m.e - 1, t.c[0] = d[(a = i % p) < 0 ? p + a : a], e = !e || c.comparedTo(t) > 0 ? i > 0 ? t : h : c, a = L, L = 1 / 0, c = new G(y), l.c[0] = 0; f = r(c, t, 0, 1), 1 != (s = n.plus(f.times(o))).comparedTo(e);) {
                n = o, o = s, h = l.plus(f.times(s = h)), l = s, t = c.minus(f.times(s = t)), c = s;
              }

              return s = r(e.minus(n), o, 0, 1), l = l.plus(s.times(h)), n = n.plus(s.times(o)), l.s = h.s = m.s, g = r(h, o, i *= 2, O).minus(m).abs().comparedTo(r(l, n, i, O).minus(m).abs()) < 1 ? [h, o] : [l, n], L = a, g;
            }, U.toNumber = function () {
              return +W(this);
            }, U.toPrecision = function (e, t) {
              return null != e && A(e, 1, y), K(this, e, t, 2);
            }, U.toString = function (e) {
              var t,
                  r = this,
                  o = r.s,
                  s = r.e;
              return null === s ? o ? (t = "Infinity", o < 0 && (t = "-" + t)) : t = "NaN" : (null == e ? t = s <= D || s >= N ? x(b(r.c), s) : S(b(r.c), s, "0") : 10 === e ? t = S(b((r = V(new G(r), R + s + 1, O)).c), r.e, "0") : (A(e, 2, H.length, "Base"), t = n(S(b(r.c), s, "0"), 10, e, o, !0)), o < 0 && r.c[0] && (t = "-" + t)), t;
            }, U.valueOf = U.toJSON = function () {
              return W(this);
            }, U._isBigNumber = !0, null != t && G.set(t), G;
          }()).default = s.BigNumber = s, void 0 === (n = function () {
            return s;
          }.call(t, r, t, e)) || (e.exports = n);
        }();
      },
      2486: function _(e, t, r) {
        "use strict";

        var n = r(5155),
            o = r(4525),
            s = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
        t.Buffer = c, t.SlowBuffer = function (e) {
          return +e != e && (e = 0), c.alloc(+e);
        }, t.INSPECT_MAX_BYTES = 50;
        var i = 2147483647;

        function a(e) {
          if (e > i) throw new RangeError('The value "' + e + '" is invalid for option "size"');
          var t = new Uint8Array(e);
          return Object.setPrototypeOf(t, c.prototype), t;
        }

        function c(e, t, r) {
          if ("number" == typeof e) {
            if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
            return h(e);
          }

          return u(e, t, r);
        }

        function u(e, t, r) {
          if ("string" == typeof e) return function (e, t) {
            if ("string" == typeof t && "" !== t || (t = "utf8"), !c.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
            var r = 0 | g(e, t);
            var n = a(r);
            var o = n.write(e, t);
            return o !== r && (n = n.slice(0, o)), n;
          }(e, t);
          if (ArrayBuffer.isView(e)) return function (e) {
            if (X(e, Uint8Array)) {
              var _t = new Uint8Array(e);

              return f(_t.buffer, _t.byteOffset, _t.byteLength);
            }

            return p(e);
          }(e);
          if (null == e) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
          if (X(e, ArrayBuffer) || e && X(e.buffer, ArrayBuffer)) return f(e, t, r);
          if ("undefined" != typeof SharedArrayBuffer && (X(e, SharedArrayBuffer) || e && X(e.buffer, SharedArrayBuffer))) return f(e, t, r);
          if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
          var n = e.valueOf && e.valueOf();
          if (null != n && n !== e) return c.from(n, t, r);

          var o = function (e) {
            if (c.isBuffer(e)) {
              var _t2 = 0 | d(e.length),
                  _r = a(_t2);

              return 0 === _r.length || e.copy(_r, 0, 0, _t2), _r;
            }

            return void 0 !== e.length ? "number" != typeof e.length || Y(e.length) ? a(0) : p(e) : "Buffer" === e.type && Array.isArray(e.data) ? p(e.data) : void 0;
          }(e);

          if (o) return o;
          if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return c.from(e[Symbol.toPrimitive]("string"), t, r);
          throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
        }

        function l(e) {
          if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
          if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
        }

        function h(e) {
          return l(e), a(e < 0 ? 0 : 0 | d(e));
        }

        function p(e) {
          var t = e.length < 0 ? 0 : 0 | d(e.length),
              r = a(t);

          for (var _n = 0; _n < t; _n += 1) {
            r[_n] = 255 & e[_n];
          }

          return r;
        }

        function f(e, t, r) {
          if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
          if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
          var n;
          return n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r), Object.setPrototypeOf(n, c.prototype), n;
        }

        function d(e) {
          if (e >= i) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
          return 0 | e;
        }

        function g(e, t) {
          if (c.isBuffer(e)) return e.length;
          if (ArrayBuffer.isView(e) || X(e, ArrayBuffer)) return e.byteLength;
          if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
          var r = e.length,
              n = arguments.length > 2 && !0 === arguments[2];
          if (!n && 0 === r) return 0;
          var o = !1;

          for (;;) {
            switch (t) {
              case "ascii":
              case "latin1":
              case "binary":
                return r;

              case "utf8":
              case "utf-8":
                return $(e).length;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * r;

              case "hex":
                return r >>> 1;

              case "base64":
                return V(e).length;

              default:
                if (o) return n ? -1 : $(e).length;
                t = ("" + t).toLowerCase(), o = !0;
            }
          }
        }

        function y(e, t, r) {
          var n = !1;
          if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
          if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
          if ((r >>>= 0) <= (t >>>= 0)) return "";

          for (e || (e = "utf8");;) {
            switch (e) {
              case "hex":
                return U(this, t, r);

              case "utf8":
              case "utf-8":
                return _(this, t, r);

              case "ascii":
                return k(this, t, r);

              case "latin1":
              case "binary":
                return I(this, t, r);

              case "base64":
                return T(this, t, r);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return C(this, t, r);

              default:
                if (n) throw new TypeError("Unknown encoding: " + e);
                e = (e + "").toLowerCase(), n = !0;
            }
          }
        }

        function m(e, t, r) {
          var n = e[t];
          e[t] = e[r], e[r] = n;
        }

        function b(e, t, r, n, o) {
          if (0 === e.length) return -1;

          if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), Y(r = +r) && (r = o ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
            if (o) return -1;
            r = e.length - 1;
          } else if (r < 0) {
            if (!o) return -1;
            r = 0;
          }

          if ("string" == typeof t && (t = c.from(t, n)), c.isBuffer(t)) return 0 === t.length ? -1 : w(e, t, r, n, o);
          if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : w(e, [t], r, n, o);
          throw new TypeError("val must be string, number or Buffer");
        }

        function w(e, t, r, n, o) {
          var s,
              i = 1,
              a = e.length,
              c = t.length;

          if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
            if (e.length < 2 || t.length < 2) return -1;
            i = 2, a /= 2, c /= 2, r /= 2;
          }

          function u(e, t) {
            return 1 === i ? e[t] : e.readUInt16BE(t * i);
          }

          if (o) {
            var _n2 = -1;

            for (s = r; s < a; s++) {
              if (u(e, s) === u(t, -1 === _n2 ? 0 : s - _n2)) {
                if (-1 === _n2 && (_n2 = s), s - _n2 + 1 === c) return _n2 * i;
              } else -1 !== _n2 && (s -= s - _n2), _n2 = -1;
            }
          } else for (r + c > a && (r = a - c), s = r; s >= 0; s--) {
            var _r2 = !0;

            for (var _n3 = 0; _n3 < c; _n3++) {
              if (u(e, s + _n3) !== u(t, _n3)) {
                _r2 = !1;
                break;
              }
            }

            if (_r2) return s;
          }

          return -1;
        }

        function A(e, t, r, n) {
          r = Number(r) || 0;
          var o = e.length - r;
          n ? (n = Number(n)) > o && (n = o) : n = o;
          var s = t.length;
          var i;

          for (n > s / 2 && (n = s / 2), i = 0; i < n; ++i) {
            var _n4 = parseInt(t.substr(2 * i, 2), 16);

            if (Y(_n4)) return i;
            e[r + i] = _n4;
          }

          return i;
        }

        function v(e, t, r, n) {
          return W($(t, e.length - r), e, r, n);
        }

        function x(e, t, r, n) {
          return W(function (e) {
            var t = [];

            for (var _r3 = 0; _r3 < e.length; ++_r3) {
              t.push(255 & e.charCodeAt(_r3));
            }

            return t;
          }(t), e, r, n);
        }

        function S(e, t, r, n) {
          return W(V(t), e, r, n);
        }

        function E(e, t, r, n) {
          return W(function (e, t) {
            var r, n, o;
            var s = [];

            for (var _i = 0; _i < e.length && !((t -= 2) < 0); ++_i) {
              r = e.charCodeAt(_i), n = r >> 8, o = r % 256, s.push(o), s.push(n);
            }

            return s;
          }(t, e.length - r), e, r, n);
        }

        function T(e, t, r) {
          return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
        }

        function _(e, t, r) {
          r = Math.min(e.length, r);
          var n = [];
          var o = t;

          for (; o < r;) {
            var _t3 = e[o];

            var _s = null,
                _i2 = _t3 > 239 ? 4 : _t3 > 223 ? 3 : _t3 > 191 ? 2 : 1;

            if (o + _i2 <= r) {
              var _r4 = void 0,
                  _n5 = void 0,
                  _a = void 0,
                  _c = void 0;

              switch (_i2) {
                case 1:
                  _t3 < 128 && (_s = _t3);
                  break;

                case 2:
                  _r4 = e[o + 1], 128 == (192 & _r4) && (_c = (31 & _t3) << 6 | 63 & _r4, _c > 127 && (_s = _c));
                  break;

                case 3:
                  _r4 = e[o + 1], _n5 = e[o + 2], 128 == (192 & _r4) && 128 == (192 & _n5) && (_c = (15 & _t3) << 12 | (63 & _r4) << 6 | 63 & _n5, _c > 2047 && (_c < 55296 || _c > 57343) && (_s = _c));
                  break;

                case 4:
                  _r4 = e[o + 1], _n5 = e[o + 2], _a = e[o + 3], 128 == (192 & _r4) && 128 == (192 & _n5) && 128 == (192 & _a) && (_c = (15 & _t3) << 18 | (63 & _r4) << 12 | (63 & _n5) << 6 | 63 & _a, _c > 65535 && _c < 1114112 && (_s = _c));
              }
            }

            null === _s ? (_s = 65533, _i2 = 1) : _s > 65535 && (_s -= 65536, n.push(_s >>> 10 & 1023 | 55296), _s = 56320 | 1023 & _s), n.push(_s), o += _i2;
          }

          return function (e) {
            var t = e.length;
            if (t <= B) return String.fromCharCode.apply(String, e);
            var r = "",
                n = 0;

            for (; n < t;) {
              r += String.fromCharCode.apply(String, e.slice(n, n += B));
            }

            return r;
          }(n);
        }

        t.kMaxLength = i, c.TYPED_ARRAY_SUPPORT = function () {
          try {
            var _e = new Uint8Array(1),
                _t4 = {
              foo: function foo() {
                return 42;
              }
            };

            return Object.setPrototypeOf(_t4, Uint8Array.prototype), Object.setPrototypeOf(_e, _t4), 42 === _e.foo();
          } catch (e) {
            return !1;
          }
        }(), c.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(c.prototype, "parent", {
          enumerable: !0,
          get: function get() {
            if (c.isBuffer(this)) return this.buffer;
          }
        }), Object.defineProperty(c.prototype, "offset", {
          enumerable: !0,
          get: function get() {
            if (c.isBuffer(this)) return this.byteOffset;
          }
        }), c.poolSize = 8192, c.from = function (e, t, r) {
          return u(e, t, r);
        }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array), c.alloc = function (e, t, r) {
          return function (e, t, r) {
            return l(e), e <= 0 ? a(e) : void 0 !== t ? "string" == typeof r ? a(e).fill(t, r) : a(e).fill(t) : a(e);
          }(e, t, r);
        }, c.allocUnsafe = function (e) {
          return h(e);
        }, c.allocUnsafeSlow = function (e) {
          return h(e);
        }, c.isBuffer = function (e) {
          return null != e && !0 === e._isBuffer && e !== c.prototype;
        }, c.compare = function (e, t) {
          if (X(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), X(t, Uint8Array) && (t = c.from(t, t.offset, t.byteLength)), !c.isBuffer(e) || !c.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
          if (e === t) return 0;
          var r = e.length,
              n = t.length;

          for (var _o = 0, _s2 = Math.min(r, n); _o < _s2; ++_o) {
            if (e[_o] !== t[_o]) {
              r = e[_o], n = t[_o];
              break;
            }
          }

          return r < n ? -1 : n < r ? 1 : 0;
        }, c.isEncoding = function (e) {
          switch (String(e).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;

            default:
              return !1;
          }
        }, c.concat = function (e, t) {
          if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === e.length) return c.alloc(0);
          var r;
          if (void 0 === t) for (t = 0, r = 0; r < e.length; ++r) {
            t += e[r].length;
          }
          var n = c.allocUnsafe(t);
          var o = 0;

          for (r = 0; r < e.length; ++r) {
            var _t5 = e[r];
            if (X(_t5, Uint8Array)) o + _t5.length > n.length ? (c.isBuffer(_t5) || (_t5 = c.from(_t5)), _t5.copy(n, o)) : Uint8Array.prototype.set.call(n, _t5, o);else {
              if (!c.isBuffer(_t5)) throw new TypeError('"list" argument must be an Array of Buffers');

              _t5.copy(n, o);
            }
            o += _t5.length;
          }

          return n;
        }, c.byteLength = g, c.prototype._isBuffer = !0, c.prototype.swap16 = function () {
          var e = this.length;
          if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

          for (var _t6 = 0; _t6 < e; _t6 += 2) {
            m(this, _t6, _t6 + 1);
          }

          return this;
        }, c.prototype.swap32 = function () {
          var e = this.length;
          if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

          for (var _t7 = 0; _t7 < e; _t7 += 4) {
            m(this, _t7, _t7 + 3), m(this, _t7 + 1, _t7 + 2);
          }

          return this;
        }, c.prototype.swap64 = function () {
          var e = this.length;
          if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

          for (var _t8 = 0; _t8 < e; _t8 += 8) {
            m(this, _t8, _t8 + 7), m(this, _t8 + 1, _t8 + 6), m(this, _t8 + 2, _t8 + 5), m(this, _t8 + 3, _t8 + 4);
          }

          return this;
        }, c.prototype.toString = function () {
          var e = this.length;
          return 0 === e ? "" : 0 === arguments.length ? _(this, 0, e) : y.apply(this, arguments);
        }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function (e) {
          if (!c.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
          return this === e || 0 === c.compare(this, e);
        }, c.prototype.inspect = function () {
          var e = "";
          var r = t.INSPECT_MAX_BYTES;
          return e = this.toString("hex", 0, r).replace(/(.{2})/g, "$1 ").trim(), this.length > r && (e += " ... "), "<Buffer " + e + ">";
        }, s && (c.prototype[s] = c.prototype.inspect), c.prototype.compare = function (e, t, r, n, o) {
          if (X(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), !c.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
          if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), t < 0 || r > e.length || n < 0 || o > this.length) throw new RangeError("out of range index");
          if (n >= o && t >= r) return 0;
          if (n >= o) return -1;
          if (t >= r) return 1;
          if (this === e) return 0;
          var s = (o >>>= 0) - (n >>>= 0),
              i = (r >>>= 0) - (t >>>= 0);
          var a = Math.min(s, i),
              u = this.slice(n, o),
              l = e.slice(t, r);

          for (var _e2 = 0; _e2 < a; ++_e2) {
            if (u[_e2] !== l[_e2]) {
              s = u[_e2], i = l[_e2];
              break;
            }
          }

          return s < i ? -1 : i < s ? 1 : 0;
        }, c.prototype.includes = function (e, t, r) {
          return -1 !== this.indexOf(e, t, r);
        }, c.prototype.indexOf = function (e, t, r) {
          return b(this, e, t, r, !0);
        }, c.prototype.lastIndexOf = function (e, t, r) {
          return b(this, e, t, r, !1);
        }, c.prototype.write = function (e, t, r, n) {
          if (void 0 === t) n = "utf8", r = this.length, t = 0;else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;else {
            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
          }
          var o = this.length - t;
          if ((void 0 === r || r > o) && (r = o), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          n || (n = "utf8");
          var s = !1;

          for (;;) {
            switch (n) {
              case "hex":
                return A(this, e, t, r);

              case "utf8":
              case "utf-8":
                return v(this, e, t, r);

              case "ascii":
              case "latin1":
              case "binary":
                return x(this, e, t, r);

              case "base64":
                return S(this, e, t, r);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return E(this, e, t, r);

              default:
                if (s) throw new TypeError("Unknown encoding: " + n);
                n = ("" + n).toLowerCase(), s = !0;
            }
          }
        }, c.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        };
        var B = 4096;

        function k(e, t, r) {
          var n = "";
          r = Math.min(e.length, r);

          for (var _o2 = t; _o2 < r; ++_o2) {
            n += String.fromCharCode(127 & e[_o2]);
          }

          return n;
        }

        function I(e, t, r) {
          var n = "";
          r = Math.min(e.length, r);

          for (var _o3 = t; _o3 < r; ++_o3) {
            n += String.fromCharCode(e[_o3]);
          }

          return n;
        }

        function U(e, t, r) {
          var n = e.length;
          (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
          var o = "";

          for (var _n6 = t; _n6 < r; ++_n6) {
            o += J[e[_n6]];
          }

          return o;
        }

        function C(e, t, r) {
          var n = e.slice(t, r);
          var o = "";

          for (var _e3 = 0; _e3 < n.length - 1; _e3 += 2) {
            o += String.fromCharCode(n[_e3] + 256 * n[_e3 + 1]);
          }

          return o;
        }

        function R(e, t, r) {
          if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
          if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
        }

        function O(e, t, r, n, o, s) {
          if (!c.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (t > o || t < s) throw new RangeError('"value" argument is out of bounds');
          if (r + n > e.length) throw new RangeError("Index out of range");
        }

        function D(e, t, r, n, o) {
          H(t, n, o, e, r, 7);
          var s = Number(t & BigInt(4294967295));
          e[r++] = s, s >>= 8, e[r++] = s, s >>= 8, e[r++] = s, s >>= 8, e[r++] = s;
          var i = Number(t >> BigInt(32) & BigInt(4294967295));
          return e[r++] = i, i >>= 8, e[r++] = i, i >>= 8, e[r++] = i, i >>= 8, e[r++] = i, r;
        }

        function N(e, t, r, n, o) {
          H(t, n, o, e, r, 7);
          var s = Number(t & BigInt(4294967295));
          e[r + 7] = s, s >>= 8, e[r + 6] = s, s >>= 8, e[r + 5] = s, s >>= 8, e[r + 4] = s;
          var i = Number(t >> BigInt(32) & BigInt(4294967295));
          return e[r + 3] = i, i >>= 8, e[r + 2] = i, i >>= 8, e[r + 1] = i, i >>= 8, e[r] = i, r + 8;
        }

        function P(e, t, r, n, o, s) {
          if (r + n > e.length) throw new RangeError("Index out of range");
          if (r < 0) throw new RangeError("Index out of range");
        }

        function L(e, t, r, n, s) {
          return t = +t, r >>>= 0, s || P(e, 0, r, 4), o.write(e, t, r, n, 23, 4), r + 4;
        }

        function F(e, t, r, n, s) {
          return t = +t, r >>>= 0, s || P(e, 0, r, 8), o.write(e, t, r, n, 52, 8), r + 8;
        }

        c.prototype.slice = function (e, t) {
          var r = this.length;
          (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
          var n = this.subarray(e, t);
          return Object.setPrototypeOf(n, c.prototype), n;
        }, c.prototype.readUintLE = c.prototype.readUIntLE = function (e, t, r) {
          e >>>= 0, t >>>= 0, r || R(e, t, this.length);
          var n = this[e],
              o = 1,
              s = 0;

          for (; ++s < t && (o *= 256);) {
            n += this[e + s] * o;
          }

          return n;
        }, c.prototype.readUintBE = c.prototype.readUIntBE = function (e, t, r) {
          e >>>= 0, t >>>= 0, r || R(e, t, this.length);
          var n = this[e + --t],
              o = 1;

          for (; t > 0 && (o *= 256);) {
            n += this[e + --t] * o;
          }

          return n;
        }, c.prototype.readUint8 = c.prototype.readUInt8 = function (e, t) {
          return e >>>= 0, t || R(e, 1, this.length), this[e];
        }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function (e, t) {
          return e >>>= 0, t || R(e, 2, this.length), this[e] | this[e + 1] << 8;
        }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function (e, t) {
          return e >>>= 0, t || R(e, 2, this.length), this[e] << 8 | this[e + 1];
        }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function (e, t) {
          return e >>>= 0, t || R(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
        }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function (e, t) {
          return e >>>= 0, t || R(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
        }, c.prototype.readBigUInt64LE = Q(function (e) {
          G(e >>>= 0, "offset");
          var t = this[e],
              r = this[e + 7];
          void 0 !== t && void 0 !== r || K(e, this.length - 8);
          var n = t + 256 * this[++e] + 65536 * this[++e] + this[++e] * Math.pow(2, 24),
              o = this[++e] + 256 * this[++e] + 65536 * this[++e] + r * Math.pow(2, 24);
          return BigInt(n) + (BigInt(o) << BigInt(32));
        }), c.prototype.readBigUInt64BE = Q(function (e) {
          G(e >>>= 0, "offset");
          var t = this[e],
              r = this[e + 7];
          void 0 !== t && void 0 !== r || K(e, this.length - 8);
          var n = t * Math.pow(2, 24) + 65536 * this[++e] + 256 * this[++e] + this[++e],
              o = this[++e] * Math.pow(2, 24) + 65536 * this[++e] + 256 * this[++e] + r;
          return (BigInt(n) << BigInt(32)) + BigInt(o);
        }), c.prototype.readIntLE = function (e, t, r) {
          e >>>= 0, t >>>= 0, r || R(e, t, this.length);
          var n = this[e],
              o = 1,
              s = 0;

          for (; ++s < t && (o *= 256);) {
            n += this[e + s] * o;
          }

          return o *= 128, n >= o && (n -= Math.pow(2, 8 * t)), n;
        }, c.prototype.readIntBE = function (e, t, r) {
          e >>>= 0, t >>>= 0, r || R(e, t, this.length);
          var n = t,
              o = 1,
              s = this[e + --n];

          for (; n > 0 && (o *= 256);) {
            s += this[e + --n] * o;
          }

          return o *= 128, s >= o && (s -= Math.pow(2, 8 * t)), s;
        }, c.prototype.readInt8 = function (e, t) {
          return e >>>= 0, t || R(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
        }, c.prototype.readInt16LE = function (e, t) {
          e >>>= 0, t || R(e, 2, this.length);
          var r = this[e] | this[e + 1] << 8;
          return 32768 & r ? 4294901760 | r : r;
        }, c.prototype.readInt16BE = function (e, t) {
          e >>>= 0, t || R(e, 2, this.length);
          var r = this[e + 1] | this[e] << 8;
          return 32768 & r ? 4294901760 | r : r;
        }, c.prototype.readInt32LE = function (e, t) {
          return e >>>= 0, t || R(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
        }, c.prototype.readInt32BE = function (e, t) {
          return e >>>= 0, t || R(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
        }, c.prototype.readBigInt64LE = Q(function (e) {
          G(e >>>= 0, "offset");
          var t = this[e],
              r = this[e + 7];
          void 0 !== t && void 0 !== r || K(e, this.length - 8);
          var n = this[e + 4] + 256 * this[e + 5] + 65536 * this[e + 6] + (r << 24);
          return (BigInt(n) << BigInt(32)) + BigInt(t + 256 * this[++e] + 65536 * this[++e] + this[++e] * Math.pow(2, 24));
        }), c.prototype.readBigInt64BE = Q(function (e) {
          G(e >>>= 0, "offset");
          var t = this[e],
              r = this[e + 7];
          void 0 !== t && void 0 !== r || K(e, this.length - 8);
          var n = (t << 24) + 65536 * this[++e] + 256 * this[++e] + this[++e];
          return (BigInt(n) << BigInt(32)) + BigInt(this[++e] * Math.pow(2, 24) + 65536 * this[++e] + 256 * this[++e] + r);
        }), c.prototype.readFloatLE = function (e, t) {
          return e >>>= 0, t || R(e, 4, this.length), o.read(this, e, !0, 23, 4);
        }, c.prototype.readFloatBE = function (e, t) {
          return e >>>= 0, t || R(e, 4, this.length), o.read(this, e, !1, 23, 4);
        }, c.prototype.readDoubleLE = function (e, t) {
          return e >>>= 0, t || R(e, 8, this.length), o.read(this, e, !0, 52, 8);
        }, c.prototype.readDoubleBE = function (e, t) {
          return e >>>= 0, t || R(e, 8, this.length), o.read(this, e, !1, 52, 8);
        }, c.prototype.writeUintLE = c.prototype.writeUIntLE = function (e, t, r, n) {
          e = +e, t >>>= 0, r >>>= 0, n || O(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
          var o = 1,
              s = 0;

          for (this[t] = 255 & e; ++s < r && (o *= 256);) {
            this[t + s] = e / o & 255;
          }

          return t + r;
        }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function (e, t, r, n) {
          e = +e, t >>>= 0, r >>>= 0, n || O(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
          var o = r - 1,
              s = 1;

          for (this[t + o] = 255 & e; --o >= 0 && (s *= 256);) {
            this[t + o] = e / s & 255;
          }

          return t + r;
        }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
        }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
        }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
        }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
        }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
        }, c.prototype.writeBigUInt64LE = Q(function (e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return D(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
        }), c.prototype.writeBigUInt64BE = Q(function (e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return N(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
        }), c.prototype.writeIntLE = function (e, t, r, n) {
          if (e = +e, t >>>= 0, !n) {
            var _n7 = Math.pow(2, 8 * r - 1);

            O(this, e, t, r, _n7 - 1, -_n7);
          }

          var o = 0,
              s = 1,
              i = 0;

          for (this[t] = 255 & e; ++o < r && (s *= 256);) {
            e < 0 && 0 === i && 0 !== this[t + o - 1] && (i = 1), this[t + o] = (e / s >> 0) - i & 255;
          }

          return t + r;
        }, c.prototype.writeIntBE = function (e, t, r, n) {
          if (e = +e, t >>>= 0, !n) {
            var _n8 = Math.pow(2, 8 * r - 1);

            O(this, e, t, r, _n8 - 1, -_n8);
          }

          var o = r - 1,
              s = 1,
              i = 0;

          for (this[t + o] = 255 & e; --o >= 0 && (s *= 256);) {
            e < 0 && 0 === i && 0 !== this[t + o + 1] && (i = 1), this[t + o] = (e / s >> 0) - i & 255;
          }

          return t + r;
        }, c.prototype.writeInt8 = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
        }, c.prototype.writeInt16LE = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
        }, c.prototype.writeInt16BE = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
        }, c.prototype.writeInt32LE = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
        }, c.prototype.writeInt32BE = function (e, t, r) {
          return e = +e, t >>>= 0, r || O(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
        }, c.prototype.writeBigInt64LE = Q(function (e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return D(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
        }), c.prototype.writeBigInt64BE = Q(function (e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return N(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
        }), c.prototype.writeFloatLE = function (e, t, r) {
          return L(this, e, t, !0, r);
        }, c.prototype.writeFloatBE = function (e, t, r) {
          return L(this, e, t, !1, r);
        }, c.prototype.writeDoubleLE = function (e, t, r) {
          return F(this, e, t, !0, r);
        }, c.prototype.writeDoubleBE = function (e, t, r) {
          return F(this, e, t, !1, r);
        }, c.prototype.copy = function (e, t, r, n) {
          if (!c.isBuffer(e)) throw new TypeError("argument should be a Buffer");
          if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
          if (0 === e.length || 0 === this.length) return 0;
          if (t < 0) throw new RangeError("targetStart out of bounds");
          if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
          if (n < 0) throw new RangeError("sourceEnd out of bounds");
          n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
          var o = n - r;
          return this === e && "function" == typeof Uint8Array.prototype.copyWithin ? this.copyWithin(t, r, n) : Uint8Array.prototype.set.call(e, this.subarray(r, n), t), o;
        }, c.prototype.fill = function (e, t, r, n) {
          if ("string" == typeof e) {
            if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
            if ("string" == typeof n && !c.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);

            if (1 === e.length) {
              var _t9 = e.charCodeAt(0);

              ("utf8" === n && _t9 < 128 || "latin1" === n) && (e = _t9);
            }
          } else "number" == typeof e ? e &= 255 : "boolean" == typeof e && (e = Number(e));

          if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
          if (r <= t) return this;
          var o;
          if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < r; ++o) {
            this[o] = e;
          } else {
            var _s3 = c.isBuffer(e) ? e : c.from(e, n),
                _i3 = _s3.length;

            if (0 === _i3) throw new TypeError('The value "' + e + '" is invalid for argument "value"');

            for (o = 0; o < r - t; ++o) {
              this[o + t] = _s3[o % _i3];
            }
          }
          return this;
        };
        var j = {};

        function z(e, t, r) {
          j[e] = /*#__PURE__*/function (_r5) {
            _inherits(_class, _r5);

            var _super = _createSuper(_class);

            function _class() {
              var _this;

              _classCallCheck(this, _class);

              _this = _super.call(this), Object.defineProperty(_assertThisInitialized(_this), "message", {
                value: t.apply(_assertThisInitialized(_this), arguments),
                writable: !0,
                configurable: !0
              }), _this.name = "".concat(_this.name, " [").concat(e, "]"), _this.stack, delete _this.name;
              return _this;
            }

            _createClass(_class, [{
              key: "code",
              get: function get() {
                return e;
              },
              set: function set(e) {
                Object.defineProperty(this, "code", {
                  configurable: !0,
                  enumerable: !0,
                  value: e,
                  writable: !0
                });
              }
            }, {
              key: "toString",
              value: function toString() {
                return "".concat(this.name, " [").concat(e, "]: ").concat(this.message);
              }
            }]);

            return _class;
          }(r);
        }

        function M(e) {
          var t = "",
              r = e.length;
          var n = "-" === e[0] ? 1 : 0;

          for (; r >= n + 4; r -= 3) {
            t = "_".concat(e.slice(r - 3, r)).concat(t);
          }

          return "".concat(e.slice(0, r)).concat(t);
        }

        function H(e, t, r, n, o, s) {
          if (e > r || e < t) {
            var _n9 = "bigint" == typeof t ? "n" : "";

            var _o4;

            throw _o4 = s > 3 ? 0 === t || t === BigInt(0) ? ">= 0".concat(_n9, " and < 2").concat(_n9, " ** ").concat(8 * (s + 1)).concat(_n9) : ">= -(2".concat(_n9, " ** ").concat(8 * (s + 1) - 1).concat(_n9, ") and < 2 ** ").concat(8 * (s + 1) - 1).concat(_n9) : ">= ".concat(t).concat(_n9, " and <= ").concat(r).concat(_n9), new j.ERR_OUT_OF_RANGE("value", _o4, e);
          }

          !function (e, t, r) {
            G(t, "offset"), void 0 !== e[t] && void 0 !== e[t + r] || K(t, e.length - (r + 1));
          }(n, o, s);
        }

        function G(e, t) {
          if ("number" != typeof e) throw new j.ERR_INVALID_ARG_TYPE(t, "number", e);
        }

        function K(e, t, r) {
          if (Math.floor(e) !== e) throw G(e, r), new j.ERR_OUT_OF_RANGE(r || "offset", "an integer", e);
          if (t < 0) throw new j.ERR_BUFFER_OUT_OF_BOUNDS();
          throw new j.ERR_OUT_OF_RANGE(r || "offset", ">= ".concat(r ? 1 : 0, " and <= ").concat(t), e);
        }

        z("ERR_BUFFER_OUT_OF_BOUNDS", function (e) {
          return e ? "".concat(e, " is outside of buffer bounds") : "Attempt to access memory outside buffer bounds";
        }, RangeError), z("ERR_INVALID_ARG_TYPE", function (e, t) {
          return "The \"".concat(e, "\" argument must be of type number. Received type ").concat(typeof t);
        }, TypeError), z("ERR_OUT_OF_RANGE", function (e, t, r) {
          var n = "The value of \"".concat(e, "\" is out of range."),
              o = r;
          return Number.isInteger(r) && Math.abs(r) > Math.pow(2, 32) ? o = M(String(r)) : "bigint" == typeof r && (o = String(r), (r > Math.pow(BigInt(2), BigInt(32)) || r < -Math.pow(BigInt(2), BigInt(32))) && (o = M(o)), o += "n"), n += " It must be ".concat(t, ". Received ").concat(o), n;
        }, RangeError);
        var q = /[^+/0-9A-Za-z-_]/g;

        function $(e, t) {
          var r;
          t = t || 1 / 0;
          var n = e.length;
          var o = null;
          var s = [];

          for (var _i4 = 0; _i4 < n; ++_i4) {
            if (r = e.charCodeAt(_i4), r > 55295 && r < 57344) {
              if (!o) {
                if (r > 56319) {
                  (t -= 3) > -1 && s.push(239, 191, 189);
                  continue;
                }

                if (_i4 + 1 === n) {
                  (t -= 3) > -1 && s.push(239, 191, 189);
                  continue;
                }

                o = r;
                continue;
              }

              if (r < 56320) {
                (t -= 3) > -1 && s.push(239, 191, 189), o = r;
                continue;
              }

              r = 65536 + (o - 55296 << 10 | r - 56320);
            } else o && (t -= 3) > -1 && s.push(239, 191, 189);

            if (o = null, r < 128) {
              if ((t -= 1) < 0) break;
              s.push(r);
            } else if (r < 2048) {
              if ((t -= 2) < 0) break;
              s.push(r >> 6 | 192, 63 & r | 128);
            } else if (r < 65536) {
              if ((t -= 3) < 0) break;
              s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
            } else {
              if (!(r < 1114112)) throw new Error("Invalid code point");
              if ((t -= 4) < 0) break;
              s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
            }
          }

          return s;
        }

        function V(e) {
          return n.toByteArray(function (e) {
            if ((e = (e = e.split("=")[0]).trim().replace(q, "")).length < 2) return "";

            for (; e.length % 4 != 0;) {
              e += "=";
            }

            return e;
          }(e));
        }

        function W(e, t, r, n) {
          var o;

          for (o = 0; o < n && !(o + r >= t.length || o >= e.length); ++o) {
            t[o + r] = e[o];
          }

          return o;
        }

        function X(e, t) {
          return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
        }

        function Y(e) {
          return e != e;
        }

        var J = function () {
          var e = "0123456789abcdef",
              t = new Array(256);

          for (var _r6 = 0; _r6 < 16; ++_r6) {
            var _n10 = 16 * _r6;

            for (var _o5 = 0; _o5 < 16; ++_o5) {
              t[_n10 + _o5] = e[_r6] + e[_o5];
            }
          }

          return t;
        }();

        function Q(e) {
          return "undefined" == typeof BigInt ? Z : e;
        }

        function Z() {
          throw new Error("BigInt not supported");
        }
      },
      7615: function _(e, t, r) {
        "use strict";

        var n = r(1801),
            o = r(2550),
            s = o(n("String.prototype.indexOf"));

        e.exports = function (e, t) {
          var r = n(e, !!t);
          return "function" == typeof r && s(e, ".prototype.") > -1 ? o(r) : r;
        };
      },
      2550: function _(e, t, r) {
        "use strict";

        var n = r(1930),
            o = r(1801),
            s = o("%Function.prototype.apply%"),
            i = o("%Function.prototype.call%"),
            a = o("%Reflect.apply%", !0) || n.call(i, s),
            c = o("%Object.getOwnPropertyDescriptor%", !0),
            u = o("%Object.defineProperty%", !0),
            l = o("%Math.max%");
        if (u) try {
          u({}, "a", {
            value: 1
          });
        } catch (e) {
          u = null;
        }

        e.exports = function (e) {
          var t = a(n, i, arguments);

          if (c && u) {
            var r = c(t, "length");
            r.configurable && u(t, "length", {
              value: 1 + l(0, e.length - (arguments.length - 1))
            });
          }

          return t;
        };

        var h = function h() {
          return a(n, s, arguments);
        };

        u ? u(e.exports, "apply", {
          value: h
        }) : e.exports.apply = h;
      },
      1069: function _(e) {
        function t(e) {
          if (e) return function (e) {
            for (var r in t.prototype) {
              e[r] = t.prototype[r];
            }

            return e;
          }(e);
        }

        e.exports = t, t.prototype.on = t.prototype.addEventListener = function (e, t) {
          return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
        }, t.prototype.once = function (e, t) {
          function r() {
            this.off(e, r), t.apply(this, arguments);
          }

          return r.fn = t, this.on(e, r), this;
        }, t.prototype.off = t.prototype.removeListener = t.prototype.removeAllListeners = t.prototype.removeEventListener = function (e, t) {
          if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
          var r,
              n = this._callbacks["$" + e];
          if (!n) return this;
          if (1 == arguments.length) return delete this._callbacks["$" + e], this;

          for (var o = 0; o < n.length; o++) {
            if ((r = n[o]) === t || r.fn === t) {
              n.splice(o, 1);
              break;
            }
          }

          return 0 === n.length && delete this._callbacks["$" + e], this;
        }, t.prototype.emit = function (e) {
          this._callbacks = this._callbacks || {};

          for (var t = new Array(arguments.length - 1), r = this._callbacks["$" + e], n = 1; n < arguments.length; n++) {
            t[n - 1] = arguments[n];
          }

          if (r) {
            n = 0;

            for (var o = (r = r.slice(0)).length; n < o; ++n) {
              r[n].apply(this, t);
            }
          }

          return this;
        }, t.prototype.listeners = function (e) {
          return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
        }, t.prototype.hasListeners = function (e) {
          return !!this.listeners(e).length;
        };
      },
      5799: function _(e) {
        e.exports = n, n.default = n, n.stable = i, n.stableStringify = i;
        var t = [],
            r = [];

        function n(e, n, s) {
          var i;

          for (o(e, "", [], void 0), i = 0 === r.length ? JSON.stringify(e, n, s) : JSON.stringify(e, c(n), s); 0 !== t.length;) {
            var a = t.pop();
            4 === a.length ? Object.defineProperty(a[0], a[1], a[3]) : a[0][a[1]] = a[2];
          }

          return i;
        }

        function o(e, n, s, i) {
          var a;

          if ("object" == typeof e && null !== e) {
            for (a = 0; a < s.length; a++) {
              if (s[a] === e) {
                var c = Object.getOwnPropertyDescriptor(i, n);
                return void (void 0 !== c.get ? c.configurable ? (Object.defineProperty(i, n, {
                  value: "[Circular]"
                }), t.push([i, n, e, c])) : r.push([e, n]) : (i[n] = "[Circular]", t.push([i, n, e])));
              }
            }

            if (s.push(e), Array.isArray(e)) for (a = 0; a < e.length; a++) {
              o(e[a], a, s, e);
            } else {
              var u = Object.keys(e);

              for (a = 0; a < u.length; a++) {
                var l = u[a];
                o(e[l], l, s, e);
              }
            }
            s.pop();
          }
        }

        function s(e, t) {
          return e < t ? -1 : e > t ? 1 : 0;
        }

        function i(e, n, o) {
          var s,
              i = a(e, "", [], void 0) || e;

          for (s = 0 === r.length ? JSON.stringify(i, n, o) : JSON.stringify(i, c(n), o); 0 !== t.length;) {
            var u = t.pop();
            4 === u.length ? Object.defineProperty(u[0], u[1], u[3]) : u[0][u[1]] = u[2];
          }

          return s;
        }

        function a(e, n, o, i) {
          var c;

          if ("object" == typeof e && null !== e) {
            for (c = 0; c < o.length; c++) {
              if (o[c] === e) {
                var u = Object.getOwnPropertyDescriptor(i, n);
                return void (void 0 !== u.get ? u.configurable ? (Object.defineProperty(i, n, {
                  value: "[Circular]"
                }), t.push([i, n, e, u])) : r.push([e, n]) : (i[n] = "[Circular]", t.push([i, n, e])));
              }
            }

            if ("function" == typeof e.toJSON) return;
            if (o.push(e), Array.isArray(e)) for (c = 0; c < e.length; c++) {
              a(e[c], c, o, e);
            } else {
              var l = {},
                  h = Object.keys(e).sort(s);

              for (c = 0; c < h.length; c++) {
                var p = h[c];
                a(e[p], p, o, e), l[p] = e[p];
              }

              if (void 0 === i) return l;
              t.push([i, n, e]), i[n] = l;
            }
            o.pop();
          }
        }

        function c(e) {
          return e = void 0 !== e ? e : function (e, t) {
            return t;
          }, function (t, n) {
            if (r.length > 0) for (var o = 0; o < r.length; o++) {
              var s = r[o];

              if (s[1] === t && s[0] === n) {
                n = "[Circular]", r.splice(o, 1);
                break;
              }
            }
            return e.call(this, t, n);
          };
        }
      },
      9930: function _(e) {
        "use strict";

        var t = "Function.prototype.bind called on incompatible ",
            r = Array.prototype.slice,
            n = Object.prototype.toString,
            o = "[object Function]";

        e.exports = function (e) {
          var s = this;
          if ("function" != typeof s || n.call(s) !== o) throw new TypeError(t + s);

          for (var i, a = r.call(arguments, 1), c = function c() {
            if (this instanceof i) {
              var t = s.apply(this, a.concat(r.call(arguments)));
              return Object(t) === t ? t : this;
            }

            return s.apply(e, a.concat(r.call(arguments)));
          }, u = Math.max(0, s.length - a.length), l = [], h = 0; h < u; h++) {
            l.push("$" + h);
          }

          if (i = Function("binder", "return function (" + l.join(",") + "){ return binder.apply(this,arguments); }")(c), s.prototype) {
            var p = function p() {};

            p.prototype = s.prototype, i.prototype = new p(), p.prototype = null;
          }

          return i;
        };
      },
      1930: function _(e, t, r) {
        "use strict";

        var n = r(9930);
        e.exports = Function.prototype.bind || n;
      },
      1801: function _(e, t, r) {
        "use strict";

        var n,
            o = SyntaxError,
            s = Function,
            i = TypeError,
            a = function a(e) {
          try {
            return s('"use strict"; return (' + e + ").constructor;")();
          } catch (e) {}
        },
            c = Object.getOwnPropertyDescriptor;

        if (c) try {
          c({}, "");
        } catch (e) {
          c = null;
        }

        var u = function u() {
          throw new i();
        },
            l = c ? function () {
          try {
            return u;
          } catch (e) {
            try {
              return c(arguments, "callee").get;
            } catch (e) {
              return u;
            }
          }
        }() : u,
            h = r(9905)(),
            p = Object.getPrototypeOf || function (e) {
          return e.__proto__;
        },
            f = {},
            d = "undefined" == typeof Uint8Array ? n : p(Uint8Array),
            g = {
          "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
          "%Array%": Array,
          "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
          "%ArrayIteratorPrototype%": h ? p([][Symbol.iterator]()) : n,
          "%AsyncFromSyncIteratorPrototype%": n,
          "%AsyncFunction%": f,
          "%AsyncGenerator%": f,
          "%AsyncGeneratorFunction%": f,
          "%AsyncIteratorPrototype%": f,
          "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
          "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
          "%Boolean%": Boolean,
          "%DataView%": "undefined" == typeof DataView ? n : DataView,
          "%Date%": Date,
          "%decodeURI%": decodeURI,
          "%decodeURIComponent%": decodeURIComponent,
          "%encodeURI%": encodeURI,
          "%encodeURIComponent%": encodeURIComponent,
          "%Error%": Error,
          "%eval%": eval,
          "%EvalError%": EvalError,
          "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
          "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
          "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
          "%Function%": s,
          "%GeneratorFunction%": f,
          "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
          "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
          "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
          "%isFinite%": isFinite,
          "%isNaN%": isNaN,
          "%IteratorPrototype%": h ? p(p([][Symbol.iterator]())) : n,
          "%JSON%": "object" == typeof JSON ? JSON : n,
          "%Map%": "undefined" == typeof Map ? n : Map,
          "%MapIteratorPrototype%": "undefined" != typeof Map && h ? p(new Map()[Symbol.iterator]()) : n,
          "%Math%": Math,
          "%Number%": Number,
          "%Object%": Object,
          "%parseFloat%": parseFloat,
          "%parseInt%": parseInt,
          "%Promise%": "undefined" == typeof Promise ? n : Promise,
          "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
          "%RangeError%": RangeError,
          "%ReferenceError%": ReferenceError,
          "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
          "%RegExp%": RegExp,
          "%Set%": "undefined" == typeof Set ? n : Set,
          "%SetIteratorPrototype%": "undefined" != typeof Set && h ? p(new Set()[Symbol.iterator]()) : n,
          "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
          "%String%": String,
          "%StringIteratorPrototype%": h ? p(""[Symbol.iterator]()) : n,
          "%Symbol%": h ? Symbol : n,
          "%SyntaxError%": o,
          "%ThrowTypeError%": l,
          "%TypedArray%": d,
          "%TypeError%": i,
          "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
          "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
          "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
          "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
          "%URIError%": URIError,
          "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
          "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
          "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet
        },
            y = function e(t) {
          var r;
          if ("%AsyncFunction%" === t) r = a("async function () {}");else if ("%GeneratorFunction%" === t) r = a("function* () {}");else if ("%AsyncGeneratorFunction%" === t) r = a("async function* () {}");else if ("%AsyncGenerator%" === t) {
            var n = e("%AsyncGeneratorFunction%");
            n && (r = n.prototype);
          } else if ("%AsyncIteratorPrototype%" === t) {
            var o = e("%AsyncGenerator%");
            o && (r = p(o.prototype));
          }
          return g[t] = r, r;
        },
            m = {
          "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
          "%ArrayPrototype%": ["Array", "prototype"],
          "%ArrayProto_entries%": ["Array", "prototype", "entries"],
          "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
          "%ArrayProto_keys%": ["Array", "prototype", "keys"],
          "%ArrayProto_values%": ["Array", "prototype", "values"],
          "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
          "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
          "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
          "%BooleanPrototype%": ["Boolean", "prototype"],
          "%DataViewPrototype%": ["DataView", "prototype"],
          "%DatePrototype%": ["Date", "prototype"],
          "%ErrorPrototype%": ["Error", "prototype"],
          "%EvalErrorPrototype%": ["EvalError", "prototype"],
          "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
          "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
          "%FunctionPrototype%": ["Function", "prototype"],
          "%Generator%": ["GeneratorFunction", "prototype"],
          "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
          "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
          "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
          "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
          "%JSONParse%": ["JSON", "parse"],
          "%JSONStringify%": ["JSON", "stringify"],
          "%MapPrototype%": ["Map", "prototype"],
          "%NumberPrototype%": ["Number", "prototype"],
          "%ObjectPrototype%": ["Object", "prototype"],
          "%ObjProto_toString%": ["Object", "prototype", "toString"],
          "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
          "%PromisePrototype%": ["Promise", "prototype"],
          "%PromiseProto_then%": ["Promise", "prototype", "then"],
          "%Promise_all%": ["Promise", "all"],
          "%Promise_reject%": ["Promise", "reject"],
          "%Promise_resolve%": ["Promise", "resolve"],
          "%RangeErrorPrototype%": ["RangeError", "prototype"],
          "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
          "%RegExpPrototype%": ["RegExp", "prototype"],
          "%SetPrototype%": ["Set", "prototype"],
          "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
          "%StringPrototype%": ["String", "prototype"],
          "%SymbolPrototype%": ["Symbol", "prototype"],
          "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
          "%TypedArrayPrototype%": ["TypedArray", "prototype"],
          "%TypeErrorPrototype%": ["TypeError", "prototype"],
          "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
          "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
          "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
          "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
          "%URIErrorPrototype%": ["URIError", "prototype"],
          "%WeakMapPrototype%": ["WeakMap", "prototype"],
          "%WeakSetPrototype%": ["WeakSet", "prototype"]
        },
            b = r(1930),
            w = r(9284),
            A = b.call(Function.call, Array.prototype.concat),
            v = b.call(Function.apply, Array.prototype.splice),
            x = b.call(Function.call, String.prototype.replace),
            S = b.call(Function.call, String.prototype.slice),
            E = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
            T = /\\(\\)?/g,
            _ = function _(e) {
          var t = S(e, 0, 1),
              r = S(e, -1);
          if ("%" === t && "%" !== r) throw new o("invalid intrinsic syntax, expected closing `%`");
          if ("%" === r && "%" !== t) throw new o("invalid intrinsic syntax, expected opening `%`");
          var n = [];
          return x(e, E, function (e, t, r, o) {
            n[n.length] = r ? x(o, T, "$1") : t || e;
          }), n;
        },
            B = function B(e, t) {
          var r,
              n = e;

          if (w(m, n) && (n = "%" + (r = m[n])[0] + "%"), w(g, n)) {
            var s = g[n];
            if (s === f && (s = y(n)), void 0 === s && !t) throw new i("intrinsic " + e + " exists, but is not available. Please file an issue!");
            return {
              alias: r,
              name: n,
              value: s
            };
          }

          throw new o("intrinsic " + e + " does not exist!");
        };

        e.exports = function (e, t) {
          if ("string" != typeof e || 0 === e.length) throw new i("intrinsic name must be a non-empty string");
          if (arguments.length > 1 && "boolean" != typeof t) throw new i('"allowMissing" argument must be a boolean');

          var r = _(e),
              n = r.length > 0 ? r[0] : "",
              s = B("%" + n + "%", t),
              a = s.name,
              u = s.value,
              l = !1,
              h = s.alias;

          h && (n = h[0], v(r, A([0, 1], h)));

          for (var p = 1, f = !0; p < r.length; p += 1) {
            var d = r[p],
                y = S(d, 0, 1),
                m = S(d, -1);
            if (('"' === y || "'" === y || "`" === y || '"' === m || "'" === m || "`" === m) && y !== m) throw new o("property names with quotes must have matching quotes");
            if ("constructor" !== d && f || (l = !0), w(g, a = "%" + (n += "." + d) + "%")) u = g[a];else if (null != u) {
              if (!(d in u)) {
                if (!t) throw new i("base intrinsic for " + e + " exists, but the property is not available.");
                return;
              }

              if (c && p + 1 >= r.length) {
                var b = c(u, d);
                u = (f = !!b) && "get" in b && !("originalValue" in b.get) ? b.get : u[d];
              } else f = w(u, d), u = u[d];

              f && !l && (g[a] = u);
            }
          }

          return u;
        };
      },
      9905: function _(e, t, r) {
        "use strict";

        var n = "undefined" != typeof Symbol && Symbol,
            o = r(5682);

        e.exports = function () {
          return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && o();
        };
      },
      5682: function _(e) {
        "use strict";

        e.exports = function () {
          if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
          if ("symbol" == typeof Symbol.iterator) return !0;
          var e = {},
              t = Symbol("test"),
              r = Object(t);
          if ("string" == typeof t) return !1;
          if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
          if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;

          for (t in e[t] = 42, e) {
            return !1;
          }

          if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
          if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
          var n = Object.getOwnPropertySymbols(e);
          if (1 !== n.length || n[0] !== t) return !1;
          if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;

          if ("function" == typeof Object.getOwnPropertyDescriptor) {
            var o = Object.getOwnPropertyDescriptor(e, t);
            if (42 !== o.value || !0 !== o.enumerable) return !1;
          }

          return !0;
        };
      },
      9284: function _(e, t, r) {
        "use strict";

        var n = r(1930);
        e.exports = n.call(Function.call, Object.prototype.hasOwnProperty);
      },
      7267: function _(e, t, r) {
        var n;
        !function () {
          "use strict";

          var t = "object" == typeof window ? window : {};
          !t.HI_BASE32_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node && (t = r.g);

          var o = !t.HI_BASE32_NO_COMMON_JS && e.exports,
              s = r.amdO,
              i = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""),
              a = {
            A: 0,
            B: 1,
            C: 2,
            D: 3,
            E: 4,
            F: 5,
            G: 6,
            H: 7,
            I: 8,
            J: 9,
            K: 10,
            L: 11,
            M: 12,
            N: 13,
            O: 14,
            P: 15,
            Q: 16,
            R: 17,
            S: 18,
            T: 19,
            U: 20,
            V: 21,
            W: 22,
            X: 23,
            Y: 24,
            Z: 25,
            2: 26,
            3: 27,
            4: 28,
            5: 29,
            6: 30,
            7: 31
          },
              c = [0, 0, 0, 0, 0, 0, 0, 0],
              u = function u(e, t) {
            t.length > 10 && (t = "..." + t.substr(-10));
            var r = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + e + " bytes: " + t + " <-");
            throw r.position = e, r;
          },
              l = function l(e) {
            if ("" === e) return [];
            if (!/^[A-Z2-7=]+$/.test(e)) throw new Error("Invalid base32 characters");

            for (var t, r, n, o, s, i, c, u, l = [], h = 0, p = (e = e.replace(/=/g, "")).length, f = 0, d = p >> 3 << 3; f < d;) {
              t = a[e.charAt(f++)], r = a[e.charAt(f++)], n = a[e.charAt(f++)], o = a[e.charAt(f++)], s = a[e.charAt(f++)], i = a[e.charAt(f++)], c = a[e.charAt(f++)], u = a[e.charAt(f++)], l[h++] = 255 & (t << 3 | r >>> 2), l[h++] = 255 & (r << 6 | n << 1 | o >>> 4), l[h++] = 255 & (o << 4 | s >>> 1), l[h++] = 255 & (s << 7 | i << 2 | c >>> 3), l[h++] = 255 & (c << 5 | u);
            }

            var g = p - d;
            return 2 === g ? (t = a[e.charAt(f++)], r = a[e.charAt(f++)], l[h++] = 255 & (t << 3 | r >>> 2)) : 4 === g ? (t = a[e.charAt(f++)], r = a[e.charAt(f++)], n = a[e.charAt(f++)], o = a[e.charAt(f++)], l[h++] = 255 & (t << 3 | r >>> 2), l[h++] = 255 & (r << 6 | n << 1 | o >>> 4)) : 5 === g ? (t = a[e.charAt(f++)], r = a[e.charAt(f++)], n = a[e.charAt(f++)], o = a[e.charAt(f++)], s = a[e.charAt(f++)], l[h++] = 255 & (t << 3 | r >>> 2), l[h++] = 255 & (r << 6 | n << 1 | o >>> 4), l[h++] = 255 & (o << 4 | s >>> 1)) : 7 === g && (t = a[e.charAt(f++)], r = a[e.charAt(f++)], n = a[e.charAt(f++)], o = a[e.charAt(f++)], s = a[e.charAt(f++)], i = a[e.charAt(f++)], c = a[e.charAt(f++)], l[h++] = 255 & (t << 3 | r >>> 2), l[h++] = 255 & (r << 6 | n << 1 | o >>> 4), l[h++] = 255 & (o << 4 | s >>> 1), l[h++] = 255 & (s << 7 | i << 2 | c >>> 3)), l;
          },
              h = function h(e, t) {
            if (!t) return function (e) {
              for (var t, r, n = "", o = e.length, s = 0, i = 0; s < o;) {
                if ((t = e[s++]) <= 127) n += String.fromCharCode(t);else {
                  t > 191 && t <= 223 ? (r = 31 & t, i = 1) : t <= 239 ? (r = 15 & t, i = 2) : t <= 247 ? (r = 7 & t, i = 3) : u(s, n);

                  for (var a = 0; a < i; ++a) {
                    ((t = e[s++]) < 128 || t > 191) && u(s, n), r <<= 6, r += 63 & t;
                  }

                  r >= 55296 && r <= 57343 && u(s, n), r > 1114111 && u(s, n), r <= 65535 ? n += String.fromCharCode(r) : (r -= 65536, n += String.fromCharCode(55296 + (r >> 10)), n += String.fromCharCode(56320 + (1023 & r)));
                }
              }

              return n;
            }(l(e));
            if ("" === e) return "";
            if (!/^[A-Z2-7=]+$/.test(e)) throw new Error("Invalid base32 characters");
            var r,
                n,
                o,
                s,
                i,
                c,
                h,
                p,
                f = "",
                d = e.indexOf("=");
            -1 === d && (d = e.length);

            for (var g = 0, y = d >> 3 << 3; g < y;) {
              r = a[e.charAt(g++)], n = a[e.charAt(g++)], o = a[e.charAt(g++)], s = a[e.charAt(g++)], i = a[e.charAt(g++)], c = a[e.charAt(g++)], h = a[e.charAt(g++)], p = a[e.charAt(g++)], f += String.fromCharCode(255 & (r << 3 | n >>> 2)) + String.fromCharCode(255 & (n << 6 | o << 1 | s >>> 4)) + String.fromCharCode(255 & (s << 4 | i >>> 1)) + String.fromCharCode(255 & (i << 7 | c << 2 | h >>> 3)) + String.fromCharCode(255 & (h << 5 | p));
            }

            var m = d - y;
            return 2 === m ? (r = a[e.charAt(g++)], n = a[e.charAt(g++)], f += String.fromCharCode(255 & (r << 3 | n >>> 2))) : 4 === m ? (r = a[e.charAt(g++)], n = a[e.charAt(g++)], o = a[e.charAt(g++)], s = a[e.charAt(g++)], f += String.fromCharCode(255 & (r << 3 | n >>> 2)) + String.fromCharCode(255 & (n << 6 | o << 1 | s >>> 4))) : 5 === m ? (r = a[e.charAt(g++)], n = a[e.charAt(g++)], o = a[e.charAt(g++)], s = a[e.charAt(g++)], i = a[e.charAt(g++)], f += String.fromCharCode(255 & (r << 3 | n >>> 2)) + String.fromCharCode(255 & (n << 6 | o << 1 | s >>> 4)) + String.fromCharCode(255 & (s << 4 | i >>> 1))) : 7 === m && (r = a[e.charAt(g++)], n = a[e.charAt(g++)], o = a[e.charAt(g++)], s = a[e.charAt(g++)], i = a[e.charAt(g++)], c = a[e.charAt(g++)], h = a[e.charAt(g++)], f += String.fromCharCode(255 & (r << 3 | n >>> 2)) + String.fromCharCode(255 & (n << 6 | o << 1 | s >>> 4)) + String.fromCharCode(255 & (s << 4 | i >>> 1)) + String.fromCharCode(255 & (i << 7 | c << 2 | h >>> 3))), f;
          },
              p = {
            encode: function encode(e, t) {
              var r = "string" != typeof e;
              return r && e.constructor === ArrayBuffer && (e = new Uint8Array(e)), r ? function (e) {
                for (var t, r, n, o, s, a = "", c = e.length, u = 0, l = 5 * parseInt(c / 5); u < l;) {
                  t = e[u++], r = e[u++], n = e[u++], o = e[u++], s = e[u++], a += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[31 & (n << 1 | o >>> 7)] + i[o >>> 2 & 31] + i[31 & (o << 3 | s >>> 5)] + i[31 & s];
                }

                var h = c - l;
                return 1 === h ? (t = e[u], a += i[t >>> 3] + i[t << 2 & 31] + "======") : 2 === h ? (t = e[u++], r = e[u], a += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[r << 4 & 31] + "====") : 3 === h ? (t = e[u++], r = e[u++], n = e[u], a += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[n << 1 & 31] + "===") : 4 === h && (t = e[u++], r = e[u++], n = e[u++], o = e[u], a += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[31 & (n << 1 | o >>> 7)] + i[o >>> 2 & 31] + i[o << 3 & 31] + "="), a;
              }(e) : t ? function (e) {
                for (var t, r, n, o, s, a = "", c = e.length, u = 0, l = 5 * parseInt(c / 5); u < l;) {
                  t = e.charCodeAt(u++), r = e.charCodeAt(u++), n = e.charCodeAt(u++), o = e.charCodeAt(u++), s = e.charCodeAt(u++), a += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[31 & (n << 1 | o >>> 7)] + i[o >>> 2 & 31] + i[31 & (o << 3 | s >>> 5)] + i[31 & s];
                }

                var h = c - l;
                return 1 === h ? (t = e.charCodeAt(u), a += i[t >>> 3] + i[t << 2 & 31] + "======") : 2 === h ? (t = e.charCodeAt(u++), r = e.charCodeAt(u), a += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[r << 4 & 31] + "====") : 3 === h ? (t = e.charCodeAt(u++), r = e.charCodeAt(u++), n = e.charCodeAt(u), a += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[n << 1 & 31] + "===") : 4 === h && (t = e.charCodeAt(u++), r = e.charCodeAt(u++), n = e.charCodeAt(u++), o = e.charCodeAt(u), a += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[31 & (n << 1 | o >>> 7)] + i[o >>> 2 & 31] + i[o << 3 & 31] + "="), a;
              }(e) : function (e) {
                var t,
                    r,
                    n,
                    o,
                    s,
                    a,
                    u,
                    l = !1,
                    h = "",
                    p = 0,
                    f = 0,
                    d = e.length;
                if ("" === e) return h;

                do {
                  for (c[0] = c[5], c[1] = c[6], c[2] = c[7], u = f; p < d && u < 5; ++p) {
                    (a = e.charCodeAt(p)) < 128 ? c[u++] = a : a < 2048 ? (c[u++] = 192 | a >> 6, c[u++] = 128 | 63 & a) : a < 55296 || a >= 57344 ? (c[u++] = 224 | a >> 12, c[u++] = 128 | a >> 6 & 63, c[u++] = 128 | 63 & a) : (a = 65536 + ((1023 & a) << 10 | 1023 & e.charCodeAt(++p)), c[u++] = 240 | a >> 18, c[u++] = 128 | a >> 12 & 63, c[u++] = 128 | a >> 6 & 63, c[u++] = 128 | 63 & a);
                  }

                  f = u - 5, p === d && ++p, p > d && u < 6 && (l = !0), t = c[0], u > 4 ? (r = c[1], n = c[2], o = c[3], s = c[4], h += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[31 & (n << 1 | o >>> 7)] + i[o >>> 2 & 31] + i[31 & (o << 3 | s >>> 5)] + i[31 & s]) : 1 === u ? h += i[t >>> 3] + i[t << 2 & 31] + "======" : 2 === u ? (r = c[1], h += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[r << 4 & 31] + "====") : 3 === u ? (r = c[1], n = c[2], h += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[n << 1 & 31] + "===") : (r = c[1], n = c[2], o = c[3], h += i[t >>> 3] + i[31 & (t << 2 | r >>> 6)] + i[r >>> 1 & 31] + i[31 & (r << 4 | n >>> 4)] + i[31 & (n << 1 | o >>> 7)] + i[o >>> 2 & 31] + i[o << 3 & 31] + "=");
                } while (!l);

                return h;
              }(e);
            },
            decode: h
          };

          h.asBytes = l, o ? e.exports = p : (t.base32 = p, s && (void 0 === (n = function () {
            return p;
          }.call(p, r, p, e)) || (e.exports = n)));
        }();
      },
      4525: function _(e, t) {
        t.read = function (e, t, r, n, o) {
          var s,
              i,
              a = 8 * o - n - 1,
              c = (1 << a) - 1,
              u = c >> 1,
              l = -7,
              h = r ? o - 1 : 0,
              p = r ? -1 : 1,
              f = e[t + h];

          for (h += p, s = f & (1 << -l) - 1, f >>= -l, l += a; l > 0; s = 256 * s + e[t + h], h += p, l -= 8) {
            ;
          }

          for (i = s & (1 << -l) - 1, s >>= -l, l += n; l > 0; i = 256 * i + e[t + h], h += p, l -= 8) {
            ;
          }

          if (0 === s) s = 1 - u;else {
            if (s === c) return i ? NaN : 1 / 0 * (f ? -1 : 1);
            i += Math.pow(2, n), s -= u;
          }
          return (f ? -1 : 1) * i * Math.pow(2, s - n);
        }, t.write = function (e, t, r, n, o, s) {
          var i,
              a,
              c,
              u = 8 * s - o - 1,
              l = (1 << u) - 1,
              h = l >> 1,
              p = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              f = n ? 0 : s - 1,
              d = n ? 1 : -1,
              g = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

          for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, i = l) : (i = Math.floor(Math.log(t) / Math.LN2), t * (c = Math.pow(2, -i)) < 1 && (i--, c *= 2), (t += i + h >= 1 ? p / c : p * Math.pow(2, 1 - h)) * c >= 2 && (i++, c /= 2), i + h >= l ? (a = 0, i = l) : i + h >= 1 ? (a = (t * c - 1) * Math.pow(2, o), i += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, o), i = 0)); o >= 8; e[r + f] = 255 & a, f += d, a /= 256, o -= 8) {
            ;
          }

          for (i = i << o | a, u += o; u > 0; e[r + f] = 255 & i, f += d, i /= 256, u -= 8) {
            ;
          }

          e[r + f - d] |= 128 * g;
        };
      },
      3477: function _(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_RESULT__;

        (function () {
          "use strict";

          var ERROR = "input is invalid type",
              WINDOW = "object" == typeof window,
              root = WINDOW ? window : {};
          root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
          var WEB_WORKER = !WINDOW && "object" == typeof self,
              NODE_JS = !root.JS_SHA256_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node;
          NODE_JS ? root = __webpack_require__.g : WEB_WORKER && (root = self);
          var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && module.exports,
              AMD = __webpack_require__.amdO,
              ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
              HEX_CHARS = "0123456789abcdef".split(""),
              EXTRA = [-2147483648, 8388608, 32768, 128],
              SHIFT = [24, 16, 8, 0],
              K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
              OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"],
              blocks = [];
          !root.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          }), !ARRAY_BUFFER || !root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
            return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
          });

          var createOutputMethod = function createOutputMethod(e, t) {
            return function (r) {
              return new Sha256(t, !0).update(r)[e]();
            };
          },
              createMethod = function createMethod(e) {
            var t = createOutputMethod("hex", e);
            NODE_JS && (t = nodeWrap(t, e)), t.create = function () {
              return new Sha256(e);
            }, t.update = function (e) {
              return t.create().update(e);
            };

            for (var r = 0; r < OUTPUT_TYPES.length; ++r) {
              var n = OUTPUT_TYPES[r];
              t[n] = createOutputMethod(n, e);
            }

            return t;
          },
              nodeWrap = function nodeWrap(method, is224) {
            var crypto = eval("require('crypto')"),
                Buffer = eval("require('buffer').Buffer"),
                algorithm = is224 ? "sha224" : "sha256",
                nodeMethod = function nodeMethod(e) {
              if ("string" == typeof e) return crypto.createHash(algorithm).update(e, "utf8").digest("hex");
              if (null == e) throw new Error(ERROR);
              return e.constructor === ArrayBuffer && (e = new Uint8Array(e)), Array.isArray(e) || ArrayBuffer.isView(e) || e.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(e)).digest("hex") : method(e);
            };

            return nodeMethod;
          },
              createHmacOutputMethod = function createHmacOutputMethod(e, t) {
            return function (r, n) {
              return new HmacSha256(r, t, !0).update(n)[e]();
            };
          },
              createHmacMethod = function createHmacMethod(e) {
            var t = createHmacOutputMethod("hex", e);
            t.create = function (t) {
              return new HmacSha256(t, e);
            }, t.update = function (e, r) {
              return t.create(e).update(r);
            };

            for (var r = 0; r < OUTPUT_TYPES.length; ++r) {
              var n = OUTPUT_TYPES[r];
              t[n] = createHmacOutputMethod(n, e);
            }

            return t;
          };

          function Sha256(e, t) {
            t ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], e ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = e;
          }

          function HmacSha256(e, t, r) {
            var n,
                o = typeof e;

            if ("string" === o) {
              var s,
                  i = [],
                  a = e.length,
                  c = 0;

              for (n = 0; n < a; ++n) {
                (s = e.charCodeAt(n)) < 128 ? i[c++] = s : s < 2048 ? (i[c++] = 192 | s >> 6, i[c++] = 128 | 63 & s) : s < 55296 || s >= 57344 ? (i[c++] = 224 | s >> 12, i[c++] = 128 | s >> 6 & 63, i[c++] = 128 | 63 & s) : (s = 65536 + ((1023 & s) << 10 | 1023 & e.charCodeAt(++n)), i[c++] = 240 | s >> 18, i[c++] = 128 | s >> 12 & 63, i[c++] = 128 | s >> 6 & 63, i[c++] = 128 | 63 & s);
              }

              e = i;
            } else {
              if ("object" !== o) throw new Error(ERROR);
              if (null === e) throw new Error(ERROR);
              if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
            }

            e.length > 64 && (e = new Sha256(t, !0).update(e).array());
            var u = [],
                l = [];

            for (n = 0; n < 64; ++n) {
              var h = e[n] || 0;
              u[n] = 92 ^ h, l[n] = 54 ^ h;
            }

            Sha256.call(this, t, r), this.update(l), this.oKeyPad = u, this.inner = !0, this.sharedMemory = r;
          }

          Sha256.prototype.update = function (e) {
            if (!this.finalized) {
              var t,
                  r = typeof e;

              if ("string" !== r) {
                if ("object" !== r) throw new Error(ERROR);
                if (null === e) throw new Error(ERROR);
                if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
                t = !0;
              }

              for (var n, o, s = 0, i = e.length, a = this.blocks; s < i;) {
                if (this.hashed && (this.hashed = !1, a[0] = this.block, a[16] = a[1] = a[2] = a[3] = a[4] = a[5] = a[6] = a[7] = a[8] = a[9] = a[10] = a[11] = a[12] = a[13] = a[14] = a[15] = 0), t) for (o = this.start; s < i && o < 64; ++s) {
                  a[o >> 2] |= e[s] << SHIFT[3 & o++];
                } else for (o = this.start; s < i && o < 64; ++s) {
                  (n = e.charCodeAt(s)) < 128 ? a[o >> 2] |= n << SHIFT[3 & o++] : n < 2048 ? (a[o >> 2] |= (192 | n >> 6) << SHIFT[3 & o++], a[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]) : n < 55296 || n >= 57344 ? (a[o >> 2] |= (224 | n >> 12) << SHIFT[3 & o++], a[o >> 2] |= (128 | n >> 6 & 63) << SHIFT[3 & o++], a[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++s)), a[o >> 2] |= (240 | n >> 18) << SHIFT[3 & o++], a[o >> 2] |= (128 | n >> 12 & 63) << SHIFT[3 & o++], a[o >> 2] |= (128 | n >> 6 & 63) << SHIFT[3 & o++], a[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]);
                }
                this.lastByteIndex = o, this.bytes += o - this.start, o >= 64 ? (this.block = a[16], this.start = o - 64, this.hash(), this.hashed = !0) : this.start = o;
              }

              return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
            }
          }, Sha256.prototype.finalize = function () {
            if (!this.finalized) {
              this.finalized = !0;
              var e = this.blocks,
                  t = this.lastByteIndex;
              e[16] = this.block, e[t >> 2] |= EXTRA[3 & t], this.block = e[16], t >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
            }
          }, Sha256.prototype.hash = function () {
            var e,
                t,
                r,
                n,
                o,
                s,
                i,
                a,
                c,
                u = this.h0,
                l = this.h1,
                h = this.h2,
                p = this.h3,
                f = this.h4,
                d = this.h5,
                g = this.h6,
                y = this.h7,
                m = this.blocks;

            for (e = 16; e < 64; ++e) {
              t = ((o = m[e - 15]) >>> 7 | o << 25) ^ (o >>> 18 | o << 14) ^ o >>> 3, r = ((o = m[e - 2]) >>> 17 | o << 15) ^ (o >>> 19 | o << 13) ^ o >>> 10, m[e] = m[e - 16] + t + m[e - 7] + r << 0;
            }

            for (c = l & h, e = 0; e < 64; e += 4) {
              this.first ? (this.is224 ? (s = 300032, y = (o = m[0] - 1413257819) - 150054599 << 0, p = o + 24177077 << 0) : (s = 704751109, y = (o = m[0] - 210244248) - 1521486534 << 0, p = o + 143694565 << 0), this.first = !1) : (t = (u >>> 2 | u << 30) ^ (u >>> 13 | u << 19) ^ (u >>> 22 | u << 10), n = (s = u & l) ^ u & h ^ c, y = p + (o = y + (r = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7)) + (f & d ^ ~f & g) + K[e] + m[e]) << 0, p = o + (t + n) << 0), t = (p >>> 2 | p << 30) ^ (p >>> 13 | p << 19) ^ (p >>> 22 | p << 10), n = (i = p & u) ^ p & l ^ s, g = h + (o = g + (r = (y >>> 6 | y << 26) ^ (y >>> 11 | y << 21) ^ (y >>> 25 | y << 7)) + (y & f ^ ~y & d) + K[e + 1] + m[e + 1]) << 0, t = ((h = o + (t + n) << 0) >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10), n = (a = h & p) ^ h & u ^ i, d = l + (o = d + (r = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7)) + (g & y ^ ~g & f) + K[e + 2] + m[e + 2]) << 0, t = ((l = o + (t + n) << 0) >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10), n = (c = l & h) ^ l & p ^ a, f = u + (o = f + (r = (d >>> 6 | d << 26) ^ (d >>> 11 | d << 21) ^ (d >>> 25 | d << 7)) + (d & g ^ ~d & y) + K[e + 3] + m[e + 3]) << 0, u = o + (t + n) << 0;
            }

            this.h0 = this.h0 + u << 0, this.h1 = this.h1 + l << 0, this.h2 = this.h2 + h << 0, this.h3 = this.h3 + p << 0, this.h4 = this.h4 + f << 0, this.h5 = this.h5 + d << 0, this.h6 = this.h6 + g << 0, this.h7 = this.h7 + y << 0;
          }, Sha256.prototype.hex = function () {
            this.finalize();
            var e = this.h0,
                t = this.h1,
                r = this.h2,
                n = this.h3,
                o = this.h4,
                s = this.h5,
                i = this.h6,
                a = this.h7,
                c = HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[15 & e] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[15 & t] + HEX_CHARS[r >> 28 & 15] + HEX_CHARS[r >> 24 & 15] + HEX_CHARS[r >> 20 & 15] + HEX_CHARS[r >> 16 & 15] + HEX_CHARS[r >> 12 & 15] + HEX_CHARS[r >> 8 & 15] + HEX_CHARS[r >> 4 & 15] + HEX_CHARS[15 & r] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[15 & n] + HEX_CHARS[o >> 28 & 15] + HEX_CHARS[o >> 24 & 15] + HEX_CHARS[o >> 20 & 15] + HEX_CHARS[o >> 16 & 15] + HEX_CHARS[o >> 12 & 15] + HEX_CHARS[o >> 8 & 15] + HEX_CHARS[o >> 4 & 15] + HEX_CHARS[15 & o] + HEX_CHARS[s >> 28 & 15] + HEX_CHARS[s >> 24 & 15] + HEX_CHARS[s >> 20 & 15] + HEX_CHARS[s >> 16 & 15] + HEX_CHARS[s >> 12 & 15] + HEX_CHARS[s >> 8 & 15] + HEX_CHARS[s >> 4 & 15] + HEX_CHARS[15 & s] + HEX_CHARS[i >> 28 & 15] + HEX_CHARS[i >> 24 & 15] + HEX_CHARS[i >> 20 & 15] + HEX_CHARS[i >> 16 & 15] + HEX_CHARS[i >> 12 & 15] + HEX_CHARS[i >> 8 & 15] + HEX_CHARS[i >> 4 & 15] + HEX_CHARS[15 & i];
            return this.is224 || (c += HEX_CHARS[a >> 28 & 15] + HEX_CHARS[a >> 24 & 15] + HEX_CHARS[a >> 20 & 15] + HEX_CHARS[a >> 16 & 15] + HEX_CHARS[a >> 12 & 15] + HEX_CHARS[a >> 8 & 15] + HEX_CHARS[a >> 4 & 15] + HEX_CHARS[15 & a]), c;
          }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function () {
            this.finalize();
            var e = this.h0,
                t = this.h1,
                r = this.h2,
                n = this.h3,
                o = this.h4,
                s = this.h5,
                i = this.h6,
                a = this.h7,
                c = [e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o, s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, 255 & i];
            return this.is224 || c.push(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a), c;
          }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function () {
            this.finalize();
            var e = new ArrayBuffer(this.is224 ? 28 : 32),
                t = new DataView(e);
            return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), t.setUint32(20, this.h5), t.setUint32(24, this.h6), this.is224 || t.setUint32(28, this.h7), e;
          }, HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function () {
            if (Sha256.prototype.finalize.call(this), this.inner) {
              this.inner = !1;
              var e = this.array();
              Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(e), Sha256.prototype.finalize.call(this);
            }
          };
          var exports = createMethod();
          exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224, AMD && (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return exports;
          }.call(exports, __webpack_require__, exports, module), void 0 === __WEBPACK_AMD_DEFINE_RESULT__ || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)));
        })();
      },
      583: function _(e, t, r) {
        var n;
        !function () {
          "use strict";

          var o = "input is invalid type",
              s = "object" == typeof window,
              i = s ? window : {};
          i.JS_SHA3_NO_WINDOW && (s = !1);
          var a = !s && "object" == typeof self;
          !i.JS_SHA3_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node ? i = r.g : a && (i = self);
          var c = !i.JS_SHA3_NO_COMMON_JS && e.exports,
              u = r.amdO,
              l = !i.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
              h = "0123456789abcdef".split(""),
              p = [4, 1024, 262144, 67108864],
              f = [0, 8, 16, 24],
              d = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
              g = [224, 256, 384, 512],
              y = [128, 256],
              m = ["hex", "buffer", "arrayBuffer", "array", "digest"],
              b = {
            128: 168,
            256: 136
          };
          !i.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          }), !l || !i.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
            return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
          });

          for (var w = function w(e, t, r) {
            return function (n) {
              return new D(e, t, e).update(n)[r]();
            };
          }, A = function A(e, t, r) {
            return function (n, o) {
              return new D(e, t, o).update(n)[r]();
            };
          }, v = function v(e, t, r) {
            return function (t, n, o, s) {
              return _["cshake" + e].update(t, n, o, s)[r]();
            };
          }, x = function x(e, t, r) {
            return function (t, n, o, s) {
              return _["kmac" + e].update(t, n, o, s)[r]();
            };
          }, S = function S(e, t, r, n) {
            for (var o = 0; o < m.length; ++o) {
              var s = m[o];
              e[s] = t(r, n, s);
            }

            return e;
          }, E = function E(e, t) {
            var r = w(e, t, "hex");
            return r.create = function () {
              return new D(e, t, e);
            }, r.update = function (e) {
              return r.create().update(e);
            }, S(r, w, e, t);
          }, T = [{
            name: "keccak",
            padding: [1, 256, 65536, 16777216],
            bits: g,
            createMethod: E
          }, {
            name: "sha3",
            padding: [6, 1536, 393216, 100663296],
            bits: g,
            createMethod: E
          }, {
            name: "shake",
            padding: [31, 7936, 2031616, 520093696],
            bits: y,
            createMethod: function createMethod(e, t) {
              var r = A(e, t, "hex");
              return r.create = function (r) {
                return new D(e, t, r);
              }, r.update = function (e, t) {
                return r.create(t).update(e);
              }, S(r, A, e, t);
            }
          }, {
            name: "cshake",
            padding: p,
            bits: y,
            createMethod: function createMethod(e, t) {
              var r = b[e],
                  n = v(e, 0, "hex");
              return n.create = function (n, o, s) {
                return o || s ? new D(e, t, n).bytepad([o, s], r) : _["shake" + e].create(n);
              }, n.update = function (e, t, r, o) {
                return n.create(t, r, o).update(e);
              }, S(n, v, e, t);
            }
          }, {
            name: "kmac",
            padding: p,
            bits: y,
            createMethod: function createMethod(e, t) {
              var r = b[e],
                  n = x(e, 0, "hex");
              return n.create = function (n, o, s) {
                return new N(e, t, o).bytepad(["KMAC", s], r).bytepad([n], r);
              }, n.update = function (e, t, r, o) {
                return n.create(e, r, o).update(t);
              }, S(n, x, e, t);
            }
          }], _ = {}, B = [], k = 0; k < T.length; ++k) {
            for (var I = T[k], U = I.bits, C = 0; C < U.length; ++C) {
              var R = I.name + "_" + U[C];

              if (B.push(R), _[R] = I.createMethod(U[C], I.padding), "sha3" !== I.name) {
                var O = I.name + U[C];
                B.push(O), _[O] = _[R];
              }
            }
          }

          function D(e, t, r) {
            this.blocks = [], this.s = [], this.padding = t, this.outputBits = r, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;

            for (var n = 0; n < 50; ++n) {
              this.s[n] = 0;
            }
          }

          function N(e, t, r) {
            D.call(this, e, t, r);
          }

          D.prototype.update = function (e) {
            if (this.finalized) throw new Error("finalize already called");
            var t,
                r = typeof e;

            if ("string" !== r) {
              if ("object" !== r) throw new Error(o);
              if (null === e) throw new Error(o);
              if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw new Error(o);
              t = !0;
            }

            for (var n, s, i = this.blocks, a = this.byteCount, c = e.length, u = this.blockCount, h = 0, p = this.s; h < c;) {
              if (this.reset) for (this.reset = !1, i[0] = this.block, n = 1; n < u + 1; ++n) {
                i[n] = 0;
              }
              if (t) for (n = this.start; h < c && n < a; ++h) {
                i[n >> 2] |= e[h] << f[3 & n++];
              } else for (n = this.start; h < c && n < a; ++h) {
                (s = e.charCodeAt(h)) < 128 ? i[n >> 2] |= s << f[3 & n++] : s < 2048 ? (i[n >> 2] |= (192 | s >> 6) << f[3 & n++], i[n >> 2] |= (128 | 63 & s) << f[3 & n++]) : s < 55296 || s >= 57344 ? (i[n >> 2] |= (224 | s >> 12) << f[3 & n++], i[n >> 2] |= (128 | s >> 6 & 63) << f[3 & n++], i[n >> 2] |= (128 | 63 & s) << f[3 & n++]) : (s = 65536 + ((1023 & s) << 10 | 1023 & e.charCodeAt(++h)), i[n >> 2] |= (240 | s >> 18) << f[3 & n++], i[n >> 2] |= (128 | s >> 12 & 63) << f[3 & n++], i[n >> 2] |= (128 | s >> 6 & 63) << f[3 & n++], i[n >> 2] |= (128 | 63 & s) << f[3 & n++]);
              }

              if (this.lastByteIndex = n, n >= a) {
                for (this.start = n - a, this.block = i[u], n = 0; n < u; ++n) {
                  p[n] ^= i[n];
                }

                P(p), this.reset = !0;
              } else this.start = n;
            }

            return this;
          }, D.prototype.encode = function (e, t) {
            var r = 255 & e,
                n = 1,
                o = [r];

            for (r = 255 & (e >>= 8); r > 0;) {
              o.unshift(r), r = 255 & (e >>= 8), ++n;
            }

            return t ? o.push(n) : o.unshift(n), this.update(o), o.length;
          }, D.prototype.encodeString = function (e) {
            var t,
                r = typeof e;

            if ("string" !== r) {
              if ("object" !== r) throw new Error(o);
              if (null === e) throw new Error(o);
              if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw new Error(o);
              t = !0;
            }

            var n = 0,
                s = e.length;
            if (t) n = s;else for (var i = 0; i < e.length; ++i) {
              var a = e.charCodeAt(i);
              a < 128 ? n += 1 : a < 2048 ? n += 2 : a < 55296 || a >= 57344 ? n += 3 : (a = 65536 + ((1023 & a) << 10 | 1023 & e.charCodeAt(++i)), n += 4);
            }
            return n += this.encode(8 * n), this.update(e), n;
          }, D.prototype.bytepad = function (e, t) {
            for (var r = this.encode(t), n = 0; n < e.length; ++n) {
              r += this.encodeString(e[n]);
            }

            var o = t - r % t,
                s = [];
            return s.length = o, this.update(s), this;
          }, D.prototype.finalize = function () {
            if (!this.finalized) {
              this.finalized = !0;
              var e = this.blocks,
                  t = this.lastByteIndex,
                  r = this.blockCount,
                  n = this.s;
              if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[r], t = 1; t < r + 1; ++t) {
                e[t] = 0;
              }

              for (e[r - 1] |= 2147483648, t = 0; t < r; ++t) {
                n[t] ^= e[t];
              }

              P(n);
            }
          }, D.prototype.toString = D.prototype.hex = function () {
            this.finalize();

            for (var e, t = this.blockCount, r = this.s, n = this.outputBlocks, o = this.extraBytes, s = 0, i = 0, a = ""; i < n;) {
              for (s = 0; s < t && i < n; ++s, ++i) {
                e = r[s], a += h[e >> 4 & 15] + h[15 & e] + h[e >> 12 & 15] + h[e >> 8 & 15] + h[e >> 20 & 15] + h[e >> 16 & 15] + h[e >> 28 & 15] + h[e >> 24 & 15];
              }

              i % t == 0 && (P(r), s = 0);
            }

            return o && (e = r[s], a += h[e >> 4 & 15] + h[15 & e], o > 1 && (a += h[e >> 12 & 15] + h[e >> 8 & 15]), o > 2 && (a += h[e >> 20 & 15] + h[e >> 16 & 15])), a;
          }, D.prototype.arrayBuffer = function () {
            this.finalize();
            var e,
                t = this.blockCount,
                r = this.s,
                n = this.outputBlocks,
                o = this.extraBytes,
                s = 0,
                i = 0,
                a = this.outputBits >> 3;
            e = o ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(a);

            for (var c = new Uint32Array(e); i < n;) {
              for (s = 0; s < t && i < n; ++s, ++i) {
                c[i] = r[s];
              }

              i % t == 0 && P(r);
            }

            return o && (c[s] = r[s], e = e.slice(0, a)), e;
          }, D.prototype.buffer = D.prototype.arrayBuffer, D.prototype.digest = D.prototype.array = function () {
            this.finalize();

            for (var e, t, r = this.blockCount, n = this.s, o = this.outputBlocks, s = this.extraBytes, i = 0, a = 0, c = []; a < o;) {
              for (i = 0; i < r && a < o; ++i, ++a) {
                e = a << 2, t = n[i], c[e] = 255 & t, c[e + 1] = t >> 8 & 255, c[e + 2] = t >> 16 & 255, c[e + 3] = t >> 24 & 255;
              }

              a % r == 0 && P(n);
            }

            return s && (e = a << 2, t = n[i], c[e] = 255 & t, s > 1 && (c[e + 1] = t >> 8 & 255), s > 2 && (c[e + 2] = t >> 16 & 255)), c;
          }, N.prototype = new D(), N.prototype.finalize = function () {
            return this.encode(this.outputBits, !0), D.prototype.finalize.call(this);
          };

          var P = function P(e) {
            var t, r, n, o, s, i, a, c, u, l, h, p, f, g, y, m, b, w, A, v, x, S, E, T, _, B, k, I, U, C, R, O, D, N, P, L, F, j, z, M, H, G, K, q, $, V, W, X, Y, J, Q, Z, ee, te, re, ne, oe, se, ie, ae, ce, ue, le;

            for (n = 0; n < 48; n += 2) {
              o = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], s = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], i = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], a = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], u = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], l = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], h = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (p = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (i << 1 | a >>> 31), r = (f = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (a << 1 | i >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = o ^ (c << 1 | u >>> 31), r = s ^ (u << 1 | c >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = i ^ (l << 1 | h >>> 31), r = a ^ (h << 1 | l >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = c ^ (p << 1 | f >>> 31), r = u ^ (f << 1 | p >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = l ^ (o << 1 | s >>> 31), r = h ^ (s << 1 | o >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, g = e[0], y = e[1], V = e[11] << 4 | e[10] >>> 28, W = e[10] << 4 | e[11] >>> 28, I = e[20] << 3 | e[21] >>> 29, U = e[21] << 3 | e[20] >>> 29, ae = e[31] << 9 | e[30] >>> 23, ce = e[30] << 9 | e[31] >>> 23, G = e[40] << 18 | e[41] >>> 14, K = e[41] << 18 | e[40] >>> 14, N = e[2] << 1 | e[3] >>> 31, P = e[3] << 1 | e[2] >>> 31, m = e[13] << 12 | e[12] >>> 20, b = e[12] << 12 | e[13] >>> 20, X = e[22] << 10 | e[23] >>> 22, Y = e[23] << 10 | e[22] >>> 22, C = e[33] << 13 | e[32] >>> 19, R = e[32] << 13 | e[33] >>> 19, ue = e[42] << 2 | e[43] >>> 30, le = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, L = e[14] << 6 | e[15] >>> 26, F = e[15] << 6 | e[14] >>> 26, w = e[25] << 11 | e[24] >>> 21, A = e[24] << 11 | e[25] >>> 21, J = e[34] << 15 | e[35] >>> 17, Q = e[35] << 15 | e[34] >>> 17, O = e[45] << 29 | e[44] >>> 3, D = e[44] << 29 | e[45] >>> 3, T = e[6] << 28 | e[7] >>> 4, _ = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, oe = e[16] << 23 | e[17] >>> 9, j = e[26] << 25 | e[27] >>> 7, z = e[27] << 25 | e[26] >>> 7, v = e[36] << 21 | e[37] >>> 11, x = e[37] << 21 | e[36] >>> 11, Z = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, q = e[8] << 27 | e[9] >>> 5, $ = e[9] << 27 | e[8] >>> 5, B = e[18] << 20 | e[19] >>> 12, k = e[19] << 20 | e[18] >>> 12, se = e[29] << 7 | e[28] >>> 25, ie = e[28] << 7 | e[29] >>> 25, M = e[38] << 8 | e[39] >>> 24, H = e[39] << 8 | e[38] >>> 24, S = e[48] << 14 | e[49] >>> 18, E = e[49] << 14 | e[48] >>> 18, e[0] = g ^ ~m & w, e[1] = y ^ ~b & A, e[10] = T ^ ~B & I, e[11] = _ ^ ~k & U, e[20] = N ^ ~L & j, e[21] = P ^ ~F & z, e[30] = q ^ ~V & X, e[31] = $ ^ ~W & Y, e[40] = te ^ ~ne & se, e[41] = re ^ ~oe & ie, e[2] = m ^ ~w & v, e[3] = b ^ ~A & x, e[12] = B ^ ~I & C, e[13] = k ^ ~U & R, e[22] = L ^ ~j & M, e[23] = F ^ ~z & H, e[32] = V ^ ~X & J, e[33] = W ^ ~Y & Q, e[42] = ne ^ ~se & ae, e[43] = oe ^ ~ie & ce, e[4] = w ^ ~v & S, e[5] = A ^ ~x & E, e[14] = I ^ ~C & O, e[15] = U ^ ~R & D, e[24] = j ^ ~M & G, e[25] = z ^ ~H & K, e[34] = X ^ ~J & Z, e[35] = Y ^ ~Q & ee, e[44] = se ^ ~ae & ue, e[45] = ie ^ ~ce & le, e[6] = v ^ ~S & g, e[7] = x ^ ~E & y, e[16] = C ^ ~O & T, e[17] = R ^ ~D & _, e[26] = M ^ ~G & N, e[27] = H ^ ~K & P, e[36] = J ^ ~Z & q, e[37] = Q ^ ~ee & $, e[46] = ae ^ ~ue & te, e[47] = ce ^ ~le & re, e[8] = S ^ ~g & m, e[9] = E ^ ~y & b, e[18] = O ^ ~T & B, e[19] = D ^ ~_ & k, e[28] = G ^ ~N & L, e[29] = K ^ ~P & F, e[38] = Z ^ ~q & V, e[39] = ee ^ ~$ & W, e[48] = ue ^ ~te & ne, e[49] = le ^ ~re & oe, e[0] ^= d[n], e[1] ^= d[n + 1];
            }
          };

          if (c) e.exports = _;else {
            for (k = 0; k < B.length; ++k) {
              i[B[k]] = _[B[k]];
            }

            u && (void 0 === (n = function () {
              return _;
            }.call(t, r, t, e)) || (e.exports = n));
          }
        }();
      },
      9757: function _(e, t, r) {
        var n;
        !function () {
          "use strict";

          var t = "input is invalid type",
              o = "object" == typeof window,
              s = o ? window : {};
          s.JS_SHA512_NO_WINDOW && (o = !1);
          var i = !o && "object" == typeof self;
          !s.JS_SHA512_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node ? s = r.g : i && (s = self);
          var a = !s.JS_SHA512_NO_COMMON_JS && e.exports,
              c = r.amdO,
              u = !s.JS_SHA512_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
              l = "0123456789abcdef".split(""),
              h = [-2147483648, 8388608, 32768, 128],
              p = [24, 16, 8, 0],
              f = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
              d = ["hex", "array", "digest", "arrayBuffer"],
              g = [];
          !s.JS_SHA512_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          }), !u || !s.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
            return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
          });

          var y = function y(e, t) {
            return function (r) {
              return new A(t, !0).update(r)[e]();
            };
          },
              m = function m(e) {
            var t = y("hex", e);
            t.create = function () {
              return new A(e);
            }, t.update = function (e) {
              return t.create().update(e);
            };

            for (var r = 0; r < d.length; ++r) {
              var n = d[r];
              t[n] = y(n, e);
            }

            return t;
          },
              b = function b(e, t) {
            return function (r, n) {
              return new v(r, t, !0).update(n)[e]();
            };
          },
              w = function w(e) {
            var t = b("hex", e);
            t.create = function (t) {
              return new v(t, e);
            }, t.update = function (e, r) {
              return t.create(e).update(r);
            };

            for (var r = 0; r < d.length; ++r) {
              var n = d[r];
              t[n] = b(n, e);
            }

            return t;
          };

          function A(e, t) {
            t ? (g[0] = g[1] = g[2] = g[3] = g[4] = g[5] = g[6] = g[7] = g[8] = g[9] = g[10] = g[11] = g[12] = g[13] = g[14] = g[15] = g[16] = g[17] = g[18] = g[19] = g[20] = g[21] = g[22] = g[23] = g[24] = g[25] = g[26] = g[27] = g[28] = g[29] = g[30] = g[31] = g[32] = 0, this.blocks = g) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], 384 == e ? (this.h0h = 3418070365, this.h0l = 3238371032, this.h1h = 1654270250, this.h1l = 914150663, this.h2h = 2438529370, this.h2l = 812702999, this.h3h = 355462360, this.h3l = 4144912697, this.h4h = 1731405415, this.h4l = 4290775857, this.h5h = 2394180231, this.h5l = 1750603025, this.h6h = 3675008525, this.h6l = 1694076839, this.h7h = 1203062813, this.h7l = 3204075428) : 256 == e ? (this.h0h = 573645204, this.h0l = 4230739756, this.h1h = 2673172387, this.h1l = 3360449730, this.h2h = 596883563, this.h2l = 1867755857, this.h3h = 2520282905, this.h3l = 1497426621, this.h4h = 2519219938, this.h4l = 2827943907, this.h5h = 3193839141, this.h5l = 1401305490, this.h6h = 721525244, this.h6l = 746961066, this.h7h = 246885852, this.h7l = 2177182882) : 224 == e ? (this.h0h = 2352822216, this.h0l = 424955298, this.h1h = 1944164710, this.h1l = 2312950998, this.h2h = 502970286, this.h2l = 855612546, this.h3h = 1738396948, this.h3l = 1479516111, this.h4h = 258812777, this.h4l = 2077511080, this.h5h = 2011393907, this.h5l = 79989058, this.h6h = 1067287976, this.h6l = 1780299464, this.h7h = 286451373, this.h7l = 2446758561) : (this.h0h = 1779033703, this.h0l = 4089235720, this.h1h = 3144134277, this.h1l = 2227873595, this.h2h = 1013904242, this.h2l = 4271175723, this.h3h = 2773480762, this.h3l = 1595750129, this.h4h = 1359893119, this.h4l = 2917565137, this.h5h = 2600822924, this.h5l = 725511199, this.h6h = 528734635, this.h6l = 4215389547, this.h7h = 1541459225, this.h7l = 327033209), this.bits = e, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1;
          }

          function v(e, r, n) {
            var o,
                s = typeof e;

            if ("string" !== s) {
              if ("object" !== s) throw new Error(t);
              if (null === e) throw new Error(t);
              if (u && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || u && ArrayBuffer.isView(e))) throw new Error(t);
              o = !0;
            }

            var i = e.length;

            if (!o) {
              for (var a, c = [], l = (i = e.length, 0), h = 0; h < i; ++h) {
                (a = e.charCodeAt(h)) < 128 ? c[l++] = a : a < 2048 ? (c[l++] = 192 | a >> 6, c[l++] = 128 | 63 & a) : a < 55296 || a >= 57344 ? (c[l++] = 224 | a >> 12, c[l++] = 128 | a >> 6 & 63, c[l++] = 128 | 63 & a) : (a = 65536 + ((1023 & a) << 10 | 1023 & e.charCodeAt(++h)), c[l++] = 240 | a >> 18, c[l++] = 128 | a >> 12 & 63, c[l++] = 128 | a >> 6 & 63, c[l++] = 128 | 63 & a);
              }

              e = c;
            }

            e.length > 128 && (e = new A(r, !0).update(e).array());
            var p = [],
                f = [];

            for (h = 0; h < 128; ++h) {
              var d = e[h] || 0;
              p[h] = 92 ^ d, f[h] = 54 ^ d;
            }

            A.call(this, r, n), this.update(f), this.oKeyPad = p, this.inner = !0, this.sharedMemory = n;
          }

          A.prototype.update = function (e) {
            if (this.finalized) throw new Error("finalize already called");
            var r,
                n = typeof e;

            if ("string" !== n) {
              if ("object" !== n) throw new Error(t);
              if (null === e) throw new Error(t);
              if (u && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || u && ArrayBuffer.isView(e))) throw new Error(t);
              r = !0;
            }

            for (var o, s, i = 0, a = e.length, c = this.blocks; i < a;) {
              if (this.hashed && (this.hashed = !1, c[0] = this.block, c[1] = c[2] = c[3] = c[4] = c[5] = c[6] = c[7] = c[8] = c[9] = c[10] = c[11] = c[12] = c[13] = c[14] = c[15] = c[16] = c[17] = c[18] = c[19] = c[20] = c[21] = c[22] = c[23] = c[24] = c[25] = c[26] = c[27] = c[28] = c[29] = c[30] = c[31] = c[32] = 0), r) for (s = this.start; i < a && s < 128; ++i) {
                c[s >> 2] |= e[i] << p[3 & s++];
              } else for (s = this.start; i < a && s < 128; ++i) {
                (o = e.charCodeAt(i)) < 128 ? c[s >> 2] |= o << p[3 & s++] : o < 2048 ? (c[s >> 2] |= (192 | o >> 6) << p[3 & s++], c[s >> 2] |= (128 | 63 & o) << p[3 & s++]) : o < 55296 || o >= 57344 ? (c[s >> 2] |= (224 | o >> 12) << p[3 & s++], c[s >> 2] |= (128 | o >> 6 & 63) << p[3 & s++], c[s >> 2] |= (128 | 63 & o) << p[3 & s++]) : (o = 65536 + ((1023 & o) << 10 | 1023 & e.charCodeAt(++i)), c[s >> 2] |= (240 | o >> 18) << p[3 & s++], c[s >> 2] |= (128 | o >> 12 & 63) << p[3 & s++], c[s >> 2] |= (128 | o >> 6 & 63) << p[3 & s++], c[s >> 2] |= (128 | 63 & o) << p[3 & s++]);
              }
              this.lastByteIndex = s, this.bytes += s - this.start, s >= 128 ? (this.block = c[32], this.start = s - 128, this.hash(), this.hashed = !0) : this.start = s;
            }

            return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
          }, A.prototype.finalize = function () {
            if (!this.finalized) {
              this.finalized = !0;
              var e = this.blocks,
                  t = this.lastByteIndex;
              e[32] = this.block, e[t >> 2] |= h[3 & t], this.block = e[32], t >= 112 && (this.hashed || this.hash(), e[0] = this.block, e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = e[16] = e[17] = e[18] = e[19] = e[20] = e[21] = e[22] = e[23] = e[24] = e[25] = e[26] = e[27] = e[28] = e[29] = e[30] = e[31] = e[32] = 0), e[30] = this.hBytes << 3 | this.bytes >>> 29, e[31] = this.bytes << 3, this.hash();
            }
          }, A.prototype.hash = function () {
            var e,
                t,
                r,
                n,
                o,
                s,
                i,
                a,
                c,
                u,
                l,
                h,
                p,
                d,
                g,
                y,
                m,
                b,
                w,
                A,
                v,
                x,
                S,
                E,
                T,
                _ = this.h0h,
                B = this.h0l,
                k = this.h1h,
                I = this.h1l,
                U = this.h2h,
                C = this.h2l,
                R = this.h3h,
                O = this.h3l,
                D = this.h4h,
                N = this.h4l,
                P = this.h5h,
                L = this.h5l,
                F = this.h6h,
                j = this.h6l,
                z = this.h7h,
                M = this.h7l,
                H = this.blocks;

            for (e = 32; e < 160; e += 2) {
              t = ((A = H[e - 30]) >>> 1 | (v = H[e - 29]) << 31) ^ (A >>> 8 | v << 24) ^ A >>> 7, r = (v >>> 1 | A << 31) ^ (v >>> 8 | A << 24) ^ (v >>> 7 | A << 25), n = ((A = H[e - 4]) >>> 19 | (v = H[e - 3]) << 13) ^ (v >>> 29 | A << 3) ^ A >>> 6, o = (v >>> 19 | A << 13) ^ (A >>> 29 | v << 3) ^ (v >>> 6 | A << 26), A = H[e - 32], v = H[e - 31], c = ((x = H[e - 14]) >>> 16) + (A >>> 16) + (t >>> 16) + (n >>> 16) + ((a = (65535 & x) + (65535 & A) + (65535 & t) + (65535 & n) + ((i = ((S = H[e - 13]) >>> 16) + (v >>> 16) + (r >>> 16) + (o >>> 16) + ((s = (65535 & S) + (65535 & v) + (65535 & r) + (65535 & o)) >>> 16)) >>> 16)) >>> 16), H[e] = c << 16 | 65535 & a, H[e + 1] = i << 16 | 65535 & s;
            }

            var G = _,
                K = B,
                q = k,
                $ = I,
                V = U,
                W = C,
                X = R,
                Y = O,
                J = D,
                Q = N,
                Z = P,
                ee = L,
                te = F,
                re = j,
                ne = z,
                oe = M;

            for (y = q & V, m = $ & W, e = 0; e < 160; e += 8) {
              t = (G >>> 28 | K << 4) ^ (K >>> 2 | G << 30) ^ (K >>> 7 | G << 25), r = (K >>> 28 | G << 4) ^ (G >>> 2 | K << 30) ^ (G >>> 7 | K << 25), n = (J >>> 14 | Q << 18) ^ (J >>> 18 | Q << 14) ^ (Q >>> 9 | J << 23), o = (Q >>> 14 | J << 18) ^ (Q >>> 18 | J << 14) ^ (J >>> 9 | Q << 23), b = (u = G & q) ^ G & V ^ y, w = (l = K & $) ^ K & W ^ m, E = J & Z ^ ~J & te, T = Q & ee ^ ~Q & re, A = H[e], v = H[e + 1], A = (c = ((x = f[e]) >>> 16) + (A >>> 16) + (E >>> 16) + (n >>> 16) + (ne >>> 16) + ((a = (65535 & x) + (65535 & A) + (65535 & E) + (65535 & n) + (65535 & ne) + ((i = ((S = f[e + 1]) >>> 16) + (v >>> 16) + (T >>> 16) + (o >>> 16) + (oe >>> 16) + ((s = (65535 & S) + (65535 & v) + (65535 & T) + (65535 & o) + (65535 & oe)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, v = i << 16 | 65535 & s, x = (c = (b >>> 16) + (t >>> 16) + ((a = (65535 & b) + (65535 & t) + ((i = (w >>> 16) + (r >>> 16) + ((s = (65535 & w) + (65535 & r)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, S = i << 16 | 65535 & s, ne = (c = (X >>> 16) + (A >>> 16) + ((a = (65535 & X) + (65535 & A) + ((i = (Y >>> 16) + (v >>> 16) + ((s = (65535 & Y) + (65535 & v)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, oe = i << 16 | 65535 & s, t = ((X = (c = (x >>> 16) + (A >>> 16) + ((a = (65535 & x) + (65535 & A) + ((i = (S >>> 16) + (v >>> 16) + ((s = (65535 & S) + (65535 & v)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a) >>> 28 | (Y = i << 16 | 65535 & s) << 4) ^ (Y >>> 2 | X << 30) ^ (Y >>> 7 | X << 25), r = (Y >>> 28 | X << 4) ^ (X >>> 2 | Y << 30) ^ (X >>> 7 | Y << 25), n = (ne >>> 14 | oe << 18) ^ (ne >>> 18 | oe << 14) ^ (oe >>> 9 | ne << 23), o = (oe >>> 14 | ne << 18) ^ (oe >>> 18 | ne << 14) ^ (ne >>> 9 | oe << 23), b = (h = X & G) ^ X & q ^ u, w = (p = Y & K) ^ Y & $ ^ l, E = ne & J ^ ~ne & Z, T = oe & Q ^ ~oe & ee, A = H[e + 2], v = H[e + 3], A = (c = ((x = f[e + 2]) >>> 16) + (A >>> 16) + (E >>> 16) + (n >>> 16) + (te >>> 16) + ((a = (65535 & x) + (65535 & A) + (65535 & E) + (65535 & n) + (65535 & te) + ((i = ((S = f[e + 3]) >>> 16) + (v >>> 16) + (T >>> 16) + (o >>> 16) + (re >>> 16) + ((s = (65535 & S) + (65535 & v) + (65535 & T) + (65535 & o) + (65535 & re)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, v = i << 16 | 65535 & s, x = (c = (b >>> 16) + (t >>> 16) + ((a = (65535 & b) + (65535 & t) + ((i = (w >>> 16) + (r >>> 16) + ((s = (65535 & w) + (65535 & r)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, S = i << 16 | 65535 & s, te = (c = (V >>> 16) + (A >>> 16) + ((a = (65535 & V) + (65535 & A) + ((i = (W >>> 16) + (v >>> 16) + ((s = (65535 & W) + (65535 & v)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, re = i << 16 | 65535 & s, t = ((V = (c = (x >>> 16) + (A >>> 16) + ((a = (65535 & x) + (65535 & A) + ((i = (S >>> 16) + (v >>> 16) + ((s = (65535 & S) + (65535 & v)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a) >>> 28 | (W = i << 16 | 65535 & s) << 4) ^ (W >>> 2 | V << 30) ^ (W >>> 7 | V << 25), r = (W >>> 28 | V << 4) ^ (V >>> 2 | W << 30) ^ (V >>> 7 | W << 25), n = (te >>> 14 | re << 18) ^ (te >>> 18 | re << 14) ^ (re >>> 9 | te << 23), o = (re >>> 14 | te << 18) ^ (re >>> 18 | te << 14) ^ (te >>> 9 | re << 23), b = (d = V & X) ^ V & G ^ h, w = (g = W & Y) ^ W & K ^ p, E = te & ne ^ ~te & J, T = re & oe ^ ~re & Q, A = H[e + 4], v = H[e + 5], A = (c = ((x = f[e + 4]) >>> 16) + (A >>> 16) + (E >>> 16) + (n >>> 16) + (Z >>> 16) + ((a = (65535 & x) + (65535 & A) + (65535 & E) + (65535 & n) + (65535 & Z) + ((i = ((S = f[e + 5]) >>> 16) + (v >>> 16) + (T >>> 16) + (o >>> 16) + (ee >>> 16) + ((s = (65535 & S) + (65535 & v) + (65535 & T) + (65535 & o) + (65535 & ee)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, v = i << 16 | 65535 & s, x = (c = (b >>> 16) + (t >>> 16) + ((a = (65535 & b) + (65535 & t) + ((i = (w >>> 16) + (r >>> 16) + ((s = (65535 & w) + (65535 & r)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, S = i << 16 | 65535 & s, Z = (c = (q >>> 16) + (A >>> 16) + ((a = (65535 & q) + (65535 & A) + ((i = ($ >>> 16) + (v >>> 16) + ((s = (65535 & $) + (65535 & v)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, ee = i << 16 | 65535 & s, t = ((q = (c = (x >>> 16) + (A >>> 16) + ((a = (65535 & x) + (65535 & A) + ((i = (S >>> 16) + (v >>> 16) + ((s = (65535 & S) + (65535 & v)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a) >>> 28 | ($ = i << 16 | 65535 & s) << 4) ^ ($ >>> 2 | q << 30) ^ ($ >>> 7 | q << 25), r = ($ >>> 28 | q << 4) ^ (q >>> 2 | $ << 30) ^ (q >>> 7 | $ << 25), n = (Z >>> 14 | ee << 18) ^ (Z >>> 18 | ee << 14) ^ (ee >>> 9 | Z << 23), o = (ee >>> 14 | Z << 18) ^ (ee >>> 18 | Z << 14) ^ (Z >>> 9 | ee << 23), b = (y = q & V) ^ q & X ^ d, w = (m = $ & W) ^ $ & Y ^ g, E = Z & te ^ ~Z & ne, T = ee & re ^ ~ee & oe, A = H[e + 6], v = H[e + 7], A = (c = ((x = f[e + 6]) >>> 16) + (A >>> 16) + (E >>> 16) + (n >>> 16) + (J >>> 16) + ((a = (65535 & x) + (65535 & A) + (65535 & E) + (65535 & n) + (65535 & J) + ((i = ((S = f[e + 7]) >>> 16) + (v >>> 16) + (T >>> 16) + (o >>> 16) + (Q >>> 16) + ((s = (65535 & S) + (65535 & v) + (65535 & T) + (65535 & o) + (65535 & Q)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, v = i << 16 | 65535 & s, x = (c = (b >>> 16) + (t >>> 16) + ((a = (65535 & b) + (65535 & t) + ((i = (w >>> 16) + (r >>> 16) + ((s = (65535 & w) + (65535 & r)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, S = i << 16 | 65535 & s, J = (c = (G >>> 16) + (A >>> 16) + ((a = (65535 & G) + (65535 & A) + ((i = (K >>> 16) + (v >>> 16) + ((s = (65535 & K) + (65535 & v)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, Q = i << 16 | 65535 & s, G = (c = (x >>> 16) + (A >>> 16) + ((a = (65535 & x) + (65535 & A) + ((i = (S >>> 16) + (v >>> 16) + ((s = (65535 & S) + (65535 & v)) >>> 16)) >>> 16)) >>> 16)) << 16 | 65535 & a, K = i << 16 | 65535 & s;
            }

            c = (_ >>> 16) + (G >>> 16) + ((a = (65535 & _) + (65535 & G) + ((i = (B >>> 16) + (K >>> 16) + ((s = (65535 & B) + (65535 & K)) >>> 16)) >>> 16)) >>> 16), this.h0h = c << 16 | 65535 & a, this.h0l = i << 16 | 65535 & s, c = (k >>> 16) + (q >>> 16) + ((a = (65535 & k) + (65535 & q) + ((i = (I >>> 16) + ($ >>> 16) + ((s = (65535 & I) + (65535 & $)) >>> 16)) >>> 16)) >>> 16), this.h1h = c << 16 | 65535 & a, this.h1l = i << 16 | 65535 & s, c = (U >>> 16) + (V >>> 16) + ((a = (65535 & U) + (65535 & V) + ((i = (C >>> 16) + (W >>> 16) + ((s = (65535 & C) + (65535 & W)) >>> 16)) >>> 16)) >>> 16), this.h2h = c << 16 | 65535 & a, this.h2l = i << 16 | 65535 & s, c = (R >>> 16) + (X >>> 16) + ((a = (65535 & R) + (65535 & X) + ((i = (O >>> 16) + (Y >>> 16) + ((s = (65535 & O) + (65535 & Y)) >>> 16)) >>> 16)) >>> 16), this.h3h = c << 16 | 65535 & a, this.h3l = i << 16 | 65535 & s, c = (D >>> 16) + (J >>> 16) + ((a = (65535 & D) + (65535 & J) + ((i = (N >>> 16) + (Q >>> 16) + ((s = (65535 & N) + (65535 & Q)) >>> 16)) >>> 16)) >>> 16), this.h4h = c << 16 | 65535 & a, this.h4l = i << 16 | 65535 & s, c = (P >>> 16) + (Z >>> 16) + ((a = (65535 & P) + (65535 & Z) + ((i = (L >>> 16) + (ee >>> 16) + ((s = (65535 & L) + (65535 & ee)) >>> 16)) >>> 16)) >>> 16), this.h5h = c << 16 | 65535 & a, this.h5l = i << 16 | 65535 & s, c = (F >>> 16) + (te >>> 16) + ((a = (65535 & F) + (65535 & te) + ((i = (j >>> 16) + (re >>> 16) + ((s = (65535 & j) + (65535 & re)) >>> 16)) >>> 16)) >>> 16), this.h6h = c << 16 | 65535 & a, this.h6l = i << 16 | 65535 & s, c = (z >>> 16) + (ne >>> 16) + ((a = (65535 & z) + (65535 & ne) + ((i = (M >>> 16) + (oe >>> 16) + ((s = (65535 & M) + (65535 & oe)) >>> 16)) >>> 16)) >>> 16), this.h7h = c << 16 | 65535 & a, this.h7l = i << 16 | 65535 & s;
          }, A.prototype.hex = function () {
            this.finalize();
            var e = this.h0h,
                t = this.h0l,
                r = this.h1h,
                n = this.h1l,
                o = this.h2h,
                s = this.h2l,
                i = this.h3h,
                a = this.h3l,
                c = this.h4h,
                u = this.h4l,
                h = this.h5h,
                p = this.h5l,
                f = this.h6h,
                d = this.h6l,
                g = this.h7h,
                y = this.h7l,
                m = this.bits,
                b = l[e >> 28 & 15] + l[e >> 24 & 15] + l[e >> 20 & 15] + l[e >> 16 & 15] + l[e >> 12 & 15] + l[e >> 8 & 15] + l[e >> 4 & 15] + l[15 & e] + l[t >> 28 & 15] + l[t >> 24 & 15] + l[t >> 20 & 15] + l[t >> 16 & 15] + l[t >> 12 & 15] + l[t >> 8 & 15] + l[t >> 4 & 15] + l[15 & t] + l[r >> 28 & 15] + l[r >> 24 & 15] + l[r >> 20 & 15] + l[r >> 16 & 15] + l[r >> 12 & 15] + l[r >> 8 & 15] + l[r >> 4 & 15] + l[15 & r] + l[n >> 28 & 15] + l[n >> 24 & 15] + l[n >> 20 & 15] + l[n >> 16 & 15] + l[n >> 12 & 15] + l[n >> 8 & 15] + l[n >> 4 & 15] + l[15 & n] + l[o >> 28 & 15] + l[o >> 24 & 15] + l[o >> 20 & 15] + l[o >> 16 & 15] + l[o >> 12 & 15] + l[o >> 8 & 15] + l[o >> 4 & 15] + l[15 & o] + l[s >> 28 & 15] + l[s >> 24 & 15] + l[s >> 20 & 15] + l[s >> 16 & 15] + l[s >> 12 & 15] + l[s >> 8 & 15] + l[s >> 4 & 15] + l[15 & s] + l[i >> 28 & 15] + l[i >> 24 & 15] + l[i >> 20 & 15] + l[i >> 16 & 15] + l[i >> 12 & 15] + l[i >> 8 & 15] + l[i >> 4 & 15] + l[15 & i];
            return m >= 256 && (b += l[a >> 28 & 15] + l[a >> 24 & 15] + l[a >> 20 & 15] + l[a >> 16 & 15] + l[a >> 12 & 15] + l[a >> 8 & 15] + l[a >> 4 & 15] + l[15 & a]), m >= 384 && (b += l[c >> 28 & 15] + l[c >> 24 & 15] + l[c >> 20 & 15] + l[c >> 16 & 15] + l[c >> 12 & 15] + l[c >> 8 & 15] + l[c >> 4 & 15] + l[15 & c] + l[u >> 28 & 15] + l[u >> 24 & 15] + l[u >> 20 & 15] + l[u >> 16 & 15] + l[u >> 12 & 15] + l[u >> 8 & 15] + l[u >> 4 & 15] + l[15 & u] + l[h >> 28 & 15] + l[h >> 24 & 15] + l[h >> 20 & 15] + l[h >> 16 & 15] + l[h >> 12 & 15] + l[h >> 8 & 15] + l[h >> 4 & 15] + l[15 & h] + l[p >> 28 & 15] + l[p >> 24 & 15] + l[p >> 20 & 15] + l[p >> 16 & 15] + l[p >> 12 & 15] + l[p >> 8 & 15] + l[p >> 4 & 15] + l[15 & p]), 512 == m && (b += l[f >> 28 & 15] + l[f >> 24 & 15] + l[f >> 20 & 15] + l[f >> 16 & 15] + l[f >> 12 & 15] + l[f >> 8 & 15] + l[f >> 4 & 15] + l[15 & f] + l[d >> 28 & 15] + l[d >> 24 & 15] + l[d >> 20 & 15] + l[d >> 16 & 15] + l[d >> 12 & 15] + l[d >> 8 & 15] + l[d >> 4 & 15] + l[15 & d] + l[g >> 28 & 15] + l[g >> 24 & 15] + l[g >> 20 & 15] + l[g >> 16 & 15] + l[g >> 12 & 15] + l[g >> 8 & 15] + l[g >> 4 & 15] + l[15 & g] + l[y >> 28 & 15] + l[y >> 24 & 15] + l[y >> 20 & 15] + l[y >> 16 & 15] + l[y >> 12 & 15] + l[y >> 8 & 15] + l[y >> 4 & 15] + l[15 & y]), b;
          }, A.prototype.toString = A.prototype.hex, A.prototype.digest = function () {
            this.finalize();
            var e = this.h0h,
                t = this.h0l,
                r = this.h1h,
                n = this.h1l,
                o = this.h2h,
                s = this.h2l,
                i = this.h3h,
                a = this.h3l,
                c = this.h4h,
                u = this.h4l,
                l = this.h5h,
                h = this.h5l,
                p = this.h6h,
                f = this.h6l,
                d = this.h7h,
                g = this.h7l,
                y = this.bits,
                m = [e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o, s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, 255 & i];
            return y >= 256 && m.push(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a), y >= 384 && m.push(c >> 24 & 255, c >> 16 & 255, c >> 8 & 255, 255 & c, u >> 24 & 255, u >> 16 & 255, u >> 8 & 255, 255 & u, l >> 24 & 255, l >> 16 & 255, l >> 8 & 255, 255 & l, h >> 24 & 255, h >> 16 & 255, h >> 8 & 255, 255 & h), 512 == y && m.push(p >> 24 & 255, p >> 16 & 255, p >> 8 & 255, 255 & p, f >> 24 & 255, f >> 16 & 255, f >> 8 & 255, 255 & f, d >> 24 & 255, d >> 16 & 255, d >> 8 & 255, 255 & d, g >> 24 & 255, g >> 16 & 255, g >> 8 & 255, 255 & g), m;
          }, A.prototype.array = A.prototype.digest, A.prototype.arrayBuffer = function () {
            this.finalize();
            var e = this.bits,
                t = new ArrayBuffer(e / 8),
                r = new DataView(t);
            return r.setUint32(0, this.h0h), r.setUint32(4, this.h0l), r.setUint32(8, this.h1h), r.setUint32(12, this.h1l), r.setUint32(16, this.h2h), r.setUint32(20, this.h2l), r.setUint32(24, this.h3h), e >= 256 && r.setUint32(28, this.h3l), e >= 384 && (r.setUint32(32, this.h4h), r.setUint32(36, this.h4l), r.setUint32(40, this.h5h), r.setUint32(44, this.h5l)), 512 == e && (r.setUint32(48, this.h6h), r.setUint32(52, this.h6l), r.setUint32(56, this.h7h), r.setUint32(60, this.h7l)), t;
          }, A.prototype.clone = function () {
            var e = new A(this.bits, !1);
            return this.copyTo(e), e;
          }, A.prototype.copyTo = function (e) {
            var t = 0,
                r = ["h0h", "h0l", "h1h", "h1l", "h2h", "h2l", "h3h", "h3l", "h4h", "h4l", "h5h", "h5l", "h6h", "h6l", "h7h", "h7l", "start", "bytes", "hBytes", "finalized", "hashed", "lastByteIndex"];

            for (t = 0; t < r.length; ++t) {
              e[r[t]] = this[r[t]];
            }

            for (t = 0; t < this.blocks.length; ++t) {
              e.blocks[t] = this.blocks[t];
            }
          }, v.prototype = new A(), v.prototype.finalize = function () {
            if (A.prototype.finalize.call(this), this.inner) {
              this.inner = !1;
              var e = this.array();
              A.call(this, this.bits, this.sharedMemory), this.update(this.oKeyPad), this.update(e), A.prototype.finalize.call(this);
            }
          }, v.prototype.clone = function () {
            var e = new v([], this.bits, !1);
            this.copyTo(e), e.inner = this.inner;

            for (var t = 0; t < this.oKeyPad.length; ++t) {
              e.oKeyPad[t] = this.oKeyPad[t];
            }

            return e;
          };
          var x = m(512);
          x.sha512 = x, x.sha384 = m(384), x.sha512_256 = m(256), x.sha512_224 = m(224), x.sha512.hmac = w(512), x.sha384.hmac = w(384), x.sha512_256.hmac = w(256), x.sha512_224.hmac = w(224), a ? e.exports = x : (s.sha512 = x.sha512, s.sha384 = x.sha384, s.sha512_256 = x.sha512_256, s.sha512_224 = x.sha512_224, c && (void 0 === (n = function () {
            return x;
          }.call(x, r, x, e)) || (e.exports = n)));
        }();
      },
      4360: function _(e, t, r) {
        var n = r(592).stringify,
            o = r(9385);
        e.exports = function (e) {
          return {
            parse: o(e),
            stringify: n
          };
        }, e.exports.parse = o(), e.exports.stringify = n;
      },
      9385: function _(e, t, r) {
        var n = null;
        var o = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/,
            s = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;

        e.exports = function (e) {
          "use strict";

          var t = {
            strict: !1,
            storeAsString: !1,
            alwaysParseAsBig: !1,
            useNativeBigInt: !1,
            protoAction: "error",
            constructorAction: "error"
          };

          if (null != e) {
            if (!0 === e.strict && (t.strict = !0), !0 === e.storeAsString && (t.storeAsString = !0), t.alwaysParseAsBig = !0 === e.alwaysParseAsBig && e.alwaysParseAsBig, t.useNativeBigInt = !0 === e.useNativeBigInt && e.useNativeBigInt, void 0 !== e.constructorAction) {
              if ("error" !== e.constructorAction && "ignore" !== e.constructorAction && "preserve" !== e.constructorAction) throw new Error("Incorrect value for constructorAction option, must be \"error\", \"ignore\" or undefined but passed ".concat(e.constructorAction));
              t.constructorAction = e.constructorAction;
            }

            if (void 0 !== e.protoAction) {
              if ("error" !== e.protoAction && "ignore" !== e.protoAction && "preserve" !== e.protoAction) throw new Error("Incorrect value for protoAction option, must be \"error\", \"ignore\" or undefined but passed ".concat(e.protoAction));
              t.protoAction = e.protoAction;
            }
          }

          var i,
              a,
              c,
              _u,
              l = {
            '"': '"',
            "\\": "\\",
            "/": "/",
            b: "\b",
            f: "\f",
            n: "\n",
            r: "\r",
            t: "\t"
          },
              h = function h(e) {
            throw {
              name: "SyntaxError",
              message: e,
              at: i,
              text: c
            };
          },
              p = function p(e) {
            return e && e !== a && h("Expected '" + e + "' instead of '" + a + "'"), a = c.charAt(i), i += 1, a;
          },
              f = function f() {
            var e,
                o = "";

            for ("-" === a && (o = "-", p("-")); a >= "0" && a <= "9";) {
              o += a, p();
            }

            if ("." === a) for (o += "."; p() && a >= "0" && a <= "9";) {
              o += a;
            }
            if ("e" === a || "E" === a) for (o += a, p(), "-" !== a && "+" !== a || (o += a, p()); a >= "0" && a <= "9";) {
              o += a, p();
            }
            if (e = +o, isFinite(e)) return null == n && (n = r(5117)), o.length > 15 ? t.storeAsString ? o : t.useNativeBigInt ? BigInt(o) : new n(o) : t.alwaysParseAsBig ? t.useNativeBigInt ? BigInt(e) : new n(e) : e;
            h("Bad number");
          },
              d = function d() {
            var e,
                t,
                r,
                n = "";
            if ('"' === a) for (var o = i; p();) {
              if ('"' === a) return i - 1 > o && (n += c.substring(o, i - 1)), p(), n;

              if ("\\" === a) {
                if (i - 1 > o && (n += c.substring(o, i - 1)), p(), "u" === a) {
                  for (r = 0, t = 0; t < 4 && (e = parseInt(p(), 16), isFinite(e)); t += 1) {
                    r = 16 * r + e;
                  }

                  n += String.fromCharCode(r);
                } else {
                  if ("string" != typeof l[a]) break;
                  n += l[a];
                }

                o = i;
              }
            }
            h("Bad string");
          },
              g = function g() {
            for (; a && a <= " ";) {
              p();
            }
          };

          return _u = function u() {
            switch (g(), a) {
              case "{":
                return function () {
                  var e,
                      r = Object.create(null);

                  if ("{" === a) {
                    if (p("{"), g(), "}" === a) return p("}"), r;

                    for (; a;) {
                      if (e = d(), g(), p(":"), !0 === t.strict && Object.hasOwnProperty.call(r, e) && h('Duplicate key "' + e + '"'), !0 === o.test(e) ? "error" === t.protoAction ? h("Object contains forbidden prototype property") : "ignore" === t.protoAction ? _u() : r[e] = _u() : !0 === s.test(e) ? "error" === t.constructorAction ? h("Object contains forbidden constructor property") : "ignore" === t.constructorAction ? _u() : r[e] = _u() : r[e] = _u(), g(), "}" === a) return p("}"), r;
                      p(","), g();
                    }
                  }

                  h("Bad object");
                }();

              case "[":
                return function () {
                  var e = [];

                  if ("[" === a) {
                    if (p("["), g(), "]" === a) return p("]"), e;

                    for (; a;) {
                      if (e.push(_u()), g(), "]" === a) return p("]"), e;
                      p(","), g();
                    }
                  }

                  h("Bad array");
                }();

              case '"':
                return d();

              case "-":
                return f();

              default:
                return a >= "0" && a <= "9" ? f() : function () {
                  switch (a) {
                    case "t":
                      return p("t"), p("r"), p("u"), p("e"), !0;

                    case "f":
                      return p("f"), p("a"), p("l"), p("s"), p("e"), !1;

                    case "n":
                      return p("n"), p("u"), p("l"), p("l"), null;
                  }

                  h("Unexpected '" + a + "'");
                }();
            }
          }, function (e, t) {
            var r;
            return c = e + "", i = 0, a = " ", r = _u(), g(), a && h("Syntax error"), "function" == typeof t ? function e(r, n) {
              var o,
                  s = r[n];
              return s && "object" == typeof s && Object.keys(s).forEach(function (t) {
                void 0 !== (o = e(s, t)) ? s[t] = o : delete s[t];
              }), t.call(r, n, s);
            }({
              "": r
            }, "") : r;
          };
        };
      },
      592: function _(e, t, r) {
        var n = r(5117),
            o = e.exports;
        !function () {
          "use strict";

          var e,
              t,
              r,
              s = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
              i = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
          };

          function a(e) {
            return s.lastIndex = 0, s.test(e) ? '"' + e.replace(s, function (e) {
              var t = i[e];
              return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + e + '"';
          }

          function c(o, s) {
            var i,
                u,
                l,
                h,
                p,
                f = e,
                d = s[o],
                g = null != d && (d instanceof n || n.isBigNumber(d));

            switch (d && "object" == typeof d && "function" == typeof d.toJSON && (d = d.toJSON(o)), "function" == typeof r && (d = r.call(s, o, d)), typeof d) {
              case "string":
                return g ? d : a(d);

              case "number":
                return isFinite(d) ? String(d) : "null";

              case "boolean":
              case "null":
              case "bigint":
                return String(d);

              case "object":
                if (!d) return "null";

                if (e += t, p = [], "[object Array]" === Object.prototype.toString.apply(d)) {
                  for (h = d.length, i = 0; i < h; i += 1) {
                    p[i] = c(i, d) || "null";
                  }

                  return l = 0 === p.length ? "[]" : e ? "[\n" + e + p.join(",\n" + e) + "\n" + f + "]" : "[" + p.join(",") + "]", e = f, l;
                }

                if (r && "object" == typeof r) for (h = r.length, i = 0; i < h; i += 1) {
                  "string" == typeof r[i] && (l = c(u = r[i], d)) && p.push(a(u) + (e ? ": " : ":") + l);
                } else Object.keys(d).forEach(function (t) {
                  var r = c(t, d);
                  r && p.push(a(t) + (e ? ": " : ":") + r);
                });
                return l = 0 === p.length ? "{}" : e ? "{\n" + e + p.join(",\n" + e) + "\n" + f + "}" : "{" + p.join(",") + "}", e = f, l;
            }
          }

          "function" != typeof o.stringify && (o.stringify = function (n, o, s) {
            var i;
            if (e = "", t = "", "number" == typeof s) for (i = 0; i < s; i += 1) {
              t += " ";
            } else "string" == typeof s && (t = s);
            if (r = o, o && "function" != typeof o && ("object" != typeof o || "number" != typeof o.length)) throw new Error("JSON.stringify");
            return c("", {
              "": n
            });
          });
        }();
      },
      3126: function _(e, t, r) {
        var n = "function" == typeof Map && Map.prototype,
            o = Object.getOwnPropertyDescriptor && n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
            s = n && o && "function" == typeof o.get ? o.get : null,
            i = n && Map.prototype.forEach,
            a = "function" == typeof Set && Set.prototype,
            c = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
            u = a && c && "function" == typeof c.get ? c.get : null,
            l = a && Set.prototype.forEach,
            h = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
            p = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
            f = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
            d = Boolean.prototype.valueOf,
            g = Object.prototype.toString,
            y = Function.prototype.toString,
            m = String.prototype.match,
            b = "function" == typeof BigInt ? BigInt.prototype.valueOf : null,
            w = Object.getOwnPropertySymbols,
            A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null,
            v = "function" == typeof Symbol && "object" == typeof Symbol.iterator,
            x = Object.prototype.propertyIsEnumerable,
            S = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function (e) {
          return e.__proto__;
        } : null),
            E = r(4654).custom,
            T = E && U(E) ? E : null,
            _ = "function" == typeof Symbol && void 0 !== Symbol.toStringTag ? Symbol.toStringTag : null;

        function B(e, t, r) {
          var n = "double" === (r.quoteStyle || t) ? '"' : "'";
          return n + e + n;
        }

        function k(e) {
          return String(e).replace(/"/g, "&quot;");
        }

        function I(e) {
          return !("[object Array]" !== O(e) || _ && "object" == typeof e && _ in e);
        }

        function U(e) {
          if (v) return e && "object" == typeof e && e instanceof Symbol;
          if ("symbol" == typeof e) return !0;
          if (!e || "object" != typeof e || !A) return !1;

          try {
            return A.call(e), !0;
          } catch (e) {}

          return !1;
        }

        e.exports = function e(t, r, n, o) {
          var a = r || {};
          if (R(a, "quoteStyle") && "single" !== a.quoteStyle && "double" !== a.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
          if (R(a, "maxStringLength") && ("number" == typeof a.maxStringLength ? a.maxStringLength < 0 && a.maxStringLength !== 1 / 0 : null !== a.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
          var c = !R(a, "customInspect") || a.customInspect;
          if ("boolean" != typeof c) throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
          if (R(a, "indent") && null !== a.indent && "\t" !== a.indent && !(parseInt(a.indent, 10) === a.indent && a.indent > 0)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
          if (void 0 === t) return "undefined";
          if (null === t) return "null";
          if ("boolean" == typeof t) return t ? "true" : "false";
          if ("string" == typeof t) return N(t, a);
          if ("number" == typeof t) return 0 === t ? 1 / 0 / t > 0 ? "0" : "-0" : String(t);
          if ("bigint" == typeof t) return String(t) + "n";
          var g = void 0 === a.depth ? 5 : a.depth;
          if (void 0 === n && (n = 0), n >= g && g > 0 && "object" == typeof t) return I(t) ? "[Array]" : "[Object]";

          var w,
              x = function (e, t) {
            var r;
            if ("\t" === e.indent) r = "\t";else {
              if (!("number" == typeof e.indent && e.indent > 0)) return null;
              r = Array(e.indent + 1).join(" ");
            }
            return {
              base: r,
              prev: Array(t + 1).join(r)
            };
          }(a, n);

          if (void 0 === o) o = [];else if (D(o, t) >= 0) return "[Circular]";

          function E(t, r, s) {
            if (r && (o = o.slice()).push(r), s) {
              var i = {
                depth: a.depth
              };
              return R(a, "quoteStyle") && (i.quoteStyle = a.quoteStyle), e(t, i, n + 1, o);
            }

            return e(t, a, n + 1, o);
          }

          if ("function" == typeof t) {
            var C = function (e) {
              if (e.name) return e.name;
              var t = m.call(y.call(e), /^function\s*([\w$]+)/);
              return t ? t[1] : null;
            }(t),
                P = M(t, E);

            return "[Function" + (C ? ": " + C : " (anonymous)") + "]" + (P.length > 0 ? " { " + P.join(", ") + " }" : "");
          }

          if (U(t)) {
            var H = v ? String(t).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : A.call(t);
            return "object" != typeof t || v ? H : L(H);
          }

          if ((w = t) && "object" == typeof w && ("undefined" != typeof HTMLElement && w instanceof HTMLElement || "string" == typeof w.nodeName && "function" == typeof w.getAttribute)) {
            for (var G = "<" + String(t.nodeName).toLowerCase(), K = t.attributes || [], q = 0; q < K.length; q++) {
              G += " " + K[q].name + "=" + B(k(K[q].value), "double", a);
            }

            return G += ">", t.childNodes && t.childNodes.length && (G += "..."), G + "</" + String(t.nodeName).toLowerCase() + ">";
          }

          if (I(t)) {
            if (0 === t.length) return "[]";
            var $ = M(t, E);
            return x && !function (e) {
              for (var t = 0; t < e.length; t++) {
                if (D(e[t], "\n") >= 0) return !1;
              }

              return !0;
            }($) ? "[" + z($, x) + "]" : "[ " + $.join(", ") + " ]";
          }

          if (function (e) {
            return !("[object Error]" !== O(e) || _ && "object" == typeof e && _ in e);
          }(t)) {
            var V = M(t, E);
            return 0 === V.length ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + V.join(", ") + " }";
          }

          if ("object" == typeof t && c) {
            if (T && "function" == typeof t[T]) return t[T]();
            if ("function" == typeof t.inspect) return t.inspect();
          }

          if (function (e) {
            if (!s || !e || "object" != typeof e) return !1;

            try {
              s.call(e);

              try {
                u.call(e);
              } catch (e) {
                return !0;
              }

              return e instanceof Map;
            } catch (e) {}

            return !1;
          }(t)) {
            var W = [];
            return i.call(t, function (e, r) {
              W.push(E(r, t, !0) + " => " + E(e, t));
            }), j("Map", s.call(t), W, x);
          }

          if (function (e) {
            if (!u || !e || "object" != typeof e) return !1;

            try {
              u.call(e);

              try {
                s.call(e);
              } catch (e) {
                return !0;
              }

              return e instanceof Set;
            } catch (e) {}

            return !1;
          }(t)) {
            var X = [];
            return l.call(t, function (e) {
              X.push(E(e, t));
            }), j("Set", u.call(t), X, x);
          }

          if (function (e) {
            if (!h || !e || "object" != typeof e) return !1;

            try {
              h.call(e, h);

              try {
                p.call(e, p);
              } catch (e) {
                return !0;
              }

              return e instanceof WeakMap;
            } catch (e) {}

            return !1;
          }(t)) return F("WeakMap");
          if (function (e) {
            if (!p || !e || "object" != typeof e) return !1;

            try {
              p.call(e, p);

              try {
                h.call(e, h);
              } catch (e) {
                return !0;
              }

              return e instanceof WeakSet;
            } catch (e) {}

            return !1;
          }(t)) return F("WeakSet");
          if (function (e) {
            if (!f || !e || "object" != typeof e) return !1;

            try {
              return f.call(e), !0;
            } catch (e) {}

            return !1;
          }(t)) return F("WeakRef");
          if (function (e) {
            return !("[object Number]" !== O(e) || _ && "object" == typeof e && _ in e);
          }(t)) return L(E(Number(t)));
          if (function (e) {
            if (!e || "object" != typeof e || !b) return !1;

            try {
              return b.call(e), !0;
            } catch (e) {}

            return !1;
          }(t)) return L(E(b.call(t)));
          if (function (e) {
            return !("[object Boolean]" !== O(e) || _ && "object" == typeof e && _ in e);
          }(t)) return L(d.call(t));
          if (function (e) {
            return !("[object String]" !== O(e) || _ && "object" == typeof e && _ in e);
          }(t)) return L(E(String(t)));

          if (!function (e) {
            return !("[object Date]" !== O(e) || _ && "object" == typeof e && _ in e);
          }(t) && !function (e) {
            return !("[object RegExp]" !== O(e) || _ && "object" == typeof e && _ in e);
          }(t)) {
            var Y = M(t, E),
                J = S ? S(t) === Object.prototype : t instanceof Object || t.constructor === Object,
                Q = t instanceof Object ? "" : "null prototype",
                Z = !J && _ && Object(t) === t && _ in t ? O(t).slice(8, -1) : Q ? "Object" : "",
                ee = (J || "function" != typeof t.constructor ? "" : t.constructor.name ? t.constructor.name + " " : "") + (Z || Q ? "[" + [].concat(Z || [], Q || []).join(": ") + "] " : "");
            return 0 === Y.length ? ee + "{}" : x ? ee + "{" + z(Y, x) + "}" : ee + "{ " + Y.join(", ") + " }";
          }

          return String(t);
        };

        var C = Object.prototype.hasOwnProperty || function (e) {
          return e in this;
        };

        function R(e, t) {
          return C.call(e, t);
        }

        function O(e) {
          return g.call(e);
        }

        function D(e, t) {
          if (e.indexOf) return e.indexOf(t);

          for (var r = 0, n = e.length; r < n; r++) {
            if (e[r] === t) return r;
          }

          return -1;
        }

        function N(e, t) {
          if (e.length > t.maxStringLength) {
            var r = e.length - t.maxStringLength,
                n = "... " + r + " more character" + (r > 1 ? "s" : "");
            return N(e.slice(0, t.maxStringLength), t) + n;
          }

          return B(e.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, P), "single", t);
        }

        function P(e) {
          var t = e.charCodeAt(0),
              r = {
            8: "b",
            9: "t",
            10: "n",
            12: "f",
            13: "r"
          }[t];
          return r ? "\\" + r : "\\x" + (t < 16 ? "0" : "") + t.toString(16).toUpperCase();
        }

        function L(e) {
          return "Object(" + e + ")";
        }

        function F(e) {
          return e + " { ? }";
        }

        function j(e, t, r, n) {
          return e + " (" + t + ") {" + (n ? z(r, n) : r.join(", ")) + "}";
        }

        function z(e, t) {
          if (0 === e.length) return "";
          var r = "\n" + t.prev + t.base;
          return r + e.join("," + r) + "\n" + t.prev;
        }

        function M(e, t) {
          var r = I(e),
              n = [];

          if (r) {
            n.length = e.length;

            for (var o = 0; o < e.length; o++) {
              n[o] = R(e, o) ? t(e[o], e) : "";
            }
          }

          var s,
              i = "function" == typeof w ? w(e) : [];

          if (v) {
            s = {};

            for (var a = 0; a < i.length; a++) {
              s["$" + i[a]] = i[a];
            }
          }

          for (var c in e) {
            R(e, c) && (r && String(Number(c)) === c && c < e.length || v && s["$" + c] instanceof Symbol || (/[^\w$]/.test(c) ? n.push(t(c, e) + ": " + t(e[c], e)) : n.push(c + ": " + t(e[c], e))));
          }

          if ("function" == typeof w) for (var u = 0; u < i.length; u++) {
            x.call(e, i[u]) && n.push("[" + t(i[u]) + "]: " + t(e[i[u]], e));
          }
          return n;
        }
      },
      9368: function _(e) {
        "use strict";

        function t(e) {
          if ("string" != typeof e) throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
        }

        function r(e, t) {
          for (var r, n = "", o = 0, s = -1, i = 0, a = 0; a <= e.length; ++a) {
            if (a < e.length) r = e.charCodeAt(a);else {
              if (47 === r) break;
              r = 47;
            }

            if (47 === r) {
              if (s === a - 1 || 1 === i) ;else if (s !== a - 1 && 2 === i) {
                if (n.length < 2 || 2 !== o || 46 !== n.charCodeAt(n.length - 1) || 46 !== n.charCodeAt(n.length - 2)) if (n.length > 2) {
                  var c = n.lastIndexOf("/");

                  if (c !== n.length - 1) {
                    -1 === c ? (n = "", o = 0) : o = (n = n.slice(0, c)).length - 1 - n.lastIndexOf("/"), s = a, i = 0;
                    continue;
                  }
                } else if (2 === n.length || 1 === n.length) {
                  n = "", o = 0, s = a, i = 0;
                  continue;
                }
                t && (n.length > 0 ? n += "/.." : n = "..", o = 2);
              } else n.length > 0 ? n += "/" + e.slice(s + 1, a) : n = e.slice(s + 1, a), o = a - s - 1;
              s = a, i = 0;
            } else 46 === r && -1 !== i ? ++i : i = -1;
          }

          return n;
        }

        var n = {
          resolve: function resolve() {
            for (var e, n = "", o = !1, s = arguments.length - 1; s >= -1 && !o; s--) {
              var i;
              s >= 0 ? i = arguments[s] : (void 0 === e && (e = process.cwd()), i = e), t(i), 0 !== i.length && (n = i + "/" + n, o = 47 === i.charCodeAt(0));
            }

            return n = r(n, !o), o ? n.length > 0 ? "/" + n : "/" : n.length > 0 ? n : ".";
          },
          normalize: function normalize(e) {
            if (t(e), 0 === e.length) return ".";
            var n = 47 === e.charCodeAt(0),
                o = 47 === e.charCodeAt(e.length - 1);
            return 0 !== (e = r(e, !n)).length || n || (e = "."), e.length > 0 && o && (e += "/"), n ? "/" + e : e;
          },
          isAbsolute: function isAbsolute(e) {
            return t(e), e.length > 0 && 47 === e.charCodeAt(0);
          },
          join: function join() {
            if (0 === arguments.length) return ".";

            for (var e, r = 0; r < arguments.length; ++r) {
              var o = arguments[r];
              t(o), o.length > 0 && (void 0 === e ? e = o : e += "/" + o);
            }

            return void 0 === e ? "." : n.normalize(e);
          },
          relative: function relative(e, r) {
            if (t(e), t(r), e === r) return "";
            if ((e = n.resolve(e)) === (r = n.resolve(r))) return "";

            for (var o = 1; o < e.length && 47 === e.charCodeAt(o); ++o) {
              ;
            }

            for (var s = e.length, i = s - o, a = 1; a < r.length && 47 === r.charCodeAt(a); ++a) {
              ;
            }

            for (var c = r.length - a, u = i < c ? i : c, l = -1, h = 0; h <= u; ++h) {
              if (h === u) {
                if (c > u) {
                  if (47 === r.charCodeAt(a + h)) return r.slice(a + h + 1);
                  if (0 === h) return r.slice(a + h);
                } else i > u && (47 === e.charCodeAt(o + h) ? l = h : 0 === h && (l = 0));

                break;
              }

              var p = e.charCodeAt(o + h);
              if (p !== r.charCodeAt(a + h)) break;
              47 === p && (l = h);
            }

            var f = "";

            for (h = o + l + 1; h <= s; ++h) {
              h !== s && 47 !== e.charCodeAt(h) || (0 === f.length ? f += ".." : f += "/..");
            }

            return f.length > 0 ? f + r.slice(a + l) : (a += l, 47 === r.charCodeAt(a) && ++a, r.slice(a));
          },
          _makeLong: function _makeLong(e) {
            return e;
          },
          dirname: function dirname(e) {
            if (t(e), 0 === e.length) return ".";

            for (var r = e.charCodeAt(0), n = 47 === r, o = -1, s = !0, i = e.length - 1; i >= 1; --i) {
              if (47 === (r = e.charCodeAt(i))) {
                if (!s) {
                  o = i;
                  break;
                }
              } else s = !1;
            }

            return -1 === o ? n ? "/" : "." : n && 1 === o ? "//" : e.slice(0, o);
          },
          basename: function basename(e, r) {
            if (void 0 !== r && "string" != typeof r) throw new TypeError('"ext" argument must be a string');
            t(e);
            var n,
                o = 0,
                s = -1,
                i = !0;

            if (void 0 !== r && r.length > 0 && r.length <= e.length) {
              if (r.length === e.length && r === e) return "";
              var a = r.length - 1,
                  c = -1;

              for (n = e.length - 1; n >= 0; --n) {
                var u = e.charCodeAt(n);

                if (47 === u) {
                  if (!i) {
                    o = n + 1;
                    break;
                  }
                } else -1 === c && (i = !1, c = n + 1), a >= 0 && (u === r.charCodeAt(a) ? -1 == --a && (s = n) : (a = -1, s = c));
              }

              return o === s ? s = c : -1 === s && (s = e.length), e.slice(o, s);
            }

            for (n = e.length - 1; n >= 0; --n) {
              if (47 === e.charCodeAt(n)) {
                if (!i) {
                  o = n + 1;
                  break;
                }
              } else -1 === s && (i = !1, s = n + 1);
            }

            return -1 === s ? "" : e.slice(o, s);
          },
          extname: function extname(e) {
            t(e);

            for (var r = -1, n = 0, o = -1, s = !0, i = 0, a = e.length - 1; a >= 0; --a) {
              var c = e.charCodeAt(a);
              if (47 !== c) -1 === o && (s = !1, o = a + 1), 46 === c ? -1 === r ? r = a : 1 !== i && (i = 1) : -1 !== r && (i = -1);else if (!s) {
                n = a + 1;
                break;
              }
            }

            return -1 === r || -1 === o || 0 === i || 1 === i && r === o - 1 && r === n + 1 ? "" : e.slice(r, o);
          },
          format: function format(e) {
            if (null === e || "object" != typeof e) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof e);
            return function (e, t) {
              var r = t.dir || t.root,
                  n = t.base || (t.name || "") + (t.ext || "");
              return r ? r === t.root ? r + n : r + "/" + n : n;
            }(0, e);
          },
          parse: function parse(e) {
            t(e);
            var r = {
              root: "",
              dir: "",
              base: "",
              ext: "",
              name: ""
            };
            if (0 === e.length) return r;
            var n,
                o = e.charCodeAt(0),
                s = 47 === o;
            s ? (r.root = "/", n = 1) : n = 0;

            for (var i = -1, a = 0, c = -1, u = !0, l = e.length - 1, h = 0; l >= n; --l) {
              if (47 !== (o = e.charCodeAt(l))) -1 === c && (u = !1, c = l + 1), 46 === o ? -1 === i ? i = l : 1 !== h && (h = 1) : -1 !== i && (h = -1);else if (!u) {
                a = l + 1;
                break;
              }
            }

            return -1 === i || -1 === c || 0 === h || 1 === h && i === c - 1 && i === a + 1 ? -1 !== c && (r.base = r.name = 0 === a && s ? e.slice(1, c) : e.slice(a, c)) : (0 === a && s ? (r.name = e.slice(1, i), r.base = e.slice(1, c)) : (r.name = e.slice(a, i), r.base = e.slice(a, c)), r.ext = e.slice(i, c)), a > 0 ? r.dir = e.slice(0, a - 1) : s && (r.dir = "/"), r;
          },
          sep: "/",
          delimiter: ":",
          win32: null,
          posix: null
        };
        n.posix = n, e.exports = n;
      },
      9370: function _(e, t) {
        "use strict";

        var r = Object.prototype.hasOwnProperty;

        function n(e) {
          try {
            return decodeURIComponent(e.replace(/\+/g, " "));
          } catch (e) {
            return null;
          }
        }

        function o(e) {
          try {
            return encodeURIComponent(e);
          } catch (e) {
            return null;
          }
        }

        t.stringify = function (e, t) {
          t = t || "";
          var n,
              s,
              i = [];

          for (s in "string" != typeof t && (t = "?"), e) {
            if (r.call(e, s)) {
              if ((n = e[s]) || null != n && !isNaN(n) || (n = ""), s = o(s), n = o(n), null === s || null === n) continue;
              i.push(s + "=" + n);
            }
          }

          return i.length ? t + i.join("&") : "";
        }, t.parse = function (e) {
          for (var t, r = /([^=?#&]+)=?([^&]*)/g, o = {}; t = r.exec(e);) {
            var s = n(t[1]),
                i = n(t[2]);
            null === s || null === i || s in o || (o[s] = i);
          }

          return o;
        };
      },
      1926: function _(e) {
        "use strict";

        e.exports = function (e, t) {
          if (t = t.split(":")[0], !(e = +e)) return !1;

          switch (t) {
            case "http":
            case "ws":
              return 80 !== e;

            case "https":
            case "wss":
              return 443 !== e;

            case "ftp":
              return 21 !== e;

            case "gopher":
              return 70 !== e;

            case "file":
              return !1;
          }

          return 0 !== e;
        };
      },
      3680: function _(e, t, r) {
        "use strict";

        var n = r(1801),
            o = r(7615),
            s = r(3126),
            i = n("%TypeError%"),
            a = n("%WeakMap%", !0),
            c = n("%Map%", !0),
            u = o("WeakMap.prototype.get", !0),
            l = o("WeakMap.prototype.set", !0),
            h = o("WeakMap.prototype.has", !0),
            p = o("Map.prototype.get", !0),
            f = o("Map.prototype.set", !0),
            d = o("Map.prototype.has", !0),
            g = function g(e, t) {
          for (var r, n = e; null !== (r = n.next); n = r) {
            if (r.key === t) return n.next = r.next, r.next = e.next, e.next = r, r;
          }
        };

        e.exports = function () {
          var e,
              t,
              r,
              n = {
            assert: function assert(e) {
              if (!n.has(e)) throw new i("Side channel does not contain " + s(e));
            },
            get: function get(n) {
              if (a && n && ("object" == typeof n || "function" == typeof n)) {
                if (e) return u(e, n);
              } else if (c) {
                if (t) return p(t, n);
              } else if (r) return function (e, t) {
                var r = g(e, t);
                return r && r.value;
              }(r, n);
            },
            has: function has(n) {
              if (a && n && ("object" == typeof n || "function" == typeof n)) {
                if (e) return h(e, n);
              } else if (c) {
                if (t) return d(t, n);
              } else if (r) return function (e, t) {
                return !!g(e, t);
              }(r, n);

              return !1;
            },
            set: function set(n, o) {
              a && n && ("object" == typeof n || "function" == typeof n) ? (e || (e = new a()), l(e, n, o)) : c ? (t || (t = new c()), f(t, n, o)) : (r || (r = {
                key: {},
                next: null
              }), function (e, t, r) {
                var n = g(e, t);
                n ? n.value = r : e.next = {
                  key: t,
                  next: e.next,
                  value: r
                };
              }(r, n, o));
            }
          };
          return n;
        };
      },
      2858: function _(e) {
        "use strict";

        function t(e, t) {
          (null == t || t > e.length) && (t = e.length);

          for (var r = 0, n = new Array(t); r < t; r++) {
            n[r] = e[r];
          }

          return n;
        }

        function r() {
          this._defaults = [];
        }

        ["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert", "disableTLSCerts"].forEach(function (e) {
          r.prototype[e] = function () {
            for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
              r[n] = arguments[n];
            }

            return this._defaults.push({
              fn: e,
              args: r
            }), this;
          };
        }), r.prototype._setDefaults = function (e) {
          this._defaults.forEach(function (r) {
            var n;
            e[r.fn].apply(e, function (e) {
              if (Array.isArray(e)) return t(e);
            }(n = r.args) || function (e) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
            }(n) || function (e, r) {
              if (e) {
                if ("string" == typeof e) return t(e, r);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e, r) : void 0;
              }
            }(n) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }());
          });
        }, e.exports = r;
      },
      5391: function _(e, t, r) {
        "use strict";

        function n(e) {
          return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        var o;
        "undefined" != typeof window ? o = window : "undefined" == typeof self ? (console.warn("Using browser-only version of superagent in non-browser environment"), o = void 0) : o = self;
        var s = r(1069),
            i = r(5799),
            a = r(3065),
            c = r(4287),
            u = r(1960),
            l = r(969),
            h = r(2858);

        function p() {}

        e.exports = function (e, r) {
          return "function" == typeof r ? new t.Request("GET", e).end(r) : 1 === arguments.length ? new t.Request("GET", e) : new t.Request(e, r);
        };

        var f = t = e.exports;
        t.Request = A, f.getXHR = function () {
          if (o.XMLHttpRequest && (!o.location || "file:" !== o.location.protocol || !o.ActiveXObject)) return new XMLHttpRequest();

          try {
            return new ActiveXObject("Microsoft.XMLHTTP");
          } catch (e) {}

          try {
            return new ActiveXObject("Msxml2.XMLHTTP.6.0");
          } catch (e) {}

          try {
            return new ActiveXObject("Msxml2.XMLHTTP.3.0");
          } catch (e) {}

          try {
            return new ActiveXObject("Msxml2.XMLHTTP");
          } catch (e) {}

          throw new Error("Browser-only version of superagent could not find XHR");
        };
        var d = "".trim ? function (e) {
          return e.trim();
        } : function (e) {
          return e.replace(/(^\s*|\s*$)/g, "");
        };

        function g(e) {
          if (!u(e)) return e;
          var t = [];

          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && y(t, r, e[r]);
          }

          return t.join("&");
        }

        function y(e, t, r) {
          if (void 0 !== r) if (null !== r) {
            if (Array.isArray(r)) r.forEach(function (r) {
              y(e, t, r);
            });else if (u(r)) for (var n in r) {
              Object.prototype.hasOwnProperty.call(r, n) && y(e, "".concat(t, "[").concat(n, "]"), r[n]);
            } else e.push(encodeURI(t) + "=" + encodeURIComponent(r));
          } else e.push(encodeURI(t));
        }

        function m(e) {
          for (var t, r, n = {}, o = e.split("&"), s = 0, i = o.length; s < i; ++s) {
            -1 === (r = (t = o[s]).indexOf("=")) ? n[decodeURIComponent(t)] = "" : n[decodeURIComponent(t.slice(0, r))] = decodeURIComponent(t.slice(r + 1));
          }

          return n;
        }

        function b(e) {
          return /[/+]json($|[^-\w])/i.test(e);
        }

        function w(e) {
          this.req = e, this.xhr = this.req.xhr, this.text = "HEAD" !== this.req.method && ("" === this.xhr.responseType || "text" === this.xhr.responseType) || void 0 === this.xhr.responseType ? this.xhr.responseText : null, this.statusText = this.req.xhr.statusText;
          var t = this.xhr.status;
          1223 === t && (t = 204), this._setStatusProperties(t), this.headers = function (e) {
            for (var t, r, n, o, s = e.split(/\r?\n/), i = {}, a = 0, c = s.length; a < c; ++a) {
              -1 !== (t = (r = s[a]).indexOf(":")) && (n = r.slice(0, t).toLowerCase(), o = d(r.slice(t + 1)), i[n] = o);
            }

            return i;
          }(this.xhr.getAllResponseHeaders()), this.header = this.headers, this.header["content-type"] = this.xhr.getResponseHeader("content-type"), this._setHeaderProperties(this.header), null === this.text && e._responseType ? this.body = this.xhr.response : this.body = "HEAD" === this.req.method ? null : this._parseBody(this.text ? this.text : this.xhr.response);
        }

        function A(e, t) {
          var r = this;
          this._query = this._query || [], this.method = e, this.url = t, this.header = {}, this._header = {}, this.on("end", function () {
            var e,
                t = null,
                n = null;

            try {
              n = new w(r);
            } catch (e) {
              return (t = new Error("Parser is unable to parse the response")).parse = !0, t.original = e, r.xhr ? (t.rawResponse = void 0 === r.xhr.responseType ? r.xhr.responseText : r.xhr.response, t.status = r.xhr.status ? r.xhr.status : null, t.statusCode = t.status) : (t.rawResponse = null, t.status = null), r.callback(t);
            }

            r.emit("response", n);

            try {
              r._isResponseOK(n) || (e = new Error(n.statusText || n.text || "Unsuccessful HTTP response"));
            } catch (t) {
              e = t;
            }

            e ? (e.original = t, e.response = n, e.status = n.status, r.callback(e, n)) : r.callback(null, n);
          });
        }

        function v(e, t, r) {
          var n = f("DELETE", e);
          return "function" == typeof t && (r = t, t = null), t && n.send(t), r && n.end(r), n;
        }

        f.serializeObject = g, f.parseString = m, f.types = {
          html: "text/html",
          json: "application/json",
          xml: "text/xml",
          urlencoded: "application/x-www-form-urlencoded",
          form: "application/x-www-form-urlencoded",
          "form-data": "application/x-www-form-urlencoded"
        }, f.serialize = {
          "application/x-www-form-urlencoded": a.stringify,
          "application/json": i
        }, f.parse = {
          "application/x-www-form-urlencoded": m,
          "application/json": JSON.parse
        }, l(w.prototype), w.prototype._parseBody = function (e) {
          var t = f.parse[this.type];
          return this.req._parser ? this.req._parser(this, e) : (!t && b(this.type) && (t = f.parse["application/json"]), t && e && (e.length > 0 || e instanceof Object) ? t(e) : null);
        }, w.prototype.toError = function () {
          var e = this.req,
              t = e.method,
              r = e.url,
              n = "cannot ".concat(t, " ").concat(r, " (").concat(this.status, ")"),
              o = new Error(n);
          return o.status = this.status, o.method = t, o.url = r, o;
        }, f.Response = w, s(A.prototype), c(A.prototype), A.prototype.type = function (e) {
          return this.set("Content-Type", f.types[e] || e), this;
        }, A.prototype.accept = function (e) {
          return this.set("Accept", f.types[e] || e), this;
        }, A.prototype.auth = function (e, t, r) {
          1 === arguments.length && (t = ""), "object" === n(t) && null !== t && (r = t, t = ""), r || (r = {
            type: "function" == typeof btoa ? "basic" : "auto"
          });

          var o = function o(e) {
            if ("function" == typeof btoa) return btoa(e);
            throw new Error("Cannot use basic auth, btoa is not a function");
          };

          return this._auth(e, t, r, o);
        }, A.prototype.query = function (e) {
          return "string" != typeof e && (e = g(e)), e && this._query.push(e), this;
        }, A.prototype.attach = function (e, t, r) {
          if (t) {
            if (this._data) throw new Error("superagent can't mix .send() and .attach()");

            this._getFormData().append(e, t, r || t.name);
          }

          return this;
        }, A.prototype._getFormData = function () {
          return this._formData || (this._formData = new o.FormData()), this._formData;
        }, A.prototype.callback = function (e, t) {
          if (this._shouldRetry(e, t)) return this._retry();
          var r = this._callback;
          this.clearTimeout(), e && (this._maxRetries && (e.retries = this._retries - 1), this.emit("error", e)), r(e, t);
        }, A.prototype.crossDomainError = function () {
          var e = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
          e.crossDomain = !0, e.status = this.status, e.method = this.method, e.url = this.url, this.callback(e);
        }, A.prototype.agent = function () {
          return console.warn("This is not supported in browser version of superagent"), this;
        }, A.prototype.ca = A.prototype.agent, A.prototype.buffer = A.prototype.ca, A.prototype.write = function () {
          throw new Error("Streaming is not supported in browser version of superagent");
        }, A.prototype.pipe = A.prototype.write, A.prototype._isHost = function (e) {
          return e && "object" === n(e) && !Array.isArray(e) && "[object Object]" !== Object.prototype.toString.call(e);
        }, A.prototype.end = function (e) {
          this._endCalled && console.warn("Warning: .end() was called twice. This is not supported in superagent"), this._endCalled = !0, this._callback = e || p, this._finalizeQueryString(), this._end();
        }, A.prototype._setUploadTimeout = function () {
          var e = this;
          this._uploadTimeout && !this._uploadTimeoutTimer && (this._uploadTimeoutTimer = setTimeout(function () {
            e._timeoutError("Upload timeout of ", e._uploadTimeout, "ETIMEDOUT");
          }, this._uploadTimeout));
        }, A.prototype._end = function () {
          if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
          var e = this;
          this.xhr = f.getXHR();
          var t = this.xhr,
              r = this._formData || this._data;
          this._setTimeouts(), t.onreadystatechange = function () {
            var r = t.readyState;

            if (r >= 2 && e._responseTimeoutTimer && clearTimeout(e._responseTimeoutTimer), 4 === r) {
              var n;

              try {
                n = t.status;
              } catch (e) {
                n = 0;
              }

              if (!n) {
                if (e.timedout || e._aborted) return;
                return e.crossDomainError();
              }

              e.emit("end");
            }
          };

          var n = function n(t, r) {
            r.total > 0 && (r.percent = r.loaded / r.total * 100, 100 === r.percent && clearTimeout(e._uploadTimeoutTimer)), r.direction = t, e.emit("progress", r);
          };

          if (this.hasListeners("progress")) try {
            t.addEventListener("progress", n.bind(null, "download")), t.upload && t.upload.addEventListener("progress", n.bind(null, "upload"));
          } catch (e) {}
          t.upload && this._setUploadTimeout();

          try {
            this.username && this.password ? t.open(this.method, this.url, !0, this.username, this.password) : t.open(this.method, this.url, !0);
          } catch (e) {
            return this.callback(e);
          }

          if (this._withCredentials && (t.withCredentials = !0), !this._formData && "GET" !== this.method && "HEAD" !== this.method && "string" != typeof r && !this._isHost(r)) {
            var o = this._header["content-type"],
                s = this._serializer || f.serialize[o ? o.split(";")[0] : ""];
            !s && b(o) && (s = f.serialize["application/json"]), s && (r = s(r));
          }

          for (var i in this.header) {
            null !== this.header[i] && Object.prototype.hasOwnProperty.call(this.header, i) && t.setRequestHeader(i, this.header[i]);
          }

          this._responseType && (t.responseType = this._responseType), this.emit("request", this), t.send(void 0 === r ? null : r);
        }, f.agent = function () {
          return new h();
        }, ["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function (e) {
          h.prototype[e.toLowerCase()] = function (t, r) {
            var n = new f.Request(e, t);
            return this._setDefaults(n), r && n.end(r), n;
          };
        }), h.prototype.del = h.prototype.delete, f.get = function (e, t, r) {
          var n = f("GET", e);
          return "function" == typeof t && (r = t, t = null), t && n.query(t), r && n.end(r), n;
        }, f.head = function (e, t, r) {
          var n = f("HEAD", e);
          return "function" == typeof t && (r = t, t = null), t && n.query(t), r && n.end(r), n;
        }, f.options = function (e, t, r) {
          var n = f("OPTIONS", e);
          return "function" == typeof t && (r = t, t = null), t && n.send(t), r && n.end(r), n;
        }, f.del = v, f.delete = v, f.patch = function (e, t, r) {
          var n = f("PATCH", e);
          return "function" == typeof t && (r = t, t = null), t && n.send(t), r && n.end(r), n;
        }, f.post = function (e, t, r) {
          var n = f("POST", e);
          return "function" == typeof t && (r = t, t = null), t && n.send(t), r && n.end(r), n;
        }, f.put = function (e, t, r) {
          var n = f("PUT", e);
          return "function" == typeof t && (r = t, t = null), t && n.send(t), r && n.end(r), n;
        };
      },
      1960: function _(e) {
        "use strict";

        function t(e) {
          return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        e.exports = function (e) {
          return null !== e && "object" === t(e);
        };
      },
      4287: function _(e, t, r) {
        "use strict";

        function n(e) {
          return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        var o = r(1960);

        function s(e) {
          if (e) return function (e) {
            for (var t in s.prototype) {
              Object.prototype.hasOwnProperty.call(s.prototype, t) && (e[t] = s.prototype[t]);
            }

            return e;
          }(e);
        }

        e.exports = s, s.prototype.clearTimeout = function () {
          return clearTimeout(this._timer), clearTimeout(this._responseTimeoutTimer), clearTimeout(this._uploadTimeoutTimer), delete this._timer, delete this._responseTimeoutTimer, delete this._uploadTimeoutTimer, this;
        }, s.prototype.parse = function (e) {
          return this._parser = e, this;
        }, s.prototype.responseType = function (e) {
          return this._responseType = e, this;
        }, s.prototype.serialize = function (e) {
          return this._serializer = e, this;
        }, s.prototype.timeout = function (e) {
          if (!e || "object" !== n(e)) return this._timeout = e, this._responseTimeout = 0, this._uploadTimeout = 0, this;

          for (var t in e) {
            if (Object.prototype.hasOwnProperty.call(e, t)) switch (t) {
              case "deadline":
                this._timeout = e.deadline;
                break;

              case "response":
                this._responseTimeout = e.response;
                break;

              case "upload":
                this._uploadTimeout = e.upload;
                break;

              default:
                console.warn("Unknown timeout option", t);
            }
          }

          return this;
        }, s.prototype.retry = function (e, t) {
          return 0 !== arguments.length && !0 !== e || (e = 1), e <= 0 && (e = 0), this._maxRetries = e, this._retries = 0, this._retryCallback = t, this;
        };
        var i = new Set(["ETIMEDOUT", "ECONNRESET", "EADDRINUSE", "ECONNREFUSED", "EPIPE", "ENOTFOUND", "ENETUNREACH", "EAI_AGAIN"]),
            a = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524]);
        s.prototype._shouldRetry = function (e, t) {
          if (!this._maxRetries || this._retries++ >= this._maxRetries) return !1;
          if (this._retryCallback) try {
            var r = this._retryCallback(e, t);

            if (!0 === r) return !0;
            if (!1 === r) return !1;
          } catch (e) {
            console.error(e);
          }
          if (t && t.status && a.has(t.status)) return !0;

          if (e) {
            if (e.code && i.has(e.code)) return !0;
            if (e.timeout && "ECONNABORTED" === e.code) return !0;
            if (e.crossDomain) return !0;
          }

          return !1;
        }, s.prototype._retry = function () {
          return this.clearTimeout(), this.req && (this.req = null, this.req = this.request()), this._aborted = !1, this.timedout = !1, this.timedoutError = null, this._end();
        }, s.prototype.then = function (e, t) {
          var r = this;

          if (!this._fullfilledPromise) {
            var n = this;
            this._endCalled && console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"), this._fullfilledPromise = new Promise(function (e, t) {
              n.on("abort", function () {
                if (!(r._maxRetries && r._maxRetries > r._retries)) if (r.timedout && r.timedoutError) t(r.timedoutError);else {
                  var e = new Error("Aborted");
                  e.code = "ABORTED", e.status = r.status, e.method = r.method, e.url = r.url, t(e);
                }
              }), n.end(function (r, n) {
                r ? t(r) : e(n);
              });
            });
          }

          return this._fullfilledPromise.then(e, t);
        }, s.prototype.catch = function (e) {
          return this.then(void 0, e);
        }, s.prototype.use = function (e) {
          return e(this), this;
        }, s.prototype.ok = function (e) {
          if ("function" != typeof e) throw new Error("Callback required");
          return this._okCallback = e, this;
        }, s.prototype._isResponseOK = function (e) {
          return !!e && (this._okCallback ? this._okCallback(e) : e.status >= 200 && e.status < 300);
        }, s.prototype.get = function (e) {
          return this._header[e.toLowerCase()];
        }, s.prototype.getHeader = s.prototype.get, s.prototype.set = function (e, t) {
          if (o(e)) {
            for (var r in e) {
              Object.prototype.hasOwnProperty.call(e, r) && this.set(r, e[r]);
            }

            return this;
          }

          return this._header[e.toLowerCase()] = t, this.header[e] = t, this;
        }, s.prototype.unset = function (e) {
          return delete this._header[e.toLowerCase()], delete this.header[e], this;
        }, s.prototype.field = function (e, t) {
          if (null == e) throw new Error(".field(name, val) name can not be empty");
          if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");

          if (o(e)) {
            for (var r in e) {
              Object.prototype.hasOwnProperty.call(e, r) && this.field(r, e[r]);
            }

            return this;
          }

          if (Array.isArray(t)) {
            for (var n in t) {
              Object.prototype.hasOwnProperty.call(t, n) && this.field(e, t[n]);
            }

            return this;
          }

          if (null == t) throw new Error(".field(name, val) val can not be empty");
          return "boolean" == typeof t && (t = String(t)), this._getFormData().append(e, t), this;
        }, s.prototype.abort = function () {
          return this._aborted || (this._aborted = !0, this.xhr && this.xhr.abort(), this.req && this.req.abort(), this.clearTimeout(), this.emit("abort")), this;
        }, s.prototype._auth = function (e, t, r, n) {
          switch (r.type) {
            case "basic":
              this.set("Authorization", "Basic ".concat(n("".concat(e, ":").concat(t))));
              break;

            case "auto":
              this.username = e, this.password = t;
              break;

            case "bearer":
              this.set("Authorization", "Bearer ".concat(e));
          }

          return this;
        }, s.prototype.withCredentials = function (e) {
          return void 0 === e && (e = !0), this._withCredentials = e, this;
        }, s.prototype.redirects = function (e) {
          return this._maxRedirects = e, this;
        }, s.prototype.maxResponseSize = function (e) {
          if ("number" != typeof e) throw new TypeError("Invalid argument");
          return this._maxResponseSize = e, this;
        }, s.prototype.toJSON = function () {
          return {
            method: this.method,
            url: this.url,
            data: this._data,
            headers: this._header
          };
        }, s.prototype.send = function (e) {
          var t = o(e),
              r = this._header["content-type"];
          if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
          if (t && !this._data) Array.isArray(e) ? this._data = [] : this._isHost(e) || (this._data = {});else if (e && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
          if (t && o(this._data)) for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && (this._data[n] = e[n]);
          } else "string" == typeof e ? (r || this.type("form"), (r = this._header["content-type"]) && (r = r.toLowerCase().trim()), this._data = "application/x-www-form-urlencoded" === r ? this._data ? "".concat(this._data, "&").concat(e) : e : (this._data || "") + e) : this._data = e;
          return !t || this._isHost(e) || r || this.type("json"), this;
        }, s.prototype.sortQuery = function (e) {
          return this._sort = void 0 === e || e, this;
        }, s.prototype._finalizeQueryString = function () {
          var e = this._query.join("&");

          if (e && (this.url += (this.url.includes("?") ? "&" : "?") + e), this._query.length = 0, this._sort) {
            var t = this.url.indexOf("?");

            if (t >= 0) {
              var r = this.url.slice(t + 1).split("&");
              "function" == typeof this._sort ? r.sort(this._sort) : r.sort(), this.url = this.url.slice(0, t) + "?" + r.join("&");
            }
          }
        }, s.prototype._appendQueryString = function () {
          console.warn("Unsupported");
        }, s.prototype._timeoutError = function (e, t, r) {
          if (!this._aborted) {
            var n = new Error("".concat(e + t, "ms exceeded"));
            n.timeout = t, n.code = "ECONNABORTED", n.errno = r, this.timedout = !0, this.timedoutError = n, this.abort(), this.callback(n);
          }
        }, s.prototype._setTimeouts = function () {
          var e = this;
          this._timeout && !this._timer && (this._timer = setTimeout(function () {
            e._timeoutError("Timeout of ", e._timeout, "ETIME");
          }, this._timeout)), this._responseTimeout && !this._responseTimeoutTimer && (this._responseTimeoutTimer = setTimeout(function () {
            e._timeoutError("Response timeout of ", e._responseTimeout, "ETIMEDOUT");
          }, this._responseTimeout));
        };
      },
      969: function _(e, t, r) {
        "use strict";

        var n = r(3094);

        function o(e) {
          if (e) return function (e) {
            for (var t in o.prototype) {
              Object.prototype.hasOwnProperty.call(o.prototype, t) && (e[t] = o.prototype[t]);
            }

            return e;
          }(e);
        }

        e.exports = o, o.prototype.get = function (e) {
          return this.header[e.toLowerCase()];
        }, o.prototype._setHeaderProperties = function (e) {
          var t = e["content-type"] || "";
          this.type = n.type(t);
          var r = n.params(t);

          for (var o in r) {
            Object.prototype.hasOwnProperty.call(r, o) && (this[o] = r[o]);
          }

          this.links = {};

          try {
            e.link && (this.links = n.parseLinks(e.link));
          } catch (e) {}
        }, o.prototype._setStatusProperties = function (e) {
          var t = e / 100 | 0;
          this.statusCode = e, this.status = this.statusCode, this.statusType = t, this.info = 1 === t, this.ok = 2 === t, this.redirect = 3 === t, this.clientError = 4 === t, this.serverError = 5 === t, this.error = (4 === t || 5 === t) && this.toError(), this.created = 201 === e, this.accepted = 202 === e, this.noContent = 204 === e, this.badRequest = 400 === e, this.unauthorized = 401 === e, this.notAcceptable = 406 === e, this.forbidden = 403 === e, this.notFound = 404 === e, this.unprocessableEntity = 422 === e;
        };
      },
      3094: function _(e, t) {
        "use strict";

        function r(e, t) {
          var r;

          if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
            if (Array.isArray(e) || (r = function (e, t) {
              if (e) {
                if ("string" == typeof e) return n(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
              }
            }(e)) || t && e && "number" == typeof e.length) {
              r && (e = r);

              var o = 0,
                  s = function s() {};

              return {
                s: s,
                n: function n() {
                  return o >= e.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: e[o++]
                  };
                },
                e: function e(_e4) {
                  throw _e4;
                },
                f: s
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          var i,
              a = !0,
              c = !1;
          return {
            s: function s() {
              r = e[Symbol.iterator]();
            },
            n: function n() {
              var e = r.next();
              return a = e.done, e;
            },
            e: function e(_e5) {
              c = !0, i = _e5;
            },
            f: function f() {
              try {
                a || null == r.return || r.return();
              } finally {
                if (c) throw i;
              }
            }
          };
        }

        function n(e, t) {
          (null == t || t > e.length) && (t = e.length);

          for (var r = 0, n = new Array(t); r < t; r++) {
            n[r] = e[r];
          }

          return n;
        }

        t.type = function (e) {
          return e.split(/ *; */).shift();
        }, t.params = function (e) {
          var t,
              n = {},
              o = r(e.split(/ *; */));

          try {
            for (o.s(); !(t = o.n()).done;) {
              var s = t.value.split(/ *= */),
                  i = s.shift(),
                  a = s.shift();
              i && a && (n[i] = a);
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }

          return n;
        }, t.parseLinks = function (e) {
          var t,
              n = {},
              o = r(e.split(/ *, */));

          try {
            for (o.s(); !(t = o.n()).done;) {
              var s = t.value.split(/ *; */),
                  i = s[0].slice(1, -1);
              n[s[1].split(/ *= */)[1].slice(1, -1)] = i;
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }

          return n;
        }, t.cleanHeader = function (e, t) {
          return delete e["content-type"], delete e["content-length"], delete e["transfer-encoding"], delete e.host, t && (delete e.authorization, delete e.cookie), e;
        };
      },
      5335: function _(e) {
        "use strict";

        var t = String.prototype.replace,
            r = /%20/g,
            n = "RFC3986";
        e.exports = {
          default: n,
          formatters: {
            RFC1738: function RFC1738(e) {
              return t.call(e, r, "+");
            },
            RFC3986: function RFC3986(e) {
              return String(e);
            }
          },
          RFC1738: "RFC1738",
          RFC3986: n
        };
      },
      3065: function _(e, t, r) {
        "use strict";

        var n = r(4246),
            o = r(1688),
            s = r(5335);
        e.exports = {
          formats: s,
          parse: o,
          stringify: n
        };
      },
      1688: function _(e, t, r) {
        "use strict";

        var n = r(4562),
            o = Object.prototype.hasOwnProperty,
            s = Array.isArray,
            i = {
          allowDots: !1,
          allowPrototypes: !1,
          allowSparse: !1,
          arrayLimit: 20,
          charset: "utf-8",
          charsetSentinel: !1,
          comma: !1,
          decoder: n.decode,
          delimiter: "&",
          depth: 5,
          ignoreQueryPrefix: !1,
          interpretNumericEntities: !1,
          parameterLimit: 1e3,
          parseArrays: !0,
          plainObjects: !1,
          strictNullHandling: !1
        },
            a = function a(e) {
          return e.replace(/&#(\d+);/g, function (e, t) {
            return String.fromCharCode(parseInt(t, 10));
          });
        },
            c = function c(e, t) {
          return e && "string" == typeof e && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
        },
            u = function u(e, t, r, n) {
          if (e) {
            var s = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
                i = /(\[[^[\]]*])/g,
                a = r.depth > 0 && /(\[[^[\]]*])/.exec(s),
                u = a ? s.slice(0, a.index) : s,
                l = [];

            if (u) {
              if (!r.plainObjects && o.call(Object.prototype, u) && !r.allowPrototypes) return;
              l.push(u);
            }

            for (var h = 0; r.depth > 0 && null !== (a = i.exec(s)) && h < r.depth;) {
              if (h += 1, !r.plainObjects && o.call(Object.prototype, a[1].slice(1, -1)) && !r.allowPrototypes) return;
              l.push(a[1]);
            }

            return a && l.push("[" + s.slice(a.index) + "]"), function (e, t, r, n) {
              for (var o = n ? t : c(t, r), s = e.length - 1; s >= 0; --s) {
                var i,
                    a = e[s];
                if ("[]" === a && r.parseArrays) i = [].concat(o);else {
                  i = r.plainObjects ? Object.create(null) : {};
                  var u = "[" === a.charAt(0) && "]" === a.charAt(a.length - 1) ? a.slice(1, -1) : a,
                      l = parseInt(u, 10);
                  r.parseArrays || "" !== u ? !isNaN(l) && a !== u && String(l) === u && l >= 0 && r.parseArrays && l <= r.arrayLimit ? (i = [])[l] = o : i[u] = o : i = {
                    0: o
                  };
                }
                o = i;
              }

              return o;
            }(l, t, r, n);
          }
        };

        e.exports = function (e, t) {
          var r = function (e) {
            if (!e) return i;
            if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder) throw new TypeError("Decoder has to be a function.");
            if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var t = void 0 === e.charset ? i.charset : e.charset;
            return {
              allowDots: void 0 === e.allowDots ? i.allowDots : !!e.allowDots,
              allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : i.allowPrototypes,
              allowSparse: "boolean" == typeof e.allowSparse ? e.allowSparse : i.allowSparse,
              arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : i.arrayLimit,
              charset: t,
              charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : i.charsetSentinel,
              comma: "boolean" == typeof e.comma ? e.comma : i.comma,
              decoder: "function" == typeof e.decoder ? e.decoder : i.decoder,
              delimiter: "string" == typeof e.delimiter || n.isRegExp(e.delimiter) ? e.delimiter : i.delimiter,
              depth: "number" == typeof e.depth || !1 === e.depth ? +e.depth : i.depth,
              ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
              interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : i.interpretNumericEntities,
              parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : i.parameterLimit,
              parseArrays: !1 !== e.parseArrays,
              plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : i.plainObjects,
              strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : i.strictNullHandling
            };
          }(t);

          if ("" === e || null == e) return r.plainObjects ? Object.create(null) : {};

          for (var l = "string" == typeof e ? function (e, t) {
            var r,
                u = {},
                l = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
                h = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
                p = l.split(t.delimiter, h),
                f = -1,
                d = t.charset;
            if (t.charsetSentinel) for (r = 0; r < p.length; ++r) {
              0 === p[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === p[r] ? d = "utf-8" : "utf8=%26%2310003%3B" === p[r] && (d = "iso-8859-1"), f = r, r = p.length);
            }

            for (r = 0; r < p.length; ++r) {
              if (r !== f) {
                var g,
                    y,
                    m = p[r],
                    b = m.indexOf("]="),
                    w = -1 === b ? m.indexOf("=") : b + 1;
                -1 === w ? (g = t.decoder(m, i.decoder, d, "key"), y = t.strictNullHandling ? null : "") : (g = t.decoder(m.slice(0, w), i.decoder, d, "key"), y = n.maybeMap(c(m.slice(w + 1), t), function (e) {
                  return t.decoder(e, i.decoder, d, "value");
                })), y && t.interpretNumericEntities && "iso-8859-1" === d && (y = a(y)), m.indexOf("[]=") > -1 && (y = s(y) ? [y] : y), o.call(u, g) ? u[g] = n.combine(u[g], y) : u[g] = y;
              }
            }

            return u;
          }(e, r) : e, h = r.plainObjects ? Object.create(null) : {}, p = Object.keys(l), f = 0; f < p.length; ++f) {
            var d = p[f],
                g = u(d, l[d], r, "string" == typeof e);
            h = n.merge(h, g, r);
          }

          return !0 === r.allowSparse ? h : n.compact(h);
        };
      },
      4246: function _(e, t, r) {
        "use strict";

        var n = r(3680),
            o = r(4562),
            s = r(5335),
            i = Object.prototype.hasOwnProperty,
            a = {
          brackets: function brackets(e) {
            return e + "[]";
          },
          comma: "comma",
          indices: function indices(e, t) {
            return e + "[" + t + "]";
          },
          repeat: function repeat(e) {
            return e;
          }
        },
            c = Array.isArray,
            u = Array.prototype.push,
            l = function l(e, t) {
          u.apply(e, c(t) ? t : [t]);
        },
            h = Date.prototype.toISOString,
            p = s.default,
            f = {
          addQueryPrefix: !1,
          allowDots: !1,
          charset: "utf-8",
          charsetSentinel: !1,
          delimiter: "&",
          encode: !0,
          encoder: o.encode,
          encodeValuesOnly: !1,
          format: p,
          formatter: s.formatters[p],
          indices: !1,
          serializeDate: function serializeDate(e) {
            return h.call(e);
          },
          skipNulls: !1,
          strictNullHandling: !1
        },
            d = function e(t, r, s, i, a, u, h, p, d, g, y, m, b, w, A) {
          var v,
              x = t;
          if (A.has(t)) throw new RangeError("Cyclic object value");

          if ("function" == typeof h ? x = h(r, x) : x instanceof Date ? x = g(x) : "comma" === s && c(x) && (x = o.maybeMap(x, function (e) {
            return e instanceof Date ? g(e) : e;
          })), null === x) {
            if (i) return u && !b ? u(r, f.encoder, w, "key", y) : r;
            x = "";
          }

          if ("string" == typeof (v = x) || "number" == typeof v || "boolean" == typeof v || "symbol" == typeof v || "bigint" == typeof v || o.isBuffer(x)) return u ? [m(b ? r : u(r, f.encoder, w, "key", y)) + "=" + m(u(x, f.encoder, w, "value", y))] : [m(r) + "=" + m(String(x))];
          var S,
              E = [];
          if (void 0 === x) return E;
          if ("comma" === s && c(x)) S = [{
            value: x.length > 0 ? x.join(",") || null : void 0
          }];else if (c(h)) S = h;else {
            var T = Object.keys(x);
            S = p ? T.sort(p) : T;
          }

          for (var _ = 0; _ < S.length; ++_) {
            var B = S[_],
                k = "object" == typeof B && void 0 !== B.value ? B.value : x[B];

            if (!a || null !== k) {
              var I = c(x) ? "function" == typeof s ? s(r, B) : r : r + (d ? "." + B : "[" + B + "]");
              A.set(t, !0);
              var U = n();
              l(E, e(k, I, s, i, a, u, h, p, d, g, y, m, b, w, U));
            }
          }

          return E;
        };

        e.exports = function (e, t) {
          var r,
              o = e,
              u = function (e) {
            if (!e) return f;
            if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder) throw new TypeError("Encoder has to be a function.");
            var t = e.charset || f.charset;
            if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var r = s.default;

            if (void 0 !== e.format) {
              if (!i.call(s.formatters, e.format)) throw new TypeError("Unknown format option provided.");
              r = e.format;
            }

            var n = s.formatters[r],
                o = f.filter;
            return ("function" == typeof e.filter || c(e.filter)) && (o = e.filter), {
              addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : f.addQueryPrefix,
              allowDots: void 0 === e.allowDots ? f.allowDots : !!e.allowDots,
              charset: t,
              charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : f.charsetSentinel,
              delimiter: void 0 === e.delimiter ? f.delimiter : e.delimiter,
              encode: "boolean" == typeof e.encode ? e.encode : f.encode,
              encoder: "function" == typeof e.encoder ? e.encoder : f.encoder,
              encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : f.encodeValuesOnly,
              filter: o,
              format: r,
              formatter: n,
              serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : f.serializeDate,
              skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : f.skipNulls,
              sort: "function" == typeof e.sort ? e.sort : null,
              strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : f.strictNullHandling
            };
          }(t);

          "function" == typeof u.filter ? o = (0, u.filter)("", o) : c(u.filter) && (r = u.filter);
          var h,
              p = [];
          if ("object" != typeof o || null === o) return "";
          h = t && t.arrayFormat in a ? t.arrayFormat : t && "indices" in t ? t.indices ? "indices" : "repeat" : "indices";
          var g = a[h];
          r || (r = Object.keys(o)), u.sort && r.sort(u.sort);

          for (var y = n(), m = 0; m < r.length; ++m) {
            var b = r[m];
            u.skipNulls && null === o[b] || l(p, d(o[b], b, g, u.strictNullHandling, u.skipNulls, u.encode ? u.encoder : null, u.filter, u.sort, u.allowDots, u.serializeDate, u.format, u.formatter, u.encodeValuesOnly, u.charset, y));
          }

          var w = p.join(u.delimiter),
              A = !0 === u.addQueryPrefix ? "?" : "";
          return u.charsetSentinel && ("iso-8859-1" === u.charset ? A += "utf8=%26%2310003%3B&" : A += "utf8=%E2%9C%93&"), w.length > 0 ? A + w : "";
        };
      },
      4562: function _(e, t, r) {
        "use strict";

        var n = r(5335),
            o = Object.prototype.hasOwnProperty,
            s = Array.isArray,
            i = function () {
          for (var e = [], t = 0; t < 256; ++t) {
            e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
          }

          return e;
        }(),
            a = function a(e, t) {
          for (var r = t && t.plainObjects ? Object.create(null) : {}, n = 0; n < e.length; ++n) {
            void 0 !== e[n] && (r[n] = e[n]);
          }

          return r;
        };

        e.exports = {
          arrayToObject: a,
          assign: function assign(e, t) {
            return Object.keys(t).reduce(function (e, r) {
              return e[r] = t[r], e;
            }, e);
          },
          combine: function combine(e, t) {
            return [].concat(e, t);
          },
          compact: function compact(e) {
            for (var t = [{
              obj: {
                o: e
              },
              prop: "o"
            }], r = [], n = 0; n < t.length; ++n) {
              for (var o = t[n], i = o.obj[o.prop], a = Object.keys(i), c = 0; c < a.length; ++c) {
                var u = a[c],
                    l = i[u];
                "object" == typeof l && null !== l && -1 === r.indexOf(l) && (t.push({
                  obj: i,
                  prop: u
                }), r.push(l));
              }
            }

            return function (e) {
              for (; e.length > 1;) {
                var t = e.pop(),
                    r = t.obj[t.prop];

                if (s(r)) {
                  for (var n = [], o = 0; o < r.length; ++o) {
                    void 0 !== r[o] && n.push(r[o]);
                  }

                  t.obj[t.prop] = n;
                }
              }
            }(t), e;
          },
          decode: function decode(e, t, r) {
            var n = e.replace(/\+/g, " ");
            if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);

            try {
              return decodeURIComponent(n);
            } catch (e) {
              return n;
            }
          },
          encode: function encode(e, t, r, o, s) {
            if (0 === e.length) return e;
            var a = e;
            if ("symbol" == typeof e ? a = Symbol.prototype.toString.call(e) : "string" != typeof e && (a = String(e)), "iso-8859-1" === r) return escape(a).replace(/%u[0-9a-f]{4}/gi, function (e) {
              return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
            });

            for (var c = "", u = 0; u < a.length; ++u) {
              var l = a.charCodeAt(u);
              45 === l || 46 === l || 95 === l || 126 === l || l >= 48 && l <= 57 || l >= 65 && l <= 90 || l >= 97 && l <= 122 || s === n.RFC1738 && (40 === l || 41 === l) ? c += a.charAt(u) : l < 128 ? c += i[l] : l < 2048 ? c += i[192 | l >> 6] + i[128 | 63 & l] : l < 55296 || l >= 57344 ? c += i[224 | l >> 12] + i[128 | l >> 6 & 63] + i[128 | 63 & l] : (u += 1, l = 65536 + ((1023 & l) << 10 | 1023 & a.charCodeAt(u)), c += i[240 | l >> 18] + i[128 | l >> 12 & 63] + i[128 | l >> 6 & 63] + i[128 | 63 & l]);
            }

            return c;
          },
          isBuffer: function isBuffer(e) {
            return !(!e || "object" != typeof e || !(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e)));
          },
          isRegExp: function isRegExp(e) {
            return "[object RegExp]" === Object.prototype.toString.call(e);
          },
          maybeMap: function maybeMap(e, t) {
            if (s(e)) {
              for (var r = [], n = 0; n < e.length; n += 1) {
                r.push(t(e[n]));
              }

              return r;
            }

            return t(e);
          },
          merge: function e(t, r, n) {
            if (!r) return t;

            if ("object" != typeof r) {
              if (s(t)) t.push(r);else {
                if (!t || "object" != typeof t) return [t, r];
                (n && (n.plainObjects || n.allowPrototypes) || !o.call(Object.prototype, r)) && (t[r] = !0);
              }
              return t;
            }

            if (!t || "object" != typeof t) return [t].concat(r);
            var i = t;
            return s(t) && !s(r) && (i = a(t, n)), s(t) && s(r) ? (r.forEach(function (r, s) {
              if (o.call(t, s)) {
                var i = t[s];
                i && "object" == typeof i && r && "object" == typeof r ? t[s] = e(i, r, n) : t.push(r);
              } else t[s] = r;
            }), t) : Object.keys(r).reduce(function (t, s) {
              var i = r[s];
              return o.call(t, s) ? t[s] = e(t[s], i, n) : t[s] = i, t;
            }, i);
          }
        };
      },
      7765: function _(e, t) {
        !function (e) {
          "use strict";

          var t = function t(e) {
            var t,
                r = new Float64Array(16);
            if (e) for (t = 0; t < e.length; t++) {
              r[t] = e[t];
            }
            return r;
          },
              r = function r() {
            throw new Error("no PRNG");
          },
              n = new Uint8Array(16),
              o = new Uint8Array(32);

          o[0] = 9;
          var s = t(),
              i = t([1]),
              a = t([56129, 1]),
              c = t([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]),
              u = t([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]),
              l = t([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]),
              h = t([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]),
              p = t([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);

          function f(e, t, r, n) {
            e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = 255 & r, e[t + 4] = n >> 24 & 255, e[t + 5] = n >> 16 & 255, e[t + 6] = n >> 8 & 255, e[t + 7] = 255 & n;
          }

          function d(e, t, r, n, o) {
            var s,
                i = 0;

            for (s = 0; s < o; s++) {
              i |= e[t + s] ^ r[n + s];
            }

            return (1 & i - 1 >>> 8) - 1;
          }

          function g(e, t, r, n) {
            return d(e, t, r, n, 16);
          }

          function y(e, t, r, n) {
            return d(e, t, r, n, 32);
          }

          function m(e, t, r, n) {
            !function (e, t, r, n) {
              for (var o, s = 255 & n[0] | (255 & n[1]) << 8 | (255 & n[2]) << 16 | (255 & n[3]) << 24, i = 255 & r[0] | (255 & r[1]) << 8 | (255 & r[2]) << 16 | (255 & r[3]) << 24, a = 255 & r[4] | (255 & r[5]) << 8 | (255 & r[6]) << 16 | (255 & r[7]) << 24, c = 255 & r[8] | (255 & r[9]) << 8 | (255 & r[10]) << 16 | (255 & r[11]) << 24, u = 255 & r[12] | (255 & r[13]) << 8 | (255 & r[14]) << 16 | (255 & r[15]) << 24, l = 255 & n[4] | (255 & n[5]) << 8 | (255 & n[6]) << 16 | (255 & n[7]) << 24, h = 255 & t[0] | (255 & t[1]) << 8 | (255 & t[2]) << 16 | (255 & t[3]) << 24, p = 255 & t[4] | (255 & t[5]) << 8 | (255 & t[6]) << 16 | (255 & t[7]) << 24, f = 255 & t[8] | (255 & t[9]) << 8 | (255 & t[10]) << 16 | (255 & t[11]) << 24, d = 255 & t[12] | (255 & t[13]) << 8 | (255 & t[14]) << 16 | (255 & t[15]) << 24, g = 255 & n[8] | (255 & n[9]) << 8 | (255 & n[10]) << 16 | (255 & n[11]) << 24, y = 255 & r[16] | (255 & r[17]) << 8 | (255 & r[18]) << 16 | (255 & r[19]) << 24, m = 255 & r[20] | (255 & r[21]) << 8 | (255 & r[22]) << 16 | (255 & r[23]) << 24, b = 255 & r[24] | (255 & r[25]) << 8 | (255 & r[26]) << 16 | (255 & r[27]) << 24, w = 255 & r[28] | (255 & r[29]) << 8 | (255 & r[30]) << 16 | (255 & r[31]) << 24, A = 255 & n[12] | (255 & n[13]) << 8 | (255 & n[14]) << 16 | (255 & n[15]) << 24, v = s, x = i, S = a, E = c, T = u, _ = l, B = h, k = p, I = f, U = d, C = g, R = y, O = m, D = b, N = w, P = A, L = 0; L < 20; L += 2) {
                v ^= (o = (O ^= (o = (I ^= (o = (T ^= (o = v + O | 0) << 7 | o >>> 25) + v | 0) << 9 | o >>> 23) + T | 0) << 13 | o >>> 19) + I | 0) << 18 | o >>> 14, _ ^= (o = (x ^= (o = (D ^= (o = (U ^= (o = _ + x | 0) << 7 | o >>> 25) + _ | 0) << 9 | o >>> 23) + U | 0) << 13 | o >>> 19) + D | 0) << 18 | o >>> 14, C ^= (o = (B ^= (o = (S ^= (o = (N ^= (o = C + B | 0) << 7 | o >>> 25) + C | 0) << 9 | o >>> 23) + N | 0) << 13 | o >>> 19) + S | 0) << 18 | o >>> 14, P ^= (o = (R ^= (o = (k ^= (o = (E ^= (o = P + R | 0) << 7 | o >>> 25) + P | 0) << 9 | o >>> 23) + E | 0) << 13 | o >>> 19) + k | 0) << 18 | o >>> 14, v ^= (o = (E ^= (o = (S ^= (o = (x ^= (o = v + E | 0) << 7 | o >>> 25) + v | 0) << 9 | o >>> 23) + x | 0) << 13 | o >>> 19) + S | 0) << 18 | o >>> 14, _ ^= (o = (T ^= (o = (k ^= (o = (B ^= (o = _ + T | 0) << 7 | o >>> 25) + _ | 0) << 9 | o >>> 23) + B | 0) << 13 | o >>> 19) + k | 0) << 18 | o >>> 14, C ^= (o = (U ^= (o = (I ^= (o = (R ^= (o = C + U | 0) << 7 | o >>> 25) + C | 0) << 9 | o >>> 23) + R | 0) << 13 | o >>> 19) + I | 0) << 18 | o >>> 14, P ^= (o = (N ^= (o = (D ^= (o = (O ^= (o = P + N | 0) << 7 | o >>> 25) + P | 0) << 9 | o >>> 23) + O | 0) << 13 | o >>> 19) + D | 0) << 18 | o >>> 14;
              }

              v = v + s | 0, x = x + i | 0, S = S + a | 0, E = E + c | 0, T = T + u | 0, _ = _ + l | 0, B = B + h | 0, k = k + p | 0, I = I + f | 0, U = U + d | 0, C = C + g | 0, R = R + y | 0, O = O + m | 0, D = D + b | 0, N = N + w | 0, P = P + A | 0, e[0] = v >>> 0 & 255, e[1] = v >>> 8 & 255, e[2] = v >>> 16 & 255, e[3] = v >>> 24 & 255, e[4] = x >>> 0 & 255, e[5] = x >>> 8 & 255, e[6] = x >>> 16 & 255, e[7] = x >>> 24 & 255, e[8] = S >>> 0 & 255, e[9] = S >>> 8 & 255, e[10] = S >>> 16 & 255, e[11] = S >>> 24 & 255, e[12] = E >>> 0 & 255, e[13] = E >>> 8 & 255, e[14] = E >>> 16 & 255, e[15] = E >>> 24 & 255, e[16] = T >>> 0 & 255, e[17] = T >>> 8 & 255, e[18] = T >>> 16 & 255, e[19] = T >>> 24 & 255, e[20] = _ >>> 0 & 255, e[21] = _ >>> 8 & 255, e[22] = _ >>> 16 & 255, e[23] = _ >>> 24 & 255, e[24] = B >>> 0 & 255, e[25] = B >>> 8 & 255, e[26] = B >>> 16 & 255, e[27] = B >>> 24 & 255, e[28] = k >>> 0 & 255, e[29] = k >>> 8 & 255, e[30] = k >>> 16 & 255, e[31] = k >>> 24 & 255, e[32] = I >>> 0 & 255, e[33] = I >>> 8 & 255, e[34] = I >>> 16 & 255, e[35] = I >>> 24 & 255, e[36] = U >>> 0 & 255, e[37] = U >>> 8 & 255, e[38] = U >>> 16 & 255, e[39] = U >>> 24 & 255, e[40] = C >>> 0 & 255, e[41] = C >>> 8 & 255, e[42] = C >>> 16 & 255, e[43] = C >>> 24 & 255, e[44] = R >>> 0 & 255, e[45] = R >>> 8 & 255, e[46] = R >>> 16 & 255, e[47] = R >>> 24 & 255, e[48] = O >>> 0 & 255, e[49] = O >>> 8 & 255, e[50] = O >>> 16 & 255, e[51] = O >>> 24 & 255, e[52] = D >>> 0 & 255, e[53] = D >>> 8 & 255, e[54] = D >>> 16 & 255, e[55] = D >>> 24 & 255, e[56] = N >>> 0 & 255, e[57] = N >>> 8 & 255, e[58] = N >>> 16 & 255, e[59] = N >>> 24 & 255, e[60] = P >>> 0 & 255, e[61] = P >>> 8 & 255, e[62] = P >>> 16 & 255, e[63] = P >>> 24 & 255;
            }(e, t, r, n);
          }

          function b(e, t, r, n) {
            !function (e, t, r, n) {
              for (var o, s = 255 & n[0] | (255 & n[1]) << 8 | (255 & n[2]) << 16 | (255 & n[3]) << 24, i = 255 & r[0] | (255 & r[1]) << 8 | (255 & r[2]) << 16 | (255 & r[3]) << 24, a = 255 & r[4] | (255 & r[5]) << 8 | (255 & r[6]) << 16 | (255 & r[7]) << 24, c = 255 & r[8] | (255 & r[9]) << 8 | (255 & r[10]) << 16 | (255 & r[11]) << 24, u = 255 & r[12] | (255 & r[13]) << 8 | (255 & r[14]) << 16 | (255 & r[15]) << 24, l = 255 & n[4] | (255 & n[5]) << 8 | (255 & n[6]) << 16 | (255 & n[7]) << 24, h = 255 & t[0] | (255 & t[1]) << 8 | (255 & t[2]) << 16 | (255 & t[3]) << 24, p = 255 & t[4] | (255 & t[5]) << 8 | (255 & t[6]) << 16 | (255 & t[7]) << 24, f = 255 & t[8] | (255 & t[9]) << 8 | (255 & t[10]) << 16 | (255 & t[11]) << 24, d = 255 & t[12] | (255 & t[13]) << 8 | (255 & t[14]) << 16 | (255 & t[15]) << 24, g = 255 & n[8] | (255 & n[9]) << 8 | (255 & n[10]) << 16 | (255 & n[11]) << 24, y = 255 & r[16] | (255 & r[17]) << 8 | (255 & r[18]) << 16 | (255 & r[19]) << 24, m = 255 & r[20] | (255 & r[21]) << 8 | (255 & r[22]) << 16 | (255 & r[23]) << 24, b = 255 & r[24] | (255 & r[25]) << 8 | (255 & r[26]) << 16 | (255 & r[27]) << 24, w = 255 & r[28] | (255 & r[29]) << 8 | (255 & r[30]) << 16 | (255 & r[31]) << 24, A = 255 & n[12] | (255 & n[13]) << 8 | (255 & n[14]) << 16 | (255 & n[15]) << 24, v = 0; v < 20; v += 2) {
                s ^= (o = (m ^= (o = (f ^= (o = (u ^= (o = s + m | 0) << 7 | o >>> 25) + s | 0) << 9 | o >>> 23) + u | 0) << 13 | o >>> 19) + f | 0) << 18 | o >>> 14, l ^= (o = (i ^= (o = (b ^= (o = (d ^= (o = l + i | 0) << 7 | o >>> 25) + l | 0) << 9 | o >>> 23) + d | 0) << 13 | o >>> 19) + b | 0) << 18 | o >>> 14, g ^= (o = (h ^= (o = (a ^= (o = (w ^= (o = g + h | 0) << 7 | o >>> 25) + g | 0) << 9 | o >>> 23) + w | 0) << 13 | o >>> 19) + a | 0) << 18 | o >>> 14, A ^= (o = (y ^= (o = (p ^= (o = (c ^= (o = A + y | 0) << 7 | o >>> 25) + A | 0) << 9 | o >>> 23) + c | 0) << 13 | o >>> 19) + p | 0) << 18 | o >>> 14, s ^= (o = (c ^= (o = (a ^= (o = (i ^= (o = s + c | 0) << 7 | o >>> 25) + s | 0) << 9 | o >>> 23) + i | 0) << 13 | o >>> 19) + a | 0) << 18 | o >>> 14, l ^= (o = (u ^= (o = (p ^= (o = (h ^= (o = l + u | 0) << 7 | o >>> 25) + l | 0) << 9 | o >>> 23) + h | 0) << 13 | o >>> 19) + p | 0) << 18 | o >>> 14, g ^= (o = (d ^= (o = (f ^= (o = (y ^= (o = g + d | 0) << 7 | o >>> 25) + g | 0) << 9 | o >>> 23) + y | 0) << 13 | o >>> 19) + f | 0) << 18 | o >>> 14, A ^= (o = (w ^= (o = (b ^= (o = (m ^= (o = A + w | 0) << 7 | o >>> 25) + A | 0) << 9 | o >>> 23) + m | 0) << 13 | o >>> 19) + b | 0) << 18 | o >>> 14;
              }

              e[0] = s >>> 0 & 255, e[1] = s >>> 8 & 255, e[2] = s >>> 16 & 255, e[3] = s >>> 24 & 255, e[4] = l >>> 0 & 255, e[5] = l >>> 8 & 255, e[6] = l >>> 16 & 255, e[7] = l >>> 24 & 255, e[8] = g >>> 0 & 255, e[9] = g >>> 8 & 255, e[10] = g >>> 16 & 255, e[11] = g >>> 24 & 255, e[12] = A >>> 0 & 255, e[13] = A >>> 8 & 255, e[14] = A >>> 16 & 255, e[15] = A >>> 24 & 255, e[16] = h >>> 0 & 255, e[17] = h >>> 8 & 255, e[18] = h >>> 16 & 255, e[19] = h >>> 24 & 255, e[20] = p >>> 0 & 255, e[21] = p >>> 8 & 255, e[22] = p >>> 16 & 255, e[23] = p >>> 24 & 255, e[24] = f >>> 0 & 255, e[25] = f >>> 8 & 255, e[26] = f >>> 16 & 255, e[27] = f >>> 24 & 255, e[28] = d >>> 0 & 255, e[29] = d >>> 8 & 255, e[30] = d >>> 16 & 255, e[31] = d >>> 24 & 255;
            }(e, t, r, n);
          }

          var w = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);

          function A(e, t, r, n, o, s, i) {
            var a,
                c,
                u = new Uint8Array(16),
                l = new Uint8Array(64);

            for (c = 0; c < 16; c++) {
              u[c] = 0;
            }

            for (c = 0; c < 8; c++) {
              u[c] = s[c];
            }

            for (; o >= 64;) {
              for (m(l, u, i, w), c = 0; c < 64; c++) {
                e[t + c] = r[n + c] ^ l[c];
              }

              for (a = 1, c = 8; c < 16; c++) {
                a = a + (255 & u[c]) | 0, u[c] = 255 & a, a >>>= 8;
              }

              o -= 64, t += 64, n += 64;
            }

            if (o > 0) for (m(l, u, i, w), c = 0; c < o; c++) {
              e[t + c] = r[n + c] ^ l[c];
            }
            return 0;
          }

          function v(e, t, r, n, o) {
            var s,
                i,
                a = new Uint8Array(16),
                c = new Uint8Array(64);

            for (i = 0; i < 16; i++) {
              a[i] = 0;
            }

            for (i = 0; i < 8; i++) {
              a[i] = n[i];
            }

            for (; r >= 64;) {
              for (m(c, a, o, w), i = 0; i < 64; i++) {
                e[t + i] = c[i];
              }

              for (s = 1, i = 8; i < 16; i++) {
                s = s + (255 & a[i]) | 0, a[i] = 255 & s, s >>>= 8;
              }

              r -= 64, t += 64;
            }

            if (r > 0) for (m(c, a, o, w), i = 0; i < r; i++) {
              e[t + i] = c[i];
            }
            return 0;
          }

          function x(e, t, r, n, o) {
            var s = new Uint8Array(32);
            b(s, n, o, w);

            for (var i = new Uint8Array(8), a = 0; a < 8; a++) {
              i[a] = n[a + 16];
            }

            return v(e, t, r, i, s);
          }

          function S(e, t, r, n, o, s, i) {
            var a = new Uint8Array(32);
            b(a, s, i, w);

            for (var c = new Uint8Array(8), u = 0; u < 8; u++) {
              c[u] = s[u + 16];
            }

            return A(e, t, r, n, o, c, a);
          }

          var E = function E(e) {
            var t, r, n, o, s, i, a, c;
            this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0, t = 255 & e[0] | (255 & e[1]) << 8, this.r[0] = 8191 & t, r = 255 & e[2] | (255 & e[3]) << 8, this.r[1] = 8191 & (t >>> 13 | r << 3), n = 255 & e[4] | (255 & e[5]) << 8, this.r[2] = 7939 & (r >>> 10 | n << 6), o = 255 & e[6] | (255 & e[7]) << 8, this.r[3] = 8191 & (n >>> 7 | o << 9), s = 255 & e[8] | (255 & e[9]) << 8, this.r[4] = 255 & (o >>> 4 | s << 12), this.r[5] = s >>> 1 & 8190, i = 255 & e[10] | (255 & e[11]) << 8, this.r[6] = 8191 & (s >>> 14 | i << 2), a = 255 & e[12] | (255 & e[13]) << 8, this.r[7] = 8065 & (i >>> 11 | a << 5), c = 255 & e[14] | (255 & e[15]) << 8, this.r[8] = 8191 & (a >>> 8 | c << 8), this.r[9] = c >>> 5 & 127, this.pad[0] = 255 & e[16] | (255 & e[17]) << 8, this.pad[1] = 255 & e[18] | (255 & e[19]) << 8, this.pad[2] = 255 & e[20] | (255 & e[21]) << 8, this.pad[3] = 255 & e[22] | (255 & e[23]) << 8, this.pad[4] = 255 & e[24] | (255 & e[25]) << 8, this.pad[5] = 255 & e[26] | (255 & e[27]) << 8, this.pad[6] = 255 & e[28] | (255 & e[29]) << 8, this.pad[7] = 255 & e[30] | (255 & e[31]) << 8;
          };

          function T(e, t, r, n, o, s) {
            var i = new E(s);
            return i.update(r, n, o), i.finish(e, t), 0;
          }

          function _(e, t, r, n, o, s) {
            var i = new Uint8Array(16);
            return T(i, 0, r, n, o, s), g(e, t, i, 0);
          }

          function B(e, t, r, n, o) {
            var s;
            if (r < 32) return -1;

            for (S(e, 0, t, 0, r, n, o), T(e, 16, e, 32, r - 32, e), s = 0; s < 16; s++) {
              e[s] = 0;
            }

            return 0;
          }

          function k(e, t, r, n, o) {
            var s,
                i = new Uint8Array(32);
            if (r < 32) return -1;
            if (x(i, 0, 32, n, o), 0 !== _(t, 16, t, 32, r - 32, i)) return -1;

            for (S(e, 0, t, 0, r, n, o), s = 0; s < 32; s++) {
              e[s] = 0;
            }

            return 0;
          }

          function I(e, t) {
            var r;

            for (r = 0; r < 16; r++) {
              e[r] = 0 | t[r];
            }
          }

          function U(e) {
            var t,
                r,
                n = 1;

            for (t = 0; t < 16; t++) {
              r = e[t] + n + 65535, n = Math.floor(r / 65536), e[t] = r - 65536 * n;
            }

            e[0] += n - 1 + 37 * (n - 1);
          }

          function C(e, t, r) {
            for (var n, o = ~(r - 1), s = 0; s < 16; s++) {
              n = o & (e[s] ^ t[s]), e[s] ^= n, t[s] ^= n;
            }
          }

          function R(e, r) {
            var n,
                o,
                s,
                i = t(),
                a = t();

            for (n = 0; n < 16; n++) {
              a[n] = r[n];
            }

            for (U(a), U(a), U(a), o = 0; o < 2; o++) {
              for (i[0] = a[0] - 65517, n = 1; n < 15; n++) {
                i[n] = a[n] - 65535 - (i[n - 1] >> 16 & 1), i[n - 1] &= 65535;
              }

              i[15] = a[15] - 32767 - (i[14] >> 16 & 1), s = i[15] >> 16 & 1, i[14] &= 65535, C(a, i, 1 - s);
            }

            for (n = 0; n < 16; n++) {
              e[2 * n] = 255 & a[n], e[2 * n + 1] = a[n] >> 8;
            }
          }

          function O(e, t) {
            var r = new Uint8Array(32),
                n = new Uint8Array(32);
            return R(r, e), R(n, t), y(r, 0, n, 0);
          }

          function D(e) {
            var t = new Uint8Array(32);
            return R(t, e), 1 & t[0];
          }

          function N(e, t) {
            var r;

            for (r = 0; r < 16; r++) {
              e[r] = t[2 * r] + (t[2 * r + 1] << 8);
            }

            e[15] &= 32767;
          }

          function P(e, t, r) {
            for (var n = 0; n < 16; n++) {
              e[n] = t[n] + r[n];
            }
          }

          function L(e, t, r) {
            for (var n = 0; n < 16; n++) {
              e[n] = t[n] - r[n];
            }
          }

          function F(e, t, r) {
            var n,
                o,
                s = 0,
                i = 0,
                a = 0,
                c = 0,
                u = 0,
                l = 0,
                h = 0,
                p = 0,
                f = 0,
                d = 0,
                g = 0,
                y = 0,
                m = 0,
                b = 0,
                w = 0,
                A = 0,
                v = 0,
                x = 0,
                S = 0,
                E = 0,
                T = 0,
                _ = 0,
                B = 0,
                k = 0,
                I = 0,
                U = 0,
                C = 0,
                R = 0,
                O = 0,
                D = 0,
                N = 0,
                P = r[0],
                L = r[1],
                F = r[2],
                j = r[3],
                z = r[4],
                M = r[5],
                H = r[6],
                G = r[7],
                K = r[8],
                q = r[9],
                $ = r[10],
                V = r[11],
                W = r[12],
                X = r[13],
                Y = r[14],
                J = r[15];
            s += (n = t[0]) * P, i += n * L, a += n * F, c += n * j, u += n * z, l += n * M, h += n * H, p += n * G, f += n * K, d += n * q, g += n * $, y += n * V, m += n * W, b += n * X, w += n * Y, A += n * J, i += (n = t[1]) * P, a += n * L, c += n * F, u += n * j, l += n * z, h += n * M, p += n * H, f += n * G, d += n * K, g += n * q, y += n * $, m += n * V, b += n * W, w += n * X, A += n * Y, v += n * J, a += (n = t[2]) * P, c += n * L, u += n * F, l += n * j, h += n * z, p += n * M, f += n * H, d += n * G, g += n * K, y += n * q, m += n * $, b += n * V, w += n * W, A += n * X, v += n * Y, x += n * J, c += (n = t[3]) * P, u += n * L, l += n * F, h += n * j, p += n * z, f += n * M, d += n * H, g += n * G, y += n * K, m += n * q, b += n * $, w += n * V, A += n * W, v += n * X, x += n * Y, S += n * J, u += (n = t[4]) * P, l += n * L, h += n * F, p += n * j, f += n * z, d += n * M, g += n * H, y += n * G, m += n * K, b += n * q, w += n * $, A += n * V, v += n * W, x += n * X, S += n * Y, E += n * J, l += (n = t[5]) * P, h += n * L, p += n * F, f += n * j, d += n * z, g += n * M, y += n * H, m += n * G, b += n * K, w += n * q, A += n * $, v += n * V, x += n * W, S += n * X, E += n * Y, T += n * J, h += (n = t[6]) * P, p += n * L, f += n * F, d += n * j, g += n * z, y += n * M, m += n * H, b += n * G, w += n * K, A += n * q, v += n * $, x += n * V, S += n * W, E += n * X, T += n * Y, _ += n * J, p += (n = t[7]) * P, f += n * L, d += n * F, g += n * j, y += n * z, m += n * M, b += n * H, w += n * G, A += n * K, v += n * q, x += n * $, S += n * V, E += n * W, T += n * X, _ += n * Y, B += n * J, f += (n = t[8]) * P, d += n * L, g += n * F, y += n * j, m += n * z, b += n * M, w += n * H, A += n * G, v += n * K, x += n * q, S += n * $, E += n * V, T += n * W, _ += n * X, B += n * Y, k += n * J, d += (n = t[9]) * P, g += n * L, y += n * F, m += n * j, b += n * z, w += n * M, A += n * H, v += n * G, x += n * K, S += n * q, E += n * $, T += n * V, _ += n * W, B += n * X, k += n * Y, I += n * J, g += (n = t[10]) * P, y += n * L, m += n * F, b += n * j, w += n * z, A += n * M, v += n * H, x += n * G, S += n * K, E += n * q, T += n * $, _ += n * V, B += n * W, k += n * X, I += n * Y, U += n * J, y += (n = t[11]) * P, m += n * L, b += n * F, w += n * j, A += n * z, v += n * M, x += n * H, S += n * G, E += n * K, T += n * q, _ += n * $, B += n * V, k += n * W, I += n * X, U += n * Y, C += n * J, m += (n = t[12]) * P, b += n * L, w += n * F, A += n * j, v += n * z, x += n * M, S += n * H, E += n * G, T += n * K, _ += n * q, B += n * $, k += n * V, I += n * W, U += n * X, C += n * Y, R += n * J, b += (n = t[13]) * P, w += n * L, A += n * F, v += n * j, x += n * z, S += n * M, E += n * H, T += n * G, _ += n * K, B += n * q, k += n * $, I += n * V, U += n * W, C += n * X, R += n * Y, O += n * J, w += (n = t[14]) * P, A += n * L, v += n * F, x += n * j, S += n * z, E += n * M, T += n * H, _ += n * G, B += n * K, k += n * q, I += n * $, U += n * V, C += n * W, R += n * X, O += n * Y, D += n * J, A += (n = t[15]) * P, i += 38 * (x += n * F), a += 38 * (S += n * j), c += 38 * (E += n * z), u += 38 * (T += n * M), l += 38 * (_ += n * H), h += 38 * (B += n * G), p += 38 * (k += n * K), f += 38 * (I += n * q), d += 38 * (U += n * $), g += 38 * (C += n * V), y += 38 * (R += n * W), m += 38 * (O += n * X), b += 38 * (D += n * Y), w += 38 * (N += n * J), s = (n = (s += 38 * (v += n * L)) + (o = 1) + 65535) - 65536 * (o = Math.floor(n / 65536)), i = (n = i + o + 65535) - 65536 * (o = Math.floor(n / 65536)), a = (n = a + o + 65535) - 65536 * (o = Math.floor(n / 65536)), c = (n = c + o + 65535) - 65536 * (o = Math.floor(n / 65536)), u = (n = u + o + 65535) - 65536 * (o = Math.floor(n / 65536)), l = (n = l + o + 65535) - 65536 * (o = Math.floor(n / 65536)), h = (n = h + o + 65535) - 65536 * (o = Math.floor(n / 65536)), p = (n = p + o + 65535) - 65536 * (o = Math.floor(n / 65536)), f = (n = f + o + 65535) - 65536 * (o = Math.floor(n / 65536)), d = (n = d + o + 65535) - 65536 * (o = Math.floor(n / 65536)), g = (n = g + o + 65535) - 65536 * (o = Math.floor(n / 65536)), y = (n = y + o + 65535) - 65536 * (o = Math.floor(n / 65536)), m = (n = m + o + 65535) - 65536 * (o = Math.floor(n / 65536)), b = (n = b + o + 65535) - 65536 * (o = Math.floor(n / 65536)), w = (n = w + o + 65535) - 65536 * (o = Math.floor(n / 65536)), A = (n = A + o + 65535) - 65536 * (o = Math.floor(n / 65536)), s = (n = (s += o - 1 + 37 * (o - 1)) + (o = 1) + 65535) - 65536 * (o = Math.floor(n / 65536)), i = (n = i + o + 65535) - 65536 * (o = Math.floor(n / 65536)), a = (n = a + o + 65535) - 65536 * (o = Math.floor(n / 65536)), c = (n = c + o + 65535) - 65536 * (o = Math.floor(n / 65536)), u = (n = u + o + 65535) - 65536 * (o = Math.floor(n / 65536)), l = (n = l + o + 65535) - 65536 * (o = Math.floor(n / 65536)), h = (n = h + o + 65535) - 65536 * (o = Math.floor(n / 65536)), p = (n = p + o + 65535) - 65536 * (o = Math.floor(n / 65536)), f = (n = f + o + 65535) - 65536 * (o = Math.floor(n / 65536)), d = (n = d + o + 65535) - 65536 * (o = Math.floor(n / 65536)), g = (n = g + o + 65535) - 65536 * (o = Math.floor(n / 65536)), y = (n = y + o + 65535) - 65536 * (o = Math.floor(n / 65536)), m = (n = m + o + 65535) - 65536 * (o = Math.floor(n / 65536)), b = (n = b + o + 65535) - 65536 * (o = Math.floor(n / 65536)), w = (n = w + o + 65535) - 65536 * (o = Math.floor(n / 65536)), A = (n = A + o + 65535) - 65536 * (o = Math.floor(n / 65536)), s += o - 1 + 37 * (o - 1), e[0] = s, e[1] = i, e[2] = a, e[3] = c, e[4] = u, e[5] = l, e[6] = h, e[7] = p, e[8] = f, e[9] = d, e[10] = g, e[11] = y, e[12] = m, e[13] = b, e[14] = w, e[15] = A;
          }

          function j(e, t) {
            F(e, t, t);
          }

          function z(e, r) {
            var n,
                o = t();

            for (n = 0; n < 16; n++) {
              o[n] = r[n];
            }

            for (n = 253; n >= 0; n--) {
              j(o, o), 2 !== n && 4 !== n && F(o, o, r);
            }

            for (n = 0; n < 16; n++) {
              e[n] = o[n];
            }
          }

          function M(e, r) {
            var n,
                o = t();

            for (n = 0; n < 16; n++) {
              o[n] = r[n];
            }

            for (n = 250; n >= 0; n--) {
              j(o, o), 1 !== n && F(o, o, r);
            }

            for (n = 0; n < 16; n++) {
              e[n] = o[n];
            }
          }

          function H(e, r, n) {
            var o,
                s,
                i = new Uint8Array(32),
                c = new Float64Array(80),
                u = t(),
                l = t(),
                h = t(),
                p = t(),
                f = t(),
                d = t();

            for (s = 0; s < 31; s++) {
              i[s] = r[s];
            }

            for (i[31] = 127 & r[31] | 64, i[0] &= 248, N(c, n), s = 0; s < 16; s++) {
              l[s] = c[s], p[s] = u[s] = h[s] = 0;
            }

            for (u[0] = p[0] = 1, s = 254; s >= 0; --s) {
              C(u, l, o = i[s >>> 3] >>> (7 & s) & 1), C(h, p, o), P(f, u, h), L(u, u, h), P(h, l, p), L(l, l, p), j(p, f), j(d, u), F(u, h, u), F(h, l, f), P(f, u, h), L(u, u, h), j(l, u), L(h, p, d), F(u, h, a), P(u, u, p), F(h, h, u), F(u, p, d), F(p, l, c), j(l, f), C(u, l, o), C(h, p, o);
            }

            for (s = 0; s < 16; s++) {
              c[s + 16] = u[s], c[s + 32] = h[s], c[s + 48] = l[s], c[s + 64] = p[s];
            }

            var g = c.subarray(32),
                y = c.subarray(16);
            return z(g, g), F(y, y, g), R(e, y), 0;
          }

          function G(e, t) {
            return H(e, t, o);
          }

          function K(e, t) {
            return r(t, 32), G(e, t);
          }

          function q(e, t, r) {
            var o = new Uint8Array(32);
            return H(o, r, t), b(e, n, o, w);
          }

          E.prototype.blocks = function (e, t, r) {
            for (var n, o, s, i, a, c, u, l, h, p, f, d, g, y, m, b, w, A, v, x = this.fin ? 0 : 2048, S = this.h[0], E = this.h[1], T = this.h[2], _ = this.h[3], B = this.h[4], k = this.h[5], I = this.h[6], U = this.h[7], C = this.h[8], R = this.h[9], O = this.r[0], D = this.r[1], N = this.r[2], P = this.r[3], L = this.r[4], F = this.r[5], j = this.r[6], z = this.r[7], M = this.r[8], H = this.r[9]; r >= 16;) {
              p = h = 0, p += (S += 8191 & (n = 255 & e[t + 0] | (255 & e[t + 1]) << 8)) * O, p += (E += 8191 & (n >>> 13 | (o = 255 & e[t + 2] | (255 & e[t + 3]) << 8) << 3)) * (5 * H), p += (T += 8191 & (o >>> 10 | (s = 255 & e[t + 4] | (255 & e[t + 5]) << 8) << 6)) * (5 * M), p += (_ += 8191 & (s >>> 7 | (i = 255 & e[t + 6] | (255 & e[t + 7]) << 8) << 9)) * (5 * z), h = (p += (B += 8191 & (i >>> 4 | (a = 255 & e[t + 8] | (255 & e[t + 9]) << 8) << 12)) * (5 * j)) >>> 13, p &= 8191, p += (k += a >>> 1 & 8191) * (5 * F), p += (I += 8191 & (a >>> 14 | (c = 255 & e[t + 10] | (255 & e[t + 11]) << 8) << 2)) * (5 * L), p += (U += 8191 & (c >>> 11 | (u = 255 & e[t + 12] | (255 & e[t + 13]) << 8) << 5)) * (5 * P), p += (C += 8191 & (u >>> 8 | (l = 255 & e[t + 14] | (255 & e[t + 15]) << 8) << 8)) * (5 * N), f = h += (p += (R += l >>> 5 | x) * (5 * D)) >>> 13, f += S * D, f += E * O, f += T * (5 * H), f += _ * (5 * M), h = (f += B * (5 * z)) >>> 13, f &= 8191, f += k * (5 * j), f += I * (5 * F), f += U * (5 * L), f += C * (5 * P), h += (f += R * (5 * N)) >>> 13, f &= 8191, d = h, d += S * N, d += E * D, d += T * O, d += _ * (5 * H), h = (d += B * (5 * M)) >>> 13, d &= 8191, d += k * (5 * z), d += I * (5 * j), d += U * (5 * F), d += C * (5 * L), g = h += (d += R * (5 * P)) >>> 13, g += S * P, g += E * N, g += T * D, g += _ * O, h = (g += B * (5 * H)) >>> 13, g &= 8191, g += k * (5 * M), g += I * (5 * z), g += U * (5 * j), g += C * (5 * F), y = h += (g += R * (5 * L)) >>> 13, y += S * L, y += E * P, y += T * N, y += _ * D, h = (y += B * O) >>> 13, y &= 8191, y += k * (5 * H), y += I * (5 * M), y += U * (5 * z), y += C * (5 * j), m = h += (y += R * (5 * F)) >>> 13, m += S * F, m += E * L, m += T * P, m += _ * N, h = (m += B * D) >>> 13, m &= 8191, m += k * O, m += I * (5 * H), m += U * (5 * M), m += C * (5 * z), b = h += (m += R * (5 * j)) >>> 13, b += S * j, b += E * F, b += T * L, b += _ * P, h = (b += B * N) >>> 13, b &= 8191, b += k * D, b += I * O, b += U * (5 * H), b += C * (5 * M), w = h += (b += R * (5 * z)) >>> 13, w += S * z, w += E * j, w += T * F, w += _ * L, h = (w += B * P) >>> 13, w &= 8191, w += k * N, w += I * D, w += U * O, w += C * (5 * H), A = h += (w += R * (5 * M)) >>> 13, A += S * M, A += E * z, A += T * j, A += _ * F, h = (A += B * L) >>> 13, A &= 8191, A += k * P, A += I * N, A += U * D, A += C * O, v = h += (A += R * (5 * H)) >>> 13, v += S * H, v += E * M, v += T * z, v += _ * j, h = (v += B * F) >>> 13, v &= 8191, v += k * L, v += I * P, v += U * N, v += C * D, S = p = 8191 & (h = (h = ((h += (v += R * O) >>> 13) << 2) + h | 0) + (p &= 8191) | 0), E = f += h >>>= 13, T = d &= 8191, _ = g &= 8191, B = y &= 8191, k = m &= 8191, I = b &= 8191, U = w &= 8191, C = A &= 8191, R = v &= 8191, t += 16, r -= 16;
            }

            this.h[0] = S, this.h[1] = E, this.h[2] = T, this.h[3] = _, this.h[4] = B, this.h[5] = k, this.h[6] = I, this.h[7] = U, this.h[8] = C, this.h[9] = R;
          }, E.prototype.finish = function (e, t) {
            var r,
                n,
                o,
                s,
                i = new Uint16Array(10);

            if (this.leftover) {
              for (s = this.leftover, this.buffer[s++] = 1; s < 16; s++) {
                this.buffer[s] = 0;
              }

              this.fin = 1, this.blocks(this.buffer, 0, 16);
            }

            for (r = this.h[1] >>> 13, this.h[1] &= 8191, s = 2; s < 10; s++) {
              this.h[s] += r, r = this.h[s] >>> 13, this.h[s] &= 8191;
            }

            for (this.h[0] += 5 * r, r = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += r, r = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += r, i[0] = this.h[0] + 5, r = i[0] >>> 13, i[0] &= 8191, s = 1; s < 10; s++) {
              i[s] = this.h[s] + r, r = i[s] >>> 13, i[s] &= 8191;
            }

            for (i[9] -= 8192, n = (1 ^ r) - 1, s = 0; s < 10; s++) {
              i[s] &= n;
            }

            for (n = ~n, s = 0; s < 10; s++) {
              this.h[s] = this.h[s] & n | i[s];
            }

            for (this.h[0] = 65535 & (this.h[0] | this.h[1] << 13), this.h[1] = 65535 & (this.h[1] >>> 3 | this.h[2] << 10), this.h[2] = 65535 & (this.h[2] >>> 6 | this.h[3] << 7), this.h[3] = 65535 & (this.h[3] >>> 9 | this.h[4] << 4), this.h[4] = 65535 & (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14), this.h[5] = 65535 & (this.h[6] >>> 2 | this.h[7] << 11), this.h[6] = 65535 & (this.h[7] >>> 5 | this.h[8] << 8), this.h[7] = 65535 & (this.h[8] >>> 8 | this.h[9] << 5), o = this.h[0] + this.pad[0], this.h[0] = 65535 & o, s = 1; s < 8; s++) {
              o = (this.h[s] + this.pad[s] | 0) + (o >>> 16) | 0, this.h[s] = 65535 & o;
            }

            e[t + 0] = this.h[0] >>> 0 & 255, e[t + 1] = this.h[0] >>> 8 & 255, e[t + 2] = this.h[1] >>> 0 & 255, e[t + 3] = this.h[1] >>> 8 & 255, e[t + 4] = this.h[2] >>> 0 & 255, e[t + 5] = this.h[2] >>> 8 & 255, e[t + 6] = this.h[3] >>> 0 & 255, e[t + 7] = this.h[3] >>> 8 & 255, e[t + 8] = this.h[4] >>> 0 & 255, e[t + 9] = this.h[4] >>> 8 & 255, e[t + 10] = this.h[5] >>> 0 & 255, e[t + 11] = this.h[5] >>> 8 & 255, e[t + 12] = this.h[6] >>> 0 & 255, e[t + 13] = this.h[6] >>> 8 & 255, e[t + 14] = this.h[7] >>> 0 & 255, e[t + 15] = this.h[7] >>> 8 & 255;
          }, E.prototype.update = function (e, t, r) {
            var n, o;

            if (this.leftover) {
              for ((o = 16 - this.leftover) > r && (o = r), n = 0; n < o; n++) {
                this.buffer[this.leftover + n] = e[t + n];
              }

              if (r -= o, t += o, this.leftover += o, this.leftover < 16) return;
              this.blocks(this.buffer, 0, 16), this.leftover = 0;
            }

            if (r >= 16 && (o = r - r % 16, this.blocks(e, t, o), t += o, r -= o), r) {
              for (n = 0; n < r; n++) {
                this.buffer[this.leftover + n] = e[t + n];
              }

              this.leftover += r;
            }
          };
          var $ = B,
              V = k,
              W = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

          function X(e, t, r, n) {
            for (var o, s, i, a, c, u, l, h, p, f, d, g, y, m, b, w, A, v, x, S, E, T, _, B, k, I, U = new Int32Array(16), C = new Int32Array(16), R = e[0], O = e[1], D = e[2], N = e[3], P = e[4], L = e[5], F = e[6], j = e[7], z = t[0], M = t[1], H = t[2], G = t[3], K = t[4], q = t[5], $ = t[6], V = t[7], X = 0; n >= 128;) {
              for (x = 0; x < 16; x++) {
                S = 8 * x + X, U[x] = r[S + 0] << 24 | r[S + 1] << 16 | r[S + 2] << 8 | r[S + 3], C[x] = r[S + 4] << 24 | r[S + 5] << 16 | r[S + 6] << 8 | r[S + 7];
              }

              for (x = 0; x < 80; x++) {
                if (o = R, s = O, i = D, a = N, c = P, u = L, l = F, p = z, f = M, d = H, g = G, y = K, m = q, b = $, _ = 65535 & (T = V), B = T >>> 16, k = 65535 & (E = j), I = E >>> 16, _ += 65535 & (T = (K >>> 14 | P << 18) ^ (K >>> 18 | P << 14) ^ (P >>> 9 | K << 23)), B += T >>> 16, k += 65535 & (E = (P >>> 14 | K << 18) ^ (P >>> 18 | K << 14) ^ (K >>> 9 | P << 23)), I += E >>> 16, _ += 65535 & (T = K & q ^ ~K & $), B += T >>> 16, k += 65535 & (E = P & L ^ ~P & F), I += E >>> 16, _ += 65535 & (T = W[2 * x + 1]), B += T >>> 16, k += 65535 & (E = W[2 * x]), I += E >>> 16, E = U[x % 16], B += (T = C[x % 16]) >>> 16, k += 65535 & E, I += E >>> 16, k += (B += (_ += 65535 & T) >>> 16) >>> 16, _ = 65535 & (T = v = 65535 & _ | B << 16), B = T >>> 16, k = 65535 & (E = A = 65535 & k | (I += k >>> 16) << 16), I = E >>> 16, _ += 65535 & (T = (z >>> 28 | R << 4) ^ (R >>> 2 | z << 30) ^ (R >>> 7 | z << 25)), B += T >>> 16, k += 65535 & (E = (R >>> 28 | z << 4) ^ (z >>> 2 | R << 30) ^ (z >>> 7 | R << 25)), I += E >>> 16, B += (T = z & M ^ z & H ^ M & H) >>> 16, k += 65535 & (E = R & O ^ R & D ^ O & D), I += E >>> 16, h = 65535 & (k += (B += (_ += 65535 & T) >>> 16) >>> 16) | (I += k >>> 16) << 16, w = 65535 & _ | B << 16, _ = 65535 & (T = g), B = T >>> 16, k = 65535 & (E = a), I = E >>> 16, B += (T = v) >>> 16, k += 65535 & (E = A), I += E >>> 16, O = o, D = s, N = i, P = a = 65535 & (k += (B += (_ += 65535 & T) >>> 16) >>> 16) | (I += k >>> 16) << 16, L = c, F = u, j = l, R = h, M = p, H = f, G = d, K = g = 65535 & _ | B << 16, q = y, $ = m, V = b, z = w, x % 16 == 15) for (S = 0; S < 16; S++) {
                  E = U[S], _ = 65535 & (T = C[S]), B = T >>> 16, k = 65535 & E, I = E >>> 16, E = U[(S + 9) % 16], _ += 65535 & (T = C[(S + 9) % 16]), B += T >>> 16, k += 65535 & E, I += E >>> 16, A = U[(S + 1) % 16], _ += 65535 & (T = ((v = C[(S + 1) % 16]) >>> 1 | A << 31) ^ (v >>> 8 | A << 24) ^ (v >>> 7 | A << 25)), B += T >>> 16, k += 65535 & (E = (A >>> 1 | v << 31) ^ (A >>> 8 | v << 24) ^ A >>> 7), I += E >>> 16, A = U[(S + 14) % 16], B += (T = ((v = C[(S + 14) % 16]) >>> 19 | A << 13) ^ (A >>> 29 | v << 3) ^ (v >>> 6 | A << 26)) >>> 16, k += 65535 & (E = (A >>> 19 | v << 13) ^ (v >>> 29 | A << 3) ^ A >>> 6), I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, U[S] = 65535 & k | I << 16, C[S] = 65535 & _ | B << 16;
                }
              }

              _ = 65535 & (T = z), B = T >>> 16, k = 65535 & (E = R), I = E >>> 16, E = e[0], B += (T = t[0]) >>> 16, k += 65535 & E, I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, e[0] = R = 65535 & k | I << 16, t[0] = z = 65535 & _ | B << 16, _ = 65535 & (T = M), B = T >>> 16, k = 65535 & (E = O), I = E >>> 16, E = e[1], B += (T = t[1]) >>> 16, k += 65535 & E, I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, e[1] = O = 65535 & k | I << 16, t[1] = M = 65535 & _ | B << 16, _ = 65535 & (T = H), B = T >>> 16, k = 65535 & (E = D), I = E >>> 16, E = e[2], B += (T = t[2]) >>> 16, k += 65535 & E, I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, e[2] = D = 65535 & k | I << 16, t[2] = H = 65535 & _ | B << 16, _ = 65535 & (T = G), B = T >>> 16, k = 65535 & (E = N), I = E >>> 16, E = e[3], B += (T = t[3]) >>> 16, k += 65535 & E, I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, e[3] = N = 65535 & k | I << 16, t[3] = G = 65535 & _ | B << 16, _ = 65535 & (T = K), B = T >>> 16, k = 65535 & (E = P), I = E >>> 16, E = e[4], B += (T = t[4]) >>> 16, k += 65535 & E, I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, e[4] = P = 65535 & k | I << 16, t[4] = K = 65535 & _ | B << 16, _ = 65535 & (T = q), B = T >>> 16, k = 65535 & (E = L), I = E >>> 16, E = e[5], B += (T = t[5]) >>> 16, k += 65535 & E, I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, e[5] = L = 65535 & k | I << 16, t[5] = q = 65535 & _ | B << 16, _ = 65535 & (T = $), B = T >>> 16, k = 65535 & (E = F), I = E >>> 16, E = e[6], B += (T = t[6]) >>> 16, k += 65535 & E, I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, e[6] = F = 65535 & k | I << 16, t[6] = $ = 65535 & _ | B << 16, _ = 65535 & (T = V), B = T >>> 16, k = 65535 & (E = j), I = E >>> 16, E = e[7], B += (T = t[7]) >>> 16, k += 65535 & E, I += E >>> 16, I += (k += (B += (_ += 65535 & T) >>> 16) >>> 16) >>> 16, e[7] = j = 65535 & k | I << 16, t[7] = V = 65535 & _ | B << 16, X += 128, n -= 128;
            }

            return n;
          }

          function Y(e, t, r) {
            var n,
                o = new Int32Array(8),
                s = new Int32Array(8),
                i = new Uint8Array(256),
                a = r;

            for (o[0] = 1779033703, o[1] = 3144134277, o[2] = 1013904242, o[3] = 2773480762, o[4] = 1359893119, o[5] = 2600822924, o[6] = 528734635, o[7] = 1541459225, s[0] = 4089235720, s[1] = 2227873595, s[2] = 4271175723, s[3] = 1595750129, s[4] = 2917565137, s[5] = 725511199, s[6] = 4215389547, s[7] = 327033209, X(o, s, t, r), r %= 128, n = 0; n < r; n++) {
              i[n] = t[a - r + n];
            }

            for (i[r] = 128, i[(r = 256 - 128 * (r < 112 ? 1 : 0)) - 9] = 0, f(i, r - 8, a / 536870912 | 0, a << 3), X(o, s, i, r), n = 0; n < 8; n++) {
              f(e, 8 * n, o[n], s[n]);
            }

            return 0;
          }

          function J(e, r) {
            var n = t(),
                o = t(),
                s = t(),
                i = t(),
                a = t(),
                c = t(),
                l = t(),
                h = t(),
                p = t();
            L(n, e[1], e[0]), L(p, r[1], r[0]), F(n, n, p), P(o, e[0], e[1]), P(p, r[0], r[1]), F(o, o, p), F(s, e[3], r[3]), F(s, s, u), F(i, e[2], r[2]), P(i, i, i), L(a, o, n), L(c, i, s), P(l, i, s), P(h, o, n), F(e[0], a, c), F(e[1], h, l), F(e[2], l, c), F(e[3], a, h);
          }

          function Q(e, t, r) {
            var n;

            for (n = 0; n < 4; n++) {
              C(e[n], t[n], r);
            }
          }

          function Z(e, r) {
            var n = t(),
                o = t(),
                s = t();
            z(s, r[2]), F(n, r[0], s), F(o, r[1], s), R(e, o), e[31] ^= D(n) << 7;
          }

          function ee(e, t, r) {
            var n, o;

            for (I(e[0], s), I(e[1], i), I(e[2], i), I(e[3], s), o = 255; o >= 0; --o) {
              Q(e, t, n = r[o / 8 | 0] >> (7 & o) & 1), J(t, e), J(e, e), Q(e, t, n);
            }
          }

          function te(e, r) {
            var n = [t(), t(), t(), t()];
            I(n[0], l), I(n[1], h), I(n[2], i), F(n[3], l, h), ee(e, n, r);
          }

          function re(e, n, o) {
            var s,
                i = new Uint8Array(64),
                a = [t(), t(), t(), t()];

            for (o || r(n, 32), Y(i, n, 32), i[0] &= 248, i[31] &= 127, i[31] |= 64, te(a, i), Z(e, a), s = 0; s < 32; s++) {
              n[s + 32] = e[s];
            }

            return 0;
          }

          var ne = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);

          function oe(e, t) {
            var r, n, o, s;

            for (n = 63; n >= 32; --n) {
              for (r = 0, o = n - 32, s = n - 12; o < s; ++o) {
                t[o] += r - 16 * t[n] * ne[o - (n - 32)], r = Math.floor((t[o] + 128) / 256), t[o] -= 256 * r;
              }

              t[o] += r, t[n] = 0;
            }

            for (r = 0, o = 0; o < 32; o++) {
              t[o] += r - (t[31] >> 4) * ne[o], r = t[o] >> 8, t[o] &= 255;
            }

            for (o = 0; o < 32; o++) {
              t[o] -= r * ne[o];
            }

            for (n = 0; n < 32; n++) {
              t[n + 1] += t[n] >> 8, e[n] = 255 & t[n];
            }
          }

          function se(e) {
            var t,
                r = new Float64Array(64);

            for (t = 0; t < 64; t++) {
              r[t] = e[t];
            }

            for (t = 0; t < 64; t++) {
              e[t] = 0;
            }

            oe(e, r);
          }

          function ie(e, r, n, o) {
            var s,
                i,
                a = new Uint8Array(64),
                c = new Uint8Array(64),
                u = new Uint8Array(64),
                l = new Float64Array(64),
                h = [t(), t(), t(), t()];
            Y(a, o, 32), a[0] &= 248, a[31] &= 127, a[31] |= 64;
            var p = n + 64;

            for (s = 0; s < n; s++) {
              e[64 + s] = r[s];
            }

            for (s = 0; s < 32; s++) {
              e[32 + s] = a[32 + s];
            }

            for (Y(u, e.subarray(32), n + 32), se(u), te(h, u), Z(e, h), s = 32; s < 64; s++) {
              e[s] = o[s];
            }

            for (Y(c, e, n + 64), se(c), s = 0; s < 64; s++) {
              l[s] = 0;
            }

            for (s = 0; s < 32; s++) {
              l[s] = u[s];
            }

            for (s = 0; s < 32; s++) {
              for (i = 0; i < 32; i++) {
                l[s + i] += c[s] * a[i];
              }
            }

            return oe(e.subarray(32), l), p;
          }

          function ae(e, r, n, o) {
            var a,
                u = new Uint8Array(32),
                l = new Uint8Array(64),
                h = [t(), t(), t(), t()],
                f = [t(), t(), t(), t()];
            if (n < 64) return -1;
            if (function (e, r) {
              var n = t(),
                  o = t(),
                  a = t(),
                  u = t(),
                  l = t(),
                  h = t(),
                  f = t();
              return I(e[2], i), N(e[1], r), j(a, e[1]), F(u, a, c), L(a, a, e[2]), P(u, e[2], u), j(l, u), j(h, l), F(f, h, l), F(n, f, a), F(n, n, u), M(n, n), F(n, n, a), F(n, n, u), F(n, n, u), F(e[0], n, u), j(o, e[0]), F(o, o, u), O(o, a) && F(e[0], e[0], p), j(o, e[0]), F(o, o, u), O(o, a) ? -1 : (D(e[0]) === r[31] >> 7 && L(e[0], s, e[0]), F(e[3], e[0], e[1]), 0);
            }(f, o)) return -1;

            for (a = 0; a < n; a++) {
              e[a] = r[a];
            }

            for (a = 0; a < 32; a++) {
              e[a + 32] = o[a];
            }

            if (Y(l, e, n), se(l), ee(h, f, l), te(f, r.subarray(32)), J(h, f), Z(u, h), n -= 64, y(r, 0, u, 0)) {
              for (a = 0; a < n; a++) {
                e[a] = 0;
              }

              return -1;
            }

            for (a = 0; a < n; a++) {
              e[a] = r[a + 64];
            }

            return n;
          }

          var ce = 64,
              ue = 32,
              le = 64;

          function he(e, t) {
            if (32 !== e.length) throw new Error("bad key size");
            if (24 !== t.length) throw new Error("bad nonce size");
          }

          function pe() {
            for (var e = 0; e < arguments.length; e++) {
              if (!(arguments[e] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
            }
          }

          function fe(e) {
            for (var t = 0; t < e.length; t++) {
              e[t] = 0;
            }
          }

          e.lowlevel = {
            crypto_core_hsalsa20: b,
            crypto_stream_xor: S,
            crypto_stream: x,
            crypto_stream_salsa20_xor: A,
            crypto_stream_salsa20: v,
            crypto_onetimeauth: T,
            crypto_onetimeauth_verify: _,
            crypto_verify_16: g,
            crypto_verify_32: y,
            crypto_secretbox: B,
            crypto_secretbox_open: k,
            crypto_scalarmult: H,
            crypto_scalarmult_base: G,
            crypto_box_beforenm: q,
            crypto_box_afternm: $,
            crypto_box: function crypto_box(e, t, r, n, o, s) {
              var i = new Uint8Array(32);
              return q(i, o, s), $(e, t, r, n, i);
            },
            crypto_box_open: function crypto_box_open(e, t, r, n, o, s) {
              var i = new Uint8Array(32);
              return q(i, o, s), V(e, t, r, n, i);
            },
            crypto_box_keypair: K,
            crypto_hash: Y,
            crypto_sign: ie,
            crypto_sign_keypair: re,
            crypto_sign_open: ae,
            crypto_secretbox_KEYBYTES: 32,
            crypto_secretbox_NONCEBYTES: 24,
            crypto_secretbox_ZEROBYTES: 32,
            crypto_secretbox_BOXZEROBYTES: 16,
            crypto_scalarmult_BYTES: 32,
            crypto_scalarmult_SCALARBYTES: 32,
            crypto_box_PUBLICKEYBYTES: 32,
            crypto_box_SECRETKEYBYTES: 32,
            crypto_box_BEFORENMBYTES: 32,
            crypto_box_NONCEBYTES: 24,
            crypto_box_ZEROBYTES: 32,
            crypto_box_BOXZEROBYTES: 16,
            crypto_sign_BYTES: ce,
            crypto_sign_PUBLICKEYBYTES: ue,
            crypto_sign_SECRETKEYBYTES: le,
            crypto_sign_SEEDBYTES: 32,
            crypto_hash_BYTES: 64,
            gf: t,
            D: c,
            L: ne,
            pack25519: R,
            unpack25519: N,
            M: F,
            A: P,
            S: j,
            Z: L,
            pow2523: M,
            add: J,
            set25519: I,
            modL: oe,
            scalarmult: ee,
            scalarbase: te
          }, e.randomBytes = function (e) {
            var t = new Uint8Array(e);
            return r(t, e), t;
          }, e.secretbox = function (e, t, r) {
            pe(e, t, r), he(r, t);

            for (var n = new Uint8Array(32 + e.length), o = new Uint8Array(n.length), s = 0; s < e.length; s++) {
              n[s + 32] = e[s];
            }

            return B(o, n, n.length, t, r), o.subarray(16);
          }, e.secretbox.open = function (e, t, r) {
            pe(e, t, r), he(r, t);

            for (var n = new Uint8Array(16 + e.length), o = new Uint8Array(n.length), s = 0; s < e.length; s++) {
              n[s + 16] = e[s];
            }

            return n.length < 32 || 0 !== k(o, n, n.length, t, r) ? null : o.subarray(32);
          }, e.secretbox.keyLength = 32, e.secretbox.nonceLength = 24, e.secretbox.overheadLength = 16, e.scalarMult = function (e, t) {
            if (pe(e, t), 32 !== e.length) throw new Error("bad n size");
            if (32 !== t.length) throw new Error("bad p size");
            var r = new Uint8Array(32);
            return H(r, e, t), r;
          }, e.scalarMult.base = function (e) {
            if (pe(e), 32 !== e.length) throw new Error("bad n size");
            var t = new Uint8Array(32);
            return G(t, e), t;
          }, e.scalarMult.scalarLength = 32, e.scalarMult.groupElementLength = 32, e.box = function (t, r, n, o) {
            var s = e.box.before(n, o);
            return e.secretbox(t, r, s);
          }, e.box.before = function (e, t) {
            pe(e, t), function (e, t) {
              if (32 !== e.length) throw new Error("bad public key size");
              if (32 !== t.length) throw new Error("bad secret key size");
            }(e, t);
            var r = new Uint8Array(32);
            return q(r, e, t), r;
          }, e.box.after = e.secretbox, e.box.open = function (t, r, n, o) {
            var s = e.box.before(n, o);
            return e.secretbox.open(t, r, s);
          }, e.box.open.after = e.secretbox.open, e.box.keyPair = function () {
            var e = new Uint8Array(32),
                t = new Uint8Array(32);
            return K(e, t), {
              publicKey: e,
              secretKey: t
            };
          }, e.box.keyPair.fromSecretKey = function (e) {
            if (pe(e), 32 !== e.length) throw new Error("bad secret key size");
            var t = new Uint8Array(32);
            return G(t, e), {
              publicKey: t,
              secretKey: new Uint8Array(e)
            };
          }, e.box.publicKeyLength = 32, e.box.secretKeyLength = 32, e.box.sharedKeyLength = 32, e.box.nonceLength = 24, e.box.overheadLength = e.secretbox.overheadLength, e.sign = function (e, t) {
            if (pe(e, t), t.length !== le) throw new Error("bad secret key size");
            var r = new Uint8Array(ce + e.length);
            return ie(r, e, e.length, t), r;
          }, e.sign.open = function (e, t) {
            if (pe(e, t), t.length !== ue) throw new Error("bad public key size");
            var r = new Uint8Array(e.length),
                n = ae(r, e, e.length, t);
            if (n < 0) return null;

            for (var o = new Uint8Array(n), s = 0; s < o.length; s++) {
              o[s] = r[s];
            }

            return o;
          }, e.sign.detached = function (t, r) {
            for (var n = e.sign(t, r), o = new Uint8Array(ce), s = 0; s < o.length; s++) {
              o[s] = n[s];
            }

            return o;
          }, e.sign.detached.verify = function (e, t, r) {
            if (pe(e, t, r), t.length !== ce) throw new Error("bad signature size");
            if (r.length !== ue) throw new Error("bad public key size");
            var n,
                o = new Uint8Array(ce + e.length),
                s = new Uint8Array(ce + e.length);

            for (n = 0; n < ce; n++) {
              o[n] = t[n];
            }

            for (n = 0; n < e.length; n++) {
              o[n + ce] = e[n];
            }

            return ae(s, o, o.length, r) >= 0;
          }, e.sign.keyPair = function () {
            var e = new Uint8Array(ue),
                t = new Uint8Array(le);
            return re(e, t), {
              publicKey: e,
              secretKey: t
            };
          }, e.sign.keyPair.fromSecretKey = function (e) {
            if (pe(e), e.length !== le) throw new Error("bad secret key size");

            for (var t = new Uint8Array(ue), r = 0; r < t.length; r++) {
              t[r] = e[32 + r];
            }

            return {
              publicKey: t,
              secretKey: new Uint8Array(e)
            };
          }, e.sign.keyPair.fromSeed = function (e) {
            if (pe(e), 32 !== e.length) throw new Error("bad seed size");

            for (var t = new Uint8Array(ue), r = new Uint8Array(le), n = 0; n < 32; n++) {
              r[n] = e[n];
            }

            return re(t, r, !0), {
              publicKey: t,
              secretKey: r
            };
          }, e.sign.publicKeyLength = ue, e.sign.secretKeyLength = le, e.sign.seedLength = 32, e.sign.signatureLength = ce, e.hash = function (e) {
            pe(e);
            var t = new Uint8Array(64);
            return Y(t, e, e.length), t;
          }, e.hash.hashLength = 64, e.verify = function (e, t) {
            return pe(e, t), 0 !== e.length && 0 !== t.length && e.length === t.length && 0 === d(e, 0, t, 0, e.length);
          }, e.setPRNG = function (e) {
            r = e;
          }, function () {
            var t = "undefined" != typeof self ? self.crypto || self.msCrypto : null;
            t && t.getRandomValues ? e.setPRNG(function (e, r) {
              var n,
                  o = new Uint8Array(r);

              for (n = 0; n < r; n += 65536) {
                t.getRandomValues(o.subarray(n, n + Math.min(r - n, 65536)));
              }

              for (n = 0; n < r; n++) {
                e[n] = o[n];
              }

              fe(o);
            }) : "undefined" != typeof require && (t = require("crypto")) && t.randomBytes && e.setPRNG(function (e, r) {
              var n,
                  o = t.randomBytes(r);

              for (n = 0; n < r; n++) {
                e[n] = o[n];
              }

              fe(o);
            });
          }();
        }(void 0 !== e && e.exports ? e.exports : self.nacl = self.nacl || {});
      },
      1042: function _(e, t, r) {
        "use strict";

        var n = r(1926),
            o = r(9370),
            s = /^[A-Za-z][A-Za-z0-9+-.]*:[\\/]+/,
            i = /^([a-z][a-z0-9.+-]*:)?([\\/]{1,})?([\S\s]*)/i,
            a = new RegExp("^[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]+");

        function c(e) {
          return (e || "").toString().replace(a, "");
        }

        var u = [["#", "hash"], ["?", "query"], function (e) {
          return e.replace("\\", "/");
        }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d+)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]],
            l = {
          hash: 1,
          query: 1
        };

        function h(e) {
          var t,
              n = ("undefined" != typeof window ? window : void 0 !== r.g ? r.g : "undefined" != typeof self ? self : {}).location || {},
              o = {},
              i = typeof (e = e || n);
          if ("blob:" === e.protocol) o = new f(unescape(e.pathname), {});else if ("string" === i) for (t in o = new f(e, {}), l) {
            delete o[t];
          } else if ("object" === i) {
            for (t in e) {
              t in l || (o[t] = e[t]);
            }

            void 0 === o.slashes && (o.slashes = s.test(e.href));
          }
          return o;
        }

        function p(e) {
          e = c(e);
          var t = i.exec(e);
          return {
            protocol: t[1] ? t[1].toLowerCase() : "",
            slashes: !!(t[2] && t[2].length >= 2),
            rest: t[2] && 1 === t[2].length ? "/" + t[3] : t[3]
          };
        }

        function f(e, t, r) {
          if (e = c(e), !(this instanceof f)) return new f(e, t, r);
          var s,
              i,
              a,
              l,
              d,
              g,
              y = u.slice(),
              m = typeof t,
              b = this,
              w = 0;

          for ("object" !== m && "string" !== m && (r = t, t = null), r && "function" != typeof r && (r = o.parse), t = h(t), s = !(i = p(e || "")).protocol && !i.slashes, b.slashes = i.slashes || s && t.slashes, b.protocol = i.protocol || t.protocol || "", e = i.rest, i.slashes || (y[3] = [/(.*)/, "pathname"]); w < y.length; w++) {
            "function" != typeof (l = y[w]) ? (a = l[0], g = l[1], a != a ? b[g] = e : "string" == typeof a ? ~(d = e.indexOf(a)) && ("number" == typeof l[2] ? (b[g] = e.slice(0, d), e = e.slice(d + l[2])) : (b[g] = e.slice(d), e = e.slice(0, d))) : (d = a.exec(e)) && (b[g] = d[1], e = e.slice(0, d.index)), b[g] = b[g] || s && l[3] && t[g] || "", l[4] && (b[g] = b[g].toLowerCase())) : e = l(e);
          }

          r && (b.query = r(b.query)), s && t.slashes && "/" !== b.pathname.charAt(0) && ("" !== b.pathname || "" !== t.pathname) && (b.pathname = function (e, t) {
            if ("" === e) return t;

            for (var r = (t || "/").split("/").slice(0, -1).concat(e.split("/")), n = r.length, o = r[n - 1], s = !1, i = 0; n--;) {
              "." === r[n] ? r.splice(n, 1) : ".." === r[n] ? (r.splice(n, 1), i++) : i && (0 === n && (s = !0), r.splice(n, 1), i--);
            }

            return s && r.unshift(""), "." !== o && ".." !== o || r.push(""), r.join("/");
          }(b.pathname, t.pathname)), "/" !== b.pathname.charAt(0) && b.hostname && (b.pathname = "/" + b.pathname), n(b.port, b.protocol) || (b.host = b.hostname, b.port = ""), b.username = b.password = "", b.auth && (l = b.auth.split(":"), b.username = l[0] || "", b.password = l[1] || ""), b.origin = b.protocol && b.host && "file:" !== b.protocol ? b.protocol + "//" + b.host : "null", b.href = b.toString();
        }

        f.prototype = {
          set: function set(e, t, r) {
            var s = this;

            switch (e) {
              case "query":
                "string" == typeof t && t.length && (t = (r || o.parse)(t)), s[e] = t;
                break;

              case "port":
                s[e] = t, n(t, s.protocol) ? t && (s.host = s.hostname + ":" + t) : (s.host = s.hostname, s[e] = "");
                break;

              case "hostname":
                s[e] = t, s.port && (t += ":" + s.port), s.host = t;
                break;

              case "host":
                s[e] = t, /:\d+$/.test(t) ? (t = t.split(":"), s.port = t.pop(), s.hostname = t.join(":")) : (s.hostname = t, s.port = "");
                break;

              case "protocol":
                s.protocol = t.toLowerCase(), s.slashes = !r;
                break;

              case "pathname":
              case "hash":
                if (t) {
                  var i = "pathname" === e ? "/" : "#";
                  s[e] = t.charAt(0) !== i ? i + t : t;
                } else s[e] = t;

                break;

              default:
                s[e] = t;
            }

            for (var a = 0; a < u.length; a++) {
              var c = u[a];
              c[4] && (s[c[1]] = s[c[1]].toLowerCase());
            }

            return s.origin = s.protocol && s.host && "file:" !== s.protocol ? s.protocol + "//" + s.host : "null", s.href = s.toString(), s;
          },
          toString: function toString(e) {
            e && "function" == typeof e || (e = o.stringify);
            var t,
                r = this,
                n = r.protocol;
            n && ":" !== n.charAt(n.length - 1) && (n += ":");
            var s = n + (r.slashes ? "//" : "");
            return r.username && (s += r.username, r.password && (s += ":" + r.password), s += "@"), s += r.host + r.pathname, (t = "object" == typeof r.query ? e(r.query) : r.query) && (s += "?" !== t.charAt(0) ? "?" + t : t), r.hash && (s += r.hash), s;
          }
        }, f.extractProtocol = p, f.location = h, f.trimLeft = c, f.qs = o, e.exports = f;
      },
      5922: function _(e, t, r) {
        var n = r(2486).Buffer;

        var _r7 = r(1113),
            o = _r7.default,
            _r8 = r(5180),
            s = _r8.setSendTransactionHeaders;

        e.exports = {
          Algod: function Algod() {
            var _this2 = this;

            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "http://r2.algorand.network";
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4180;
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var a = e;
            "string" == typeof a && (a = {
              "X-Algo-API-Token": a
            });
            var c = new o(a, t, r, i);

            function u(e) {
              return void 0 !== e.noteb64 && null !== e.noteb64 && (e.note = n.from(e.noteb64, "base64")), e;
            }

            this.status = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var e,
                  _args = arguments;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      e = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                      _context.next = 3;
                      return c.get("/v1/status", {}, e);

                    case 3:
                      return _context.abrupt("return", _context.sent.body);

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })), this.healthCheck = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var e,
                  t,
                  _args2 = arguments;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      e = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                      _context2.next = 3;
                      return c.get("/health", {}, e);

                    case 3:
                      t = _context2.sent;

                      if (t.ok) {
                        _context2.next = 6;
                        break;
                      }

                      throw new Error("Health response: ".concat(t.status));

                    case 6:
                      return _context2.abrupt("return", {});

                    case 7:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })), this.statusAfterBlock = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
                var t,
                    _args3 = arguments;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        t = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

                        if (Number.isInteger(e)) {
                          _context3.next = 3;
                          break;
                        }

                        throw Error("roundNumber should be an integer");

                      case 3:
                        _context3.next = 5;
                        return c.get("/v1/status/wait-for-block-after/".concat(e), {}, t);

                      case 5:
                        return _context3.abrupt("return", _context3.sent.body);

                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x) {
                return _ref3.apply(this, arguments);
              };
            }(), this.pendingTransactions = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
                var t,
                    r,
                    _e6,
                    _args4 = arguments;

                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        t = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

                        if (Number.isInteger(e)) {
                          _context4.next = 3;
                          break;
                        }

                        throw Error("maxTxns should be an integer");

                      case 3:
                        _context4.next = 5;
                        return c.get("/v1/transactions/pending", {
                          max: e
                        }, t);

                      case 5:
                        r = _context4.sent;
                        if (200 === r.statusCode && void 0 !== r.body.truncatedTxns.transactions) for (_e6 = 0; _e6 < r.body.truncatedTxns.transactions.length; _e6++) {
                          r.body.truncatedTxns.transactions[_e6] = u(r.body.truncatedTxns.transactions[_e6]);
                        }
                        return _context4.abrupt("return", r.body);

                      case 8:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x2) {
                return _ref4.apply(this, arguments);
              };
            }(), this.versions = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var e,
                  _args5 = arguments;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      e = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                      _context5.next = 3;
                      return c.get("/versions", {}, e);

                    case 3:
                      return _context5.abrupt("return", _context5.sent.body);

                    case 4:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            })), this.ledgerSupply = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
              var e,
                  _args6 = arguments;
              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      e = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
                      _context6.next = 3;
                      return c.get("/v1/ledger/supply", {}, e);

                    case 3:
                      return _context6.abrupt("return", _context6.sent.body);

                    case 4:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            })), this.transactionByAddress = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
                var t,
                    r,
                    n,
                    o,
                    s,
                    _e7,
                    _args7 = arguments;

                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        t = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
                        r = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : null;
                        n = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : null;
                        o = _args7.length > 4 && _args7[4] !== undefined ? _args7[4] : {};

                        if (!(null !== t && !Number.isInteger(t))) {
                          _context7.next = 6;
                          break;
                        }

                        throw Error("first round should be an integer");

                      case 6:
                        if (!(null !== r && !Number.isInteger(r))) {
                          _context7.next = 8;
                          break;
                        }

                        throw Error("last round should be an integer");

                      case 8:
                        _context7.next = 10;
                        return c.get("/v1/account/".concat(e, "/transactions"), {
                          firstRound: t,
                          lastRound: r,
                          max: n
                        }, o);

                      case 10:
                        s = _context7.sent;
                        if (200 === s.statusCode && void 0 !== s.body.transactions) for (_e7 = 0; _e7 < s.body.transactions.length; _e7++) {
                          s.body.transactions[_e7] = u(s.body.transactions[_e7]);
                        }
                        return _context7.abrupt("return", s.body);

                      case 13:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x3) {
                return _ref7.apply(this, arguments);
              };
            }(), this.transactionByAddressAndDate = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e, t, r) {
                var n,
                    o,
                    s,
                    _e8,
                    _args8 = arguments;

                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        n = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : null;
                        o = _args8.length > 4 && _args8[4] !== undefined ? _args8[4] : {};
                        _context8.next = 4;
                        return c.get("/v1/account/".concat(e, "/transactions"), {
                          fromDate: t,
                          toDate: r,
                          max: n
                        }, o);

                      case 4:
                        s = _context8.sent;
                        if (200 === s.statusCode && void 0 !== s.body.transactions) for (_e8 = 0; _e8 < s.body.transactions.length; _e8++) {
                          s.body.transactions[_e8] = u(s.body.transactions[_e8]);
                        }
                        return _context8.abrupt("return", s.body);

                      case 7:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));

              return function (_x4, _x5, _x6) {
                return _ref8.apply(this, arguments);
              };
            }(), this.transactionById = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
                var t,
                    r,
                    _args9 = arguments;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        t = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
                        _context9.next = 3;
                        return c.get("/v1/transaction/".concat(e), {}, t);

                      case 3:
                        r = _context9.sent;
                        return _context9.abrupt("return", (200 === r.statusCode && (r.body = u(r.body)), r.body));

                      case 5:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));

              return function (_x7) {
                return _ref9.apply(this, arguments);
              };
            }(), this.transactionInformation = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e, t) {
                var r,
                    n,
                    _args10 = arguments;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        r = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : {};
                        _context10.next = 3;
                        return c.get("/v1/account/".concat(e, "/transaction/").concat(t), {}, r);

                      case 3:
                        n = _context10.sent;
                        return _context10.abrupt("return", (200 === n.statusCode && (n.body = u(n.body)), n.body));

                      case 5:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              }));

              return function (_x8, _x9) {
                return _ref10.apply(this, arguments);
              };
            }(), this.pendingTransactionInformation = /*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
                var t,
                    r,
                    _args11 = arguments;
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        t = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
                        _context11.next = 3;
                        return c.get("/v1/transactions/pending/".concat(e), {}, t);

                      case 3:
                        r = _context11.sent;
                        return _context11.abrupt("return", (200 === r.statusCode && (r.body = u(r.body)), r.body));

                      case 5:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11);
              }));

              return function (_x10) {
                return _ref11.apply(this, arguments);
              };
            }(), this.accountInformation = /*#__PURE__*/function () {
              var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
                var t,
                    _args12 = arguments;
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        t = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {};
                        _context12.next = 3;
                        return c.get("/v1/account/".concat(e), {}, t);

                      case 3:
                        return _context12.abrupt("return", _context12.sent.body);

                      case 4:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12);
              }));

              return function (_x11) {
                return _ref12.apply(this, arguments);
              };
            }(), this.assetInformation = /*#__PURE__*/function () {
              var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(e) {
                var t,
                    _args13 = arguments;
                return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        t = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : {};
                        _context13.next = 3;
                        return c.get("/v1/asset/".concat(e), {}, t);

                      case 3:
                        return _context13.abrupt("return", _context13.sent.body);

                      case 4:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee13);
              }));

              return function (_x12) {
                return _ref13.apply(this, arguments);
              };
            }(), this.suggestedFee = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
              var e,
                  _args14 = arguments;
              return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                  switch (_context14.prev = _context14.next) {
                    case 0:
                      e = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
                      _context14.next = 3;
                      return c.get("/v1/transactions/fee", {}, e);

                    case 3:
                      return _context14.abrupt("return", _context14.sent.body);

                    case 4:
                    case "end":
                      return _context14.stop();
                  }
                }
              }, _callee14);
            })), this.sendRawTransaction = /*#__PURE__*/function () {
              var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(e) {
                var t,
                    r,
                    _args15 = arguments;
                return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                  while (1) {
                    switch (_context15.prev = _context15.next) {
                      case 0:
                        t = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : {};
                        r = s(t);
                        _context15.next = 4;
                        return c.post("/v1/transactions", n.from(e), r);

                      case 4:
                        return _context15.abrupt("return", _context15.sent.body);

                      case 5:
                      case "end":
                        return _context15.stop();
                    }
                  }
                }, _callee15);
              }));

              return function (_x13) {
                return _ref15.apply(this, arguments);
              };
            }(), this.sendRawTransactions = /*#__PURE__*/function () {
              var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(e) {
                var _Array$prototype;

                var t,
                    r,
                    o,
                    _args16 = arguments;
                return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        t = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {};
                        r = s(t), o = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, _toConsumableArray(e.map(function (e) {
                          return Array.from(e);
                        })));
                        _context16.next = 4;
                        return c.post("/v1/transactions", n.from(o), r);

                      case 4:
                        return _context16.abrupt("return", _context16.sent.body);

                      case 5:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee16);
              }));

              return function (_x14) {
                return _ref16.apply(this, arguments);
              };
            }(), this.getTransactionParams = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
              var e,
                  _args17 = arguments;
              return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                  switch (_context17.prev = _context17.next) {
                    case 0:
                      e = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {};
                      _context17.next = 3;
                      return c.get("/v1/transactions/params", {}, e);

                    case 3:
                      return _context17.abrupt("return", _context17.sent.body);

                    case 4:
                    case "end":
                      return _context17.stop();
                  }
                }
              }, _callee17);
            })), this.suggestParams = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
              var e,
                  t,
                  _args18 = arguments;
              return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) {
                  switch (_context18.prev = _context18.next) {
                    case 0:
                      e = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {};
                      _context18.next = 3;
                      return _this2.getTransactionParams(e);

                    case 3:
                      t = _context18.sent;
                      return _context18.abrupt("return", {
                        flatFee: !1,
                        fee: t.fee,
                        firstRound: t.lastRound,
                        lastRound: t.lastRound + 1e3,
                        genesisID: t.genesisID,
                        genesisHash: t.genesishashb64
                      });

                    case 5:
                    case "end":
                      return _context18.stop();
                  }
                }
              }, _callee18);
            })), this.block = /*#__PURE__*/function () {
              var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(e) {
                var t,
                    r,
                    _e9,
                    _args19 = arguments;

                return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                  while (1) {
                    switch (_context19.prev = _context19.next) {
                      case 0:
                        t = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : {};

                        if (Number.isInteger(e)) {
                          _context19.next = 3;
                          break;
                        }

                        throw Error("roundNumber should be an integer");

                      case 3:
                        _context19.next = 5;
                        return c.get("/v1/block/".concat(e), {}, t);

                      case 5:
                        r = _context19.sent;
                        if (200 === r.statusCode && void 0 !== r.body.txns.transactions) for (_e9 = 0; _e9 < r.body.txns.transactions.length; _e9++) {
                          r.body.txns.transactions[_e9] = u(r.body.txns.transactions[_e9]);
                        }
                        return _context19.abrupt("return", r.body);

                      case 8:
                      case "end":
                        return _context19.stop();
                    }
                  }
                }, _callee19);
              }));

              return function (_x15) {
                return _ref19.apply(this, arguments);
              };
            }();
          }
        };
      },
      1834: function _(e, t, r) {
        var n = r(2486).Buffer;
        var o = r(7116),
            s = r(3033),
            i = r(1063),
            a = r(5583),
            c = r(8800),
            u = r(9404),
            l = r(2514),
            h = r(9417);
        e.exports = {
          DynamicFee: /*#__PURE__*/function () {
            "use strict";

            function DynamicFee(e, t, r, s, i, a) {
              _classCallCheck(this, DynamicFee);

              if (!Number.isSafeInteger(t) || t < 0) throw Error("amount must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(r) || r < 0) throw Error("firstValid must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(s) || s < 0) throw Error("lastValid must be a positive number and smaller than 2^53-1");

              if (void 0 === i && (i = o.ALGORAND_ZERO_ADDRESS_STRING), void 0 === a) {
                var _e10 = u.randomBytes(32);

                a = n.from(_e10).toString("base64");
              }

              var h = n.from("ASAFAgEHBgUmAyD+vKC7FEpaTqe0OKRoGsgObKEFvLYH/FZTJclWlfaiEyDmmpYeby1feshmB5JlUr6YI17TM2PKiJGLuck4qRW2+SB/g7Flf/H8U7ktwYFIodZd/C1LH6PWdyhK3dIAEm2QaTIEIhIzABAjEhAzAAcxABIQMwAIMQESEDEWIxIQMRAjEhAxBygSEDEJKRIQMQgkEhAxAiUSEDEEIQQSEDEGKhIQ", "base64"),
                  p = [t, r, s, e, i, a],
                  f = [l.valTypes.INT, l.valTypes.INT, l.valTypes.INT, l.valTypes.ADDRESS, l.valTypes.ADDRESS, l.valTypes.BASE64],
                  d = l.inject(h, [5, 6, 7, 11, 44, 76], p, f);
              this.programBytes = d;
              var g = new c.LogicSig(d, void 0);
              this.address = g.address();
            }

            _createClass(DynamicFee, [{
              key: "getProgram",
              value: function getProgram() {
                return this.programBytes;
              }
            }, {
              key: "getAddress",
              value: function getAddress() {
                return this.address;
              }
            }]);

            return DynamicFee;
          }(),
          getDynamicFeeTransactions: function getDynamicFeeTransactions(e, t, r, n) {
            if (!t.verify(o.decodeAddress(e.from).publicKey)) throw new Error("invalid signature");
            e.fee = n, e.fee < h.ALGORAND_MIN_TX_FEE && (e.fee = h.ALGORAND_MIN_TX_FEE);
            var a = u.keyPairFromSecretKey(r),
                c = o.encodeAddress(a.publicKey),
                l = e.lease;
            delete e.lease;
            var p = new h.Transaction(e);
            p.addLease(l, n);
            var f = {
              from: c,
              to: e.from,
              fee: n,
              amount: p.fee,
              firstRound: e.firstRound,
              lastRound: e.lastRound,
              genesisHash: e.genesisHash,
              type: "pay"
            },
                d = new h.Transaction(f);
            d.addLease(l, n);
            var g = i.assignGroupID([d, p], void 0),
                y = g[0],
                m = g[1],
                b = {
              lsig: t.get_obj_for_encoding(),
              txn: m.get_obj_for_encoding()
            },
                w = y.signTxn(r),
                A = s.encode(b),
                v = new Uint8Array(w.length + A.length);
            return v.set(w), v.set(A, w.length), v;
          },
          signDynamicFee: function signDynamicFee(e, t, r) {
            var n = a.readProgram(e, void 0),
                s = n[0],
                i = n[1],
                l = u.keyPairFromSecretKey(t),
                h = {
              from: o.encodeAddress(l.publicKey),
              to: o.encodeAddress(i[0]),
              fee: 0,
              amount: s[2],
              closeRemainderTo: o.encodeAddress(i[1]),
              firstRound: s[3],
              lastRound: s[4],
              genesisHash: r,
              type: "pay",
              lease: new Uint8Array(i[2])
            },
                p = new c.LogicSig(e, void 0);
            return p.sign(t), {
              txn: h,
              lsig: p
            };
          }
        };
      },
      1786: function _(e, t, r) {
        var n = r(2486).Buffer;

        var o = r(3477),
            _r9 = r(583),
            s = _r9.keccak256,
            i = r(5583),
            a = r(8800),
            c = r(2514),
            u = r(9417);

        e.exports = {
          HTLC: /*#__PURE__*/function () {
            "use strict";

            function HTLC(e, t, r, o, s, i) {
              _classCallCheck(this, HTLC);

              if (!Number.isSafeInteger(s) || s < 0) throw Error("expiryRound must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(i) || i < 0) throw Error("maxFee must be a positive number and smaller than 2^53-1");
              var u = "";
              if ("sha256" === r) u = "ASAECAEACSYDIOaalh5vLV96yGYHkmVSvpgjXtMzY8qIkYu5yTipFbb5IH+DsWV/8fxTuS3BgUih1l38LUsfo9Z3KErd0gASbZBpIP68oLsUSlpOp7Q4pGgayA5soQW8tgf8VlMlyVaV9qITMQEiDjEQIxIQMQcyAxIQMQgkEhAxCSgSLQEpEhAxCSoSMQIlDRAREA==";else {
                if ("keccak256" !== r) throw Error("hash function unrecognized");
                u = "ASAECAEACSYDIOaalh5vLV96yGYHkmVSvpgjXtMzY8qIkYu5yTipFbb5IH+DsWV/8fxTuS3BgUih1l38LUsfo9Z3KErd0gASbZBpIP68oLsUSlpOp7Q4pGgayA5soQW8tgf8VlMlyVaV9qITMQEiDjEQIxIQMQcyAxIQMQgkEhAxCSgSLQIpEhAxCSoSMQIlDRAREA==";
              }
              if (32 !== n.from(o, "base64").length) throw Error("hash image must be 32 bytes");
              var l = n.from(u, "base64"),
                  h = [i, s, t, o, e],
                  p = [c.valTypes.INT, c.valTypes.INT, c.valTypes.ADDRESS, c.valTypes.BASE64, c.valTypes.ADDRESS],
                  f = c.inject(l, [3, 6, 10, 42, 76], h, p);
              this.programBytes = f;
              var d = new a.LogicSig(f, void 0);
              this.address = d.address();
            }

            _createClass(HTLC, [{
              key: "getProgram",
              value: function getProgram() {
                return this.programBytes;
              }
            }, {
              key: "getAddress",
              value: function getAddress() {
                return this.address;
              }
            }]);

            return HTLC;
          }(),
          signTransactionWithHTLCUnlock: function signTransactionWithHTLCUnlock(e, t, r) {
            var c = n.from(r, "base64"),
                l = i.readProgram(e, void 0),
                h = l[0],
                p = l[1][1],
                f = e[e.length - 15];

            if (1 === f) {
              var _e11 = o.create();

              if (_e11.update(c), !n.from(_e11.hex(), "hex").equals(p)) throw new Error("sha256 hash of preimage did not match stored contract hash");
            } else {
              if (2 !== f) throw new Error("hash function in contract unrecognized");
              {
                var _e12 = s.create();

                if (_e12.update(c), !n.from(_e12.hex(), "hex").equals(p)) throw new Error("keccak256 hash of preimage did not match stored contract hash");
              }
            }

            var d = [c],
                g = new a.LogicSig(e, d);
            delete t.to;
            var y = h[0],
                m = new u.Transaction(t);
            if (m.fee > y) throw new Error("final fee of payment transaction".concat(m.fee.toString(), "greater than transaction max fee").concat(y.toString()));
            return a.signLogicSigTransaction(t, g);
          }
        };
      },
      8886: function _(e, t, r) {
        var n = r(1834),
            o = r(1786),
            s = r(4748),
            i = r(3758),
            a = r(2200);
        e.exports = {
          DynamicFee: n.DynamicFee,
          getDynamicFeeTransactions: n.getDynamicFeeTransactions,
          signDynamicFee: n.signDynamicFee,
          HTLC: o.HTLC,
          signTransactionWithHTLCUnlock: o.signTransactionWithHTLCUnlock,
          LimitOrder: s.LimitOrder,
          getSwapAssetsTransaction: s.getSwapAssetsTransaction,
          Split: i.Split,
          getSplitFundsTransaction: i.getSplitFundsTransaction,
          PeriodicPayment: a.PeriodicPayment,
          getPeriodicPaymentWithdrawalTransaction: a.getPeriodicPaymentWithdrawalTransaction
        };
      },
      4748: function _(e, t, r) {
        var n = r(2486).Buffer;
        var o = r(7116),
            s = r(1988),
            i = r(1063),
            a = r(5583),
            c = r(8800),
            u = r(9404),
            l = r(2514),
            h = r(413);
        e.exports = {
          LimitOrder: /*#__PURE__*/function () {
            "use strict";

            function LimitOrder(e, t, r, o, s, i, a) {
              _classCallCheck(this, LimitOrder);

              if (!Number.isSafeInteger(t) || t < 0) throw Error("assetid must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(r) || r < 0) throw Error("ratn must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(o) || o < 0) throw Error("ratd must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(s) || s < 0) throw Error("expiryRound must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(i) || i < 0) throw Error("minTrade must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(a) || a < 0) throw Error("maxFee must be a positive number and smaller than 2^53-1");
              var u = n.from("ASAKAAEFAgYEBwgJCiYBIP68oLsUSlpOp7Q4pGgayA5soQW8tgf8VlMlyVaV9qITMRYiEjEQIxIQMQEkDhAyBCMSQABVMgQlEjEIIQQNEDEJMgMSEDMBECEFEhAzAREhBhIQMwEUKBIQMwETMgMSEDMBEiEHHTUCNQExCCEIHTUENQM0ATQDDUAAJDQBNAMSNAI0BA8QQAAWADEJKBIxAiEJDRAxBzIDEhAxCCISEBA=", "base64"),
                  h = [a, i, t, o, r, s, e],
                  p = [l.valTypes.INT, l.valTypes.INT, l.valTypes.INT, l.valTypes.INT, l.valTypes.INT, l.valTypes.INT, l.valTypes.ADDRESS],
                  f = l.inject(u, [5, 7, 9, 10, 11, 12, 16], h, p);
              this.programBytes = f;
              var d = new c.LogicSig(f, void 0);
              this.address = d.address(), this.owner = e, this.assetid = t;
            }

            _createClass(LimitOrder, [{
              key: "getProgram",
              value: function getProgram() {
                return this.programBytes;
              }
            }, {
              key: "getAddress",
              value: function getAddress() {
                return this.address;
              }
            }]);

            return LimitOrder;
          }(),
          getSwapAssetsTransaction: function getSwapAssetsTransaction(e, t, r, n, l, p, f, d) {
            var g = u.keyPairFromSecretKey(n),
                y = o.encodeAddress(g.publicKey),
                m = a.readProgram(e, void 0),
                b = m[0],
                w = m[1];
            var A;

            var v = b[6],
                x = o.encodeAddress(w[0]),
                S = c.makeLogicSig(e, void 0),
                E = S.address(),
                T = [s.makePaymentTxn(E, y, l, r, A, p, f, void 0, d, void 0), s.makeAssetTransferTxn(y, x, A, void 0, l, t, p, f, void 0, d, void 0, v)],
                _ = i.assignGroupID(T),
                B = b[7],
                k = b[8];

            if (t * B < r * k) throw new Error("bad payment ratio, ".concat(t.toString(), "*").concat(B.toString(), " !>= ").concat(r.toString(), "*").concat(k.toString()));
            var I = b[4];
            if (r < I) throw new Error("payment amount ".concat(r.toString(), " less than minimum trade ").concat(I.toString()));
            var U = b[2];
            if (_[0].fee > U) throw new Error("final fee of payment transaction ".concat(_[0].fee.toString(), " greater than transaction max fee ").concat(U.toString()));
            if (_[1].fee > U) throw new Error("final fee of asset transaction ".concat(_[1].fee.toString(), " greater than transaction max fee ").concat(U.toString()));

            var C = c.signLogicSigTransactionObject(_[0], S),
                R = _[1].signTxn(n);

            return h.concatArrays(C.blob, R);
          }
        };
      },
      2200: function _(e, t, r) {
        var n = r(2486).Buffer;
        var o = r(7116),
            s = r(1988),
            i = r(5583),
            a = r(8800),
            c = r(9404),
            u = r(2514);
        e.exports = {
          PeriodicPayment: /*#__PURE__*/function () {
            "use strict";

            function PeriodicPayment(e, t, r, o, s, i, u) {
              _classCallCheck(this, PeriodicPayment);

              if (this.receiver = e, !Number.isSafeInteger(t) || t < 0) throw Error("amount must be a positive number and smaller than 2^53-1");
              if (this.amount = t, !Number.isSafeInteger(r) || r < 0) throw Error("withdrawalWindow must be a positive number and smaller than 2^53-1");
              if (this.withdrawalWindow = r, !Number.isSafeInteger(o) || o < 0) throw Error("period must be a positive number and smaller than 2^53-1");
              if (this.period = o, !Number.isSafeInteger(s) || s < 0) throw Error("expiryRound must be a positive number and smaller than 2^53-1");
              if (this.expiryRound = s, !Number.isSafeInteger(i) || i < 0) throw Error("maxFee must be a positive number and smaller than 2^53-1");

              if (this.maxFee = i, void 0 === u) {
                var _e13 = c.randomBytes(32);

                this.lease = n.from(_e13).toString("base64");
              } else this.lease = u;

              this.programBytes = this.getProgram();
              var l = new a.LogicSig(this.programBytes, void 0);
              this.address = l.address();
            }

            _createClass(PeriodicPayment, [{
              key: "getProgram",
              value: function getProgram() {
                var e = n.from("ASAHAQYFAAQDByYCIAECAwQFBgcIAQIDBAUGBwgBAgMEBQYHCAECAwQFBgcIIJKvkYTkEzwJf2arzJOxERsSogG9nQzKPkpIoc4TzPTFMRAiEjEBIw4QMQIkGCUSEDEEIQQxAggSEDEGKBIQMQkyAxIxBykSEDEIIQUSEDEJKRIxBzIDEhAxAiEGDRAxCCUSEBEQ", "base64"),
                    t = [this.maxFee, this.period, this.withdrawalWindow, this.amount, this.expiryRound, this.lease, this.receiver],
                    r = [u.valTypes.INT, u.valTypes.INT, u.valTypes.INT, u.valTypes.INT, u.valTypes.INT, u.valTypes.BASE64, u.valTypes.ADDRESS];
                return u.inject(e, [4, 5, 7, 8, 9, 12, 46], t, r);
              }
            }, {
              key: "getAddress",
              value: function getAddress() {
                return this.address;
              }
            }]);

            return PeriodicPayment;
          }(),
          getPeriodicPaymentWithdrawalTransaction: function getPeriodicPaymentWithdrawalTransaction(e, t, r, n) {
            var c = i.readProgram(e, void 0),
                u = c[0],
                l = c[1],
                h = u[2],
                p = u[4],
                f = u[5];
            if (r % h != 0) throw new Error("firstValid round ".concat(r.toString(), " was not a multiple of contract period ").concat(h.toString()));
            var d = l[1],
                g = o.encodeAddress(d),
                y = l[0],
                m = new Uint8Array(y),
                b = r + p,
                w = g;
            var A, v;
            var x = a.makeLogicSig(e, void 0),
                S = x.address(),
                E = {
              from: S,
              to: w,
              fee: t,
              amount: f,
              closeRemainderTo: A,
              firstRound: r,
              lastRound: b,
              note: v,
              genesisHash: n,
              genesisID: "",
              type: "pay",
              lease: m
            },
                T = s.makePaymentTxn(S, w, t, f, A, r, b, v, n, "");
            if (T.fee > u[1]) throw new Error("final fee of payment transaction".concat(T.fee.toString(), "greater than transaction max fee").concat(u[1].toString()));
            return a.signLogicSigTransaction(E, x);
          }
        };
      },
      3758: function _(e, t, r) {
        var n = r(2486).Buffer;
        var o = r(7116),
            s = r(1988),
            i = r(1063),
            a = r(8800),
            c = r(5583),
            u = r(2514),
            l = r(413);
        e.exports = {
          Split: /*#__PURE__*/function () {
            "use strict";

            function Split(e, t, r, o, s, i, c, l) {
              _classCallCheck(this, Split);

              if (!Number.isSafeInteger(s) || s < 0) throw Error("rat2 must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(o) || o < 0) throw Error("rat1 must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(i) || i < 0) throw Error("expiryRound must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(c) || c < 0) throw Error("minPay must be a positive number and smaller than 2^53-1");
              if (!Number.isSafeInteger(l) || l < 0) throw Error("maxFee must be a positive number and smaller than 2^53-1");
              var h = n.from("ASAIAQUCAAYHCAkmAyCztwQn0+DycN+vsk+vJWcsoz/b7NDS6i33HOkvTpf+YiC3qUpIgHGWE8/1LPh9SGCalSN7IaITeeWSXbfsS5wsXyC4kBQ38Z8zcwWVAym4S8vpFB/c0XC6R4mnPi9EBADsPDEQIhIxASMMEDIEJBJAABkxCSgSMQcyAxIQMQglEhAxAiEEDRAiQAAuMwAAMwEAEjEJMgMSEDMABykSEDMBByoSEDMACCEFCzMBCCEGCxIQMwAIIQcPEBA=", "base64"),
                  p = [l, i, s, o, c, e, t, r],
                  f = [u.valTypes.INT, u.valTypes.INT, u.valTypes.INT, u.valTypes.INT, u.valTypes.INT, u.valTypes.ADDRESS, u.valTypes.ADDRESS, u.valTypes.ADDRESS],
                  d = u.inject(h, [4, 7, 8, 9, 10, 14, 47, 80], p, f);
              this.programBytes = d;
              var g = a.makeLogicSig(d, void 0);
              this.address = g.address();
            }

            _createClass(Split, [{
              key: "getProgram",
              value: function getProgram() {
                return this.programBytes;
              }
            }, {
              key: "getAddress",
              value: function getAddress() {
                return this.address;
              }
            }]);

            return Split;
          }(),
          getSplitFundsTransaction: function getSplitFundsTransaction(e, t, r, n, u, h) {
            var p = c.readProgram(e, void 0),
                f = p[0],
                d = p[1];
            var g = f[6],
                y = f[5],
                m = 0;

            var b = function b(e, t) {
              if ("number" != typeof e || "number" != typeof t) throw new Error("gcd operates only on positive integers");
              return t ? b(t, e % t) : e;
            },
                w = b(g, y);

            g = Math.floor(g / w), y = Math.floor(y / w);
            var A = y / g;
            m = Math.round(t / (1 + A));
            var v = t - m;
            if (y * m != g * v) throw Error("could not split funds in a way that satisfied the contract ratio");

            var x = a.makeLogicSig(e, void 0).address(),
                S = o.encodeAddress(d[1]),
                E = o.encodeAddress(d[2]),
                T = [s.makePaymentTxn(x, S, u, m, void 0, r, n, void 0, h), s.makePaymentTxn(x, E, u, v, void 0, r, n, void 0, h)],
                _ = i.assignGroupID(T).map(function (e) {
              return a.signLogicSigTransactionObject(e, a).blob;
            });

            return l.concatArrays(_[0], _[1]);
          }
        };
      },
      2514: function _(e, t, r) {
        var n = r(2486).Buffer;
        var o = r(7116);

        function s(e, t) {
          var r = 0;

          for (; t > 128;) {
            e.push(255 & t | 128), t >>= 7, r += 1;
          }

          return e.push(255 & t), r + 1;
        }

        var i = {
          INT: 1,
          ADDRESS: 2,
          BASE64: 3
        };
        e.exports = {
          inject: function inject(e, t, r, a) {
            if (t.length !== r.length || t.length !== a.length) throw new Error("Lengths do not match");
            var c = e;

            function u(e, t, r, o) {
              var s = e.slice(0, r),
                  i = e.slice(r + o, e.length),
                  a = [s, n.from(t), i];
              return n.concat(a);
            }

            for (var _e14 = 0; _e14 < t.length; _e14++) {
              var l = 0,
                  h = r[_e14];

              switch (a[_e14]) {
                case i.INT:
                  var _r10 = [];
                  l = s(_r10, h), c = u(c, _r10, t[_e14], 1);
                  break;

                case i.ADDRESS:
                  h = o.decodeAddress(h), c = u(c, h.publicKey, t[_e14], 32);
                  break;

                case i.BASE64:
                  var _a2 = [];
                  h = n.from(h, "base64"), s(_a2, h.length), h = n.concat([n.from(_a2), h]), c = u(c, h, t[_e14], 33);
                  break;

                default:
                  throw new Error("unrecognized value type");
              }

              if (0 !== l) for (var _e15 = 0; _e15 < t.length; _e15++) {
                t[_e15] += l - 1;
              }
            }

            return c;
          },
          valTypes: i
        };
      },
      3410: function _(e, t, r) {
        "use strict";

        r.d(t, {
          JQ: function JQ() {
            return w;
          },
          _4: function _4() {
            return E;
          },
          X3: function X3() {
            return S;
          },
          R0: function R0() {
            return A;
          },
          jD: function jD() {
            return v;
          },
          Yh: function Yh() {
            return N;
          },
          bL: function bL() {
            return P;
          },
          Ls: function Ls() {
            return D;
          },
          UV: function UV() {
            return I;
          },
          Ax: function Ax() {
            return x;
          },
          A9: function A9() {
            return k;
          },
          w1: function w1() {
            return T;
          },
          NK: function NK() {
            return y;
          },
          RY: function RY() {
            return b;
          },
          Pu: function Pu() {
            return m;
          },
          Vk: function Vk() {
            return l;
          },
          nh: function nh() {
            return f;
          },
          kG: function kG() {
            return u;
          },
          qH: function qH() {
            return p;
          },
          JH: function JH() {
            return h;
          },
          vJ: function vJ() {
            return R;
          },
          o5: function o5() {
            return O;
          },
          AE: function AE() {
            return C;
          }
        });
        var n = r(7116),
            o = r(2486).Buffer;

        function s(e, t) {
          var r = e.toString(16);
          r.length !== 2 * t && (r = r.padStart(2 * t, "0"));
          var n = new Uint8Array(r.length / 2);

          for (var _e16 = 0, _t10 = 0; _e16 < r.length / 2; _e16++, _t10 += 2) {
            n[_e16] = parseInt(r.slice(_t10, _t10 + 2), 16);
          }

          return n;
        }

        function i(e) {
          var t = BigInt(0);
          var r = o.from(e);

          for (var _n11 = 0; _n11 < e.length; _n11++) {
            t = BigInt(Number(r.readUIntBE(_n11, 1))) + t * BigInt(256);
          }

          return t;
        }

        var a = r(413),
            c = r(2486).Buffer;
        var u = 65535,
            l = 32,
            h = 1,
            p = 1,
            f = 2,
            d = /^([a-z\d[\](),]+)\[([1-9][\d]*)]$/,
            g = /^ufixed([1-9][\d]*)x([1-9][\d]*)$/;

        var y = /*#__PURE__*/function () {
          function y() {
            _classCallCheck(this, y);
          }

          _createClass(y, null, [{
            key: "from",
            value: function from(e) {
              if (e.endsWith("[]")) {
                var _t11 = y.from(e.slice(0, e.length - 2));

                return new E(_t11);
              }

              if (e.endsWith("]")) {
                var _t12 = e.match(d);

                if (3 !== _t12.length) throw new Error("malformed static array string: ".concat(e));

                var _r11 = _t12[2],
                    _n12 = parseInt(_r11, 10);

                if (_n12 > u) throw new Error("array length exceeds limit ".concat(u));

                var _o6 = y.from(_t12[1]);

                return new S(_o6, _n12);
              }

              if (e.startsWith("uint")) {
                var _t13 = function _t13(e) {
                  return _toConsumableArray(e).every(function (e) {
                    return "0123456789".includes(e);
                  });
                },
                    _r12 = e.slice(4, e.length);

                if (!_t13(_r12)) throw new Error("malformed uint string: ".concat(_r12));

                var _n13 = parseInt(_r12, 10);

                if (_n13 > u) throw new Error("malformed uint string: ".concat(_n13));
                return new m(_n13);
              }

              if ("byte" === e) return new v();

              if (e.startsWith("ufixed")) {
                var _t14 = e.match(g);

                if (3 !== _t14.length) throw new Error("malformed ufixed type: ".concat(e));

                var _r13 = parseInt(_t14[1], 10),
                    _n14 = parseInt(_t14[2], 10);

                return new b(_r13, _n14);
              }

              if ("bool" === e) return new A();
              if ("address" === e) return new w();
              if ("string" === e) return new x();

              if (e.length >= 2 && "(" === e[0] && ")" === e[e.length - 1]) {
                var _t15 = T.parseTupleContent(e.slice(1, e.length - 1)),
                    _r14 = [];

                for (var _e17 = 0; _e17 < _t15.length; _e17++) {
                  var _n15 = y.from(_t15[_e17]);

                  _r14.push(_n15);
                }

                return new T(_r14);
              }

              throw new Error("cannot convert a string ".concat(e, " to an ABI type"));
            }
          }]);

          return y;
        }();

        var m = /*#__PURE__*/function (_y) {
          _inherits(m, _y);

          var _super2 = _createSuper(m);

          function m(e) {
            var _this3;

            _classCallCheck(this, m);

            if (_this3 = _super2.call(this), e % 8 != 0 || e < 8 || e > 512) throw new Error("unsupported uint type bitSize: ".concat(e));
            _this3.bitSize = e;
            return _possibleConstructorReturn(_this3);
          }

          _createClass(m, [{
            key: "toString",
            value: function toString() {
              return "uint".concat(this.bitSize);
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof m && this.bitSize === e.bitSize;
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return !1;
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              return this.bitSize / 8;
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if ("bigint" != typeof e && "number" != typeof e) throw new Error("Cannot encode value as uint".concat(this.bitSize, ": ").concat(e));
              if (e >= BigInt(Math.pow(2, this.bitSize)) || e < BigInt(0)) throw new Error("".concat(e, " is not a non-negative int or too big to fit in size uint").concat(this.bitSize));
              if ("number" == typeof e && !Number.isSafeInteger(e)) throw new Error("".concat(e, " should be converted into a BigInt before it is encoded"));
              return s(e, this.bitSize / 8);
            }
          }, {
            key: "decode",
            value: function decode(e) {
              if (e.length !== this.bitSize / 8) throw new Error("byte string must correspond to a uint".concat(this.bitSize));
              return i(e);
            }
          }]);

          return m;
        }(y);

        var b = /*#__PURE__*/function (_y2) {
          _inherits(b, _y2);

          var _super3 = _createSuper(b);

          function b(e, t) {
            var _this4;

            _classCallCheck(this, b);

            if (_this4 = _super3.call(this), e % 8 != 0 || e < 8 || e > 512) throw new Error("unsupported ufixed type bitSize: ".concat(e));
            if (t > 160 || t < 1) throw new Error("unsupported ufixed type precision: ".concat(t));
            _this4.bitSize = e, _this4.precision = t;
            return _possibleConstructorReturn(_this4);
          }

          _createClass(b, [{
            key: "toString",
            value: function toString() {
              return "ufixed".concat(this.bitSize, "x").concat(this.precision);
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof b && this.bitSize === e.bitSize && this.precision === e.precision;
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return !1;
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              return this.bitSize / 8;
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if ("bigint" != typeof e && "number" != typeof e) throw new Error("Cannot encode value as ".concat(this.toString(), ": ").concat(e));
              if (e >= BigInt(Math.pow(2, this.bitSize)) || e < BigInt(0)) throw new Error("".concat(e, " is not a non-negative int or too big to fit in size ").concat(this.toString()));
              if ("number" == typeof e && !Number.isSafeInteger(e)) throw new Error("".concat(e, " should be converted into a BigInt before it is encoded"));
              return s(e, this.bitSize / 8);
            }
          }, {
            key: "decode",
            value: function decode(e) {
              if (e.length !== this.bitSize / 8) throw new Error("byte string must correspond to a ".concat(this.toString()));
              return i(e);
            }
          }]);

          return b;
        }(y);

        var w = /*#__PURE__*/function (_y3) {
          _inherits(w, _y3);

          var _super4 = _createSuper(w);

          function w() {
            _classCallCheck(this, w);

            return _super4.apply(this, arguments);
          }

          _createClass(w, [{
            key: "toString",
            value: function toString() {
              return "address";
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof w;
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return !1;
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              return l;
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if ("string" != typeof e && !(e instanceof Uint8Array)) throw new Error("Cannot encode value as ".concat(this.toString(), ": ").concat(e));
              if ("string" == typeof e) return (0, n.decodeAddress)(e).publicKey;
              if (32 !== e.byteLength) throw new Error("byte string must be 32 bytes long for an address");
              return e;
            }
          }, {
            key: "decode",
            value: function decode(e) {
              if (32 !== e.byteLength) throw new Error("byte string must be 32 bytes long for an address");
              return (0, n.encodeAddress)(e);
            }
          }]);

          return w;
        }(y);

        var A = /*#__PURE__*/function (_y4) {
          _inherits(A, _y4);

          var _super5 = _createSuper(A);

          function A() {
            _classCallCheck(this, A);

            return _super5.apply(this, arguments);
          }

          _createClass(A, [{
            key: "toString",
            value: function toString() {
              return "bool";
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof A;
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return !1;
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              return p;
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if ("boolean" != typeof e) throw new Error("Cannot encode value as bool: ".concat(e));
              return e ? new Uint8Array([128]) : new Uint8Array([0]);
            }
          }, {
            key: "decode",
            value: function decode(e) {
              if (1 !== e.byteLength) throw new Error("bool string must be 1 byte long");
              var t = e[0];
              if (128 === t) return !0;
              if (0 === t) return !1;
              throw new Error("boolean could not be decoded from the byte string");
            }
          }]);

          return A;
        }(y);

        var v = /*#__PURE__*/function (_y5) {
          _inherits(v, _y5);

          var _super6 = _createSuper(v);

          function v() {
            _classCallCheck(this, v);

            return _super6.apply(this, arguments);
          }

          _createClass(v, [{
            key: "toString",
            value: function toString() {
              return "byte";
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof v;
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return !1;
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              return h;
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if ("number" != typeof e && "bigint" != typeof e) throw new Error("Cannot encode value as byte: ".concat(e));
              if ("bigint" == typeof e && (e = Number(e)), e < 0 || e > 255) throw new Error("".concat(e, " cannot be encoded into a byte"));
              return new Uint8Array([e]);
            }
          }, {
            key: "decode",
            value: function decode(e) {
              if (1 !== e.byteLength) throw new Error("byte string must be 1 byte long");
              return e[0];
            }
          }]);

          return v;
        }(y);

        var x = /*#__PURE__*/function (_y6) {
          _inherits(x, _y6);

          var _super7 = _createSuper(x);

          function x() {
            _classCallCheck(this, x);

            return _super7.apply(this, arguments);
          }

          _createClass(x, [{
            key: "toString",
            value: function toString() {
              return "string";
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof x;
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return !0;
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              throw new Error("".concat(this.toString(), " is a dynamic type"));
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if ("string" != typeof e && !(e instanceof Uint8Array)) throw new Error("Cannot encode value as string: ".concat(e));
              var t = c.from(e),
                  r = s(e.length, f),
                  n = new Uint8Array(e.length + f);
              return n.set(r), n.set(t, f), n;
            }
          }, {
            key: "decode",
            value: function decode(e) {
              if (e.length < f) throw new Error("byte string is too short to be decoded. Actual length is ".concat(e.length, ", but expected at least ").concat(f));
              var t = c.from(e).readUIntBE(0, f),
                  r = e.slice(f, e.length);
              if (t !== r.length) throw new Error("string length bytes do not match the actual length of string. Expected ".concat(t, ", got ").concat(r.length));
              return c.from(r).toString("utf-8");
            }
          }]);

          return x;
        }(y);

        var S = /*#__PURE__*/function (_y7) {
          _inherits(S, _y7);

          var _super8 = _createSuper(S);

          function S(e, t) {
            var _this5;

            _classCallCheck(this, S);

            if (_this5 = _super8.call(this), t < 1) throw new Error("static array must have a length greater than 0: ".concat(t));
            _this5.childType = e, _this5.staticLength = t;
            return _possibleConstructorReturn(_this5);
          }

          _createClass(S, [{
            key: "toString",
            value: function toString() {
              return "".concat(this.childType.toString(), "[").concat(this.staticLength, "]");
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof S && this.staticLength === e.staticLength && this.childType.equals(e.childType);
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return this.childType.isDynamic();
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              return this.childType.constructor === A ? Math.ceil(this.staticLength / 8) : this.staticLength * this.childType.byteLen();
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if (!(Array.isArray(e) || e instanceof Uint8Array)) throw new Error("Cannot encode value as ".concat(this.toString(), ": ").concat(e));
              if (e.length !== this.staticLength) throw new Error("Value array does not match static array length. Expected ".concat(this.staticLength, ", got ").concat(e.length));
              return this.toABITupleType().encode(e);
            }
          }, {
            key: "decode",
            value: function decode(e) {
              return this.toABITupleType().decode(e);
            }
          }, {
            key: "toABITupleType",
            value: function toABITupleType() {
              return new T(Array(this.staticLength).fill(this.childType));
            }
          }]);

          return S;
        }(y);

        var E = /*#__PURE__*/function (_y8) {
          _inherits(E, _y8);

          var _super9 = _createSuper(E);

          function E(e) {
            var _this6;

            _classCallCheck(this, E);

            _this6 = _super9.call(this), _this6.childType = e;
            return _this6;
          }

          _createClass(E, [{
            key: "toString",
            value: function toString() {
              return "".concat(this.childType.toString(), "[]");
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof E && this.childType.equals(e.childType);
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return !0;
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              throw new Error("".concat(this.toString(), " is a dynamic type"));
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if (!(Array.isArray(e) || e instanceof Uint8Array)) throw new Error("Cannot encode value as ".concat(this.toString(), ": ").concat(e));
              var t = this.toABITupleType(e.length),
                  r = t.encode(e),
                  n = s(t.childTypes.length, f);
              return (0, a.concatArrays)(n, r);
            }
          }, {
            key: "decode",
            value: function decode(e) {
              var t = c.from(e).readUIntBE(0, f);
              return this.toABITupleType(t).decode(e.slice(f, e.length));
            }
          }, {
            key: "toABITupleType",
            value: function toABITupleType(e) {
              return new T(Array(e).fill(this.childType));
            }
          }]);

          return E;
        }(y);

        var T = /*#__PURE__*/function (_y9) {
          _inherits(T, _y9);

          var _super10 = _createSuper(T);

          function T(e) {
            var _this7;

            _classCallCheck(this, T);

            if (_this7 = _super10.call(this), e.length >= u) throw new Error("tuple type child type number larger than maximum uint16 error");
            _this7.childTypes = e;
            return _possibleConstructorReturn(_this7);
          }

          _createClass(T, [{
            key: "toString",
            value: function toString() {
              var e = [];

              for (var _t16 = 0; _t16 < this.childTypes.length; _t16++) {
                e[_t16] = this.childTypes[_t16].toString();
              }

              return "(".concat(e.join(","), ")");
            }
          }, {
            key: "equals",
            value: function equals(e) {
              return e instanceof T && this.childTypes.length === e.childTypes.length && this.childTypes.every(function (t, r) {
                return t.equals(e.childTypes[r]);
              });
            }
          }, {
            key: "isDynamic",
            value: function isDynamic() {
              return this.childTypes.some(function (e) {
                return e.isDynamic();
              });
            }
          }, {
            key: "byteLen",
            value: function byteLen() {
              var e = 0;

              for (var _t17 = 0; _t17 < this.childTypes.length; _t17++) {
                if (this.childTypes[_t17].constructor === A) {
                  var _r15 = B(this.childTypes, _t17, 1),
                      _n16 = _r15 + 1;

                  _t17 += _r15, e += Math.trunc((_n16 + 7) / 8);
                } else e += this.childTypes[_t17].byteLen();
              }

              return e;
            }
          }, {
            key: "encode",
            value: function encode(e) {
              if (!(Array.isArray(e) || e instanceof Uint8Array)) throw new Error("Cannot encode value as ".concat(this.toString(), ": ").concat(e));
              var t = Array.from(e);
              if (e.length > u) throw new Error("length of tuple array should not exceed a uint16");
              var r = this.childTypes,
                  n = [],
                  o = [],
                  i = new Map();
              var c = 0;

              for (; c < r.length;) {
                var _e18 = r[c];
                if (_e18.isDynamic()) i.set(n.length, !0), n.push(new Uint8Array([0, 0])), o.push(_e18.encode(t[c]));else {
                  if (_e18.constructor === A) {
                    var _e19 = B(r, c, -1);

                    var _o7 = B(r, c, 1);

                    if (_e19 % 8 != 0) throw new Error("expected before index should have number of bool mod 8 equal 0");
                    _o7 = Math.min(7, _o7);

                    var _i5 = _(t.slice(c, c + _o7 + 1));

                    n.push(s(_i5, 1)), c += _o7;
                  } else {
                    var _r16 = _e18.encode(t[c]);

                    n.push(_r16);
                  }

                  i.set(c, !1), o.push(new Uint8Array());
                }
                c += 1;
              }

              var l = 0;

              for (var _i6 = 0, _n17 = n; _i6 < _n17.length; _i6++) {
                var _e20 = _n17[_i6];
                l += _e20.length;
              }

              var h = 0;

              for (var _e21 = 0; _e21 < n.length; _e21++) {
                if (i.get(_e21)) {
                  var _t18 = l + h;

                  if (_t18 > u) throw new Error("byte length of ".concat(_t18, " should not exceed a uint16"));
                  n[_e21] = s(_t18, f);
                }

                h += o[_e21].length;
              }

              return (0, a.concatArrays).apply(void 0, n.concat(o));
            }
          }, {
            key: "decode",
            value: function decode(e) {
              var t = this.childTypes,
                  r = [],
                  n = [];
              var o = 0,
                  s = 0;
              var i = c.from(e);

              for (; o < t.length;) {
                var _a3 = t[o];

                if (_a3.isDynamic()) {
                  if (e.slice(s, e.length).length < f) throw new Error("dynamic type in tuple is too short to be decoded");

                  var _t19 = i.readUIntBE(s, f);

                  if (r.length > 0 && (r[r.length - 1].right = _t19, _t19 < r[r.length - 1].left)) throw new Error("dynamic index segment miscalculation: left is greater than right index");
                  var _o8 = {
                    left: _t19,
                    right: -1
                  };
                  r.push(_o8), n.push(null), s += f;
                } else if (_a3.constructor === A) {
                  var _t20 = B(this.childTypes, o, -1);

                  var _r17 = B(this.childTypes, o, 1);

                  if (_t20 % 8 != 0) throw new Error("expected before bool number mod 8 === 0");
                  _r17 = Math.min(7, _r17);

                  for (var _t21 = 0; _t21 <= _r17; _t21++) {
                    var _r18 = 128 >> _t21;

                    (e[s] & _r18) > 0 ? n.push(new Uint8Array([128])) : n.push(new Uint8Array([0]));
                  }

                  o += _r17, s += 1;
                } else {
                  var _t22 = _a3.byteLen();

                  n.push(e.slice(s, s + _t22)), s += _t22;
                }

                if (o !== t.length - 1 && s >= e.length) throw new Error("input byte not enough to decode");
                o += 1;
              }

              if (r.length > 0 && (r[r.length - 1].right = e.length, s = e.length), s < e.length) throw new Error("input byte not fully consumed");

              for (var _e22 = 0; _e22 < r.length; _e22++) {
                var _t23 = r[_e22];
                if (_t23.left > _t23.right) throw new Error("dynamic segment should display a [l, r] space with l <= r");
                if (_e22 !== r.length - 1 && _t23.right !== r[_e22 + 1].left) throw new Error("dynamic segment should be consecutive");
              }

              var a = 0;

              for (var _o9 = 0; _o9 < t.length; _o9++) {
                t[_o9].isDynamic() && (n[_o9] = e.slice(r[a].left, r[a].right), a += 1);
              }

              var u = [];

              for (var _e23 = 0; _e23 < t.length; _e23++) {
                var _r19 = t[_e23].decode(n[_e23]);

                u.push(_r19);
              }

              return u;
            }
          }], [{
            key: "parseTupleContent",
            value: function parseTupleContent(e) {
              if (0 === e.length) return [];
              if (e.endsWith(",") || e.startsWith(",")) throw new Error("tuple string should not start with comma");
              if (e.includes(",,")) throw new Error("tuple string should not have consecutive commas");
              var t = [];
              var r = 0,
                  n = "";

              var _iterator = _createForOfIteratorHelper(e),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _o10 = _step.value;
                  n += _o10, "(" === _o10 ? r += 1 : ")" === _o10 ? r -= 1 : "," === _o10 && 0 === r && (t.push(n.slice(0, n.length - 1)), n = "");
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              if (0 !== n.length && t.push(n), 0 !== r) throw new Error("tuple string has mismatched parentheses");
              return t;
            }
          }]);

          return T;
        }(y);

        function _(e) {
          var t = 0;
          if (e.length > 8) throw new Error("value list passed in should be no greater than length 8");

          for (var _r20 = 0; _r20 < e.length; _r20++) {
            var _n18 = e[_r20];
            if ("boolean" != typeof _n18) throw new Error("non-boolean values cannot be compressed into a byte");
            _n18 && (t |= 1 << 7 - _r20);
          }

          return t;
        }

        function B(e, t, r) {
          var n = 0;

          for (;;) {
            var _o11 = t + r * n;

            if (e[_o11].constructor !== A) {
              n -= 1;
              break;
            }

            if (_o11 !== e.length - 1 && 1 === r) n += 1;else {
              if (!(_o11 > 0 && -1 === r)) break;
              n += 1;
            }
          }

          return n;
        }

        var k,
            I,
            U = r(9404);

        function C(e) {
          return e === k.any || e === k.pay || e === k.keyreg || e === k.acfg || e === k.axfer || e === k.afrz || e === k.appl;
        }

        function R(e, t) {
          return e === k.any || t.type && t.type.toString() === e.toString();
        }

        function O(e) {
          return e === I.account || e === I.application || e === I.asset;
        }

        !function (e) {
          e.any = "txn", e.pay = "pay", e.keyreg = "keyreg", e.acfg = "acfg", e.axfer = "axfer", e.afrz = "afrz", e.appl = "appl";
        }(k || (k = {})), function (e) {
          e.account = "account", e.application = "application", e.asset = "asset";
        }(I || (I = {}));

        var D = /*#__PURE__*/function () {
          function D(e) {
            _classCallCheck(this, D);

            if ("string" != typeof e.name || "object" != typeof e.returns || !Array.isArray(e.args)) throw new Error("Invalid ABIMethod parameters");
            this.name = e.name, this.description = e.desc, this.args = e.args.map(function (_ref20) {
              var e = _ref20.type,
                  t = _ref20.name,
                  r = _ref20.desc;
              return C(e) || O(e) ? {
                type: e,
                name: t,
                description: r
              } : {
                type: y.from(e),
                name: t,
                description: r
              };
            }), this.returns = {
              type: "void" === e.returns.type ? e.returns.type : y.from(e.returns.type),
              description: e.returns.desc
            };
          }

          _createClass(D, [{
            key: "getSignature",
            value: function getSignature() {
              var e = this.args.map(function (e) {
                return e.type.toString();
              }).join(","),
                  t = this.returns.type.toString();
              return "".concat(this.name, "(").concat(e, ")").concat(t);
            }
          }, {
            key: "getSelector",
            value: function getSelector() {
              var e = (0, U.genericHash)(this.getSignature());
              return new Uint8Array(e.slice(0, 4));
            }
          }, {
            key: "txnCount",
            value: function txnCount() {
              var e = 1;

              var _iterator2 = _createForOfIteratorHelper(this.args),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _t24 = _step2.value;
                  "string" == typeof _t24.type && C(_t24.type) && (e += 1);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }

              return e;
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              return {
                name: this.name,
                desc: this.description,
                args: this.args.map(function (_ref21) {
                  var e = _ref21.type,
                      t = _ref21.name,
                      r = _ref21.description;
                  return {
                    type: e.toString(),
                    name: t,
                    desc: r
                  };
                }),
                returns: {
                  type: this.returns.type.toString(),
                  desc: this.returns.description
                }
              };
            }
          }], [{
            key: "fromSignature",
            value: function fromSignature(e) {
              var _ref22 = function (e) {
                var t = e.indexOf("(");
                if (-1 === t) throw new Error("Invalid method signature: ".concat(e));
                var r = -1,
                    n = 0;

                for (var _o12 = t; _o12 < e.length; _o12++) {
                  var _t25 = e[_o12];
                  if ("(" === _t25) n += 1;else if (")" === _t25) {
                    if (0 === n) break;

                    if (n -= 1, 0 === n) {
                      r = _o12;
                      break;
                    }
                  }
                }

                if (-1 === r) throw new Error("Invalid method signature: ".concat(e));
                return {
                  name: e.slice(0, t),
                  args: T.parseTupleContent(e.slice(t + 1, r)),
                  returns: e.slice(r + 1)
                };
              }(e),
                  t = _ref22.name,
                  r = _ref22.args,
                  n = _ref22.returns;

              return new D({
                name: t,
                args: r.map(function (e) {
                  return {
                    type: e
                  };
                }),
                returns: {
                  type: n
                }
              });
            }
          }]);

          return D;
        }();

        var N = /*#__PURE__*/function () {
          function N(e) {
            _classCallCheck(this, N);

            if ("string" != typeof e.name || !Array.isArray(e.methods) || e.networks && "object" != typeof e.networks) throw new Error("Invalid ABIContract parameters");
            this.name = e.name, this.description = e.desc, this.networks = e.networks ? _objectSpread({}, e.networks) : {}, this.methods = e.methods.map(function (e) {
              return new D(e);
            });
          }

          _createClass(N, [{
            key: "toJSON",
            value: function toJSON() {
              return {
                name: this.name,
                desc: this.description,
                networks: this.networks,
                methods: this.methods.map(function (e) {
                  return e.toJSON();
                })
              };
            }
          }]);

          return N;
        }();

        var P = /*#__PURE__*/function () {
          function P(e) {
            _classCallCheck(this, P);

            if ("string" != typeof e.name || !Array.isArray(e.methods)) throw new Error("Invalid ABIInterface parameters");
            this.name = e.name, this.description = e.desc, this.methods = e.methods.map(function (e) {
              return new D(e);
            });
          }

          _createClass(P, [{
            key: "toJSON",
            value: function toJSON() {
              return {
                name: this.name,
                desc: this.description,
                methods: this.methods.map(function (e) {
                  return e.toJSON();
                })
              };
            }
          }]);

          return P;
        }();
      },
      7988: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = r(9404),
            o = r(7116);

        function s() {
          var e = n.keyPair();
          return {
            addr: o.encodeAddress(e.publicKey),
            sk: e.secretKey
          };
        }
      },
      2691: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var n = r(7116),
            o = r(3033),
            s = r(9404),
            i = r(413),
            a = r(2486).Buffer;

        var c = /*#__PURE__*/function () {
          function c(_ref23) {
            var e = _ref23.bidderKey,
                t = _ref23.bidAmount,
                r = _ref23.bidID,
                o = _ref23.auctionKey,
                s = _ref23.auctionID,
                i = _ref23.maxPrice;

            _classCallCheck(this, c);

            this.name = "Bid", this.tag = a.from([97, 66]);

            var _c2 = n.decodeAddress(e),
                u = n.decodeAddress(o);

            if (!Number.isSafeInteger(t) || t < 0) throw Error("Bid amount must be positive and 2^53-1");
            if (!Number.isSafeInteger(r) || r < 0) throw Error("BidID must be positive and 2^53-1");
            if (!Number.isSafeInteger(s) || s < 0) throw Error("auctionID must be positive");
            Object.assign(this, {
              bidderKey: _c2,
              bidAmount: t,
              bidID: r,
              auctionKey: u,
              auctionID: s,
              maxPrice: i
            });
          }

          _createClass(c, [{
            key: "get_obj_for_encoding",
            value: function get_obj_for_encoding() {
              return {
                bidder: a.from(this.bidderKey.publicKey),
                cur: this.bidAmount,
                price: this.maxPrice,
                id: this.bidID,
                auc: a.from(this.auctionKey.publicKey),
                aid: this.auctionID
              };
            }
          }, {
            key: "signBid",
            value: function signBid(e) {
              var t = o.encode(this.get_obj_for_encoding()),
                  r = a.from(i.concatArrays(this.tag, t)),
                  n = s.sign(r, e),
                  _c3 = {
                t: "b",
                b: {
                  sig: a.from(n),
                  bid: this.get_obj_for_encoding()
                }
              };
              return new Uint8Array(o.encode(_c3));
            }
          }]);

          return c;
        }();
      },
      1113: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          default: function _default() {
            return f;
          }
        });
        var n = r(413),
            o = r(1042),
            s = r.n(o),
            i = r(9368),
            a = r.n(i),
            c = r(5391),
            u = r(2486).Buffer;

        var l = /*#__PURE__*/function () {
          function l(e, t, r) {
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            _classCallCheck(this, l);

            this.defaultHeaders = n;
            var o = new (s())(t, {});
            if (void 0 !== r && o.set("port", r.toString()), 0 === o.protocol.length) throw new Error("Invalid base server URL, protocol must be defined.");
            this.baseURL = o, this.tokenHeader = e;
          }

          _createClass(l, [{
            key: "addressWithPath",
            value: function addressWithPath(e) {
              return new (s())(a().posix.join(this.baseURL.pathname, e), this.baseURL).toString();
            }
          }, {
            key: "get",
            value: function () {
              var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(e, t) {
                var r,
                    n,
                    _e24,
                    _args20 = arguments;

                return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                  while (1) {
                    switch (_context20.prev = _context20.next) {
                      case 0:
                        r = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : {};
                        n = c.get(this.addressWithPath(e)).set(this.tokenHeader).set(this.defaultHeaders).set(r).responseType("arraybuffer").query(t);
                        _context20.prev = 2;
                        _context20.next = 5;
                        return n;

                      case 5:
                        _e24 = _context20.sent;
                        return _context20.abrupt("return", l.superagentToHTTPClientResponse(_e24));

                      case 9:
                        _context20.prev = 9;
                        _context20.t0 = _context20["catch"](2);
                        throw l.formatSuperagentError(_context20.t0);

                      case 12:
                      case "end":
                        return _context20.stop();
                    }
                  }
                }, _callee20, this, [[2, 9]]);
              }));

              function get(_x16, _x17) {
                return _get.apply(this, arguments);
              }

              return get;
            }()
          }, {
            key: "post",
            value: function () {
              var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(e, t, r) {
                var n,
                    o,
                    _e25,
                    _args21 = arguments;

                return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                  while (1) {
                    switch (_context21.prev = _context21.next) {
                      case 0:
                        n = _args21.length > 3 && _args21[3] !== undefined ? _args21[3] : {};
                        o = c.post(this.addressWithPath(e)).set(this.tokenHeader).set(this.defaultHeaders).set(n).query(r).serialize(function (e) {
                          return e;
                        }).responseType("arraybuffer").send(u.from(t));
                        _context21.prev = 2;
                        _context21.next = 5;
                        return o;

                      case 5:
                        _e25 = _context21.sent;
                        return _context21.abrupt("return", l.superagentToHTTPClientResponse(_e25));

                      case 9:
                        _context21.prev = 9;
                        _context21.t0 = _context21["catch"](2);
                        throw l.formatSuperagentError(_context21.t0);

                      case 12:
                      case "end":
                        return _context21.stop();
                    }
                  }
                }, _callee21, this, [[2, 9]]);
              }));

              function post(_x18, _x19, _x20) {
                return _post.apply(this, arguments);
              }

              return post;
            }()
          }, {
            key: "delete",
            value: function () {
              var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(e, t, r) {
                var n,
                    o,
                    _e26,
                    _args22 = arguments;

                return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                  while (1) {
                    switch (_context22.prev = _context22.next) {
                      case 0:
                        n = _args22.length > 3 && _args22[3] !== undefined ? _args22[3] : {};
                        o = c.delete(this.addressWithPath(e)).set(this.tokenHeader).set(this.defaultHeaders).set(n).query(r).serialize(function (e) {
                          return e;
                        }).responseType("arraybuffer").send(u.from(t));
                        _context22.prev = 2;
                        _context22.next = 5;
                        return o;

                      case 5:
                        _e26 = _context22.sent;
                        return _context22.abrupt("return", l.superagentToHTTPClientResponse(_e26));

                      case 9:
                        _context22.prev = 9;
                        _context22.t0 = _context22["catch"](2);
                        throw l.formatSuperagentError(_context22.t0);

                      case 12:
                      case "end":
                        return _context22.stop();
                    }
                  }
                }, _callee22, this, [[2, 9]]);
              }));

              function _delete(_x21, _x22, _x23) {
                return _delete2.apply(this, arguments);
              }

              return _delete;
            }()
          }], [{
            key: "superagentToHTTPClientResponse",
            value: function superagentToHTTPClientResponse(e) {
              return e.body instanceof ArrayBuffer && (e.body = new Uint8Array(e.body)), e;
            }
          }, {
            key: "formatSuperagentError",
            value: function formatSuperagentError(e) {
              if (e.response) try {
                var _t26 = JSON.parse(u.from(e.response.body).toString());

                e.message = "Network request error. Received status ".concat(e.response.status, ": ").concat(_t26.message);
              } catch (e) {}
              return e;
            }
          }]);

          return l;
        }();

        var h = r(2486).Buffer;

        function p(e) {
          return Object.keys(e).reduce(function (t, r) {
            return t[r.toLowerCase()] = e[r], t;
          }, {});
        }

        var f = /*#__PURE__*/function () {
          function f(e, t, r) {
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            _classCallCheck(this, f);

            this.bc = void 0 !== t ? new l(e, t, r, n) : e;
          }

          _createClass(f, [{
            key: "get",
            value: function () {
              var _get2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(e, t) {
                var r,
                    n,
                    o,
                    _r21,
                    _args23 = arguments;

                return _regeneratorRuntime.wrap(function _callee23$(_context23) {
                  while (1) {
                    switch (_context23.prev = _context23.next) {
                      case 0:
                        r = _args23.length > 2 && _args23[2] !== undefined ? _args23[2] : {};
                        n = _args23.length > 3 && _args23[3] !== undefined ? _args23[3] : {};
                        o = _objectSpread(_objectSpread({}, r), {}, {
                          accept: function (e) {
                            if (void 0 === e || !Object.prototype.hasOwnProperty.call(e, "format")) return "application/json";

                            switch (e.format) {
                              case "msgpack":
                                return "application/msgpack";

                              case "json":
                              default:
                                return "application/json";
                            }
                          }(t)
                        });
                        _context23.prev = 3;
                        _context23.next = 6;
                        return this.bc.get(e, function (e) {
                          for (var _t27 in e) {
                            Object.prototype.hasOwnProperty.call(e, _t27) && (e[_t27] && 0 !== e[_t27].length || delete e[_t27]);
                          }

                          return e;
                        }(t), o);

                      case 6:
                        _r21 = _context23.sent;
                        return _context23.abrupt("return", f.prepareResponse(_r21, n));

                      case 10:
                        _context23.prev = 10;
                        _context23.t0 = _context23["catch"](3);
                        throw f.prepareResponseError(_context23.t0);

                      case 13:
                      case "end":
                        return _context23.stop();
                    }
                  }
                }, _callee23, this, [[3, 10]]);
              }));

              function get(_x24, _x25) {
                return _get2.apply(this, arguments);
              }

              return get;
            }()
          }, {
            key: "post",
            value: function () {
              var _post2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(e, t) {
                var r,
                    n,
                    _r22,
                    _args24 = arguments;

                return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                  while (1) {
                    switch (_context24.prev = _context24.next) {
                      case 0:
                        r = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : {};
                        n = _objectSpread({
                          "content-type": "application/json"
                        }, p(r));
                        _context24.prev = 2;
                        _context24.next = 5;
                        return this.bc.post(e, f.serializeData(t, n), void 0, n);

                      case 5:
                        _r22 = _context24.sent;
                        return _context24.abrupt("return", f.prepareResponse(_r22));

                      case 9:
                        _context24.prev = 9;
                        _context24.t0 = _context24["catch"](2);
                        throw f.prepareResponseError(_context24.t0);

                      case 12:
                      case "end":
                        return _context24.stop();
                    }
                  }
                }, _callee24, this, [[2, 9]]);
              }));

              function post(_x26, _x27) {
                return _post2.apply(this, arguments);
              }

              return post;
            }()
          }, {
            key: "delete",
            value: function () {
              var _delete3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e, t) {
                var r,
                    n,
                    o,
                    _args25 = arguments;
                return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                  while (1) {
                    switch (_context25.prev = _context25.next) {
                      case 0:
                        r = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : {};
                        n = _objectSpread({
                          "content-type": "application/json"
                        }, p(r));
                        _context25.next = 4;
                        return this.bc.delete(e, f.serializeData(t, n), void 0, n);

                      case 4:
                        o = _context25.sent;
                        return _context25.abrupt("return", f.prepareResponse(o));

                      case 6:
                      case "end":
                        return _context25.stop();
                    }
                  }
                }, _callee25, this);
              }));

              function _delete(_x28, _x29) {
                return _delete3.apply(this, arguments);
              }

              return _delete;
            }()
          }], [{
            key: "parseJSON",
            value: function parseJSON(e, t) {
              var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

              try {
                return 0 === Object.keys(r).length ? e && JSON.parse(e) : e && n.parseJSON(e, r);
              } catch (r) {
                var _n19 = r;
                throw _n19.rawResponse = e || null, _n19.statusCode = t, _n19;
              }
            }
          }, {
            key: "serializeData",
            value: function serializeData(e, t) {
              if (!e) return new Uint8Array(0);
              if ("application/json" === t["content-type"]) return new Uint8Array(h.from(JSON.stringify(e)));
              if ("string" == typeof e) return new Uint8Array(h.from(e));
              if (e instanceof Uint8Array) return e;
              throw new Error("provided data is neither a string nor a Uint8Array and content-type is not application/json");
            }
          }, {
            key: "prepareResponse",
            value: function prepareResponse(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var r,
                  n = e.body;
              return function (e) {
                var t = p(e.headers)["content-type"];
                return t && (t = t.split(";")[0]), /[/+]json($|[^-\w])/i.test(t);
              }(e) ? (r = n && new TextDecoder().decode(n) || "", n = f.parseJSON(r, e.status, t)) : function (e) {
                var t = p(e.headers)["content-type"] || "text/plain";
                return /^\w*text\//i.test(t);
              }(e) && (r = n && new TextDecoder().decode(n) || ""), _objectSpread(_objectSpread({}, e), {}, {
                body: n,
                text: r,
                ok: 2 === Math.trunc(e.status / 100)
              });
            }
          }, {
            key: "prepareResponseError",
            value: function prepareResponseError(e) {
              return e.response && (e.response = f.prepareResponse(e.response), e.status = e.response.status), e;
            }
          }]);

          return f;
        }();
      },
      6477: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var n = r(3480),
            o = r(9417),
            s = r(2486).Buffer;

        var i = /*#__PURE__*/function (_n$Z) {
          _inherits(i, _n$Z);

          var _super11 = _createSuper(i);

          function i(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "http://127.0.0.1";
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7833;
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            _classCallCheck(this, i);

            return _super11.call(this, "X-KMD-API-Token", e, t, r, n);
          }

          _createClass(i, [{
            key: "versions",
            value: function () {
              var _versions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
                return _regeneratorRuntime.wrap(function _callee26$(_context26) {
                  while (1) {
                    switch (_context26.prev = _context26.next) {
                      case 0:
                        _context26.next = 2;
                        return this.c.get("/versions");

                      case 2:
                        return _context26.abrupt("return", _context26.sent.body);

                      case 3:
                      case "end":
                        return _context26.stop();
                    }
                  }
                }, _callee26, this);
              }));

              function versions() {
                return _versions.apply(this, arguments);
              }

              return versions;
            }()
          }, {
            key: "listWallets",
            value: function () {
              var _listWallets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
                return _regeneratorRuntime.wrap(function _callee27$(_context27) {
                  while (1) {
                    switch (_context27.prev = _context27.next) {
                      case 0:
                        _context27.next = 2;
                        return this.c.get("/v1/wallets");

                      case 2:
                        return _context27.abrupt("return", _context27.sent.body);

                      case 3:
                      case "end":
                        return _context27.stop();
                    }
                  }
                }, _callee27, this);
              }));

              function listWallets() {
                return _listWallets.apply(this, arguments);
              }

              return listWallets;
            }()
          }, {
            key: "createWallet",
            value: function () {
              var _createWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(e, t) {
                var r,
                    n,
                    o,
                    _args28 = arguments;
                return _regeneratorRuntime.wrap(function _callee28$(_context28) {
                  while (1) {
                    switch (_context28.prev = _context28.next) {
                      case 0:
                        r = _args28.length > 2 && _args28[2] !== undefined ? _args28[2] : "";
                        n = _args28.length > 3 && _args28[3] !== undefined ? _args28[3] : "sqlite";
                        o = {
                          wallet_name: e,
                          wallet_driver_name: n,
                          wallet_password: t,
                          master_derivation_key: s.from(r).toString("base64")
                        };
                        _context28.next = 5;
                        return this.c.post("/v1/wallet", o);

                      case 5:
                        return _context28.abrupt("return", _context28.sent.body);

                      case 6:
                      case "end":
                        return _context28.stop();
                    }
                  }
                }, _callee28, this);
              }));

              function createWallet(_x30, _x31) {
                return _createWallet.apply(this, arguments);
              }

              return createWallet;
            }()
          }, {
            key: "initWalletHandle",
            value: function () {
              var _initWalletHandle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(e, t) {
                var r;
                return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                  while (1) {
                    switch (_context29.prev = _context29.next) {
                      case 0:
                        r = {
                          wallet_id: e,
                          wallet_password: t
                        };
                        _context29.next = 3;
                        return this.c.post("/v1/wallet/init", r);

                      case 3:
                        return _context29.abrupt("return", _context29.sent.body);

                      case 4:
                      case "end":
                        return _context29.stop();
                    }
                  }
                }, _callee29, this);
              }));

              function initWalletHandle(_x32, _x33) {
                return _initWalletHandle.apply(this, arguments);
              }

              return initWalletHandle;
            }()
          }, {
            key: "releaseWalletHandle",
            value: function () {
              var _releaseWalletHandle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(e) {
                var t;
                return _regeneratorRuntime.wrap(function _callee30$(_context30) {
                  while (1) {
                    switch (_context30.prev = _context30.next) {
                      case 0:
                        t = {
                          wallet_handle_token: e
                        };
                        _context30.next = 3;
                        return this.c.post("/v1/wallet/release", t);

                      case 3:
                        return _context30.abrupt("return", _context30.sent.body);

                      case 4:
                      case "end":
                        return _context30.stop();
                    }
                  }
                }, _callee30, this);
              }));

              function releaseWalletHandle(_x34) {
                return _releaseWalletHandle.apply(this, arguments);
              }

              return releaseWalletHandle;
            }()
          }, {
            key: "renewWalletHandle",
            value: function () {
              var _renewWalletHandle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(e) {
                var t;
                return _regeneratorRuntime.wrap(function _callee31$(_context31) {
                  while (1) {
                    switch (_context31.prev = _context31.next) {
                      case 0:
                        t = {
                          wallet_handle_token: e
                        };
                        _context31.next = 3;
                        return this.c.post("/v1/wallet/renew", t);

                      case 3:
                        return _context31.abrupt("return", _context31.sent.body);

                      case 4:
                      case "end":
                        return _context31.stop();
                    }
                  }
                }, _callee31, this);
              }));

              function renewWalletHandle(_x35) {
                return _renewWalletHandle.apply(this, arguments);
              }

              return renewWalletHandle;
            }()
          }, {
            key: "renameWallet",
            value: function () {
              var _renameWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(e, t, r) {
                var n;
                return _regeneratorRuntime.wrap(function _callee32$(_context32) {
                  while (1) {
                    switch (_context32.prev = _context32.next) {
                      case 0:
                        n = {
                          wallet_id: e,
                          wallet_password: t,
                          wallet_name: r
                        };
                        _context32.next = 3;
                        return this.c.post("/v1/wallet/rename", n);

                      case 3:
                        return _context32.abrupt("return", _context32.sent.body);

                      case 4:
                      case "end":
                        return _context32.stop();
                    }
                  }
                }, _callee32, this);
              }));

              function renameWallet(_x36, _x37, _x38) {
                return _renameWallet.apply(this, arguments);
              }

              return renameWallet;
            }()
          }, {
            key: "getWallet",
            value: function () {
              var _getWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(e) {
                var t;
                return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                  while (1) {
                    switch (_context33.prev = _context33.next) {
                      case 0:
                        t = {
                          wallet_handle_token: e
                        };
                        _context33.next = 3;
                        return this.c.post("/v1/wallet/info", t);

                      case 3:
                        return _context33.abrupt("return", _context33.sent.body);

                      case 4:
                      case "end":
                        return _context33.stop();
                    }
                  }
                }, _callee33, this);
              }));

              function getWallet(_x39) {
                return _getWallet.apply(this, arguments);
              }

              return getWallet;
            }()
          }, {
            key: "exportMasterDerivationKey",
            value: function () {
              var _exportMasterDerivationKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(e, t) {
                var r, n;
                return _regeneratorRuntime.wrap(function _callee34$(_context34) {
                  while (1) {
                    switch (_context34.prev = _context34.next) {
                      case 0:
                        r = {
                          wallet_handle_token: e,
                          wallet_password: t
                        };
                        _context34.next = 3;
                        return this.c.post("/v1/master-key/export", r);

                      case 3:
                        n = _context34.sent;
                        return _context34.abrupt("return", {
                          master_derivation_key: s.from(n.body.master_derivation_key, "base64")
                        });

                      case 5:
                      case "end":
                        return _context34.stop();
                    }
                  }
                }, _callee34, this);
              }));

              function exportMasterDerivationKey(_x40, _x41) {
                return _exportMasterDerivationKey.apply(this, arguments);
              }

              return exportMasterDerivationKey;
            }()
          }, {
            key: "importKey",
            value: function () {
              var _importKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(e, t) {
                var r;
                return _regeneratorRuntime.wrap(function _callee35$(_context35) {
                  while (1) {
                    switch (_context35.prev = _context35.next) {
                      case 0:
                        r = {
                          wallet_handle_token: e,
                          private_key: s.from(t).toString("base64")
                        };
                        _context35.next = 3;
                        return this.c.post("/v1/key/import", r);

                      case 3:
                        return _context35.abrupt("return", _context35.sent.body);

                      case 4:
                      case "end":
                        return _context35.stop();
                    }
                  }
                }, _callee35, this);
              }));

              function importKey(_x42, _x43) {
                return _importKey.apply(this, arguments);
              }

              return importKey;
            }()
          }, {
            key: "exportKey",
            value: function () {
              var _exportKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(e, t, r) {
                var n, o;
                return _regeneratorRuntime.wrap(function _callee36$(_context36) {
                  while (1) {
                    switch (_context36.prev = _context36.next) {
                      case 0:
                        n = {
                          wallet_handle_token: e,
                          address: r,
                          wallet_password: t
                        };
                        _context36.next = 3;
                        return this.c.post("/v1/key/export", n);

                      case 3:
                        o = _context36.sent;
                        return _context36.abrupt("return", {
                          private_key: s.from(o.body.private_key, "base64")
                        });

                      case 5:
                      case "end":
                        return _context36.stop();
                    }
                  }
                }, _callee36, this);
              }));

              function exportKey(_x44, _x45, _x46) {
                return _exportKey.apply(this, arguments);
              }

              return exportKey;
            }()
          }, {
            key: "generateKey",
            value: function () {
              var _generateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(e) {
                var t;
                return _regeneratorRuntime.wrap(function _callee37$(_context37) {
                  while (1) {
                    switch (_context37.prev = _context37.next) {
                      case 0:
                        t = {
                          wallet_handle_token: e,
                          display_mnemonic: !1
                        };
                        _context37.next = 3;
                        return this.c.post("/v1/key", t);

                      case 3:
                        return _context37.abrupt("return", _context37.sent.body);

                      case 4:
                      case "end":
                        return _context37.stop();
                    }
                  }
                }, _callee37, this);
              }));

              function generateKey(_x47) {
                return _generateKey.apply(this, arguments);
              }

              return generateKey;
            }()
          }, {
            key: "deleteKey",
            value: function () {
              var _deleteKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(e, t, r) {
                var n;
                return _regeneratorRuntime.wrap(function _callee38$(_context38) {
                  while (1) {
                    switch (_context38.prev = _context38.next) {
                      case 0:
                        n = {
                          wallet_handle_token: e,
                          address: r,
                          wallet_password: t
                        };
                        _context38.next = 3;
                        return this.c.delete("/v1/key", n);

                      case 3:
                        return _context38.abrupt("return", _context38.sent.body);

                      case 4:
                      case "end":
                        return _context38.stop();
                    }
                  }
                }, _callee38, this);
              }));

              function deleteKey(_x48, _x49, _x50) {
                return _deleteKey.apply(this, arguments);
              }

              return deleteKey;
            }()
          }, {
            key: "listKeys",
            value: function () {
              var _listKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(e) {
                var t;
                return _regeneratorRuntime.wrap(function _callee39$(_context39) {
                  while (1) {
                    switch (_context39.prev = _context39.next) {
                      case 0:
                        t = {
                          wallet_handle_token: e
                        };
                        _context39.next = 3;
                        return this.c.post("/v1/key/list", t);

                      case 3:
                        return _context39.abrupt("return", _context39.sent.body);

                      case 4:
                      case "end":
                        return _context39.stop();
                    }
                  }
                }, _callee39, this);
              }));

              function listKeys(_x51) {
                return _listKeys.apply(this, arguments);
              }

              return listKeys;
            }()
          }, {
            key: "signTransaction",
            value: function () {
              var _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(e, t, r) {
                var n, _i7, a;

                return _regeneratorRuntime.wrap(function _callee40$(_context40) {
                  while (1) {
                    switch (_context40.prev = _context40.next) {
                      case 0:
                        n = o.instantiateTxnIfNeeded(r);
                        _i7 = {
                          wallet_handle_token: e,
                          wallet_password: t,
                          transaction: s.from(n.toByte()).toString("base64")
                        };
                        _context40.next = 4;
                        return this.c.post("/v1/transaction/sign", _i7);

                      case 4:
                        a = _context40.sent;
                        return _context40.abrupt("return", 200 === a.status ? s.from(a.body.signed_transaction, "base64") : a.body);

                      case 6:
                      case "end":
                        return _context40.stop();
                    }
                  }
                }, _callee40, this);
              }));

              function signTransaction(_x52, _x53, _x54) {
                return _signTransaction.apply(this, arguments);
              }

              return signTransaction;
            }()
          }, {
            key: "signTransactionWithSpecificPublicKey",
            value: function () {
              var _signTransactionWithSpecificPublicKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(e, t, r, n) {
                var _i8, a, c;

                return _regeneratorRuntime.wrap(function _callee41$(_context41) {
                  while (1) {
                    switch (_context41.prev = _context41.next) {
                      case 0:
                        _i8 = o.instantiateTxnIfNeeded(r);
                        a = {
                          wallet_handle_token: e,
                          wallet_password: t,
                          transaction: s.from(_i8.toByte()).toString("base64"),
                          public_key: s.from(n).toString("base64")
                        };
                        _context41.next = 4;
                        return this.c.post("/v1/transaction/sign", a);

                      case 4:
                        c = _context41.sent;
                        return _context41.abrupt("return", 200 === c.status ? s.from(c.body.signed_transaction, "base64") : c.body);

                      case 6:
                      case "end":
                        return _context41.stop();
                    }
                  }
                }, _callee41, this);
              }));

              function signTransactionWithSpecificPublicKey(_x55, _x56, _x57, _x58) {
                return _signTransactionWithSpecificPublicKey.apply(this, arguments);
              }

              return signTransactionWithSpecificPublicKey;
            }()
          }, {
            key: "listMultisig",
            value: function () {
              var _listMultisig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(e) {
                var t;
                return _regeneratorRuntime.wrap(function _callee42$(_context42) {
                  while (1) {
                    switch (_context42.prev = _context42.next) {
                      case 0:
                        t = {
                          wallet_handle_token: e
                        };
                        _context42.next = 3;
                        return this.c.post("/v1/multisig/list", t);

                      case 3:
                        return _context42.abrupt("return", _context42.sent.body);

                      case 4:
                      case "end":
                        return _context42.stop();
                    }
                  }
                }, _callee42, this);
              }));

              function listMultisig(_x59) {
                return _listMultisig.apply(this, arguments);
              }

              return listMultisig;
            }()
          }, {
            key: "importMultisig",
            value: function () {
              var _importMultisig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(e, t, r, n) {
                var o;
                return _regeneratorRuntime.wrap(function _callee43$(_context43) {
                  while (1) {
                    switch (_context43.prev = _context43.next) {
                      case 0:
                        o = {
                          wallet_handle_token: e,
                          multisig_version: t,
                          threshold: r,
                          pks: n
                        };
                        _context43.next = 3;
                        return this.c.post("/v1/multisig/import", o);

                      case 3:
                        return _context43.abrupt("return", _context43.sent.body);

                      case 4:
                      case "end":
                        return _context43.stop();
                    }
                  }
                }, _callee43, this);
              }));

              function importMultisig(_x60, _x61, _x62, _x63) {
                return _importMultisig.apply(this, arguments);
              }

              return importMultisig;
            }()
          }, {
            key: "exportMultisig",
            value: function () {
              var _exportMultisig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(e, t) {
                var r;
                return _regeneratorRuntime.wrap(function _callee44$(_context44) {
                  while (1) {
                    switch (_context44.prev = _context44.next) {
                      case 0:
                        r = {
                          wallet_handle_token: e,
                          address: t
                        };
                        _context44.next = 3;
                        return this.c.post("/v1/multisig/export", r);

                      case 3:
                        return _context44.abrupt("return", _context44.sent.body);

                      case 4:
                      case "end":
                        return _context44.stop();
                    }
                  }
                }, _callee44, this);
              }));

              function exportMultisig(_x64, _x65) {
                return _exportMultisig.apply(this, arguments);
              }

              return exportMultisig;
            }()
          }, {
            key: "signMultisigTransaction",
            value: function () {
              var _signMultisigTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(e, t, r, n, _i9) {
                var a, c;
                return _regeneratorRuntime.wrap(function _callee45$(_context45) {
                  while (1) {
                    switch (_context45.prev = _context45.next) {
                      case 0:
                        a = o.instantiateTxnIfNeeded(r), c = {
                          wallet_handle_token: e,
                          transaction: s.from(a.toByte()).toString("base64"),
                          public_key: s.from(n).toString("base64"),
                          partial_multisig: _i9,
                          wallet_password: t
                        };
                        _context45.next = 3;
                        return this.c.post("/v1/multisig/sign", c);

                      case 3:
                        return _context45.abrupt("return", _context45.sent.body);

                      case 4:
                      case "end":
                        return _context45.stop();
                    }
                  }
                }, _callee45, this);
              }));

              function signMultisigTransaction(_x66, _x67, _x68, _x69, _x70) {
                return _signMultisigTransaction.apply(this, arguments);
              }

              return signMultisigTransaction;
            }()
          }, {
            key: "deleteMultisig",
            value: function () {
              var _deleteMultisig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(e, t, r) {
                var n;
                return _regeneratorRuntime.wrap(function _callee46$(_context46) {
                  while (1) {
                    switch (_context46.prev = _context46.next) {
                      case 0:
                        n = {
                          wallet_handle_token: e,
                          address: r,
                          wallet_password: t
                        };
                        _context46.next = 3;
                        return this.c.delete("/v1/multisig", n);

                      case 3:
                        return _context46.abrupt("return", _context46.sent.body);

                      case 4:
                      case "end":
                        return _context46.stop();
                    }
                  }
                }, _callee46, this);
              }));

              function deleteMultisig(_x71, _x72, _x73) {
                return _deleteMultisig.apply(this, arguments);
              }

              return deleteMultisig;
            }()
          }]);

          return i;
        }(n.Z);
      },
      5427: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return B;
          }
        });
        var n = r(3480),
            o = r(8680);

        var s = /*#__PURE__*/function (_o$Z) {
          _inherits(s, _o$Z);

          var _super12 = _createSuper(s);

          function s(e, t, r) {
            var _this8;

            _classCallCheck(this, s);

            _this8 = _super12.call(this, e, t), _this8.account = r, _this8.account = r;
            return _this8;
          }

          _createClass(s, [{
            key: "path",
            value: function path() {
              return "/v2/accounts/".concat(this.account);
            }
          }]);

          return s;
        }(o.Z);

        var i = r(3033);

        var a = /*#__PURE__*/function (_o$Z2) {
          _inherits(a, _o$Z2);

          var _super13 = _createSuper(a);

          function a(e, t) {
            var _this9;

            _classCallCheck(this, a);

            if (_this9 = _super13.call(this, e), !Number.isInteger(t)) throw Error("roundNumber should be an integer");
            _this9.round = t, _this9.query = {
              format: "msgpack"
            };
            return _possibleConstructorReturn(_this9);
          }

          _createClass(a, [{
            key: "path",
            value: function path() {
              return "/v2/blocks/".concat(this.round);
            }
          }, {
            key: "prepare",
            value: function prepare(e) {
              if (e && e.byteLength > 0) return i.decode(e);
            }
          }]);

          return a;
        }(o.Z);

        var c = r(2486).Buffer;

        function u() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = e;
          return Object.keys(t).every(function (e) {
            return "content-type" !== e.toLowerCase();
          }) && (t = _objectSpread({}, e), t["Content-Type"] = "text/plain"), t;
        }

        var l = /*#__PURE__*/function (_o$Z3) {
          _inherits(l, _o$Z3);

          var _super14 = _createSuper(l);

          function l(e, t) {
            var _this10;

            _classCallCheck(this, l);

            _this10 = _super14.call(this, e), _this10.source = t, _this10.source = t;
            return _this10;
          }

          _createClass(l, [{
            key: "path",
            value: function path() {
              return "/v2/teal/compile";
            }
          }, {
            key: "do",
            value: function () {
              var _do2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
                var e,
                    t,
                    _args47 = arguments;
                return _regeneratorRuntime.wrap(function _callee47$(_context47) {
                  while (1) {
                    switch (_context47.prev = _context47.next) {
                      case 0:
                        e = _args47.length > 0 && _args47[0] !== undefined ? _args47[0] : {};
                        t = u(e);
                        _context47.next = 4;
                        return this.c.post(this.path(), c.from(this.source), t);

                      case 4:
                        return _context47.abrupt("return", _context47.sent.body);

                      case 5:
                      case "end":
                        return _context47.stop();
                    }
                  }
                }, _callee47, this);
              }));

              function _do() {
                return _do2.apply(this, arguments);
              }

              return _do;
            }()
          }]);

          return l;
        }(o.Z);

        var h = r(2486).Buffer;

        var p = /*#__PURE__*/function (_o$Z4) {
          _inherits(p, _o$Z4);

          var _super15 = _createSuper(p);

          function p(e, t) {
            var _this11;

            _classCallCheck(this, p);

            _this11 = _super15.call(this, e), _this11.blob = i.encode(t.get_obj_for_encoding(!0));
            return _this11;
          }

          _createClass(p, [{
            key: "path",
            value: function path() {
              return "/v2/teal/dryrun";
            }
          }, {
            key: "do",
            value: function () {
              var _do3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
                var e,
                    t,
                    _args48 = arguments;
                return _regeneratorRuntime.wrap(function _callee48$(_context48) {
                  while (1) {
                    switch (_context48.prev = _context48.next) {
                      case 0:
                        e = _args48.length > 0 && _args48[0] !== undefined ? _args48[0] : {};
                        t = u(e);
                        _context48.next = 4;
                        return this.c.post(this.path(), h.from(this.blob), t);

                      case 4:
                        return _context48.abrupt("return", _context48.sent.body);

                      case 5:
                      case "end":
                        return _context48.stop();
                    }
                  }
                }, _callee48, this);
              }));

              function _do() {
                return _do3.apply(this, arguments);
              }

              return _do;
            }()
          }]);

          return p;
        }(o.Z);

        var f = /*#__PURE__*/function (_o$Z5) {
          _inherits(f, _o$Z5);

          var _super16 = _createSuper(f);

          function f(e, t, r) {
            var _this12;

            _classCallCheck(this, f);

            _this12 = _super16.call(this, e, t), _this12.index = r, _this12.index = r;
            return _this12;
          }

          _createClass(f, [{
            key: "path",
            value: function path() {
              return "/v2/assets/".concat(this.index);
            }
          }]);

          return f;
        }(o.Z);

        var d = /*#__PURE__*/function (_o$Z6) {
          _inherits(d, _o$Z6);

          var _super17 = _createSuper(d);

          function d(e, t, r) {
            var _this13;

            _classCallCheck(this, d);

            _this13 = _super17.call(this, e, t), _this13.index = r, _this13.index = r;
            return _this13;
          }

          _createClass(d, [{
            key: "path",
            value: function path() {
              return "/v2/applications/".concat(this.index);
            }
          }]);

          return d;
        }(o.Z);

        var g = /*#__PURE__*/function (_o$Z7) {
          _inherits(g, _o$Z7);

          var _super18 = _createSuper(g);

          function g() {
            _classCallCheck(this, g);

            return _super18.apply(this, arguments);
          }

          _createClass(g, [{
            key: "path",
            value: function path() {
              return "/health";
            }
          }, {
            key: "do",
            value: function () {
              var _do4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
                var e,
                    t,
                    _args49 = arguments;
                return _regeneratorRuntime.wrap(function _callee49$(_context49) {
                  while (1) {
                    switch (_context49.prev = _context49.next) {
                      case 0:
                        e = _args49.length > 0 && _args49[0] !== undefined ? _args49[0] : {};
                        _context49.next = 3;
                        return this.c.get(this.path(), {}, e);

                      case 3:
                        t = _context49.sent;

                        if (t.ok) {
                          _context49.next = 6;
                          break;
                        }

                        throw new Error("Health response: ".concat(t.status));

                      case 6:
                        return _context49.abrupt("return", {});

                      case 7:
                      case "end":
                        return _context49.stop();
                    }
                  }
                }, _callee49, this);
              }));

              function _do() {
                return _do4.apply(this, arguments);
              }

              return _do;
            }()
          }]);

          return g;
        }(o.Z);

        var y = /*#__PURE__*/function (_o$Z8) {
          _inherits(y, _o$Z8);

          var _super19 = _createSuper(y);

          function y(e, t) {
            var _this14;

            _classCallCheck(this, y);

            _this14 = _super19.call(this, e), _this14.txid = t, _this14.txid = t, _this14.query.format = "msgpack";
            return _this14;
          }

          _createClass(y, [{
            key: "prepare",
            value: function prepare(e) {
              if (e && e.byteLength > 0) return i.decode(e);
            }
          }, {
            key: "path",
            value: function path() {
              return "/v2/transactions/pending/".concat(this.txid);
            }
          }, {
            key: "max",
            value: function max(e) {
              return this.query.max = e, this;
            }
          }]);

          return y;
        }(o.Z);

        var m = /*#__PURE__*/function (_o$Z9) {
          _inherits(m, _o$Z9);

          var _super20 = _createSuper(m);

          function m(e) {
            var _this15;

            _classCallCheck(this, m);

            _this15 = _super20.call(this, e), _this15.query.format = "msgpack";
            return _this15;
          }

          _createClass(m, [{
            key: "path",
            value: function path() {
              return "/v2/transactions/pending";
            }
          }, {
            key: "prepare",
            value: function prepare(e) {
              if (e && e.byteLength > 0) return i.decode(e);
            }
          }, {
            key: "max",
            value: function max(e) {
              return this.query.max = e, this;
            }
          }]);

          return m;
        }(o.Z);

        var b = /*#__PURE__*/function (_o$Z10) {
          _inherits(b, _o$Z10);

          var _super21 = _createSuper(b);

          function b(e, t) {
            var _this16;

            _classCallCheck(this, b);

            _this16 = _super21.call(this, e), _this16.address = t, _this16.address = t, _this16.query.format = "msgpack";
            return _this16;
          }

          _createClass(b, [{
            key: "prepare",
            value: function prepare(e) {
              if (e && e.byteLength > 0) return i.decode(e);
            }
          }, {
            key: "path",
            value: function path() {
              return "/v2/accounts/".concat(this.address, "/transactions/pending");
            }
          }, {
            key: "max",
            value: function max(e) {
              return this.query.max = e, this;
            }
          }]);

          return b;
        }(o.Z);

        var w = r(5180);

        var A = /*#__PURE__*/function (_o$Z11) {
          _inherits(A, _o$Z11);

          var _super22 = _createSuper(A);

          function A() {
            _classCallCheck(this, A);

            return _super22.apply(this, arguments);
          }

          _createClass(A, [{
            key: "path",
            value: function path() {
              return "/v2/status";
            }
          }]);

          return A;
        }(o.Z);

        var v = /*#__PURE__*/function (_o$Z12) {
          _inherits(v, _o$Z12);

          var _super23 = _createSuper(v);

          function v(e, t, r) {
            var _this17;

            _classCallCheck(this, v);

            if (_this17 = _super23.call(this, e, t), _this17.round = r, !Number.isInteger(r)) throw Error("round should be an integer");
            _this17.round = r;
            return _possibleConstructorReturn(_this17);
          }

          _createClass(v, [{
            key: "path",
            value: function path() {
              return "/v2/status/wait-for-block-after/".concat(this.round);
            }
          }]);

          return v;
        }(o.Z);

        var x = /*#__PURE__*/function (_o$Z13) {
          _inherits(x, _o$Z13);

          var _super24 = _createSuper(x);

          function x() {
            _classCallCheck(this, x);

            return _super24.apply(this, arguments);
          }

          _createClass(x, [{
            key: "path",
            value: function path() {
              return "/v2/transactions/params";
            }
          }, {
            key: "prepare",
            value: function prepare(e) {
              return {
                flatFee: !1,
                fee: e.fee,
                firstRound: e["last-round"],
                lastRound: e["last-round"] + 1e3,
                genesisID: e["genesis-id"],
                genesisHash: e["genesis-hash"]
              };
            }
          }]);

          return x;
        }(o.Z);

        var S = /*#__PURE__*/function (_o$Z14) {
          _inherits(S, _o$Z14);

          var _super25 = _createSuper(S);

          function S() {
            _classCallCheck(this, S);

            return _super25.apply(this, arguments);
          }

          _createClass(S, [{
            key: "path",
            value: function path() {
              return "/v2/ledger/supply";
            }
          }]);

          return S;
        }(o.Z);

        var E = /*#__PURE__*/function (_o$Z15) {
          _inherits(E, _o$Z15);

          var _super26 = _createSuper(E);

          function E() {
            _classCallCheck(this, E);

            return _super26.apply(this, arguments);
          }

          _createClass(E, [{
            key: "path",
            value: function path() {
              return "/versions";
            }
          }]);

          return E;
        }(o.Z);

        var T = /*#__PURE__*/function (_o$Z16) {
          _inherits(T, _o$Z16);

          var _super27 = _createSuper(T);

          function T() {
            _classCallCheck(this, T);

            return _super27.apply(this, arguments);
          }

          _createClass(T, [{
            key: "path",
            value: function path() {
              return "/genesis";
            }
          }]);

          return T;
        }(o.Z);

        var _ = /*#__PURE__*/function (_o$Z17) {
          _inherits(_, _o$Z17);

          var _super28 = _createSuper(_);

          function _(e, t, r, n) {
            var _this18;

            _classCallCheck(this, _);

            _this18 = _super28.call(this, e, t), _this18.round = r, _this18.txID = n, _this18.round = r, _this18.txID = n;
            return _this18;
          }

          _createClass(_, [{
            key: "path",
            value: function path() {
              return "/v2/blocks/".concat(this.round, "/transactions/").concat(this.txID, "/proof");
            }
          }]);

          return _;
        }(o.Z);

        var B = /*#__PURE__*/function (_n$Z2) {
          _inherits(B, _n$Z2);

          var _super29 = _createSuper(B);

          function B(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "http://r2.algorand.network";
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4180;
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            _classCallCheck(this, B);

            return _super29.call(this, "X-Algo-API-Token", e, t, r, n);
          }

          _createClass(B, [{
            key: "healthCheck",
            value: function healthCheck() {
              return new g(this.c);
            }
          }, {
            key: "versionsCheck",
            value: function versionsCheck() {
              return new E(this.c);
            }
          }, {
            key: "sendRawTransaction",
            value: function sendRawTransaction(e) {
              return new w.default(this.c, e);
            }
          }, {
            key: "accountInformation",
            value: function accountInformation(e) {
              return new s(this.c, this.intDecoding, e);
            }
          }, {
            key: "block",
            value: function block(e) {
              return new a(this.c, e);
            }
          }, {
            key: "pendingTransactionInformation",
            value: function pendingTransactionInformation(e) {
              return new y(this.c, e);
            }
          }, {
            key: "pendingTransactionsInformation",
            value: function pendingTransactionsInformation() {
              return new m(this.c);
            }
          }, {
            key: "pendingTransactionByAddress",
            value: function pendingTransactionByAddress(e) {
              return new b(this.c, e);
            }
          }, {
            key: "status",
            value: function status() {
              return new A(this.c, this.intDecoding);
            }
          }, {
            key: "statusAfterBlock",
            value: function statusAfterBlock(e) {
              return new v(this.c, this.intDecoding, e);
            }
          }, {
            key: "getTransactionParams",
            value: function getTransactionParams() {
              return new x(this.c);
            }
          }, {
            key: "supply",
            value: function supply() {
              return new S(this.c, this.intDecoding);
            }
          }, {
            key: "compile",
            value: function compile(e) {
              return new l(this.c, e);
            }
          }, {
            key: "dryrun",
            value: function dryrun(e) {
              return new p(this.c, e);
            }
          }, {
            key: "getAssetByID",
            value: function getAssetByID(e) {
              return new f(this.c, this.intDecoding, e);
            }
          }, {
            key: "getApplicationByID",
            value: function getApplicationByID(e) {
              return new d(this.c, this.intDecoding, e);
            }
          }, {
            key: "genesis",
            value: function genesis() {
              return new T(this.c, this.intDecoding);
            }
          }, {
            key: "getProof",
            value: function getProof(e, t) {
              return new _(this.c, this.intDecoding, e, t);
            }
          }]);

          return B;
        }(n.Z);
      },
      227: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          Account: function Account() {
            return a;
          },
          AccountParticipation: function AccountParticipation() {
            return c;
          },
          AccountStateDelta: function AccountStateDelta() {
            return u;
          },
          Application: function Application() {
            return l;
          },
          ApplicationLocalState: function ApplicationLocalState() {
            return h;
          },
          ApplicationParams: function ApplicationParams() {
            return p;
          },
          ApplicationStateSchema: function ApplicationStateSchema() {
            return f;
          },
          Asset: function Asset() {
            return d;
          },
          AssetHolding: function AssetHolding() {
            return g;
          },
          AssetParams: function AssetParams() {
            return y;
          },
          BlockResponse: function BlockResponse() {
            return m;
          },
          BuildVersion: function BuildVersion() {
            return b;
          },
          CatchpointAbortResponse: function CatchpointAbortResponse() {
            return w;
          },
          CatchpointStartResponse: function CatchpointStartResponse() {
            return A;
          },
          CompileResponse: function CompileResponse() {
            return v;
          },
          DryrunRequest: function DryrunRequest() {
            return x;
          },
          DryrunResponse: function DryrunResponse() {
            return S;
          },
          DryrunSource: function DryrunSource() {
            return E;
          },
          DryrunState: function DryrunState() {
            return T;
          },
          DryrunTxnResult: function DryrunTxnResult() {
            return _;
          },
          ErrorResponse: function ErrorResponse() {
            return B;
          },
          EvalDelta: function EvalDelta() {
            return k;
          },
          EvalDeltaKeyValue: function EvalDeltaKeyValue() {
            return I;
          },
          NodeStatusResponse: function NodeStatusResponse() {
            return U;
          },
          PendingTransactionResponse: function PendingTransactionResponse() {
            return C;
          },
          PendingTransactionsResponse: function PendingTransactionsResponse() {
            return R;
          },
          PostTransactionsResponse: function PostTransactionsResponse() {
            return O;
          },
          ProofResponse: function ProofResponse() {
            return D;
          },
          SupplyResponse: function SupplyResponse() {
            return N;
          },
          TealKeyValue: function TealKeyValue() {
            return P;
          },
          TealValue: function TealValue() {
            return L;
          },
          TransactionParametersResponse: function TransactionParametersResponse() {
            return F;
          },
          Version: function Version() {
            return j;
          }
        });
        var n = r(2486).Buffer;

        function o(e, t) {
          var r;
          if (e instanceof Uint8Array) r = t ? e : n.from(e).toString("base64");else if ("function" == typeof e.get_obj_for_encoding) r = e.get_obj_for_encoding(t);else if (Array.isArray(e)) {
            r = [];

            var _iterator3 = _createForOfIteratorHelper(e),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _n20 = _step3.value;
                r.push(o(_n20, t));
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else if ("object" == typeof e) {
            var _n21 = {};

            for (var _i10 = 0, _Object$keys = Object.keys(e); _i10 < _Object$keys.length; _i10++) {
              var _r23 = _Object$keys[_i10];
              _n21[_r23] = o(e[_r23], t);
            }

            r = _n21;
          } else {
            if (!function (e) {
              return void 0 === e || null == e || "object" != typeof e && "function" != typeof e;
            }(e)) throw new Error("Unsupported value: ".concat(String(e)));
            r = e;
          }
          return r;
        }

        var s = /*#__PURE__*/function () {
          function s() {
            _classCallCheck(this, s);
          }

          _createClass(s, [{
            key: "get_obj_for_encoding",
            value: function get_obj_for_encoding() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              var t = {};

              for (var _i11 = 0, _Object$keys2 = Object.keys(this.attribute_map); _i11 < _Object$keys2.length; _i11++) {
                var _r24 = _Object$keys2[_i11];
                var _n22 = this.attribute_map[_r24],
                    _s5 = this[_r24];
                void 0 !== _s5 && (t[_n22] = null === _s5 ? null : o(_s5, e));
              }

              return t;
            }
          }]);

          return s;
        }();

        var i = r(2486).Buffer;

        var a = /*#__PURE__*/function (_s6) {
          _inherits(a, _s6);

          var _super30 = _createSuper(a);

          function a(_ref24) {
            var _this19;

            var e = _ref24.address,
                t = _ref24.amount,
                r = _ref24.amountWithoutPendingRewards,
                n = _ref24.pendingRewards,
                o = _ref24.rewards,
                s = _ref24.round,
                i = _ref24.status,
                _a4 = _ref24.appsLocalState,
                c = _ref24.appsTotalExtraPages,
                u = _ref24.appsTotalSchema,
                l = _ref24.assets,
                h = _ref24.authAddr,
                p = _ref24.createdApps,
                f = _ref24.createdAssets,
                d = _ref24.participation,
                g = _ref24.rewardBase,
                y = _ref24.sigType;

            _classCallCheck(this, a);

            _this19 = _super30.call(this), _this19.address = e, _this19.amount = t, _this19.amountWithoutPendingRewards = r, _this19.pendingRewards = n, _this19.rewards = o, _this19.round = s, _this19.status = i, _this19.appsLocalState = _a4, _this19.appsTotalExtraPages = c, _this19.appsTotalSchema = u, _this19.assets = l, _this19.authAddr = h, _this19.createdApps = p, _this19.createdAssets = f, _this19.participation = d, _this19.rewardBase = g, _this19.sigType = y, _this19.attribute_map = {
              address: "address",
              amount: "amount",
              amountWithoutPendingRewards: "amount-without-pending-rewards",
              pendingRewards: "pending-rewards",
              rewards: "rewards",
              round: "round",
              status: "status",
              appsLocalState: "apps-local-state",
              appsTotalExtraPages: "apps-total-extra-pages",
              appsTotalSchema: "apps-total-schema",
              assets: "assets",
              authAddr: "auth-addr",
              createdApps: "created-apps",
              createdAssets: "created-assets",
              participation: "participation",
              rewardBase: "reward-base",
              sigType: "sig-type"
            };
            return _this19;
          }

          return _createClass(a);
        }(s);

        var c = /*#__PURE__*/function (_s7) {
          _inherits(c, _s7);

          var _super31 = _createSuper(c);

          function c(_ref25) {
            var _this20;

            var e = _ref25.selectionParticipationKey,
                t = _ref25.voteFirstValid,
                r = _ref25.voteKeyDilution,
                n = _ref25.voteLastValid,
                o = _ref25.voteParticipationKey;

            _classCallCheck(this, c);

            _this20 = _super31.call(this), _this20.selectionParticipationKey = "string" == typeof e ? new Uint8Array(i.from(e, "base64")) : e, _this20.voteFirstValid = t, _this20.voteKeyDilution = r, _this20.voteLastValid = n, _this20.voteParticipationKey = "string" == typeof o ? new Uint8Array(i.from(o, "base64")) : o, _this20.attribute_map = {
              selectionParticipationKey: "selection-participation-key",
              voteFirstValid: "vote-first-valid",
              voteKeyDilution: "vote-key-dilution",
              voteLastValid: "vote-last-valid",
              voteParticipationKey: "vote-participation-key"
            };
            return _this20;
          }

          return _createClass(c);
        }(s);

        var u = /*#__PURE__*/function (_s8) {
          _inherits(u, _s8);

          var _super32 = _createSuper(u);

          function u(e, t) {
            var _this21;

            _classCallCheck(this, u);

            _this21 = _super32.call(this), _this21.address = e, _this21.delta = t, _this21.attribute_map = {
              address: "address",
              delta: "delta"
            };
            return _this21;
          }

          return _createClass(u);
        }(s);

        var l = /*#__PURE__*/function (_s9) {
          _inherits(l, _s9);

          var _super33 = _createSuper(l);

          function l(e, t) {
            var _this22;

            _classCallCheck(this, l);

            _this22 = _super33.call(this), _this22.id = e, _this22.params = t, _this22.attribute_map = {
              id: "id",
              params: "params"
            };
            return _this22;
          }

          return _createClass(l);
        }(s);

        var h = /*#__PURE__*/function (_s10) {
          _inherits(h, _s10);

          var _super34 = _createSuper(h);

          function h(e, t, r) {
            var _this23;

            _classCallCheck(this, h);

            _this23 = _super34.call(this), _this23.id = e, _this23.schema = t, _this23.keyValue = r, _this23.attribute_map = {
              id: "id",
              schema: "schema",
              keyValue: "key-value"
            };
            return _this23;
          }

          return _createClass(h);
        }(s);

        var p = /*#__PURE__*/function (_s11) {
          _inherits(p, _s11);

          var _super35 = _createSuper(p);

          function p(_ref26) {
            var _this24;

            var e = _ref26.approvalProgram,
                t = _ref26.clearStateProgram,
                r = _ref26.creator,
                n = _ref26.extraProgramPages,
                o = _ref26.globalState,
                s = _ref26.globalStateSchema,
                a = _ref26.localStateSchema;

            _classCallCheck(this, p);

            _this24 = _super35.call(this), _this24.approvalProgram = "string" == typeof e ? new Uint8Array(i.from(e, "base64")) : e, _this24.clearStateProgram = "string" == typeof t ? new Uint8Array(i.from(t, "base64")) : t, _this24.creator = r, _this24.extraProgramPages = n, _this24.globalState = o, _this24.globalStateSchema = s, _this24.localStateSchema = a, _this24.attribute_map = {
              approvalProgram: "approval-program",
              clearStateProgram: "clear-state-program",
              creator: "creator",
              extraProgramPages: "extra-program-pages",
              globalState: "global-state",
              globalStateSchema: "global-state-schema",
              localStateSchema: "local-state-schema"
            };
            return _this24;
          }

          return _createClass(p);
        }(s);

        var f = /*#__PURE__*/function (_s12) {
          _inherits(f, _s12);

          var _super36 = _createSuper(f);

          function f(e, t) {
            var _this25;

            _classCallCheck(this, f);

            _this25 = _super36.call(this), _this25.numUint = e, _this25.numByteSlice = t, _this25.attribute_map = {
              numUint: "num-uint",
              numByteSlice: "num-byte-slice"
            };
            return _this25;
          }

          return _createClass(f);
        }(s);

        var d = /*#__PURE__*/function (_s13) {
          _inherits(d, _s13);

          var _super37 = _createSuper(d);

          function d(e, t) {
            var _this26;

            _classCallCheck(this, d);

            _this26 = _super37.call(this), _this26.index = e, _this26.params = t, _this26.attribute_map = {
              index: "index",
              params: "params"
            };
            return _this26;
          }

          return _createClass(d);
        }(s);

        var g = /*#__PURE__*/function (_s14) {
          _inherits(g, _s14);

          var _super38 = _createSuper(g);

          function g(e, t, r, n) {
            var _this27;

            _classCallCheck(this, g);

            _this27 = _super38.call(this), _this27.amount = e, _this27.assetId = t, _this27.creator = r, _this27.isFrozen = n, _this27.attribute_map = {
              amount: "amount",
              assetId: "asset-id",
              creator: "creator",
              isFrozen: "is-frozen"
            };
            return _this27;
          }

          return _createClass(g);
        }(s);

        var y = /*#__PURE__*/function (_s15) {
          _inherits(y, _s15);

          var _super39 = _createSuper(y);

          function y(_ref27) {
            var _this28;

            var e = _ref27.creator,
                t = _ref27.decimals,
                r = _ref27.total,
                n = _ref27.clawback,
                o = _ref27.defaultFrozen,
                s = _ref27.freeze,
                a = _ref27.manager,
                c = _ref27.metadataHash,
                u = _ref27.name,
                l = _ref27.nameB64,
                h = _ref27.reserve,
                p = _ref27.unitName,
                f = _ref27.unitNameB64,
                d = _ref27.url,
                g = _ref27.urlB64;

            _classCallCheck(this, y);

            _this28 = _super39.call(this), _this28.creator = e, _this28.decimals = t, _this28.total = r, _this28.clawback = n, _this28.defaultFrozen = o, _this28.freeze = s, _this28.manager = a, _this28.metadataHash = "string" == typeof c ? new Uint8Array(i.from(c, "base64")) : c, _this28.name = u, _this28.nameB64 = "string" == typeof l ? new Uint8Array(i.from(l, "base64")) : l, _this28.reserve = h, _this28.unitName = p, _this28.unitNameB64 = "string" == typeof f ? new Uint8Array(i.from(f, "base64")) : f, _this28.url = d, _this28.urlB64 = "string" == typeof g ? new Uint8Array(i.from(g, "base64")) : g, _this28.attribute_map = {
              creator: "creator",
              decimals: "decimals",
              total: "total",
              clawback: "clawback",
              defaultFrozen: "default-frozen",
              freeze: "freeze",
              manager: "manager",
              metadataHash: "metadata-hash",
              name: "name",
              nameB64: "name-b64",
              reserve: "reserve",
              unitName: "unit-name",
              unitNameB64: "unit-name-b64",
              url: "url",
              urlB64: "url-b64"
            };
            return _this28;
          }

          return _createClass(y);
        }(s);

        var m = /*#__PURE__*/function (_s16) {
          _inherits(m, _s16);

          var _super40 = _createSuper(m);

          function m(e, t) {
            var _this29;

            _classCallCheck(this, m);

            _this29 = _super40.call(this), _this29.block = e, _this29.cert = t, _this29.attribute_map = {
              block: "block",
              cert: "cert"
            };
            return _this29;
          }

          return _createClass(m);
        }(s);

        var b = /*#__PURE__*/function (_s17) {
          _inherits(b, _s17);

          var _super41 = _createSuper(b);

          function b(_ref28) {
            var _this30;

            var e = _ref28.branch,
                t = _ref28.buildNumber,
                r = _ref28.channel,
                n = _ref28.commitHash,
                o = _ref28.major,
                s = _ref28.minor;

            _classCallCheck(this, b);

            _this30 = _super41.call(this), _this30.branch = e, _this30.buildNumber = t, _this30.channel = r, _this30.commitHash = n, _this30.major = o, _this30.minor = s, _this30.attribute_map = {
              branch: "branch",
              buildNumber: "build_number",
              channel: "channel",
              commitHash: "commit_hash",
              major: "major",
              minor: "minor"
            };
            return _this30;
          }

          return _createClass(b);
        }(s);

        var w = /*#__PURE__*/function (_s18) {
          _inherits(w, _s18);

          var _super42 = _createSuper(w);

          function w(e) {
            var _this31;

            _classCallCheck(this, w);

            _this31 = _super42.call(this), _this31.catchupMessage = e, _this31.attribute_map = {
              catchupMessage: "catchup-message"
            };
            return _this31;
          }

          return _createClass(w);
        }(s);

        var A = /*#__PURE__*/function (_s19) {
          _inherits(A, _s19);

          var _super43 = _createSuper(A);

          function A(e) {
            var _this32;

            _classCallCheck(this, A);

            _this32 = _super43.call(this), _this32.catchupMessage = e, _this32.attribute_map = {
              catchupMessage: "catchup-message"
            };
            return _this32;
          }

          return _createClass(A);
        }(s);

        var v = /*#__PURE__*/function (_s20) {
          _inherits(v, _s20);

          var _super44 = _createSuper(v);

          function v(e, t) {
            var _this33;

            _classCallCheck(this, v);

            _this33 = _super44.call(this), _this33.hash = e, _this33.result = t, _this33.attribute_map = {
              hash: "hash",
              result: "result"
            };
            return _this33;
          }

          return _createClass(v);
        }(s);

        var x = /*#__PURE__*/function (_s21) {
          _inherits(x, _s21);

          var _super45 = _createSuper(x);

          function x(_ref29) {
            var _this34;

            var e = _ref29.accounts,
                t = _ref29.apps,
                r = _ref29.latestTimestamp,
                n = _ref29.protocolVersion,
                o = _ref29.round,
                s = _ref29.sources,
                i = _ref29.txns;

            _classCallCheck(this, x);

            _this34 = _super45.call(this), _this34.accounts = e, _this34.apps = t, _this34.latestTimestamp = r, _this34.protocolVersion = n, _this34.round = o, _this34.sources = s, _this34.txns = i, _this34.attribute_map = {
              accounts: "accounts",
              apps: "apps",
              latestTimestamp: "latest-timestamp",
              protocolVersion: "protocol-version",
              round: "round",
              sources: "sources",
              txns: "txns"
            };
            return _this34;
          }

          return _createClass(x);
        }(s);

        var S = /*#__PURE__*/function (_s22) {
          _inherits(S, _s22);

          var _super46 = _createSuper(S);

          function S(e, t, r) {
            var _this35;

            _classCallCheck(this, S);

            _this35 = _super46.call(this), _this35.error = e, _this35.protocolVersion = t, _this35.txns = r, _this35.attribute_map = {
              error: "error",
              protocolVersion: "protocol-version",
              txns: "txns"
            };
            return _this35;
          }

          return _createClass(S);
        }(s);

        var E = /*#__PURE__*/function (_s23) {
          _inherits(E, _s23);

          var _super47 = _createSuper(E);

          function E(e, t, r, n) {
            var _this36;

            _classCallCheck(this, E);

            _this36 = _super47.call(this), _this36.fieldName = e, _this36.source = t, _this36.txnIndex = r, _this36.appIndex = n, _this36.attribute_map = {
              fieldName: "field-name",
              source: "source",
              txnIndex: "txn-index",
              appIndex: "app-index"
            };
            return _this36;
          }

          return _createClass(E);
        }(s);

        var T = /*#__PURE__*/function (_s24) {
          _inherits(T, _s24);

          var _super48 = _createSuper(T);

          function T(_ref30) {
            var _this37;

            var e = _ref30.line,
                t = _ref30.pc,
                r = _ref30.stack,
                n = _ref30.error,
                o = _ref30.scratch;

            _classCallCheck(this, T);

            _this37 = _super48.call(this), _this37.line = e, _this37.pc = t, _this37.stack = r, _this37.error = n, _this37.scratch = o, _this37.attribute_map = {
              line: "line",
              pc: "pc",
              stack: "stack",
              error: "error",
              scratch: "scratch"
            };
            return _this37;
          }

          return _createClass(T);
        }(s);

        var _ = /*#__PURE__*/function (_s25) {
          _inherits(_, _s25);

          var _super49 = _createSuper(_);

          function _(_ref31) {
            var _this38;

            var e = _ref31.disassembly,
                t = _ref31.appCallMessages,
                r = _ref31.appCallTrace,
                n = _ref31.cost,
                o = _ref31.globalDelta,
                s = _ref31.localDeltas,
                i = _ref31.logicSigMessages,
                a = _ref31.logicSigTrace,
                c = _ref31.logs;

            _classCallCheck(this, _);

            _this38 = _super49.call(this), _this38.disassembly = e, _this38.appCallMessages = t, _this38.appCallTrace = r, _this38.cost = n, _this38.globalDelta = o, _this38.localDeltas = s, _this38.logicSigMessages = i, _this38.logicSigTrace = a, _this38.logs = c, _this38.attribute_map = {
              disassembly: "disassembly",
              appCallMessages: "app-call-messages",
              appCallTrace: "app-call-trace",
              cost: "cost",
              globalDelta: "global-delta",
              localDeltas: "local-deltas",
              logicSigMessages: "logic-sig-messages",
              logicSigTrace: "logic-sig-trace",
              logs: "logs"
            };
            return _this38;
          }

          return _createClass(_);
        }(s);

        var B = /*#__PURE__*/function (_s26) {
          _inherits(B, _s26);

          var _super50 = _createSuper(B);

          function B(e, t) {
            var _this39;

            _classCallCheck(this, B);

            _this39 = _super50.call(this), _this39.message = e, _this39.data = t, _this39.attribute_map = {
              message: "message",
              data: "data"
            };
            return _this39;
          }

          return _createClass(B);
        }(s);

        var k = /*#__PURE__*/function (_s27) {
          _inherits(k, _s27);

          var _super51 = _createSuper(k);

          function k(e, t, r) {
            var _this40;

            _classCallCheck(this, k);

            _this40 = _super51.call(this), _this40.action = e, _this40.bytes = t, _this40.uint = r, _this40.attribute_map = {
              action: "action",
              bytes: "bytes",
              uint: "uint"
            };
            return _this40;
          }

          return _createClass(k);
        }(s);

        var I = /*#__PURE__*/function (_s28) {
          _inherits(I, _s28);

          var _super52 = _createSuper(I);

          function I(e, t) {
            var _this41;

            _classCallCheck(this, I);

            _this41 = _super52.call(this), _this41.key = e, _this41.value = t, _this41.attribute_map = {
              key: "key",
              value: "value"
            };
            return _this41;
          }

          return _createClass(I);
        }(s);

        var U = /*#__PURE__*/function (_s29) {
          _inherits(U, _s29);

          var _super53 = _createSuper(U);

          function U(_ref32) {
            var _this42;

            var e = _ref32.catchupTime,
                t = _ref32.lastRound,
                r = _ref32.lastVersion,
                n = _ref32.nextVersion,
                o = _ref32.nextVersionRound,
                s = _ref32.nextVersionSupported,
                i = _ref32.stoppedAtUnsupportedRound,
                a = _ref32.timeSinceLastRound,
                c = _ref32.catchpoint,
                u = _ref32.catchpointAcquiredBlocks,
                l = _ref32.catchpointProcessedAccounts,
                h = _ref32.catchpointTotalAccounts,
                p = _ref32.catchpointTotalBlocks,
                f = _ref32.catchpointVerifiedAccounts,
                d = _ref32.lastCatchpoint;

            _classCallCheck(this, U);

            _this42 = _super53.call(this), _this42.catchupTime = e, _this42.lastRound = t, _this42.lastVersion = r, _this42.nextVersion = n, _this42.nextVersionRound = o, _this42.nextVersionSupported = s, _this42.stoppedAtUnsupportedRound = i, _this42.timeSinceLastRound = a, _this42.catchpoint = c, _this42.catchpointAcquiredBlocks = u, _this42.catchpointProcessedAccounts = l, _this42.catchpointTotalAccounts = h, _this42.catchpointTotalBlocks = p, _this42.catchpointVerifiedAccounts = f, _this42.lastCatchpoint = d, _this42.attribute_map = {
              catchupTime: "catchup-time",
              lastRound: "last-round",
              lastVersion: "last-version",
              nextVersion: "next-version",
              nextVersionRound: "next-version-round",
              nextVersionSupported: "next-version-supported",
              stoppedAtUnsupportedRound: "stopped-at-unsupported-round",
              timeSinceLastRound: "time-since-last-round",
              catchpoint: "catchpoint",
              catchpointAcquiredBlocks: "catchpoint-acquired-blocks",
              catchpointProcessedAccounts: "catchpoint-processed-accounts",
              catchpointTotalAccounts: "catchpoint-total-accounts",
              catchpointTotalBlocks: "catchpoint-total-blocks",
              catchpointVerifiedAccounts: "catchpoint-verified-accounts",
              lastCatchpoint: "last-catchpoint"
            };
            return _this42;
          }

          return _createClass(U);
        }(s);

        var C = /*#__PURE__*/function (_s30) {
          _inherits(C, _s30);

          var _super54 = _createSuper(C);

          function C(_ref33) {
            var _this43;

            var e = _ref33.poolError,
                t = _ref33.txn,
                r = _ref33.applicationIndex,
                n = _ref33.assetClosingAmount,
                o = _ref33.assetIndex,
                s = _ref33.closeRewards,
                i = _ref33.closingAmount,
                a = _ref33.confirmedRound,
                c = _ref33.globalStateDelta,
                u = _ref33.innerTxns,
                l = _ref33.localStateDelta,
                h = _ref33.logs,
                p = _ref33.receiverRewards,
                f = _ref33.senderRewards;

            _classCallCheck(this, C);

            _this43 = _super54.call(this), _this43.poolError = e, _this43.txn = t, _this43.applicationIndex = r, _this43.assetClosingAmount = n, _this43.assetIndex = o, _this43.closeRewards = s, _this43.closingAmount = i, _this43.confirmedRound = a, _this43.globalStateDelta = c, _this43.innerTxns = u, _this43.localStateDelta = l, _this43.logs = h, _this43.receiverRewards = p, _this43.senderRewards = f, _this43.attribute_map = {
              poolError: "pool-error",
              txn: "txn",
              applicationIndex: "application-index",
              assetClosingAmount: "asset-closing-amount",
              assetIndex: "asset-index",
              closeRewards: "close-rewards",
              closingAmount: "closing-amount",
              confirmedRound: "confirmed-round",
              globalStateDelta: "global-state-delta",
              innerTxns: "inner-txns",
              localStateDelta: "local-state-delta",
              logs: "logs",
              receiverRewards: "receiver-rewards",
              senderRewards: "sender-rewards"
            };
            return _this43;
          }

          return _createClass(C);
        }(s);

        var R = /*#__PURE__*/function (_s31) {
          _inherits(R, _s31);

          var _super55 = _createSuper(R);

          function R(e, t) {
            var _this44;

            _classCallCheck(this, R);

            _this44 = _super55.call(this), _this44.topTransactions = e, _this44.totalTransactions = t, _this44.attribute_map = {
              topTransactions: "top-transactions",
              totalTransactions: "total-transactions"
            };
            return _this44;
          }

          return _createClass(R);
        }(s);

        var O = /*#__PURE__*/function (_s32) {
          _inherits(O, _s32);

          var _super56 = _createSuper(O);

          function O(e) {
            var _this45;

            _classCallCheck(this, O);

            _this45 = _super56.call(this), _this45.txid = e, _this45.attribute_map = {
              txid: "txId"
            };
            return _this45;
          }

          return _createClass(O);
        }(s);

        var D = /*#__PURE__*/function (_s33) {
          _inherits(D, _s33);

          var _super57 = _createSuper(D);

          function D(e, t, r) {
            var _this46;

            _classCallCheck(this, D);

            _this46 = _super57.call(this), _this46.idx = e, _this46.proof = "string" == typeof t ? new Uint8Array(i.from(t, "base64")) : t, _this46.stibhash = "string" == typeof r ? new Uint8Array(i.from(r, "base64")) : r, _this46.attribute_map = {
              idx: "idx",
              proof: "proof",
              stibhash: "stibhash"
            };
            return _this46;
          }

          return _createClass(D);
        }(s);

        var N = /*#__PURE__*/function (_s34) {
          _inherits(N, _s34);

          var _super58 = _createSuper(N);

          function N(e, t, r) {
            var _this47;

            _classCallCheck(this, N);

            _this47 = _super58.call(this), _this47.currentRound = e, _this47.onlineMoney = t, _this47.totalMoney = r, _this47.attribute_map = {
              currentRound: "current_round",
              onlineMoney: "online-money",
              totalMoney: "total-money"
            };
            return _this47;
          }

          return _createClass(N);
        }(s);

        var P = /*#__PURE__*/function (_s35) {
          _inherits(P, _s35);

          var _super59 = _createSuper(P);

          function P(e, t) {
            var _this48;

            _classCallCheck(this, P);

            _this48 = _super59.call(this), _this48.key = e, _this48.value = t, _this48.attribute_map = {
              key: "key",
              value: "value"
            };
            return _this48;
          }

          return _createClass(P);
        }(s);

        var L = /*#__PURE__*/function (_s36) {
          _inherits(L, _s36);

          var _super60 = _createSuper(L);

          function L(e, t, r) {
            var _this49;

            _classCallCheck(this, L);

            _this49 = _super60.call(this), _this49.type = e, _this49.bytes = t, _this49.uint = r, _this49.attribute_map = {
              type: "type",
              bytes: "bytes",
              uint: "uint"
            };
            return _this49;
          }

          return _createClass(L);
        }(s);

        var F = /*#__PURE__*/function (_s37) {
          _inherits(F, _s37);

          var _super61 = _createSuper(F);

          function F(_ref34) {
            var _this50;

            var e = _ref34.consensusVersion,
                t = _ref34.fee,
                r = _ref34.genesisHash,
                n = _ref34.genesisId,
                o = _ref34.lastRound,
                s = _ref34.minFee;

            _classCallCheck(this, F);

            _this50 = _super61.call(this), _this50.consensusVersion = e, _this50.fee = t, _this50.genesisHash = "string" == typeof r ? new Uint8Array(i.from(r, "base64")) : r, _this50.genesisId = n, _this50.lastRound = o, _this50.minFee = s, _this50.attribute_map = {
              consensusVersion: "consensus-version",
              fee: "fee",
              genesisHash: "genesis-hash",
              genesisId: "genesis-id",
              lastRound: "last-round",
              minFee: "min-fee"
            };
            return _this50;
          }

          return _createClass(F);
        }(s);

        var j = /*#__PURE__*/function (_s38) {
          _inherits(j, _s38);

          var _super62 = _createSuper(j);

          function j(e, t, r, n) {
            var _this51;

            _classCallCheck(this, j);

            _this51 = _super62.call(this), _this51.build = e, _this51.genesisHashB64 = "string" == typeof t ? new Uint8Array(i.from(t, "base64")) : t, _this51.genesisId = r, _this51.versions = n, _this51.attribute_map = {
              build: "build",
              genesisHashB64: "genesis_hash_b64",
              genesisId: "genesis_id",
              versions: "versions"
            };
            return _this51;
          }

          return _createClass(j);
        }(s);
      },
      5180: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          setSendTransactionHeaders: function setSendTransactionHeaders() {
            return i;
          },
          default: function _default() {
            return c;
          }
        });
        var n = r(8680),
            o = r(413),
            s = r(2486).Buffer;

        function i() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = e;
          return Object.keys(t).every(function (e) {
            return "content-type" !== e.toLowerCase();
          }) && (t = _objectSpread({}, e), t["Content-Type"] = "application/x-binary"), t;
        }

        function a(e) {
          return e && void 0 !== e.byteLength;
        }

        var c = /*#__PURE__*/function (_n$Z3) {
          _inherits(c, _n$Z3);

          var _super63 = _createSuper(c);

          function c(e, t) {
            var _this52;

            _classCallCheck(this, c);

            _this52 = _super63.call(this, e);
            var r = t;

            if (Array.isArray(t)) {
              if (!t.every(a)) throw new TypeError("Array elements must be byte arrays");
              r = (0, o.concatArrays).apply(void 0, _toConsumableArray(t));
            } else if (!a(r)) throw new TypeError("Argument must be byte array");

            _this52.txnBytesToPost = r;
            return _this52;
          }

          _createClass(c, [{
            key: "path",
            value: function path() {
              return "/v2/transactions";
            }
          }, {
            key: "do",
            value: function () {
              var _do5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
                var e,
                    t,
                    _args50 = arguments;
                return _regeneratorRuntime.wrap(function _callee50$(_context50) {
                  while (1) {
                    switch (_context50.prev = _context50.next) {
                      case 0:
                        e = _args50.length > 0 && _args50[0] !== undefined ? _args50[0] : {};
                        t = i(e);
                        _context50.next = 4;
                        return this.c.post(this.path(), s.from(this.txnBytesToPost), t);

                      case 4:
                        return _context50.abrupt("return", _context50.sent.body);

                      case 5:
                      case "end":
                        return _context50.stop();
                    }
                  }
                }, _callee50, this);
              }));

              function _do() {
                return _do5.apply(this, arguments);
              }

              return _do;
            }()
          }]);

          return c;
        }(n.Z);
      },
      8104: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return v;
          }
        });
        var n = r(3480),
            o = r(8680);

        var s = /*#__PURE__*/function (_o$Z18) {
          _inherits(s, _o$Z18);

          var _super64 = _createSuper(s);

          function s() {
            _classCallCheck(this, s);

            return _super64.apply(this, arguments);
          }

          _createClass(s, [{
            key: "path",
            value: function path() {
              return "/health";
            }
          }]);

          return s;
        }(o.Z);

        var i = /*#__PURE__*/function (_o$Z19) {
          _inherits(i, _o$Z19);

          var _super65 = _createSuper(i);

          function i(e, t, r) {
            var _this53;

            _classCallCheck(this, i);

            _this53 = _super65.call(this, e, t), _this53.index = r, _this53.index = r;
            return _this53;
          }

          _createClass(i, [{
            key: "path",
            value: function path() {
              return "/v2/assets/".concat(this.index, "/balances");
            }
          }, {
            key: "limit",
            value: function limit(e) {
              return this.query.limit = e, this;
            }
          }, {
            key: "round",
            value: function round(e) {
              return this.query.round = e, this;
            }
          }, {
            key: "currencyGreaterThan",
            value: function currencyGreaterThan(e) {
              return this.query["currency-greater-than"] = e, this;
            }
          }, {
            key: "currencyLessThan",
            value: function currencyLessThan(e) {
              return this.query["currency-less-than"] = e, this;
            }
          }, {
            key: "nextToken",
            value: function nextToken(e) {
              return this.query.next = e, this;
            }
          }, {
            key: "includeAll",
            value: function includeAll() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              return this.query["include-all"] = e, this;
            }
          }]);

          return i;
        }(o.Z);

        var a = r(2486).Buffer;

        function c(e) {
          return "string" == typeof e ? e : a.from(e).toString("base64");
        }

        var u = /*#__PURE__*/function (_o$Z20) {
          _inherits(u, _o$Z20);

          var _super66 = _createSuper(u);

          function u(e, t, r) {
            var _this54;

            _classCallCheck(this, u);

            _this54 = _super66.call(this, e, t), _this54.account = r, _this54.account = r;
            return _this54;
          }

          _createClass(u, [{
            key: "path",
            value: function path() {
              return "/v2/accounts/".concat(this.account, "/transactions");
            }
          }, {
            key: "notePrefix",
            value: function notePrefix(e) {
              return this.query["note-prefix"] = c(e), this;
            }
          }, {
            key: "txType",
            value: function txType(e) {
              return this.query["tx-type"] = e, this;
            }
          }, {
            key: "sigType",
            value: function sigType(e) {
              return this.query["sig-type"] = e, this;
            }
          }, {
            key: "txid",
            value: function txid(e) {
              return this.query.txid = e, this;
            }
          }, {
            key: "round",
            value: function round(e) {
              return this.query.round = e, this;
            }
          }, {
            key: "minRound",
            value: function minRound(e) {
              return this.query["min-round"] = e, this;
            }
          }, {
            key: "maxRound",
            value: function maxRound(e) {
              return this.query["max-round"] = e, this;
            }
          }, {
            key: "assetID",
            value: function assetID(e) {
              return this.query["asset-id"] = e, this;
            }
          }, {
            key: "limit",
            value: function limit(e) {
              return this.query.limit = e, this;
            }
          }, {
            key: "beforeTime",
            value: function beforeTime(e) {
              return this.query["before-time"] = e, this;
            }
          }, {
            key: "afterTime",
            value: function afterTime(e) {
              return this.query["after-time"] = e, this;
            }
          }, {
            key: "currencyGreaterThan",
            value: function currencyGreaterThan(e) {
              return this.query["currency-greater-than"] = e, this;
            }
          }, {
            key: "currencyLessThan",
            value: function currencyLessThan(e) {
              return this.query["currency-less-than"] = e, this;
            }
          }, {
            key: "nextToken",
            value: function nextToken(e) {
              return this.query.next = e, this;
            }
          }, {
            key: "rekeyTo",
            value: function rekeyTo(e) {
              return this.query["rekey-to"] = e, this;
            }
          }]);

          return u;
        }(o.Z);

        var l = /*#__PURE__*/function (_o$Z21) {
          _inherits(l, _o$Z21);

          var _super67 = _createSuper(l);

          function l(e, t, r) {
            var _this55;

            _classCallCheck(this, l);

            _this55 = _super67.call(this, e, t), _this55.index = r, _this55.index = r;
            return _this55;
          }

          _createClass(l, [{
            key: "path",
            value: function path() {
              return "/v2/assets/".concat(this.index, "/transactions");
            }
          }, {
            key: "notePrefix",
            value: function notePrefix(e) {
              return this.query["note-prefix"] = c(e), this;
            }
          }, {
            key: "txType",
            value: function txType(e) {
              return this.query["tx-type"] = e, this;
            }
          }, {
            key: "sigType",
            value: function sigType(e) {
              return this.query["sig-type"] = e, this;
            }
          }, {
            key: "txid",
            value: function txid(e) {
              return this.query.txid = e, this;
            }
          }, {
            key: "round",
            value: function round(e) {
              return this.query.round = e, this;
            }
          }, {
            key: "minRound",
            value: function minRound(e) {
              return this.query["min-round"] = e, this;
            }
          }, {
            key: "maxRound",
            value: function maxRound(e) {
              return this.query["max-round"] = e, this;
            }
          }, {
            key: "assetID",
            value: function assetID(e) {
              return this.query["asset-id"] = e, this;
            }
          }, {
            key: "limit",
            value: function limit(e) {
              return this.query.limit = e, this;
            }
          }, {
            key: "beforeTime",
            value: function beforeTime(e) {
              return this.query["before-time"] = e, this;
            }
          }, {
            key: "afterTime",
            value: function afterTime(e) {
              return this.query["after-time"] = e, this;
            }
          }, {
            key: "currencyGreaterThan",
            value: function currencyGreaterThan(e) {
              return this.query["currency-greater-than"] = e, this;
            }
          }, {
            key: "currencyLessThan",
            value: function currencyLessThan(e) {
              return this.query["currency-less-than"] = e, this;
            }
          }, {
            key: "addressRole",
            value: function addressRole(e) {
              return this.query["address-role"] = e, this;
            }
          }, {
            key: "address",
            value: function address(e) {
              return this.query.address = e, this;
            }
          }, {
            key: "excludeCloseTo",
            value: function excludeCloseTo(e) {
              return this.query["exclude-close-to"] = e, this;
            }
          }, {
            key: "nextToken",
            value: function nextToken(e) {
              return this.query.next = e, this;
            }
          }, {
            key: "rekeyTo",
            value: function rekeyTo(e) {
              return this.query["rekey-to"] = e, this;
            }
          }]);

          return l;
        }(o.Z);

        var h = /*#__PURE__*/function (_o$Z22) {
          _inherits(h, _o$Z22);

          var _super68 = _createSuper(h);

          function h(e, t, r) {
            var _this56;

            _classCallCheck(this, h);

            _this56 = _super68.call(this, e, t), _this56.round = r, _this56.round = r;
            return _this56;
          }

          _createClass(h, [{
            key: "path",
            value: function path() {
              return "/v2/blocks/".concat(this.round);
            }
          }]);

          return h;
        }(o.Z);

        var p = /*#__PURE__*/function (_o$Z23) {
          _inherits(p, _o$Z23);

          var _super69 = _createSuper(p);

          function p(e, t, r) {
            var _this57;

            _classCallCheck(this, p);

            _this57 = _super69.call(this, e, t), _this57.txID = r, _this57.txID = r;
            return _this57;
          }

          _createClass(p, [{
            key: "path",
            value: function path() {
              return "/v2/transactions/".concat(this.txID);
            }
          }]);

          return p;
        }(o.Z);

        var f = /*#__PURE__*/function (_o$Z24) {
          _inherits(f, _o$Z24);

          var _super70 = _createSuper(f);

          function f(e, t, r) {
            var _this58;

            _classCallCheck(this, f);

            _this58 = _super70.call(this, e, t), _this58.account = r, _this58.account = r;
            return _this58;
          }

          _createClass(f, [{
            key: "path",
            value: function path() {
              return "/v2/accounts/".concat(this.account);
            }
          }, {
            key: "round",
            value: function round(e) {
              return this.query.round = e, this;
            }
          }, {
            key: "includeAll",
            value: function includeAll() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              return this.query["include-all"] = e, this;
            }
          }]);

          return f;
        }(o.Z);

        var d = /*#__PURE__*/function (_o$Z25) {
          _inherits(d, _o$Z25);

          var _super71 = _createSuper(d);

          function d(e, t, r) {
            var _this59;

            _classCallCheck(this, d);

            _this59 = _super71.call(this, e, t), _this59.index = r, _this59.index = r;
            return _this59;
          }

          _createClass(d, [{
            key: "path",
            value: function path() {
              return "/v2/assets/".concat(this.index);
            }
          }, {
            key: "includeAll",
            value: function includeAll() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              return this.query["include-all"] = e, this;
            }
          }]);

          return d;
        }(o.Z);

        var g = /*#__PURE__*/function (_o$Z26) {
          _inherits(g, _o$Z26);

          var _super72 = _createSuper(g);

          function g(e, t, r) {
            var _this60;

            _classCallCheck(this, g);

            _this60 = _super72.call(this, e, t), _this60.index = r, _this60.index = r;
            return _this60;
          }

          _createClass(g, [{
            key: "path",
            value: function path() {
              return "/v2/applications/".concat(this.index);
            }
          }, {
            key: "includeAll",
            value: function includeAll() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              return this.query["include-all"] = e, this;
            }
          }]);

          return g;
        }(o.Z);

        var y = /*#__PURE__*/function (_o$Z27) {
          _inherits(y, _o$Z27);

          var _super73 = _createSuper(y);

          function y(e, t, r) {
            var _this61;

            _classCallCheck(this, y);

            _this61 = _super73.call(this, e, t), _this61.appID = r, _this61.appID = r;
            return _this61;
          }

          _createClass(y, [{
            key: "path",
            value: function path() {
              return "/v2/applications/".concat(this.appID, "/logs");
            }
          }, {
            key: "limit",
            value: function limit(e) {
              return this.query.limit = e, this;
            }
          }, {
            key: "minRound",
            value: function minRound(e) {
              return this.query["min-round"] = e, this;
            }
          }, {
            key: "maxRound",
            value: function maxRound(e) {
              return this.query["max-round"] = e, this;
            }
          }, {
            key: "nextToken",
            value: function nextToken(e) {
              return this.query.next = e, this;
            }
          }, {
            key: "sender",
            value: function sender(e) {
              return this.query["sender-address"] = e, this;
            }
          }, {
            key: "txid",
            value: function txid(e) {
              return this.query.txid = e, this;
            }
          }]);

          return y;
        }(o.Z);

        var m = /*#__PURE__*/function (_o$Z28) {
          _inherits(m, _o$Z28);

          var _super74 = _createSuper(m);

          function m() {
            _classCallCheck(this, m);

            return _super74.apply(this, arguments);
          }

          _createClass(m, [{
            key: "path",
            value: function path() {
              return "/v2/accounts";
            }
          }, {
            key: "currencyGreaterThan",
            value: function currencyGreaterThan(e) {
              return this.query["currency-greater-than"] = e, this;
            }
          }, {
            key: "currencyLessThan",
            value: function currencyLessThan(e) {
              return this.query["currency-less-than"] = e, this;
            }
          }, {
            key: "limit",
            value: function limit(e) {
              return this.query.limit = e, this;
            }
          }, {
            key: "assetID",
            value: function assetID(e) {
              return this.query["asset-id"] = e, this;
            }
          }, {
            key: "nextToken",
            value: function nextToken(e) {
              return this.query.next = e, this;
            }
          }, {
            key: "round",
            value: function round(e) {
              return this.query.round = e, this;
            }
          }, {
            key: "authAddr",
            value: function authAddr(e) {
              return this.query["auth-addr"] = e, this;
            }
          }, {
            key: "applicationID",
            value: function applicationID(e) {
              return this.query["application-id"] = e, this;
            }
          }, {
            key: "includeAll",
            value: function includeAll() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              return this.query["include-all"] = e, this;
            }
          }]);

          return m;
        }(o.Z);

        var b = /*#__PURE__*/function (_o$Z29) {
          _inherits(b, _o$Z29);

          var _super75 = _createSuper(b);

          function b() {
            _classCallCheck(this, b);

            return _super75.apply(this, arguments);
          }

          _createClass(b, [{
            key: "path",
            value: function path() {
              return "/v2/transactions";
            }
          }, {
            key: "notePrefix",
            value: function notePrefix(e) {
              return this.query["note-prefix"] = c(e), this;
            }
          }, {
            key: "txType",
            value: function txType(e) {
              return this.query["tx-type"] = e, this;
            }
          }, {
            key: "sigType",
            value: function sigType(e) {
              return this.query["sig-type"] = e, this;
            }
          }, {
            key: "txid",
            value: function txid(e) {
              return this.query.txid = e, this;
            }
          }, {
            key: "round",
            value: function round(e) {
              return this.query.round = e, this;
            }
          }, {
            key: "minRound",
            value: function minRound(e) {
              return this.query["min-round"] = e, this;
            }
          }, {
            key: "maxRound",
            value: function maxRound(e) {
              return this.query["max-round"] = e, this;
            }
          }, {
            key: "assetID",
            value: function assetID(e) {
              return this.query["asset-id"] = e, this;
            }
          }, {
            key: "limit",
            value: function limit(e) {
              return this.query.limit = e, this;
            }
          }, {
            key: "beforeTime",
            value: function beforeTime(e) {
              return this.query["before-time"] = e, this;
            }
          }, {
            key: "afterTime",
            value: function afterTime(e) {
              return this.query["after-time"] = e, this;
            }
          }, {
            key: "currencyGreaterThan",
            value: function currencyGreaterThan(e) {
              return this.query["currency-greater-than"] = e, this;
            }
          }, {
            key: "currencyLessThan",
            value: function currencyLessThan(e) {
              return this.query["currency-less-than"] = e, this;
            }
          }, {
            key: "addressRole",
            value: function addressRole(e) {
              return this.query["address-role"] = e, this;
            }
          }, {
            key: "address",
            value: function address(e) {
              return this.query.address = e, this;
            }
          }, {
            key: "excludeCloseTo",
            value: function excludeCloseTo(e) {
              return this.query["exclude-close-to"] = e, this;
            }
          }, {
            key: "nextToken",
            value: function nextToken(e) {
              return this.query.next = e, this;
            }
          }, {
            key: "rekeyTo",
            value: function rekeyTo(e) {
              return this.query["rekey-to"] = e, this;
            }
          }, {
            key: "applicationID",
            value: function applicationID(e) {
              return this.query["application-id"] = e, this;
            }
          }]);

          return b;
        }(o.Z);

        var w = /*#__PURE__*/function (_o$Z30) {
          _inherits(w, _o$Z30);

          var _super76 = _createSuper(w);

          function w() {
            _classCallCheck(this, w);

            return _super76.apply(this, arguments);
          }

          _createClass(w, [{
            key: "path",
            value: function path() {
              return "/v2/assets";
            }
          }, {
            key: "limit",
            value: function limit(e) {
              return this.query.limit = e, this;
            }
          }, {
            key: "creator",
            value: function creator(e) {
              return this.query.creator = e, this;
            }
          }, {
            key: "name",
            value: function name(e) {
              return this.query.name = e, this;
            }
          }, {
            key: "unit",
            value: function unit(e) {
              return this.query.unit = e, this;
            }
          }, {
            key: "index",
            value: function index(e) {
              return this.query["asset-id"] = e, this;
            }
          }, {
            key: "nextToken",
            value: function nextToken(e) {
              return this.query.next = e, this;
            }
          }, {
            key: "includeAll",
            value: function includeAll() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              return this.query["include-all"] = e, this;
            }
          }]);

          return w;
        }(o.Z);

        var A = /*#__PURE__*/function (_o$Z31) {
          _inherits(A, _o$Z31);

          var _super77 = _createSuper(A);

          function A() {
            _classCallCheck(this, A);

            return _super77.apply(this, arguments);
          }

          _createClass(A, [{
            key: "path",
            value: function path() {
              return "/v2/applications";
            }
          }, {
            key: "index",
            value: function index(e) {
              return this.query["application-id"] = e, this;
            }
          }, {
            key: "nextToken",
            value: function nextToken(e) {
              return this.query.next = e, this;
            }
          }, {
            key: "limit",
            value: function limit(e) {
              return this.query.limit = e, this;
            }
          }, {
            key: "includeAll",
            value: function includeAll() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              return this.query["include-all"] = e, this;
            }
          }]);

          return A;
        }(o.Z);

        var v = /*#__PURE__*/function (_n$Z4) {
          _inherits(v, _n$Z4);

          var _super78 = _createSuper(v);

          function v(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "http://127.0.0.1";
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8080;
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            _classCallCheck(this, v);

            return _super78.call(this, "X-Indexer-API-Token", e, t, r, n);
          }

          _createClass(v, [{
            key: "makeHealthCheck",
            value: function makeHealthCheck() {
              return new s(this.c, this.intDecoding);
            }
          }, {
            key: "lookupAssetBalances",
            value: function lookupAssetBalances(e) {
              return new i(this.c, this.intDecoding, e);
            }
          }, {
            key: "lookupAssetTransactions",
            value: function lookupAssetTransactions(e) {
              return new l(this.c, this.intDecoding, e);
            }
          }, {
            key: "lookupAccountTransactions",
            value: function lookupAccountTransactions(e) {
              return new u(this.c, this.intDecoding, e);
            }
          }, {
            key: "lookupBlock",
            value: function lookupBlock(e) {
              return new h(this.c, this.intDecoding, e);
            }
          }, {
            key: "lookupTransactionByID",
            value: function lookupTransactionByID(e) {
              return new p(this.c, this.intDecoding, e);
            }
          }, {
            key: "lookupAccountByID",
            value: function lookupAccountByID(e) {
              return new f(this.c, this.intDecoding, e);
            }
          }, {
            key: "lookupAssetByID",
            value: function lookupAssetByID(e) {
              return new d(this.c, this.intDecoding, e);
            }
          }, {
            key: "lookupApplications",
            value: function lookupApplications(e) {
              return new g(this.c, this.intDecoding, e);
            }
          }, {
            key: "lookupApplicationLogs",
            value: function lookupApplicationLogs(e) {
              return new y(this.c, this.intDecoding, e);
            }
          }, {
            key: "searchAccounts",
            value: function searchAccounts() {
              return new m(this.c, this.intDecoding);
            }
          }, {
            key: "searchForTransactions",
            value: function searchForTransactions() {
              return new b(this.c, this.intDecoding);
            }
          }, {
            key: "searchForAssets",
            value: function searchForAssets() {
              return new w(this.c, this.intDecoding);
            }
          }, {
            key: "searchForApplications",
            value: function searchForApplications() {
              return new A(this.c, this.intDecoding);
            }
          }]);

          return v;
        }(n.Z);
      },
      8680: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var n = r(7197);

        var o = /*#__PURE__*/function () {
          function o(e, t) {
            _classCallCheck(this, o);

            this.c = e, this.query = {}, this.intDecoding = t || n.Z.DEFAULT;
          }

          _createClass(o, [{
            key: "prepare",
            value: function prepare(e) {
              return e;
            }
          }, {
            key: "do",
            value: function () {
              var _do6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
                var e,
                    t,
                    r,
                    _args51 = arguments;
                return _regeneratorRuntime.wrap(function _callee51$(_context51) {
                  while (1) {
                    switch (_context51.prev = _context51.next) {
                      case 0:
                        e = _args51.length > 0 && _args51[0] !== undefined ? _args51[0] : {};
                        t = {};
                        "default" !== this.intDecoding && (t.intDecoding = this.intDecoding);
                        _context51.next = 5;
                        return this.c.get(this.path(), this.query, e, t);

                      case 5:
                        r = _context51.sent;
                        return _context51.abrupt("return", this.prepare(r.body));

                      case 7:
                      case "end":
                        return _context51.stop();
                    }
                  }
                }, _callee51, this);
              }));

              function _do() {
                return _do6.apply(this, arguments);
              }

              return _do;
            }()
          }, {
            key: "setIntDecoding",
            value: function setIntDecoding(e) {
              if ("default" !== e && "safe" !== e && "mixed" !== e && "bigint" !== e) throw new Error("Invalid method for int decoding: ".concat(e));
              return this.intDecoding = e, this;
            }
          }]);

          return o;
        }();
      },
      3480: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = r(1113),
            o = r(7197);

        var s = /*#__PURE__*/function () {
          function s(e, t, r, _s39) {
            var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

            _classCallCheck(this, s);

            if ("function" == typeof t.get) this.c = new n.default(t);else {
              var _o13;

              _o13 = "string" == typeof t ? function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var t = arguments.length > 1 ? arguments[1] : undefined;
                var r = {};
                return r[t] = e, r;
              }(t, e) : t, this.c = new n.default(_o13, r, _s39, i);
            }
            this.intDecoding = o.Z.DEFAULT;
          }

          _createClass(s, [{
            key: "setIntEncoding",
            value: function setIntEncoding(e) {
              this.intDecoding = e;
            }
          }, {
            key: "getIntEncoding",
            value: function getIntEncoding() {
              return this.intDecoding;
            }
          }]);

          return s;
        }();
      },
      3458: function _(e, t, r) {
        "use strict";

        r.d(t, {
          b: function b() {
            return p;
          },
          A: function A() {
            return d;
          }
        });
        var n = r(3410),
            o = r(9417),
            s = r(1988),
            i = r(1063),
            a = r(5062),
            c = r(834),
            u = r(1624),
            l = r(2486).Buffer;
        var h = l.from([21, 31, 124, 117]);
        var p;

        function f(e, t, r) {
          if (null != r && e === r) return 0;
          var n = null == r ? 0 : 1;

          for (var _r25 = 0; _r25 < t.length; _r25++) {
            if (e === t[_r25]) return _r25 + n;
          }

          return t.push(e), t.length - 1 + n;
        }

        !function (e) {
          e[e.BUILDING = 0] = "BUILDING", e[e.BUILT = 1] = "BUILT", e[e.SIGNED = 2] = "SIGNED", e[e.SUBMITTED = 3] = "SUBMITTED", e[e.COMMITTED = 4] = "COMMITTED";
        }(p || (p = {}));

        var d = /*#__PURE__*/function () {
          function d() {
            _classCallCheck(this, d);

            this.status = p.BUILDING, this.transactions = [], this.methodCalls = new Map(), this.signedTxns = [], this.txIDs = [];
          }

          _createClass(d, [{
            key: "getStatus",
            value: function getStatus() {
              return this.status;
            }
          }, {
            key: "count",
            value: function count() {
              return this.transactions.length;
            }
          }, {
            key: "clone",
            value: function clone() {
              var e = new d();
              return e.transactions = this.transactions.map(function (_ref35) {
                var e = _ref35.txn,
                    t = _ref35.signer;
                return {
                  txn: o.Transaction.from_obj_for_encoding(_objectSpread(_objectSpread({}, e.get_obj_for_encoding()), {}, {
                    grp: void 0
                  })),
                  signer: t
                };
              }), e.methodCalls = new Map(this.methodCalls), e;
            }
          }, {
            key: "addTransaction",
            value: function addTransaction(e) {
              if (this.status !== p.BUILDING) throw new Error("Cannot add transactions when composer status is not BUILDING");
              if (this.transactions.length === d.MAX_GROUP_SIZE) throw new Error("Adding an additional transaction exceeds the maximum atomic group size of ".concat(d.MAX_GROUP_SIZE));
              if (e.txn.group && e.txn.group.some(function (e) {
                return 0 !== e;
              })) throw new Error("Cannot add a transaction with nonzero group ID");
              this.transactions.push(e);
            }
          }, {
            key: "addMethodCall",
            value: function addMethodCall(_ref36) {
              var _this$transactions;

              var e = _ref36.appID,
                  t = _ref36.method,
                  r = _ref36.methodArgs,
                  o = _ref36.sender,
                  i = _ref36.suggestedParams,
                  a = _ref36.onComplete,
                  l = _ref36.approvalProgram,
                  h = _ref36.clearProgram,
                  g = _ref36.numGlobalInts,
                  y = _ref36.numGlobalByteSlices,
                  m = _ref36.numLocalInts,
                  b = _ref36.numLocalByteSlices,
                  w = _ref36.extraPages,
                  A = _ref36.note,
                  v = _ref36.lease,
                  x = _ref36.rekeyTo,
                  S = _ref36.signer;
              if (this.status !== p.BUILDING) throw new Error("Cannot add transactions when composer status is not BUILDING");
              if (this.transactions.length + t.txnCount() > d.MAX_GROUP_SIZE) throw new Error("Adding additional transactions exceeds the maximum atomic group size of ".concat(d.MAX_GROUP_SIZE));

              if (0 === e) {
                if (null == l || null == h || null == g || null == y || null == m || null == b) throw new Error("One of the following required parameters for application creation is missing: approvalProgram, clearProgram, numGlobalInts, numGlobalByteSlices, numLocalInts, numLocalByteSlices");
              } else if (a === u.h.UpdateApplicationOC) {
                if (null == l || null == h) throw new Error("One of the following required parameters for OnApplicationComplete.UpdateApplicationOC is missing: approvalProgram, clearProgram");
                if (null != g || null != y || null != m || null != b || null != w) throw new Error("One of the following application creation parameters were set on a non-creation call: numGlobalInts, numGlobalByteSlices, numLocalInts, numLocalByteSlices, extraPages");
              } else if (null != l || null != h || null != g || null != y || null != m || null != b || null != w) throw new Error("One of the following application creation parameters were set on a non-creation call: approvalProgram, clearProgram, numGlobalInts, numGlobalByteSlices, numLocalInts, numLocalByteSlices, extraPages");

              if (null == r && (r = []), r.length !== t.args.length) throw new Error("Incorrect number of method arguments. Expected ".concat(t.args.length, ", got ").concat(r.length));
              var E = [],
                  T = [];
              var _ = [],
                  B = [],
                  k = [],
                  I = new Map();

              for (var _e27 = 0; _e27 < r.length; _e27++) {
                var _o14 = t.args[_e27].type;
                var _s40 = r[_e27];

                if ((0, n.AE)(_o14)) {
                  if (!(0, c.Xw)(_s40) || !(0, n.vJ)(_o14, _s40.txn)) throw new Error("Expected ".concat(_o14, " transaction for argument at index ").concat(_e27));
                  if (_s40.txn.group && _s40.txn.group.some(function (e) {
                    return 0 !== e;
                  })) throw new Error("Cannot add a transaction with nonzero group ID");

                  _.push(_s40);
                } else {
                  if ((0, c.Xw)(_s40)) throw new Error("Expected non-transaction value for argument at index ".concat(_e27));
                  if ((0, n.o5)(_o14) && (I.set(B.length, E.length), B.push(_o14), k.push(_s40), _o14 = new n.Pu(8)), "string" == typeof _o14) throw new Error("Unknown ABI type: ".concat(_o14));
                  E.push(_o14), T.push(_s40);
                }
              }

              var U = [],
                  C = [],
                  R = [],
                  O = [];

              for (var _t28 = 0; _t28 < B.length; _t28++) {
                var _r26 = B[_t28],
                    _s41 = k[_t28];
                var _i12 = 0;

                switch (_r26) {
                  case n.UV.account:
                    {
                      var _e28 = new n.JQ();

                      _i12 = f(_e28.decode(_e28.encode(_s41)), C, o);
                      break;
                    }

                  case n.UV.application:
                    {
                      var _t29 = new n.Pu(64),
                          _r27 = _t29.decode(_t29.encode(_s41));

                      if (_r27 > Number.MAX_SAFE_INTEGER) throw new Error("Expected safe integer for application value, got ".concat(_r27));
                      _i12 = f(Number(_r27), R, e);
                      break;
                    }

                  case n.UV.asset:
                    {
                      var _e29 = new n.Pu(64),
                          _t30 = _e29.decode(_e29.encode(_s41));

                      if (_t30 > Number.MAX_SAFE_INTEGER) throw new Error("Expected safe integer for asset value, got ".concat(_t30));
                      _i12 = f(Number(_t30), O);
                      break;
                    }

                  default:
                    throw new Error("Unknown reference type: ".concat(_r26));
                }

                U.push(_i12);
              }

              for (var _e30 = 0; _e30 < U.length; _e30++) {
                T[I.get(_e30)] = U[_e30];
              }

              if (E.length > 15) {
                var _e31 = E.slice(14),
                    _t31 = T.slice(14);

                E = E.slice(0, 14), T = T.slice(0, 14), E.push(new n.w1(_e31)), T.push(_t31);
              }

              var D = [t.getSelector()];

              for (var _e32 = 0; _e32 < E.length; _e32++) {
                D.push(E[_e32].encode(T[_e32]));
              }

              var N = {
                txn: (0, s.makeApplicationCallTxnFromObject)({
                  from: o,
                  appIndex: e,
                  appArgs: D,
                  accounts: C,
                  foreignApps: R,
                  foreignAssets: O,
                  onComplete: null == a ? u.h.NoOpOC : a,
                  approvalProgram: l,
                  clearProgram: h,
                  numGlobalInts: g,
                  numGlobalByteSlices: y,
                  numLocalInts: m,
                  numLocalByteSlices: b,
                  extraPages: w,
                  lease: v,
                  note: A,
                  rekeyTo: x,
                  suggestedParams: i
                }),
                signer: S
              };
              (_this$transactions = this.transactions).push.apply(_this$transactions, _.concat([N])), this.methodCalls.set(this.transactions.length - 1, t);
            }
          }, {
            key: "buildGroup",
            value: function buildGroup() {
              if (this.status === p.BUILDING) {
                if (0 === this.transactions.length) throw new Error("Cannot build a group with 0 transactions");
                this.transactions.length > 1 && (0, i.assignGroupID)(this.transactions.map(function (e) {
                  return e.txn;
                })), this.status = p.BUILT;
              }

              return this.transactions;
            }
          }, {
            key: "gatherSignatures",
            value: function () {
              var _gatherSignatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
                var e, t, r, _t32, _n23, n, s, i, _e33, _t33, _r28, _e34, a;

                return _regeneratorRuntime.wrap(function _callee52$(_context52) {
                  while (1) {
                    switch (_context52.prev = _context52.next) {
                      case 0:
                        if (!(this.status >= p.SIGNED)) {
                          _context52.next = 2;
                          break;
                        }

                        return _context52.abrupt("return", this.signedTxns);

                      case 2:
                        e = this.buildGroup(), t = e.map(function (e) {
                          return e.txn;
                        }), r = new Map();

                        for (_t32 = 0; _t32 < e.length; _t32++) {
                          _n23 = e[_t32].signer;
                          r.has(_n23) || r.set(_n23, []), r.get(_n23).push(_t32);
                        }

                        n = Array.from(r);
                        _context52.next = 7;
                        return Promise.all(n.map(function (_ref37) {
                          var _ref38 = _slicedToArray(_ref37, 2),
                              e = _ref38[0],
                              r = _ref38[1];

                          return e(t, r);
                        }));

                      case 7:
                        s = _context52.sent;
                        i = e.map(function () {
                          return null;
                        });

                        for (_e33 = 0; _e33 < n.length; _e33++) {
                          _t33 = n[_e33][1], _r28 = s[_e33];

                          for (_e34 = 0; _e34 < _t33.length; _e34++) {
                            i[_t33[_e34]] = _r28[_e34];
                          }
                        }

                        if (i.every(function (e) {
                          return null != e;
                        })) {
                          _context52.next = 12;
                          break;
                        }

                        throw new Error("Missing signatures. Got ".concat(i));

                      case 12:
                        a = i.map(function (e, t) {
                          try {
                            return (0, o.decodeSignedTransaction)(e).txn.txID();
                          } catch (e) {
                            throw new Error("Cannot decode signed transaction at index ".concat(t, ". ").concat(e));
                          }
                        });
                        return _context52.abrupt("return", (this.signedTxns = i, this.txIDs = a, this.status = p.SIGNED, i));

                      case 14:
                      case "end":
                        return _context52.stop();
                    }
                  }
                }, _callee52, this);
              }));

              function gatherSignatures() {
                return _gatherSignatures.apply(this, arguments);
              }

              return gatherSignatures;
            }()
          }, {
            key: "submit",
            value: function () {
              var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(e) {
                var t;
                return _regeneratorRuntime.wrap(function _callee53$(_context53) {
                  while (1) {
                    switch (_context53.prev = _context53.next) {
                      case 0:
                        if (!(this.status > p.SUBMITTED)) {
                          _context53.next = 2;
                          break;
                        }

                        throw new Error("Transaction group cannot be resubmitted");

                      case 2:
                        _context53.next = 4;
                        return this.gatherSignatures();

                      case 4:
                        t = _context53.sent;
                        _context53.next = 7;
                        return e.sendRawTransaction(t).do();

                      case 7:
                        this.status = p.SUBMITTED;
                        return _context53.abrupt("return", this.txIDs);

                      case 9:
                      case "end":
                        return _context53.stop();
                    }
                  }
                }, _callee53, this);
              }));

              function submit(_x74) {
                return _submit.apply(this, arguments);
              }

              return submit;
            }()
          }, {
            key: "execute",
            value: function () {
              var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(e, t) {
                var _this62 = this;

                var r, n, o, s, i, c, _iterator4, _step4, _step4$value, _t34, _o15, _i13, _a5, _r29, _c4;

                return _regeneratorRuntime.wrap(function _callee54$(_context54) {
                  while (1) {
                    switch (_context54.prev = _context54.next) {
                      case 0:
                        if (!(this.status === p.COMMITTED)) {
                          _context54.next = 2;
                          break;
                        }

                        throw new Error("Transaction group has already been executed successfully");

                      case 2:
                        _context54.next = 4;
                        return this.submit(e);

                      case 4:
                        r = _context54.sent;
                        this.status = p.SUBMITTED;
                        n = this.transactions.findIndex(function (e, t) {
                          return _this62.methodCalls.has(t);
                        });
                        o = -1 === n ? 0 : n;
                        _context54.next = 10;
                        return (0, a.K)(e, r[o], t);

                      case 10:
                        s = _context54.sent;
                        this.status = p.COMMITTED;
                        i = s["confirmed-round"], c = [];
                        _iterator4 = _createForOfIteratorHelper(this.methodCalls);
                        _context54.prev = 14;

                        _iterator4.s();

                      case 16:
                        if ((_step4 = _iterator4.n()).done) {
                          _context54.next = 46;
                          break;
                        }

                        _step4$value = _slicedToArray(_step4.value, 2), _t34 = _step4$value[0], _o15 = _step4$value[1];
                        _i13 = r[_t34], _a5 = {
                          txID: _i13,
                          rawReturnValue: new Uint8Array()
                        };
                        _context54.prev = 19;

                        if (!("void" !== _o15.returns.type)) {
                          _context54.next = 38;
                          break;
                        }

                        if (!(_t34 === n)) {
                          _context54.next = 25;
                          break;
                        }

                        _context54.t1 = s;
                        _context54.next = 28;
                        break;

                      case 25:
                        _context54.next = 27;
                        return e.pendingTransactionInformation(_i13).do();

                      case 27:
                        _context54.t1 = _context54.sent;

                      case 28:
                        _context54.t0 = _context54.t1.logs;

                        if (_context54.t0) {
                          _context54.next = 31;
                          break;
                        }

                        _context54.t0 = [];

                      case 31:
                        _r29 = _context54.t0;

                        if (!(0 === _r29.length)) {
                          _context54.next = 34;
                          break;
                        }

                        throw new Error("App call transaction did not log a return value");

                      case 34:
                        _c4 = l.from(_r29[_r29.length - 1], "base64");

                        if (!(_c4.byteLength < 4 || !_c4.slice(0, 4).equals(h))) {
                          _context54.next = 37;
                          break;
                        }

                        throw new Error("App call transaction did not log a return value");

                      case 37:
                        _a5.rawReturnValue = new Uint8Array(_c4.slice(4)), _a5.returnValue = _o15.returns.type.decode(_a5.rawReturnValue);

                      case 38:
                        _context54.next = 43;
                        break;

                      case 40:
                        _context54.prev = 40;
                        _context54.t2 = _context54["catch"](19);
                        _a5.decodeError = _context54.t2;

                      case 43:
                        c.push(_a5);

                      case 44:
                        _context54.next = 16;
                        break;

                      case 46:
                        _context54.next = 51;
                        break;

                      case 48:
                        _context54.prev = 48;
                        _context54.t3 = _context54["catch"](14);

                        _iterator4.e(_context54.t3);

                      case 51:
                        _context54.prev = 51;

                        _iterator4.f();

                        return _context54.finish(51);

                      case 54:
                        return _context54.abrupt("return", {
                          confirmedRound: i,
                          txIDs: r,
                          methodResults: c
                        });

                      case 55:
                      case "end":
                        return _context54.stop();
                    }
                  }
                }, _callee54, this, [[14, 48, 51, 54], [19, 40]]);
              }));

              function execute(_x75, _x76) {
                return _execute.apply(this, arguments);
              }

              return execute;
            }()
          }]);

          return d;
        }();

        d.MAX_GROUP_SIZE = 16;
      },
      9070: function _(e, t, r) {
        "use strict";

        r.d(t, {
          rD: function rD() {
            return o;
          },
          _: function _() {
            return s;
          },
          HN: function HN() {
            return i;
          }
        });
        var n = 1e6,
            o = "Microalgos should be positive and less than 2^53 - 1.";

        function s(e) {
          if (e < 0 || !Number.isSafeInteger(e)) throw new Error(o);
          return e / n;
        }

        function i(e) {
          var t = e * n;
          return Math.round(t);
        }
      },
      4383: function _(e, t, r) {
        "use strict";

        r.d(t, {
          P: function P() {
            return c;
          }
        });
        var n = r(227),
            o = r(1824),
            s = r(7116),
            i = r(2486).Buffer;

        function a(e) {
          return e.params["approval-program"] = i.from(e.params["approval-program"].toString(), "base64"), e.params["clear-state-program"] = i.from(e.params["clear-state-program"].toString(), "base64"), e;
        }

        function c(_x77) {
          return _c5.apply(this, arguments);
        }

        function _c5() {
          _c5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(_ref39) {
            var e, t, r, i, c, u, l, h, p, f, d, _iterator5, _step5, _e35, g, _i14, _arr, _t35, y, _i15, _arr2, _t36, m, _i16, _arr3, _t37;

            return _regeneratorRuntime.wrap(function _callee55$(_context55) {
              while (1) {
                switch (_context55.prev = _context55.next) {
                  case 0:
                    e = _ref39.client, t = _ref39.txns, r = _ref39.protocolVersion, i = _ref39.latestTimestamp, c = _ref39.round, u = _ref39.sources;
                    l = [], h = [], p = [], f = [], d = [];
                    _iterator5 = _createForOfIteratorHelper(t);

                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        _e35 = _step5.value;
                        _e35.txn.type === o.i.appl && (d.push((0, s.encodeAddress)(_e35.txn.from.publicKey)), _e35.txn.appAccounts && d.push.apply(d, _toConsumableArray(_e35.txn.appAccounts.map(function (e) {
                          return (0, s.encodeAddress)(e.publicKey);
                        }))), _e35.txn.appForeignApps && p.push.apply(p, _toConsumableArray(_e35.txn.appForeignApps)), _e35.txn.appForeignAssets && f.push.apply(f, _toConsumableArray(_e35.txn.appForeignAssets)), 0 === _e35.txn.appIndex ? l.push(new n.Application(1380011588, new n.ApplicationParams({
                          creator: (0, s.encodeAddress)(_e35.txn.from.publicKey),
                          approvalProgram: _e35.txn.appApprovalProgram,
                          clearStateProgram: _e35.txn.appClearProgram,
                          localStateSchema: new n.ApplicationStateSchema(_e35.txn.appLocalInts, _e35.txn.appLocalByteSlices),
                          globalStateSchema: new n.ApplicationStateSchema(_e35.txn.appGlobalInts, _e35.txn.appGlobalByteSlices)
                        }))) : (p.push(_e35.txn.appIndex), d.push((0, s.getApplicationAddress)(_e35.txn.appIndex))));
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }

                    g = [];

                    for (_i14 = 0, _arr = _toConsumableArray(new Set(f)); _i14 < _arr.length; _i14++) {
                      _t35 = _arr[_i14];
                      g.push(e.getAssetByID(_t35).do().then(function (e) {
                        d.push(e.params.creator);
                      }));
                    }

                    _context55.next = 8;
                    return Promise.all(g);

                  case 8:
                    y = [];

                    for (_i15 = 0, _arr2 = _toConsumableArray(new Set(p)); _i15 < _arr2.length; _i15++) {
                      _t36 = _arr2[_i15];
                      y.push(e.getApplicationByID(_t36).do().then(function (e) {
                        var t = a(e);
                        l.push(t), d.push(t.params.creator);
                      }));
                    }

                    _context55.next = 12;
                    return Promise.all(y);

                  case 12:
                    m = [];

                    for (_i16 = 0, _arr3 = _toConsumableArray(new Set(d)); _i16 < _arr3.length; _i16++) {
                      _t37 = _arr3[_i16];
                      m.push(e.accountInformation(_t37).do().then(function (e) {
                        "created-apps" in e && (e["created-apps"] = e["created-apps"].map(function (e) {
                          return a(e);
                        })), h.push(e);
                      }));
                    }

                    _context55.next = 16;
                    return Promise.all(m);

                  case 16:
                    return _context55.abrupt("return", new n.DryrunRequest({
                      txns: t.map(function (e) {
                        return _objectSpread(_objectSpread({}, e), {}, {
                          txn: e.txn.get_obj_for_encoding()
                        });
                      }),
                      accounts: h,
                      apps: l,
                      latestTimestamp: i,
                      round: c,
                      protocolVersion: r,
                      sources: u
                    }));

                  case 17:
                  case "end":
                    return _context55.stop();
                }
              }
            }, _callee55);
          }));
          return _c5.apply(this, arguments);
        }
      },
      7116: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          ALGORAND_ZERO_ADDRESS_STRING: function ALGORAND_ZERO_ADDRESS_STRING() {
            return u;
          },
          MALFORMED_ADDRESS_ERROR_MSG: function MALFORMED_ADDRESS_ERROR_MSG() {
            return p;
          },
          CHECKSUM_ADDRESS_ERROR_MSG: function CHECKSUM_ADDRESS_ERROR_MSG() {
            return f;
          },
          INVALID_MSIG_VERSION_ERROR_MSG: function INVALID_MSIG_VERSION_ERROR_MSG() {
            return d;
          },
          INVALID_MSIG_THRESHOLD_ERROR_MSG: function INVALID_MSIG_THRESHOLD_ERROR_MSG() {
            return g;
          },
          INVALID_MSIG_PK_ERROR_MSG: function INVALID_MSIG_PK_ERROR_MSG() {
            return y;
          },
          UNEXPECTED_PK_LEN_ERROR_MSG: function UNEXPECTED_PK_LEN_ERROR_MSG() {
            return m;
          },
          decodeAddress: function decodeAddress() {
            return b;
          },
          isValidAddress: function isValidAddress() {
            return w;
          },
          encodeAddress: function encodeAddress() {
            return A;
          },
          fromMultisigPreImg: function fromMultisigPreImg() {
            return v;
          },
          fromMultisigPreImgAddrs: function fromMultisigPreImgAddrs() {
            return x;
          },
          getApplicationAddress: function getApplicationAddress() {
            return S;
          }
        });
        var n = r(7267),
            o = r.n(n),
            s = r(9404),
            i = r(413),
            a = r(6963),
            c = r(2486).Buffer;
        var u = "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY5HFKQ",
            l = new Uint8Array([77, 117, 108, 116, 105, 115, 105, 103, 65, 100, 100, 114]),
            h = c.from("appID"),
            p = "address seems to be malformed",
            f = "wrong checksum for address",
            d = "invalid multisig version",
            g = "bad multisig threshold",
            y = "bad multisig public key - wrong length",
            m = "nacl public key length is not 32 bytes";

        function b(e) {
          if ("string" != typeof e || 58 !== e.length) throw new Error(p);
          var t = o().decode.asBytes(e.toString());
          if (36 !== t.length) throw new Error(p);
          var r = new Uint8Array(t.slice(0, 32)),
              n = new Uint8Array(t.slice(s.PUBLIC_KEY_LENGTH, 36)),
              a = s.genericHash(r).slice(s.HASH_BYTES_LENGTH - 4, s.HASH_BYTES_LENGTH);
          if (!i.arrayEqual(a, n)) throw new Error(f);
          return {
            publicKey: r,
            checksum: n
          };
        }

        function w(e) {
          try {
            b(e);
          } catch (e) {
            return !1;
          }

          return !0;
        }

        function A(e) {
          var t = s.genericHash(e).slice(s.PUBLIC_KEY_LENGTH - 4, s.PUBLIC_KEY_LENGTH);
          return o().encode(i.concatArrays(e, t)).toString().slice(0, 58);
        }

        function v(_ref40) {
          var e = _ref40.version,
              t = _ref40.threshold,
              r = _ref40.pks;
          if (1 !== e || e > 255 || e < 0) throw new Error(d);
          if (0 === t || 0 === r.length || t > r.length || t > 255) throw new Error(g);
          if (32 !== s.PUBLIC_KEY_LENGTH) throw new Error(m);
          var n = new Uint8Array(l.length + 2 + 32 * r.length);
          n.set(l, 0), n.set([e], l.length), n.set([t], l.length + 1);

          for (var _e36 = 0; _e36 < r.length; _e36++) {
            if (32 !== r[_e36].length) throw new Error(y);
            n.set(r[_e36], l.length + 2 + 32 * _e36);
          }

          return new Uint8Array(s.genericHash(n));
        }

        function x(_ref41) {
          var e = _ref41.version,
              t = _ref41.threshold,
              r = _ref41.addrs;
          return A(v({
            version: e,
            threshold: t,
            pks: r.map(function (e) {
              return b(e).publicKey;
            })
          }));
        }

        function S(e) {
          var t = i.concatArrays(h, (0, a.T)(e)),
              r = s.genericHash(t);
          return A(new Uint8Array(r));
        }
      },
      3033: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          ERROR_CONTAINS_EMPTY_STRING: function ERROR_CONTAINS_EMPTY_STRING() {
            return o;
          },
          encode: function encode() {
            return s;
          },
          decode: function decode() {
            return i;
          }
        });
        var n = r(5406);
        var o = "The object contains empty or 0 values. First empty or 0 value encountered during encoding: ";

        function s(e) {
          var t = function (e) {
            for (var _t38 in e) {
              if (Object.prototype.hasOwnProperty.call(e, _t38) && (!e[_t38] || 0 === e[_t38].length)) return {
                containsEmpty: !0,
                firstEmptyKey: _t38
              };
            }

            return {
              containsEmpty: !1,
              firstEmptyKey: void 0
            };
          }(e);

          if (t.containsEmpty) throw new Error(o + t.firstEmptyKey);
          return n.encode(e, {
            sortKeys: !0
          });
        }

        function i(e) {
          return n.decode(e);
        }
      },
      6963: function _(e, t, r) {
        "use strict";

        r.d(t, {
          T: function T() {
            return o;
          },
          u: function u() {
            return s;
          }
        });
        var n = r(2486).Buffer;

        function o(e) {
          if ("bigint" != typeof e && !Number.isInteger(e) || e < 0 || e > BigInt("0xffffffffffffffff")) throw new Error("Input is not a 64-bit unsigned integer");
          var t = n.allocUnsafe(8);
          return t.writeBigUInt64BE(BigInt(e)), new Uint8Array(t);
        }

        function s(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "safe";
          if ("safe" !== t && "mixed" !== t && "bigint" !== t) throw new Error("Unknown decodingMode option: ".concat(t));
          if (0 === e.byteLength || e.byteLength > 8) throw new Error("Data has unacceptable length. Expected length is between 1 and 8, got ".concat(e.byteLength));
          var r = n.allocUnsafe(8 - e.byteLength);
          r.fill(0);
          var o = n.concat([r, n.from(e)]).readBigUInt64BE(),
              s = o > Number.MAX_SAFE_INTEGER;

          if ("safe" === t) {
            if (s) throw new Error("Integer exceeds maximum safe integer: ".concat(o.toString(), ". Try decoding with \"mixed\" or \"safe\" decodingMode."));
            return Number(o);
          }

          return "mixed" !== t || s ? o : Number(o);
        }
      },
      1063: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          TxGroup: function TxGroup() {
            return u;
          },
          computeGroupID: function computeGroupID() {
            return l;
          },
          assignGroupID: function assignGroupID() {
            return h;
          },
          default: function _default() {
            return p;
          }
        });
        var n = r(9417),
            o = r(9404),
            s = r(3033),
            i = r(7116),
            a = r(413),
            c = r(2486).Buffer;

        var u = /*#__PURE__*/function () {
          function u(e) {
            _classCallCheck(this, u);

            if (this.name = "Transaction group", this.tag = c.from("TG"), e.length > 16) {
              var _t39 = "".concat(e.length.toString(), " transactions grouped together but max group size is ").concat(16..toString());

              throw Error(_t39);
            }

            this.txGroupHashes = e;
          }

          _createClass(u, [{
            key: "get_obj_for_encoding",
            value: function get_obj_for_encoding() {
              return {
                txlist: this.txGroupHashes
              };
            }
          }, {
            key: "toByte",
            value: function toByte() {
              return s.encode(this.get_obj_for_encoding());
            }
          }], [{
            key: "from_obj_for_encoding",
            value: function from_obj_for_encoding(e) {
              var t = Object.create(this.prototype);
              t.name = "Transaction group", t.tag = c.from("TG"), t.txGroupHashes = [];

              var _iterator6 = _createForOfIteratorHelper(e.txlist),
                  _step6;

              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var _r30 = _step6.value;
                  t.txGroupHashes.push(c.from(_r30));
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }

              return t;
            }
          }]);

          return u;
        }();

        function l(e) {
          var t = [];

          var _iterator7 = _createForOfIteratorHelper(e),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _r31 = _step7.value;

              var _e37 = n.instantiateTxnIfNeeded(_r31);

              t.push(_e37.rawTxID());
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          var r = new u(t),
              s = r.toByte(),
              i = c.from(a.concatArrays(r.tag, s)),
              l = o.genericHash(i);
          return c.from(l);
        }

        function h(e, t) {
          var r = l(e),
              o = [];

          var _iterator8 = _createForOfIteratorHelper(e),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _s42 = _step8.value;

              var _e38 = n.instantiateTxnIfNeeded(_s42);

              t && i.encodeAddress(_e38.from.publicKey) !== t || (_e38.group = r, o.push(_e38));
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          return o;
        }

        var p = u;
      },
      5583: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          checkByteConstBlock: function checkByteConstBlock() {
            return f;
          },
          checkIntConstBlock: function checkIntConstBlock() {
            return p;
          },
          checkProgram: function checkProgram() {
            return h;
          },
          checkPushByteOp: function checkPushByteOp() {
            return g;
          },
          checkPushIntOp: function checkPushIntOp() {
            return d;
          },
          langspecEvalMaxVersion: function langspecEvalMaxVersion() {
            return y;
          },
          langspecLogicSigVersion: function langspecLogicSigVersion() {
            return m;
          },
          parseUvarint: function parseUvarint() {
            return s;
          },
          readProgram: function readProgram() {
            return l;
          }
        });
        var n = JSON.parse('{"z_":5,"BV":5,"AP":[{"Opcode":0,"Name":"err","Cost":1,"Size":1,"Doc":"Error. Fail immediately. This is primarily a fencepost against accidental zero bytes getting compiled into programs.","Groups":["Flow Control"]},{"Opcode":1,"Name":"sha256","Args":"B","Returns":"B","Cost":35,"Size":1,"Doc":"SHA256 hash of value X, yields [32]byte","Groups":["Arithmetic"]},{"Opcode":2,"Name":"keccak256","Args":"B","Returns":"B","Cost":130,"Size":1,"Doc":"Keccak256 hash of value X, yields [32]byte","Groups":["Arithmetic"]},{"Opcode":3,"Name":"sha512_256","Args":"B","Returns":"B","Cost":45,"Size":1,"Doc":"SHA512_256 hash of value X, yields [32]byte","Groups":["Arithmetic"]},{"Opcode":4,"Name":"ed25519verify","Args":"BBB","Returns":"U","Cost":1900,"Size":1,"Doc":"for (data A, signature B, pubkey C) verify the signature of (\\"ProgData\\" || program_hash || data) against the pubkey => {0 or 1}","DocExtra":"The 32 byte public key is the last element on the stack, preceded by the 64 byte signature at the second-to-last element on the stack, preceded by the data which was signed at the third-to-last element on the stack.","Groups":["Arithmetic"]},{"Opcode":5,"Name":"ecdsa_verify","Args":"BBBBB","Returns":"U","Cost":1700,"Size":2,"Doc":"for (data A, signature B, C and pubkey D, E) verify the signature of the data against the pubkey => {0 or 1}","DocExtra":"The 32 byte Y-component of a public key is the last element on the stack, preceded by X-component of a pubkey, preceded by S and R components of a signature, preceded by the data that is fifth element on the stack. All values are big-endian encoded. The signed data must be 32 bytes long, and signatures in lower-S form are only accepted.","ImmediateNote":"{uint8 curve index}","Groups":["Arithmetic"]},{"Opcode":6,"Name":"ecdsa_pk_decompress","Args":"B","Returns":"BB","Cost":650,"Size":2,"Doc":"decompress pubkey A into components X, Y => [*... stack*, X, Y]","DocExtra":"The 33 byte public key in a compressed form to be decompressed into X and Y (top) components. All values are big-endian encoded.","ImmediateNote":"{uint8 curve index}","Groups":["Arithmetic"]},{"Opcode":7,"Name":"ecdsa_pk_recover","Args":"BUBB","Returns":"BB","Cost":2000,"Size":2,"Doc":"for (data A, recovery id B, signature C, D) recover a public key => [*... stack*, X, Y]","DocExtra":"S (top) and R elements of a signature, recovery id and data (bottom) are expected on the stack and used to deriver a public key. All values are big-endian encoded. The signed data must be 32 bytes long.","ImmediateNote":"{uint8 curve index}","Groups":["Arithmetic"]},{"Opcode":8,"Name":"+","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A plus B. Fail on overflow.","DocExtra":"Overflow is an error condition which halts execution and fails the transaction. Full precision is available from `addw`.","Groups":["Arithmetic"]},{"Opcode":9,"Name":"-","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A minus B. Fail if B > A.","Groups":["Arithmetic"]},{"Opcode":10,"Name":"/","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A divided by B (truncated division). Fail if B == 0.","DocExtra":"`divmodw` is available to divide the two-element values produced by `mulw` and `addw`.","Groups":["Arithmetic"]},{"Opcode":11,"Name":"*","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A times B. Fail on overflow.","DocExtra":"Overflow is an error condition which halts execution and fails the transaction. Full precision is available from `mulw`.","Groups":["Arithmetic"]},{"Opcode":12,"Name":"<","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A less than B => {0 or 1}","Groups":["Arithmetic"]},{"Opcode":13,"Name":">","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A greater than B => {0 or 1}","Groups":["Arithmetic"]},{"Opcode":14,"Name":"<=","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A less than or equal to B => {0 or 1}","Groups":["Arithmetic"]},{"Opcode":15,"Name":">=","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A greater than or equal to B => {0 or 1}","Groups":["Arithmetic"]},{"Opcode":16,"Name":"&&","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A is not zero and B is not zero => {0 or 1}","Groups":["Arithmetic"]},{"Opcode":17,"Name":"||","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A is not zero or B is not zero => {0 or 1}","Groups":["Arithmetic"]},{"Opcode":18,"Name":"==","Args":"..","Returns":"U","Cost":1,"Size":1,"Doc":"A is equal to B => {0 or 1}","Groups":["Arithmetic"]},{"Opcode":19,"Name":"!=","Args":"..","Returns":"U","Cost":1,"Size":1,"Doc":"A is not equal to B => {0 or 1}","Groups":["Arithmetic"]},{"Opcode":20,"Name":"!","Args":"U","Returns":"U","Cost":1,"Size":1,"Doc":"X == 0 yields 1; else 0","Groups":["Arithmetic"]},{"Opcode":21,"Name":"len","Args":"B","Returns":"U","Cost":1,"Size":1,"Doc":"yields length of byte value X","Groups":["Arithmetic"]},{"Opcode":22,"Name":"itob","Args":"U","Returns":"B","Cost":1,"Size":1,"Doc":"converts uint64 X to big endian bytes","Groups":["Arithmetic"]},{"Opcode":23,"Name":"btoi","Args":"B","Returns":"U","Cost":1,"Size":1,"Doc":"converts bytes X as big endian to uint64","DocExtra":"`btoi` fails if the input is longer than 8 bytes.","Groups":["Arithmetic"]},{"Opcode":24,"Name":"%","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A modulo B. Fail if B == 0.","Groups":["Arithmetic"]},{"Opcode":25,"Name":"|","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A bitwise-or B","Groups":["Arithmetic"]},{"Opcode":26,"Name":"&","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A bitwise-and B","Groups":["Arithmetic"]},{"Opcode":27,"Name":"^","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A bitwise-xor B","Groups":["Arithmetic"]},{"Opcode":28,"Name":"~","Args":"U","Returns":"U","Cost":1,"Size":1,"Doc":"bitwise invert value X","Groups":["Arithmetic"]},{"Opcode":29,"Name":"mulw","Args":"UU","Returns":"UU","Cost":1,"Size":1,"Doc":"A times B out to 128-bit long result as low (top) and high uint64 values on the stack","Groups":["Arithmetic"]},{"Opcode":30,"Name":"addw","Args":"UU","Returns":"UU","Cost":1,"Size":1,"Doc":"A plus B out to 128-bit long result as sum (top) and carry-bit uint64 values on the stack","Groups":["Arithmetic"]},{"Opcode":31,"Name":"divmodw","Args":"UUUU","Returns":"UUUU","Cost":20,"Size":1,"Doc":"Pop four uint64 values.  The deepest two are interpreted as a uint128 dividend (deepest value is high word), the top two are interpreted as a uint128 divisor.  Four uint64 values are pushed to the stack. The deepest two are the quotient (deeper value is the high uint64). The top two are the remainder, low bits on top.","Groups":["Arithmetic"]},{"Opcode":32,"Name":"intcblock","Cost":1,"Size":0,"Doc":"prepare block of uint64 constants for use by intc","DocExtra":"`intcblock` loads following program bytes into an array of integer constants in the evaluator. These integer constants can be referred to by `intc` and `intc_*` which will push the value onto the stack. Subsequent calls to `intcblock` reset and replace the integer constants available to the script.","ImmediateNote":"{varuint length} [{varuint value}, ...]","Groups":["Loading Values"]},{"Opcode":33,"Name":"intc","Returns":"U","Cost":1,"Size":2,"Doc":"push Ith constant from intcblock to stack","ImmediateNote":"{uint8 int constant index}","Groups":["Loading Values"]},{"Opcode":34,"Name":"intc_0","Returns":"U","Cost":1,"Size":1,"Doc":"push constant 0 from intcblock to stack","Groups":["Loading Values"]},{"Opcode":35,"Name":"intc_1","Returns":"U","Cost":1,"Size":1,"Doc":"push constant 1 from intcblock to stack","Groups":["Loading Values"]},{"Opcode":36,"Name":"intc_2","Returns":"U","Cost":1,"Size":1,"Doc":"push constant 2 from intcblock to stack","Groups":["Loading Values"]},{"Opcode":37,"Name":"intc_3","Returns":"U","Cost":1,"Size":1,"Doc":"push constant 3 from intcblock to stack","Groups":["Loading Values"]},{"Opcode":38,"Name":"bytecblock","Cost":1,"Size":0,"Doc":"prepare block of byte-array constants for use by bytec","DocExtra":"`bytecblock` loads the following program bytes into an array of byte-array constants in the evaluator. These constants can be referred to by `bytec` and `bytec_*` which will push the value onto the stack. Subsequent calls to `bytecblock` reset and replace the bytes constants available to the script.","ImmediateNote":"{varuint length} [({varuint value length} bytes), ...]","Groups":["Loading Values"]},{"Opcode":39,"Name":"bytec","Returns":"B","Cost":1,"Size":2,"Doc":"push Ith constant from bytecblock to stack","ImmediateNote":"{uint8 byte constant index}","Groups":["Loading Values"]},{"Opcode":40,"Name":"bytec_0","Returns":"B","Cost":1,"Size":1,"Doc":"push constant 0 from bytecblock to stack","Groups":["Loading Values"]},{"Opcode":41,"Name":"bytec_1","Returns":"B","Cost":1,"Size":1,"Doc":"push constant 1 from bytecblock to stack","Groups":["Loading Values"]},{"Opcode":42,"Name":"bytec_2","Returns":"B","Cost":1,"Size":1,"Doc":"push constant 2 from bytecblock to stack","Groups":["Loading Values"]},{"Opcode":43,"Name":"bytec_3","Returns":"B","Cost":1,"Size":1,"Doc":"push constant 3 from bytecblock to stack","Groups":["Loading Values"]},{"Opcode":44,"Name":"arg","Returns":"B","Cost":1,"Size":2,"Doc":"push Nth LogicSig argument to stack","ImmediateNote":"{uint8 arg index N}","Groups":["Loading Values"]},{"Opcode":45,"Name":"arg_0","Returns":"B","Cost":1,"Size":1,"Doc":"push LogicSig argument 0 to stack","Groups":["Loading Values"]},{"Opcode":46,"Name":"arg_1","Returns":"B","Cost":1,"Size":1,"Doc":"push LogicSig argument 1 to stack","Groups":["Loading Values"]},{"Opcode":47,"Name":"arg_2","Returns":"B","Cost":1,"Size":1,"Doc":"push LogicSig argument 2 to stack","Groups":["Loading Values"]},{"Opcode":48,"Name":"arg_3","Returns":"B","Cost":1,"Size":1,"Doc":"push LogicSig argument 3 to stack","Groups":["Loading Values"]},{"Opcode":49,"Name":"txn","Returns":".","Cost":1,"Size":2,"ArgEnum":["Sender","Fee","FirstValid","FirstValidTime","LastValid","Note","Lease","Receiver","Amount","CloseRemainderTo","VotePK","SelectionPK","VoteFirst","VoteLast","VoteKeyDilution","Type","TypeEnum","XferAsset","AssetAmount","AssetSender","AssetReceiver","AssetCloseTo","GroupIndex","TxID","ApplicationID","OnCompletion","ApplicationArgs","NumAppArgs","Accounts","NumAccounts","ApprovalProgram","ClearStateProgram","RekeyTo","ConfigAsset","ConfigAssetTotal","ConfigAssetDecimals","ConfigAssetDefaultFrozen","ConfigAssetUnitName","ConfigAssetName","ConfigAssetURL","ConfigAssetMetadataHash","ConfigAssetManager","ConfigAssetReserve","ConfigAssetFreeze","ConfigAssetClawback","FreezeAsset","FreezeAssetAccount","FreezeAssetFrozen","Assets","NumAssets","Applications","NumApplications","GlobalNumUint","GlobalNumByteSlice","LocalNumUint","LocalNumByteSlice","ExtraProgramPages","Nonparticipation","Logs","NumLogs","CreatedAssetID","CreatedApplicationID"],"ArgEnumTypes":"BUUUUBBBUBBBUUUBUUUBBBUBUUBUBUBBBUUUUBBBBBBBBUBUUUUUUUUUUUBUUU","Doc":"push field F of current transaction to stack","DocExtra":"FirstValidTime causes the program to fail. The field is reserved for future use.","ImmediateNote":"{uint8 transaction field index}","Groups":["Loading Values"]},{"Opcode":50,"Name":"global","Returns":".","Cost":1,"Size":2,"ArgEnum":["MinTxnFee","MinBalance","MaxTxnLife","ZeroAddress","GroupSize","LogicSigVersion","Round","LatestTimestamp","CurrentApplicationID","CreatorAddress","CurrentApplicationAddress","GroupID"],"ArgEnumTypes":"UUUBUUUUUBBB","Doc":"push value from globals to stack","ImmediateNote":"{uint8 global field index}","Groups":["Loading Values"]},{"Opcode":51,"Name":"gtxn","Returns":".","Cost":1,"Size":3,"ArgEnum":["Sender","Fee","FirstValid","FirstValidTime","LastValid","Note","Lease","Receiver","Amount","CloseRemainderTo","VotePK","SelectionPK","VoteFirst","VoteLast","VoteKeyDilution","Type","TypeEnum","XferAsset","AssetAmount","AssetSender","AssetReceiver","AssetCloseTo","GroupIndex","TxID","ApplicationID","OnCompletion","ApplicationArgs","NumAppArgs","Accounts","NumAccounts","ApprovalProgram","ClearStateProgram","RekeyTo","ConfigAsset","ConfigAssetTotal","ConfigAssetDecimals","ConfigAssetDefaultFrozen","ConfigAssetUnitName","ConfigAssetName","ConfigAssetURL","ConfigAssetMetadataHash","ConfigAssetManager","ConfigAssetReserve","ConfigAssetFreeze","ConfigAssetClawback","FreezeAsset","FreezeAssetAccount","FreezeAssetFrozen","Assets","NumAssets","Applications","NumApplications","GlobalNumUint","GlobalNumByteSlice","LocalNumUint","LocalNumByteSlice","ExtraProgramPages","Nonparticipation","Logs","NumLogs","CreatedAssetID","CreatedApplicationID"],"ArgEnumTypes":"BUUUUBBBUBBBUUUBUUUBBBUBUUBUBUBBBUUUUBBBBBBBBUBUUUUUUUUUUUBUUU","Doc":"push field F of the Tth transaction in the current group","DocExtra":"for notes on transaction fields available, see `txn`. If this transaction is _i_ in the group, `gtxn i field` is equivalent to `txn field`.","ImmediateNote":"{uint8 transaction group index} {uint8 transaction field index}","Groups":["Loading Values"]},{"Opcode":52,"Name":"load","Returns":".","Cost":1,"Size":2,"Doc":"copy a value from scratch space to the stack. All scratch spaces are 0 at program start.","ImmediateNote":"{uint8 position in scratch space to load from}","Groups":["Loading Values"]},{"Opcode":53,"Name":"store","Args":".","Cost":1,"Size":2,"Doc":"pop value X. store X to the Ith scratch space","ImmediateNote":"{uint8 position in scratch space to store to}","Groups":["Loading Values"]},{"Opcode":54,"Name":"txna","Returns":".","Cost":1,"Size":3,"ArgEnum":["ApplicationArgs","Accounts","Assets","Applications","Logs"],"ArgEnumTypes":"BBUUB","Doc":"push Ith value of the array field F of the current transaction","ImmediateNote":"{uint8 transaction field index} {uint8 transaction field array index}","Groups":["Loading Values"]},{"Opcode":55,"Name":"gtxna","Returns":".","Cost":1,"Size":4,"ArgEnum":["ApplicationArgs","Accounts","Assets","Applications","Logs"],"ArgEnumTypes":"BBUUB","Doc":"push Ith value of the array field F from the Tth transaction in the current group","ImmediateNote":"{uint8 transaction group index} {uint8 transaction field index} {uint8 transaction field array index}","Groups":["Loading Values"]},{"Opcode":56,"Name":"gtxns","Args":"U","Returns":".","Cost":1,"Size":2,"ArgEnum":["Sender","Fee","FirstValid","FirstValidTime","LastValid","Note","Lease","Receiver","Amount","CloseRemainderTo","VotePK","SelectionPK","VoteFirst","VoteLast","VoteKeyDilution","Type","TypeEnum","XferAsset","AssetAmount","AssetSender","AssetReceiver","AssetCloseTo","GroupIndex","TxID","ApplicationID","OnCompletion","ApplicationArgs","NumAppArgs","Accounts","NumAccounts","ApprovalProgram","ClearStateProgram","RekeyTo","ConfigAsset","ConfigAssetTotal","ConfigAssetDecimals","ConfigAssetDefaultFrozen","ConfigAssetUnitName","ConfigAssetName","ConfigAssetURL","ConfigAssetMetadataHash","ConfigAssetManager","ConfigAssetReserve","ConfigAssetFreeze","ConfigAssetClawback","FreezeAsset","FreezeAssetAccount","FreezeAssetFrozen","Assets","NumAssets","Applications","NumApplications","GlobalNumUint","GlobalNumByteSlice","LocalNumUint","LocalNumByteSlice","ExtraProgramPages","Nonparticipation","Logs","NumLogs","CreatedAssetID","CreatedApplicationID"],"ArgEnumTypes":"BUUUUBBBUBBBUUUBUUUBBBUBUUBUBUBBBUUUUBBBBBBBBUBUUUUUUUUUUUBUUU","Doc":"push field F of the Xth transaction in the current group","DocExtra":"for notes on transaction fields available, see `txn`. If top of stack is _i_, `gtxns field` is equivalent to `gtxn _i_ field`. gtxns exists so that _i_ can be calculated, often based on the index of the current transaction.","ImmediateNote":"{uint8 transaction field index}","Groups":["Loading Values"]},{"Opcode":57,"Name":"gtxnsa","Args":"U","Returns":".","Cost":1,"Size":3,"ArgEnum":["ApplicationArgs","Accounts","Assets","Applications","Logs"],"ArgEnumTypes":"BBUUB","Doc":"push Ith value of the array field F from the Xth transaction in the current group","ImmediateNote":"{uint8 transaction field index} {uint8 transaction field array index}","Groups":["Loading Values"]},{"Opcode":58,"Name":"gload","Returns":".","Cost":1,"Size":3,"Doc":"push Ith scratch space index of the Tth transaction in the current group","DocExtra":"`gload` fails unless the requested transaction is an ApplicationCall and T < GroupIndex.","ImmediateNote":"{uint8 transaction group index} {uint8 position in scratch space to load from}","Groups":["Loading Values"]},{"Opcode":59,"Name":"gloads","Args":"U","Returns":".","Cost":1,"Size":2,"Doc":"push Ith scratch space index of the Xth transaction in the current group","DocExtra":"`gloads` fails unless the requested transaction is an ApplicationCall and X < GroupIndex.","ImmediateNote":"{uint8 position in scratch space to load from}","Groups":["Loading Values"]},{"Opcode":60,"Name":"gaid","Returns":"U","Cost":1,"Size":2,"Doc":"push the ID of the asset or application created in the Tth transaction of the current group","DocExtra":"`gaid` fails unless the requested transaction created an asset or application and T < GroupIndex.","ImmediateNote":"{uint8 transaction group index}","Groups":["Loading Values"]},{"Opcode":61,"Name":"gaids","Args":"U","Returns":"U","Cost":1,"Size":1,"Doc":"push the ID of the asset or application created in the Xth transaction of the current group","DocExtra":"`gaids` fails unless the requested transaction created an asset or application and X < GroupIndex.","Groups":["Loading Values"]},{"Opcode":62,"Name":"loads","Args":"U","Returns":".","Cost":1,"Size":1,"Doc":"copy a value from the Xth scratch space to the stack.  All scratch spaces are 0 at program start.","Groups":["Loading Values"]},{"Opcode":63,"Name":"stores","Args":"U.","Cost":1,"Size":1,"Doc":"pop indexes A and B. store B to the Ath scratch space","Groups":["Loading Values"]},{"Opcode":64,"Name":"bnz","Args":"U","Cost":1,"Size":3,"Doc":"branch to TARGET if value X is not zero","DocExtra":"The `bnz` instruction opcode 0x40 is followed by two immediate data bytes which are a high byte first and low byte second which together form a 16 bit offset which the instruction may branch to. For a bnz instruction at `pc`, if the last element of the stack is not zero then branch to instruction at `pc + 3 + N`, else proceed to next instruction at `pc + 3`. Branch targets must be aligned instructions. (e.g. Branching to the second byte of a 2 byte op will be rejected.) Starting at v4, the offset is treated as a signed 16 bit integer allowing for backward branches and looping. In prior version (v1 to v3), branch offsets are limited to forward branches only, 0-0x7fff.\\n\\nAt v2 it became allowed to branch to the end of the program exactly after the last instruction: bnz to byte N (with 0-indexing) was illegal for a TEAL program with N bytes before v2, and is legal after it. This change eliminates the need for a last instruction of no-op as a branch target at the end. (Branching beyond the end--in other words, to a byte larger than N--is still illegal and will cause the program to fail.)","ImmediateNote":"{int16 branch offset, big endian}","Groups":["Flow Control"]},{"Opcode":65,"Name":"bz","Args":"U","Cost":1,"Size":3,"Doc":"branch to TARGET if value X is zero","DocExtra":"See `bnz` for details on how branches work. `bz` inverts the behavior of `bnz`.","ImmediateNote":"{int16 branch offset, big endian}","Groups":["Flow Control"]},{"Opcode":66,"Name":"b","Cost":1,"Size":3,"Doc":"branch unconditionally to TARGET","DocExtra":"See `bnz` for details on how branches work. `b` always jumps to the offset.","ImmediateNote":"{int16 branch offset, big endian}","Groups":["Flow Control"]},{"Opcode":67,"Name":"return","Args":"U","Cost":1,"Size":1,"Doc":"use last value on stack as success value; end","Groups":["Flow Control"]},{"Opcode":68,"Name":"assert","Args":"U","Cost":1,"Size":1,"Doc":"immediately fail unless value X is a non-zero number","Groups":["Flow Control"]},{"Opcode":72,"Name":"pop","Args":".","Cost":1,"Size":1,"Doc":"discard value X from stack","Groups":["Flow Control"]},{"Opcode":73,"Name":"dup","Args":".","Returns":"..","Cost":1,"Size":1,"Doc":"duplicate last value on stack","Groups":["Flow Control"]},{"Opcode":74,"Name":"dup2","Args":"..","Returns":"....","Cost":1,"Size":1,"Doc":"duplicate two last values on stack: A, B -> A, B, A, B","Groups":["Flow Control"]},{"Opcode":75,"Name":"dig","Args":".","Returns":"..","Cost":1,"Size":2,"Doc":"push the Nth value from the top of the stack. dig 0 is equivalent to dup","ImmediateNote":"{uint8 depth}","Groups":["Flow Control"]},{"Opcode":76,"Name":"swap","Args":"..","Returns":"..","Cost":1,"Size":1,"Doc":"swaps two last values on stack: A, B -> B, A","Groups":["Flow Control"]},{"Opcode":77,"Name":"select","Args":"..U","Returns":".","Cost":1,"Size":1,"Doc":"selects one of two values based on top-of-stack: A, B, C -> (if C != 0 then B else A)","Groups":["Flow Control"]},{"Opcode":78,"Name":"cover","Args":".","Returns":".","Cost":1,"Size":2,"Doc":"remove top of stack, and place it deeper in the stack such that N elements are above it. Fails if stack depth <= N.","ImmediateNote":"{uint8 depth}","Groups":["Flow Control"]},{"Opcode":79,"Name":"uncover","Args":".","Returns":".","Cost":1,"Size":2,"Doc":"remove the value at depth N in the stack and shift above items down so the Nth deep value is on top of the stack. Fails if stack depth <= N.","ImmediateNote":"{uint8 depth}","Groups":["Flow Control"]},{"Opcode":80,"Name":"concat","Args":"BB","Returns":"B","Cost":1,"Size":1,"Doc":"pop two byte-arrays A and B and join them, push the result","DocExtra":"`concat` fails if the result would be greater than 4096 bytes.","Groups":["Arithmetic"]},{"Opcode":81,"Name":"substring","Args":"B","Returns":"B","Cost":1,"Size":3,"Doc":"pop a byte-array A. For immediate values in 0..255 S and E: extract a range of bytes from A starting at S up to but not including E, push the substring result. If E < S, or either is larger than the array length, the program fails","ImmediateNote":"{uint8 start position} {uint8 end position}","Groups":["Byte Array Slicing"]},{"Opcode":82,"Name":"substring3","Args":"BUU","Returns":"B","Cost":1,"Size":1,"Doc":"pop a byte-array A and two integers B and C. Extract a range of bytes from A starting at B up to but not including C, push the substring result. If C < B, or either is larger than the array length, the program fails","Groups":["Byte Array Slicing"]},{"Opcode":83,"Name":"getbit","Args":".U","Returns":"U","Cost":1,"Size":1,"Doc":"pop a target A (integer or byte-array), and index B. Push the Bth bit of A.","DocExtra":"see explanation of bit ordering in setbit","Groups":["Arithmetic"]},{"Opcode":84,"Name":"setbit","Args":".UU","Returns":".","Cost":1,"Size":1,"Doc":"pop a target A, index B, and bit C. Set the Bth bit of A to C, and push the result","DocExtra":"When A is a uint64, index 0 is the least significant bit. Setting bit 3 to 1 on the integer 0 yields 8, or 2^3. When A is a byte array, index 0 is the leftmost bit of the leftmost byte. Setting bits 0 through 11 to 1 in a 4-byte-array of 0s yields the byte array 0xfff00000. Setting bit 3 to 1 on the 1-byte-array 0x00 yields the byte array 0x10.","Groups":["Arithmetic"]},{"Opcode":85,"Name":"getbyte","Args":"BU","Returns":"U","Cost":1,"Size":1,"Doc":"pop a byte-array A and integer B. Extract the Bth byte of A and push it as an integer","Groups":["Arithmetic"]},{"Opcode":86,"Name":"setbyte","Args":"BUU","Returns":"B","Cost":1,"Size":1,"Doc":"pop a byte-array A, integer B, and small integer C (between 0..255). Set the Bth byte of A to C, and push the result","Groups":["Arithmetic"]},{"Opcode":87,"Name":"extract","Args":"B","Returns":"B","Cost":1,"Size":3,"Doc":"pop a byte-array A. For immediate values in 0..255 S and L: extract a range of bytes from A starting at S up to but not including S+L, push the substring result. If L is 0, then extract to the end of the string. If S or S+L is larger than the array length, the program fails","ImmediateNote":"{uint8 start position} {uint8 length}","Groups":["Byte Array Slicing"]},{"Opcode":88,"Name":"extract3","Args":"BUU","Returns":"B","Cost":1,"Size":1,"Doc":"pop a byte-array A and two integers B and C. Extract a range of bytes from A starting at B up to but not including B+C, push the substring result. If B+C is larger than the array length, the program fails","Groups":["Byte Array Slicing"]},{"Opcode":89,"Name":"extract_uint16","Args":"BU","Returns":"U","Cost":1,"Size":1,"Doc":"pop a byte-array A and integer B. Extract a range of bytes from A starting at B up to but not including B+2, convert bytes as big endian and push the uint64 result. If B+2 is larger than the array length, the program fails","Groups":["Byte Array Slicing"]},{"Opcode":90,"Name":"extract_uint32","Args":"BU","Returns":"U","Cost":1,"Size":1,"Doc":"pop a byte-array A and integer B. Extract a range of bytes from A starting at B up to but not including B+4, convert bytes as big endian and push the uint64 result. If B+4 is larger than the array length, the program fails","Groups":["Byte Array Slicing"]},{"Opcode":91,"Name":"extract_uint64","Args":"BU","Returns":"U","Cost":1,"Size":1,"Doc":"pop a byte-array A and integer B. Extract a range of bytes from A starting at B up to but not including B+8, convert bytes as big endian and push the uint64 result. If B+8 is larger than the array length, the program fails","Groups":["Byte Array Slicing"]},{"Opcode":96,"Name":"balance","Args":".","Returns":"U","Cost":1,"Size":1,"Doc":"get balance for account A, in microalgos. The balance is observed after the effects of previous transactions in the group, and after the fee for the current transaction is deducted.","DocExtra":"params: Before v4, Txn.Accounts offset. Since v4, Txn.Accounts offset or an account address that appears in Txn.Accounts or is Txn.Sender). Return: value.","Groups":["State Access"]},{"Opcode":97,"Name":"app_opted_in","Args":".U","Returns":"U","Cost":1,"Size":1,"Doc":"check if account A opted in for the application B => {0 or 1}","DocExtra":"params: Txn.Accounts offset (or, since v4, an account address that appears in Txn.Accounts or is Txn.Sender), application id (or, since v4, a Txn.ForeignApps offset). Return: 1 if opted in and 0 otherwise.","Groups":["State Access"]},{"Opcode":98,"Name":"app_local_get","Args":".B","Returns":".","Cost":1,"Size":1,"Doc":"read from account A from local state of the current application key B => value","DocExtra":"params: Txn.Accounts offset (or, since v4, an account address that appears in Txn.Accounts or is Txn.Sender), state key. Return: value. The value is zero (of type uint64) if the key does not exist.","Groups":["State Access"]},{"Opcode":99,"Name":"app_local_get_ex","Args":".UB","Returns":".U","Cost":1,"Size":1,"Doc":"read from account A from local state of the application B key C => [*... stack*, value, 0 or 1]","DocExtra":"params: Txn.Accounts offset (or, since v4, an account address that appears in Txn.Accounts or is Txn.Sender), application id (or, since v4, a Txn.ForeignApps offset), state key. Return: did_exist flag (top of the stack, 1 if the application existed and 0 otherwise), value. The value is zero (of type uint64) if the key does not exist.","Groups":["State Access"]},{"Opcode":100,"Name":"app_global_get","Args":"B","Returns":".","Cost":1,"Size":1,"Doc":"read key A from global state of a current application => value","DocExtra":"params: state key. Return: value. The value is zero (of type uint64) if the key does not exist.","Groups":["State Access"]},{"Opcode":101,"Name":"app_global_get_ex","Args":"UB","Returns":".U","Cost":1,"Size":1,"Doc":"read from application A global state key B => [*... stack*, value, 0 or 1]","DocExtra":"params: Txn.ForeignApps offset (or, since v4, an application id that appears in Txn.ForeignApps or is the CurrentApplicationID), state key. Return: did_exist flag (top of the stack, 1 if the application existed and 0 otherwise), value. The value is zero (of type uint64) if the key does not exist.","Groups":["State Access"]},{"Opcode":102,"Name":"app_local_put","Args":".B.","Cost":1,"Size":1,"Doc":"write to account specified by A to local state of a current application key B with value C","DocExtra":"params: Txn.Accounts offset (or, since v4, an account address that appears in Txn.Accounts or is Txn.Sender), state key, value.","Groups":["State Access"]},{"Opcode":103,"Name":"app_global_put","Args":"B.","Cost":1,"Size":1,"Doc":"write key A and value B to global state of the current application","Groups":["State Access"]},{"Opcode":104,"Name":"app_local_del","Args":".B","Cost":1,"Size":1,"Doc":"delete from account A local state key B of the current application","DocExtra":"params: Txn.Accounts offset (or, since v4, an account address that appears in Txn.Accounts or is Txn.Sender), state key.\\n\\nDeleting a key which is already absent has no effect on the application local state. (In particular, it does _not_ cause the program to fail.)","Groups":["State Access"]},{"Opcode":105,"Name":"app_global_del","Args":"B","Cost":1,"Size":1,"Doc":"delete key A from a global state of the current application","DocExtra":"params: state key.\\n\\nDeleting a key which is already absent has no effect on the application global state. (In particular, it does _not_ cause the program to fail.)","Groups":["State Access"]},{"Opcode":112,"Name":"asset_holding_get","Args":".U","Returns":".U","Cost":1,"Size":2,"ArgEnum":["AssetBalance","AssetFrozen"],"ArgEnumTypes":"UU","Doc":"read from account A and asset B holding field X (imm arg) => {0 or 1 (top), value}","DocExtra":"params: Txn.Accounts offset (or, since v4, an account address that appears in Txn.Accounts or is Txn.Sender), asset id (or, since v4, a Txn.ForeignAssets offset). Return: did_exist flag (1 if the asset existed and 0 otherwise), value.","ImmediateNote":"{uint8 asset holding field index}","Groups":["State Access"]},{"Opcode":113,"Name":"asset_params_get","Args":"U","Returns":".U","Cost":1,"Size":2,"ArgEnum":["AssetTotal","AssetDecimals","AssetDefaultFrozen","AssetUnitName","AssetName","AssetURL","AssetMetadataHash","AssetManager","AssetReserve","AssetFreeze","AssetClawback","AssetCreator"],"ArgEnumTypes":"UUUBBBBBBBBB","Doc":"read from asset A params field X (imm arg) => {0 or 1 (top), value}","DocExtra":"params: Before v4, Txn.ForeignAssets offset. Since v4, Txn.ForeignAssets offset or an asset id that appears in Txn.ForeignAssets. Return: did_exist flag (1 if the asset existed and 0 otherwise), value.","ImmediateNote":"{uint8 asset params field index}","Groups":["State Access"]},{"Opcode":114,"Name":"app_params_get","Args":"U","Returns":".U","Cost":1,"Size":2,"ArgEnum":["AppApprovalProgram","AppClearStateProgram","AppGlobalNumUint","AppGlobalNumByteSlice","AppLocalNumUint","AppLocalNumByteSlice","AppExtraProgramPages","AppCreator","AppAddress"],"ArgEnumTypes":"BBUUUUUBB","Doc":"read from app A params field X (imm arg) => {0 or 1 (top), value}","DocExtra":"params: Txn.ForeignApps offset or an app id that appears in Txn.ForeignApps. Return: did_exist flag (1 if the application existed and 0 otherwise), value.","ImmediateNote":"{uint8 app params field index}","Groups":["State Access"]},{"Opcode":120,"Name":"min_balance","Args":".","Returns":"U","Cost":1,"Size":1,"Doc":"get minimum required balance for account A, in microalgos. Required balance is affected by [ASA](https://developer.algorand.org/docs/features/asa/#assets-overview) and [App](https://developer.algorand.org/docs/features/asc1/stateful/#minimum-balance-requirement-for-a-smart-contract) usage. When creating or opting into an app, the minimum balance grows before the app code runs, therefore the increase is visible there. When deleting or closing out, the minimum balance decreases after the app executes.","DocExtra":"params: Before v4, Txn.Accounts offset. Since v4, Txn.Accounts offset or an account address that appears in Txn.Accounts or is Txn.Sender). Return: value.","Groups":["State Access"]},{"Opcode":128,"Name":"pushbytes","Returns":"B","Cost":1,"Size":0,"Doc":"push the following program bytes to the stack","DocExtra":"pushbytes args are not added to the bytecblock during assembly processes","ImmediateNote":"{varuint length} {bytes}","Groups":["Loading Values"]},{"Opcode":129,"Name":"pushint","Returns":"U","Cost":1,"Size":0,"Doc":"push immediate UINT to the stack as an integer","DocExtra":"pushint args are not added to the intcblock during assembly processes","ImmediateNote":"{varuint int}","Groups":["Loading Values"]},{"Opcode":136,"Name":"callsub","Cost":1,"Size":3,"Doc":"branch unconditionally to TARGET, saving the next instruction on the call stack","DocExtra":"The call stack is separate from the data stack. Only `callsub` and `retsub` manipulate it.","ImmediateNote":"{int16 branch offset, big endian}","Groups":["Flow Control"]},{"Opcode":137,"Name":"retsub","Cost":1,"Size":1,"Doc":"pop the top instruction from the call stack and branch to it","DocExtra":"The call stack is separate from the data stack. Only `callsub` and `retsub` manipulate it.","Groups":["Flow Control"]},{"Opcode":144,"Name":"shl","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A times 2^B, modulo 2^64","Groups":["Arithmetic"]},{"Opcode":145,"Name":"shr","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A divided by 2^B","Groups":["Arithmetic"]},{"Opcode":146,"Name":"sqrt","Args":"U","Returns":"U","Cost":4,"Size":1,"Doc":"The largest integer B such that B^2 <= X","Groups":["Arithmetic"]},{"Opcode":147,"Name":"bitlen","Args":".","Returns":"U","Cost":1,"Size":1,"Doc":"The highest set bit in X. If X is a byte-array, it is interpreted as a big-endian unsigned integer. bitlen of 0 is 0, bitlen of 8 is 4","DocExtra":"bitlen interprets arrays as big-endian integers, unlike setbit/getbit","Groups":["Arithmetic"]},{"Opcode":148,"Name":"exp","Args":"UU","Returns":"U","Cost":1,"Size":1,"Doc":"A raised to the Bth power. Fail if A == B == 0 and on overflow","Groups":["Arithmetic"]},{"Opcode":149,"Name":"expw","Args":"UU","Returns":"UU","Cost":10,"Size":1,"Doc":"A raised to the Bth power as a 128-bit long result as low (top) and high uint64 values on the stack. Fail if A == B == 0 or if the results exceeds 2^128-1","Groups":["Arithmetic"]},{"Opcode":160,"Name":"b+","Args":"BB","Returns":"B","Cost":10,"Size":1,"Doc":"A plus B, where A and B are byte-arrays interpreted as big-endian unsigned integers","Groups":["Byte Array Arithmetic"]},{"Opcode":161,"Name":"b-","Args":"BB","Returns":"B","Cost":10,"Size":1,"Doc":"A minus B, where A and B are byte-arrays interpreted as big-endian unsigned integers. Fail on underflow.","Groups":["Byte Array Arithmetic"]},{"Opcode":162,"Name":"b/","Args":"BB","Returns":"B","Cost":20,"Size":1,"Doc":"A divided by B (truncated division), where A and B are byte-arrays interpreted as big-endian unsigned integers. Fail if B is zero.","Groups":["Byte Array Arithmetic"]},{"Opcode":163,"Name":"b*","Args":"BB","Returns":"B","Cost":20,"Size":1,"Doc":"A times B, where A and B are byte-arrays interpreted as big-endian unsigned integers.","Groups":["Byte Array Arithmetic"]},{"Opcode":164,"Name":"b<","Args":"BB","Returns":"U","Cost":1,"Size":1,"Doc":"A is less than B, where A and B are byte-arrays interpreted as big-endian unsigned integers => { 0 or 1}","Groups":["Byte Array Arithmetic"]},{"Opcode":165,"Name":"b>","Args":"BB","Returns":"U","Cost":1,"Size":1,"Doc":"A is greater than B, where A and B are byte-arrays interpreted as big-endian unsigned integers => { 0 or 1}","Groups":["Byte Array Arithmetic"]},{"Opcode":166,"Name":"b<=","Args":"BB","Returns":"U","Cost":1,"Size":1,"Doc":"A is less than or equal to B, where A and B are byte-arrays interpreted as big-endian unsigned integers => { 0 or 1}","Groups":["Byte Array Arithmetic"]},{"Opcode":167,"Name":"b>=","Args":"BB","Returns":"U","Cost":1,"Size":1,"Doc":"A is greater than or equal to B, where A and B are byte-arrays interpreted as big-endian unsigned integers => { 0 or 1}","Groups":["Byte Array Arithmetic"]},{"Opcode":168,"Name":"b==","Args":"BB","Returns":"U","Cost":1,"Size":1,"Doc":"A is equals to B, where A and B are byte-arrays interpreted as big-endian unsigned integers => { 0 or 1}","Groups":["Byte Array Arithmetic"]},{"Opcode":169,"Name":"b!=","Args":"BB","Returns":"U","Cost":1,"Size":1,"Doc":"A is not equal to B, where A and B are byte-arrays interpreted as big-endian unsigned integers => { 0 or 1}","Groups":["Byte Array Arithmetic"]},{"Opcode":170,"Name":"b%","Args":"BB","Returns":"B","Cost":20,"Size":1,"Doc":"A modulo B, where A and B are byte-arrays interpreted as big-endian unsigned integers. Fail if B is zero.","Groups":["Byte Array Arithmetic"]},{"Opcode":171,"Name":"b|","Args":"BB","Returns":"B","Cost":6,"Size":1,"Doc":"A bitwise-or B, where A and B are byte-arrays, zero-left extended to the greater of their lengths","Groups":["Byte Array Logic"]},{"Opcode":172,"Name":"b&","Args":"BB","Returns":"B","Cost":6,"Size":1,"Doc":"A bitwise-and B, where A and B are byte-arrays, zero-left extended to the greater of their lengths","Groups":["Byte Array Logic"]},{"Opcode":173,"Name":"b^","Args":"BB","Returns":"B","Cost":6,"Size":1,"Doc":"A bitwise-xor B, where A and B are byte-arrays, zero-left extended to the greater of their lengths","Groups":["Byte Array Logic"]},{"Opcode":174,"Name":"b~","Args":"B","Returns":"B","Cost":4,"Size":1,"Doc":"X with all bits inverted","Groups":["Byte Array Logic"]},{"Opcode":175,"Name":"bzero","Args":"U","Returns":"B","Cost":1,"Size":1,"Doc":"push a byte-array of length X, containing all zero bytes","Groups":["Loading Values"]},{"Opcode":176,"Name":"log","Args":"B","Cost":1,"Size":1,"Doc":"write bytes to log state of the current application","DocExtra":"`log` fails if called more than MaxLogCalls times in a program, or if the sum of logged bytes exceeds 1024 bytes.","Groups":["State Access"]},{"Opcode":177,"Name":"itxn_begin","Cost":1,"Size":1,"Doc":"Begin preparation of a new inner transaction","DocExtra":"`itxn_begin` initializes Sender to the application address; Fee to the minimum allowable, taking into account MinTxnFee and credit from overpaying in earlier transactions; FirstValid/LastValid to the values in the top-level transaction, and all other fields to zero values.","Groups":["Inner Transactions"]},{"Opcode":178,"Name":"itxn_field","Args":".","Cost":1,"Size":2,"Doc":"Set field F of the current inner transaction to X","DocExtra":"`itxn_field` fails if X is of the wrong type for F, including a byte array of the wrong size for use as an address when F is an address field. `itxn_field` also fails if X is an account or asset that does not appear in `txn.Accounts` or `txn.ForeignAssets` of the top-level transaction. (Setting addresses in asset creation are exempted from this requirement.)","ImmediateNote":"{uint8 transaction field index}","Groups":["Inner Transactions"]},{"Opcode":179,"Name":"itxn_submit","Cost":1,"Size":1,"Doc":"Execute the current inner transaction. Fail if 16 inner transactions have already been executed, or if the transaction itself fails.","Groups":["Inner Transactions"]},{"Opcode":180,"Name":"itxn","Returns":".","Cost":1,"Size":2,"Doc":"push field F of the last inner transaction to stack","ImmediateNote":"{uint8 transaction field index}","Groups":["Inner Transactions"]},{"Opcode":181,"Name":"itxna","Returns":".","Cost":1,"Size":3,"Doc":"push Ith value of the array field F of the last inner transaction to stack","ImmediateNote":"{uint8 transaction field index} {uint8 transaction field array index}","Groups":["Inner Transactions"]},{"Opcode":192,"Name":"txnas","Args":"U","Returns":".","Cost":1,"Size":2,"ArgEnum":["ApplicationArgs","Accounts","Assets","Applications","Logs"],"ArgEnumTypes":"BBUUB","Doc":"push Xth value of the array field F of the current transaction","ImmediateNote":"{uint8 transaction field index}","Groups":["Loading Values"]},{"Opcode":193,"Name":"gtxnas","Args":"U","Returns":".","Cost":1,"Size":3,"ArgEnum":["ApplicationArgs","Accounts","Assets","Applications","Logs"],"ArgEnumTypes":"BBUUB","Doc":"push Xth value of the array field F from the Tth transaction in the current group","ImmediateNote":"{uint8 transaction group index} {uint8 transaction field index}","Groups":["Loading Values"]},{"Opcode":194,"Name":"gtxnsas","Args":"UU","Returns":".","Cost":1,"Size":2,"ArgEnum":["ApplicationArgs","Accounts","Assets","Applications","Logs"],"ArgEnumTypes":"BBUUB","Doc":"pop an index A and an index B. push Bth value of the array field F from the Ath transaction in the current group","ImmediateNote":"{uint8 transaction field index}","Groups":["Loading Values"]},{"Opcode":195,"Name":"args","Args":"U","Returns":"B","Cost":1,"Size":1,"Doc":"push Xth LogicSig argument to stack","Groups":["Loading Values"]}]}');
        var o;

        function s(e) {
          var t = 0,
              r = 0;

          for (var _n24 = 0; _n24 < e.length; _n24++) {
            var _o16 = e[_n24];
            if (_o16 < 128) return _n24 > 9 || 9 === _n24 && _o16 > 1 ? [0, -(_n24 + 1)] : [t | _o16 << r, _n24 + 1];
            t += (127 & _o16) << r, r += 7;
          }

          return [0, 0];
        }

        function i(e, t) {
          var r = 1;
          var n = s(e.slice(t + r)),
              o = n[0];
          var i = n[1];
          if (i <= 0) throw new Error("could not decode int const block size at pc=".concat(t + r));
          var a = [];
          r += i;

          for (var _n25 = 0; _n25 < o; _n25++) {
            var _s43, _s44;

            if (t + r >= e.length) throw new Error("intcblock ran past end of program");

            var _o17 = void 0;

            if ((_s43 = s(e.slice(t + r)), _s44 = _slicedToArray(_s43, 2), _o17 = _s44[0], i = _s44[1], _s43), i <= 0) throw new Error("could not decode int const[".concat(_n25, "] block size at pc=").concat(t + r));
            a.push(_o17), r += i;
          }

          return [r, a];
        }

        function a(e, t) {
          var r = 1;
          var n = s(e.slice(t + r)),
              o = n[0];
          var i = n[1];
          if (i <= 0) throw new Error("could not decode []byte const block size at pc=".concat(t + r));
          var a = [];
          r += i;

          for (var _n26 = 0; _n26 < o; _n26++) {
            var _s45, _s46;

            if (t + r >= e.length) throw new Error("bytecblock ran past end of program");

            var _o18 = void 0;

            if ((_s45 = s(e.slice(t + r)), _s46 = _slicedToArray(_s45, 2), _o18 = _s46[0], i = _s46[1], _s45), i <= 0) throw new Error("could not decode []byte] const[".concat(_n26, "] block size at pc=").concat(t + r));
            if (r += i, t + r + _o18 > e.length) throw new Error("bytecblock ran past end of program");

            var _c6 = e.slice(t + r, t + r + _o18);

            a.push(_c6), r += _o18;
          }

          return [r, a];
        }

        function c(e, t) {
          var r = 1;

          var _s47 = s(e.slice(t + r)),
              _s48 = _slicedToArray(_s47, 2),
              n = _s48[0],
              o = _s48[1];

          if (o <= 0) throw new Error("could not decode push int const at pc=".concat(t + r));
          return r += o, [r, n];
        }

        function u(e, t) {
          var r = 1;

          var _s49 = s(e.slice(t + r)),
              _s50 = _slicedToArray(_s49, 2),
              n = _s50[0],
              o = _s50[1];

          if (o <= 0) throw new Error("could not decode push []byte const size at pc=".concat(t + r));
          if (r += o, t + r + n > e.length) throw new Error("pushbytes ran past end of program");
          var i = e.slice(t + r, t + r + n);
          return r += n, [r, i];
        }

        function l(e, t) {
          if (!e) throw new Error("empty program");
          if (void 0 === t && (t = []), !Array.isArray(t)) throw new Error("invalid arguments");

          var _s51 = s(e),
              _s52 = _slicedToArray(_s51, 2),
              r = _s52[0],
              l = _s52[1];

          if (l <= 0) throw new Error("version parsing error");
          if (r > n.z_) throw new Error("unsupported version");
          var h = 0,
              p = e.length;

          var _iterator9 = _createForOfIteratorHelper(t),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var _e40 = _step9.value;
              p += _e40.length;
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }

          if (p > 1e3) throw new Error("program too long");

          if (!o) {
            o = {};

            var _iterator10 = _createForOfIteratorHelper(n.AP),
                _step10;

            try {
              for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                var _e39 = _step10.value;
                o[_e39.Opcode] = _e39;
              }
            } catch (err) {
              _iterator10.e(err);
            } finally {
              _iterator10.f();
            }
          }

          var f = l,
              d = [],
              g = [];

          for (; f < e.length;) {
            var _t40 = o[e[f]];
            if (void 0 === _t40) throw new Error("invalid instruction");
            h += _t40.Cost;
            var _r32 = _t40.Size;
            if (0 === _r32) switch (_t40.Opcode) {
              case 32:
                {
                  var _i17, _i18;

                  var _t41 = void 0;

                  (_i17 = i(e, f), _i18 = _slicedToArray(_i17, 2), _r32 = _i18[0], _t41 = _i18[1], _i17), d = d.concat(_t41);
                  break;
                }

              case 38:
                {
                  var _a6, _a7;

                  var _t42 = void 0;

                  (_a6 = a(e, f), _a7 = _slicedToArray(_a6, 2), _r32 = _a7[0], _t42 = _a7[1], _a6), g = g.concat(_t42);
                  break;
                }

              case 129:
                {
                  var _c7, _c8;

                  var _t43 = void 0;

                  (_c7 = c(e, f), _c8 = _slicedToArray(_c7, 2), _r32 = _c8[0], _t43 = _c8[1], _c7), d.push(_t43);
                  break;
                }

              case 128:
                {
                  var _u2, _u3;

                  var _t44 = void 0;

                  (_u2 = u(e, f), _u3 = _slicedToArray(_u2, 2), _r32 = _u3[0], _t44 = _u3[1], _u2), g.push(_t44);
                  break;
                }

              default:
                throw new Error("invalid instruction");
            }
            f += _r32;
          }

          if (r < 4 && h > 2e4) throw new Error("program too costly for Teal version < 4. consider using v4.");
          return [d, g, !0];
        }

        function h(e, t) {
          var _l = l(e, t),
              _l2 = _slicedToArray(_l, 3),
              r = _l2[2];

          return r;
        }

        function p(e, t) {
          var _i19 = i(e, t),
              _i20 = _slicedToArray(_i19, 1),
              r = _i20[0];

          return r;
        }

        function f(e, t) {
          var _a8 = a(e, t),
              _a9 = _slicedToArray(_a8, 1),
              r = _a9[0];

          return r;
        }

        function d(e, t) {
          var _c9 = c(e, t),
              _c10 = _slicedToArray(_c9, 1),
              r = _c10[0];

          return r;
        }

        function g(e, t) {
          var _u4 = u(e, t),
              _u5 = _slicedToArray(_u4, 1),
              r = _u5[0];

          return r;
        }

        var y = n.z_,
            m = n.BV;
      },
      8800: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          LogicSig: function LogicSig() {
            return h;
          },
          LogicSigAccount: function LogicSigAccount() {
            return p;
          },
          makeLogicSig: function makeLogicSig() {
            return f;
          },
          signLogicSigTransactionObject: function signLogicSigTransactionObject() {
            return d;
          },
          signLogicSigTransaction: function signLogicSigTransaction() {
            return g;
          },
          logicSigFromByte: function logicSigFromByte() {
            return y;
          },
          tealSign: function tealSign() {
            return b;
          },
          tealSignFromProgram: function tealSignFromProgram() {
            return w;
          }
        });
        var n = r(9404),
            o = r(7116),
            s = r(3033),
            i = r(5583),
            a = r(4158),
            c = r(413),
            u = r(9417),
            l = r(2486).Buffer;

        var h = /*#__PURE__*/function () {
          function h(e, t) {
            _classCallCheck(this, h);

            if (this.tag = l.from("Program"), t && (!Array.isArray(t) || !t.every(function (e) {
              return e.constructor === Uint8Array || l.isBuffer(e);
            }))) throw new TypeError("Invalid arguments");
            var r;
            if (null != t && (r = t.map(function (e) {
              return new Uint8Array(e);
            })), !i.checkProgram(e, r)) throw new Error("Invalid program");
            this.logic = e, this.args = r, this.sig = void 0, this.msig = void 0;
          }

          _createClass(h, [{
            key: "get_obj_for_encoding",
            value: function get_obj_for_encoding() {
              var e = {
                l: this.logic
              };
              return this.args && (e.arg = this.args), this.sig ? e.sig = this.sig : this.msig && (e.msig = this.msig), e;
            }
          }, {
            key: "verify",
            value: function verify(e) {
              if (this.sig && this.msig) return !1;

              try {
                i.checkProgram(this.logic, this.args);
              } catch (e) {
                return !1;
              }

              var t = c.concatArrays(this.tag, this.logic);

              if (!this.sig && !this.msig) {
                var _r33 = n.genericHash(t);

                return c.arrayEqual(_r33, e);
              }

              return this.sig ? n.verify(t, this.sig, e) : (0, a.F2)(t, this.msig, e);
            }
          }, {
            key: "address",
            value: function address() {
              var e = c.concatArrays(this.tag, this.logic),
                  t = n.genericHash(e);
              return o.encodeAddress(new Uint8Array(t));
            }
          }, {
            key: "sign",
            value: function sign(e, t) {
              if (null == t) this.sig = this.signProgram(e);else {
                var _r34 = t.addrs.map(function (e) {
                  return {
                    pk: o.decodeAddress(e).publicKey
                  };
                });

                this.msig = {
                  v: t.version,
                  thr: t.threshold,
                  subsig: _r34
                };

                var _this$singleSignMulti = this.singleSignMultisig(e, this.msig),
                    _this$singleSignMulti2 = _slicedToArray(_this$singleSignMulti, 2),
                    _n27 = _this$singleSignMulti2[0],
                    _s53 = _this$singleSignMulti2[1];

                this.msig.subsig[_s53].s = _n27;
              }
            }
          }, {
            key: "appendToMultisig",
            value: function appendToMultisig(e) {
              if (void 0 === this.msig) throw new Error("no multisig present");

              var _this$singleSignMulti3 = this.singleSignMultisig(e, this.msig),
                  _this$singleSignMulti4 = _slicedToArray(_this$singleSignMulti3, 2),
                  t = _this$singleSignMulti4[0],
                  r = _this$singleSignMulti4[1];

              this.msig.subsig[r].s = t;
            }
          }, {
            key: "signProgram",
            value: function signProgram(e) {
              var t = c.concatArrays(this.tag, this.logic);
              return n.sign(t, e);
            }
          }, {
            key: "singleSignMultisig",
            value: function singleSignMultisig(e, t) {
              var r = -1;
              var o = n.keyPairFromSecretKey(e).publicKey;

              for (var _e41 = 0; _e41 < t.subsig.length; _e41++) {
                var _n28 = t.subsig[_e41].pk;

                if (c.arrayEqual(_n28, o)) {
                  r = _e41;
                  break;
                }
              }

              if (-1 === r) throw new Error("invalid secret key");
              return [this.signProgram(e), r];
            }
          }, {
            key: "toByte",
            value: function toByte() {
              return s.encode(this.get_obj_for_encoding());
            }
          }], [{
            key: "from_obj_for_encoding",
            value: function from_obj_for_encoding(e) {
              var t = new h(e.l, e.arg);
              return t.sig = e.sig, t.msig = e.msig, t;
            }
          }, {
            key: "fromByte",
            value: function fromByte(e) {
              var t = s.decode(e);
              return h.from_obj_for_encoding(t);
            }
          }]);

          return h;
        }();

        var p = /*#__PURE__*/function () {
          function p(e, t) {
            _classCallCheck(this, p);

            this.lsig = new h(e, t), this.sigkey = void 0;
          }

          _createClass(p, [{
            key: "get_obj_for_encoding",
            value: function get_obj_for_encoding() {
              var e = {
                lsig: this.lsig.get_obj_for_encoding()
              };
              return this.sigkey && (e.sigkey = this.sigkey), e;
            }
          }, {
            key: "toByte",
            value: function toByte() {
              return s.encode(this.get_obj_for_encoding());
            }
          }, {
            key: "isDelegated",
            value: function isDelegated() {
              return !(!this.lsig.sig && !this.lsig.msig);
            }
          }, {
            key: "verify",
            value: function verify() {
              var e = this.address();
              return this.lsig.verify(o.decodeAddress(e).publicKey);
            }
          }, {
            key: "address",
            value: function address() {
              if (this.lsig.sig && this.lsig.msig) throw new Error("LogicSig has too many signatures. At most one of sig or msig may be present");

              if (this.lsig.sig) {
                if (!this.sigkey) throw new Error("Signing key for delegated account is missing");
                return o.encodeAddress(this.sigkey);
              }

              if (this.lsig.msig) {
                var _e42 = {
                  version: this.lsig.msig.v,
                  threshold: this.lsig.msig.thr,
                  pks: this.lsig.msig.subsig.map(function (e) {
                    return e.pk;
                  })
                };
                return o.encodeAddress(o.fromMultisigPreImg(_e42));
              }

              return this.lsig.address();
            }
          }, {
            key: "signMultisig",
            value: function signMultisig(e, t) {
              this.lsig.sign(t, e);
            }
          }, {
            key: "appendToMultisig",
            value: function appendToMultisig(e) {
              this.lsig.appendToMultisig(e);
            }
          }, {
            key: "sign",
            value: function sign(e) {
              this.lsig.sign(e), this.sigkey = n.keyPairFromSecretKey(e).publicKey;
            }
          }], [{
            key: "from_obj_for_encoding",
            value: function from_obj_for_encoding(e) {
              var t = new p(e.lsig.l, e.lsig.arg);
              return t.lsig = h.from_obj_for_encoding(e.lsig), t.sigkey = e.sigkey, t;
            }
          }, {
            key: "fromByte",
            value: function fromByte(e) {
              var t = s.decode(e);
              return p.from_obj_for_encoding(t);
            }
          }]);

          return p;
        }();

        function f(e, t) {
          return new h(e, t);
        }

        function d(e, t) {
          var r, i;
          if (t instanceof p) r = t.lsig, i = o.decodeAddress(t.address()).publicKey;else if (r = t, r.sig) i = e.from.publicKey;else if (r.msig) {
            var _e43 = {
              version: r.msig.v,
              threshold: r.msig.thr,
              pks: r.msig.subsig.map(function (e) {
                return e.pk;
              })
            };
            i = o.fromMultisigPreImg(_e43);
          } else i = o.decodeAddress(r.address()).publicKey;
          return function (e, t, r) {
            if (!t.verify(r)) throw new Error("Logic signature verification failed. Ensure the program and signature are valid.");
            var o = {
              lsig: t.get_obj_for_encoding(),
              txn: e.get_obj_for_encoding()
            };
            return n.bytesEqual(r, e.from.publicKey) || (o.sgnr = l.from(r)), {
              txID: e.txID().toString(),
              blob: s.encode(o)
            };
          }(e, r, i);
        }

        function g(e, t) {
          return d(u.instantiateTxnIfNeeded(e), t);
        }

        function y(e) {
          return h.fromByte(e);
        }

        var m = l.from("ProgData");

        function b(e, t, r) {
          var s = c.concatArrays(o.decodeAddress(r).publicKey, t),
              i = l.from(c.concatArrays(m, s));
          return n.sign(i, e);
        }

        function w(e, t, r) {
          return b(e, t, new h(r).address());
        }
      },
      6608: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          MULTISIG_BAD_SENDER_ERROR_MSG: function MULTISIG_BAD_SENDER_ERROR_MSG() {
            return D;
          },
          signTransaction: function signTransaction() {
            return N;
          },
          signBid: function signBid() {
            return P;
          },
          signBytes: function signBytes() {
            return L;
          },
          verifyBytes: function verifyBytes() {
            return F;
          },
          encodeObj: function encodeObj() {
            return j;
          },
          decodeObj: function decodeObj() {
            return z;
          },
          ERROR_MULTISIG_BAD_SENDER: function ERROR_MULTISIG_BAD_SENDER() {
            return M;
          },
          ERROR_INVALID_MICROALGOS: function ERROR_INVALID_MICROALGOS() {
            return H;
          },
          Algodv2: function Algodv2() {
            return d.Z;
          },
          Kmd: function Kmd() {
            return g.Z;
          },
          IntDecoding: function IntDecoding() {
            return y.Z;
          },
          Indexer: function Indexer() {
            return m.Z;
          },
          waitForConfirmation: function waitForConfirmation() {
            return b.K;
          },
          isValidAddress: function isValidAddress() {
            return o.isValidAddress;
          },
          encodeAddress: function encodeAddress() {
            return o.encodeAddress;
          },
          decodeAddress: function decodeAddress() {
            return o.decodeAddress;
          },
          getApplicationAddress: function getApplicationAddress() {
            return o.getApplicationAddress;
          },
          encodeUint64: function encodeUint64() {
            return w.T;
          },
          decodeUint64: function decodeUint64() {
            return w.u;
          },
          generateAccount: function generateAccount() {
            return A.Z;
          },
          modelsv2: function modelsv2() {
            return v;
          },
          mnemonicToMasterDerivationKey: function mnemonicToMasterDerivationKey() {
            return x.OF;
          },
          masterDerivationKeyToMnemonic: function masterDerivationKeyToMnemonic() {
            return x.vC;
          },
          secretKeyToMnemonic: function secretKeyToMnemonic() {
            return x.QX;
          },
          mnemonicToSecretKey: function mnemonicToSecretKey() {
            return x.Ch;
          },
          seedFromMnemonic: function seedFromMnemonic() {
            return x.mE;
          },
          mnemonicFromSeed: function mnemonicFromSeed() {
            return x.w3;
          },
          microalgosToAlgos: function microalgosToAlgos() {
            return l._;
          },
          algosToMicroalgos: function algosToMicroalgos() {
            return l.HN;
          },
          INVALID_MICROALGOS_ERROR_MSG: function INVALID_MICROALGOS_ERROR_MSG() {
            return l.rD;
          },
          computeGroupID: function computeGroupID() {
            return S.computeGroupID;
          },
          assignGroupID: function assignGroupID() {
            return S.assignGroupID;
          },
          LogicSigAccount: function LogicSigAccount() {
            return E.LogicSigAccount;
          },
          makeLogicSig: function makeLogicSig() {
            return E.makeLogicSig;
          },
          signLogicSigTransaction: function signLogicSigTransaction() {
            return E.signLogicSigTransaction;
          },
          signLogicSigTransactionObject: function signLogicSigTransactionObject() {
            return E.signLogicSigTransactionObject;
          },
          logicSigFromByte: function logicSigFromByte() {
            return E.logicSigFromByte;
          },
          tealSign: function tealSign() {
            return E.tealSign;
          },
          tealSignFromProgram: function tealSignFromProgram() {
            return E.tealSignFromProgram;
          },
          signMultisigTransaction: function signMultisigTransaction() {
            return T.PU;
          },
          mergeMultisigTransactions: function mergeMultisigTransactions() {
            return T.J6;
          },
          appendSignMultisigTransaction: function appendSignMultisigTransaction() {
            return T.PO;
          },
          multisigAddress: function multisigAddress() {
            return T.vH;
          },
          LogicTemplates: function LogicTemplates() {
            return G;
          },
          createDryrun: function createDryrun() {
            return _.P;
          },
          OnApplicationComplete: function OnApplicationComplete() {
            return B.OnApplicationComplete;
          },
          makeApplicationCallTxnFromObject: function makeApplicationCallTxnFromObject() {
            return B.makeApplicationCallTxnFromObject;
          },
          makeApplicationClearStateTxn: function makeApplicationClearStateTxn() {
            return B.makeApplicationClearStateTxn;
          },
          makeApplicationClearStateTxnFromObject: function makeApplicationClearStateTxnFromObject() {
            return B.makeApplicationClearStateTxnFromObject;
          },
          makeApplicationCloseOutTxn: function makeApplicationCloseOutTxn() {
            return B.makeApplicationCloseOutTxn;
          },
          makeApplicationCloseOutTxnFromObject: function makeApplicationCloseOutTxnFromObject() {
            return B.makeApplicationCloseOutTxnFromObject;
          },
          makeApplicationCreateTxn: function makeApplicationCreateTxn() {
            return B.makeApplicationCreateTxn;
          },
          makeApplicationCreateTxnFromObject: function makeApplicationCreateTxnFromObject() {
            return B.makeApplicationCreateTxnFromObject;
          },
          makeApplicationDeleteTxn: function makeApplicationDeleteTxn() {
            return B.makeApplicationDeleteTxn;
          },
          makeApplicationDeleteTxnFromObject: function makeApplicationDeleteTxnFromObject() {
            return B.makeApplicationDeleteTxnFromObject;
          },
          makeApplicationNoOpTxn: function makeApplicationNoOpTxn() {
            return B.makeApplicationNoOpTxn;
          },
          makeApplicationNoOpTxnFromObject: function makeApplicationNoOpTxnFromObject() {
            return B.makeApplicationNoOpTxnFromObject;
          },
          makeApplicationOptInTxn: function makeApplicationOptInTxn() {
            return B.makeApplicationOptInTxn;
          },
          makeApplicationOptInTxnFromObject: function makeApplicationOptInTxnFromObject() {
            return B.makeApplicationOptInTxnFromObject;
          },
          makeApplicationUpdateTxn: function makeApplicationUpdateTxn() {
            return B.makeApplicationUpdateTxn;
          },
          makeApplicationUpdateTxnFromObject: function makeApplicationUpdateTxnFromObject() {
            return B.makeApplicationUpdateTxnFromObject;
          },
          makeAssetConfigTxn: function makeAssetConfigTxn() {
            return B.makeAssetConfigTxn;
          },
          makeAssetConfigTxnWithSuggestedParams: function makeAssetConfigTxnWithSuggestedParams() {
            return B.makeAssetConfigTxnWithSuggestedParams;
          },
          makeAssetConfigTxnWithSuggestedParamsFromObject: function makeAssetConfigTxnWithSuggestedParamsFromObject() {
            return B.makeAssetConfigTxnWithSuggestedParamsFromObject;
          },
          makeAssetCreateTxn: function makeAssetCreateTxn() {
            return B.makeAssetCreateTxn;
          },
          makeAssetCreateTxnWithSuggestedParams: function makeAssetCreateTxnWithSuggestedParams() {
            return B.makeAssetCreateTxnWithSuggestedParams;
          },
          makeAssetCreateTxnWithSuggestedParamsFromObject: function makeAssetCreateTxnWithSuggestedParamsFromObject() {
            return B.makeAssetCreateTxnWithSuggestedParamsFromObject;
          },
          makeAssetDestroyTxn: function makeAssetDestroyTxn() {
            return B.makeAssetDestroyTxn;
          },
          makeAssetDestroyTxnWithSuggestedParams: function makeAssetDestroyTxnWithSuggestedParams() {
            return B.makeAssetDestroyTxnWithSuggestedParams;
          },
          makeAssetDestroyTxnWithSuggestedParamsFromObject: function makeAssetDestroyTxnWithSuggestedParamsFromObject() {
            return B.makeAssetDestroyTxnWithSuggestedParamsFromObject;
          },
          makeAssetFreezeTxn: function makeAssetFreezeTxn() {
            return B.makeAssetFreezeTxn;
          },
          makeAssetFreezeTxnWithSuggestedParams: function makeAssetFreezeTxnWithSuggestedParams() {
            return B.makeAssetFreezeTxnWithSuggestedParams;
          },
          makeAssetFreezeTxnWithSuggestedParamsFromObject: function makeAssetFreezeTxnWithSuggestedParamsFromObject() {
            return B.makeAssetFreezeTxnWithSuggestedParamsFromObject;
          },
          makeAssetTransferTxn: function makeAssetTransferTxn() {
            return B.makeAssetTransferTxn;
          },
          makeAssetTransferTxnWithSuggestedParams: function makeAssetTransferTxnWithSuggestedParams() {
            return B.makeAssetTransferTxnWithSuggestedParams;
          },
          makeAssetTransferTxnWithSuggestedParamsFromObject: function makeAssetTransferTxnWithSuggestedParamsFromObject() {
            return B.makeAssetTransferTxnWithSuggestedParamsFromObject;
          },
          makeKeyRegistrationTxn: function makeKeyRegistrationTxn() {
            return B.makeKeyRegistrationTxn;
          },
          makeKeyRegistrationTxnWithSuggestedParams: function makeKeyRegistrationTxnWithSuggestedParams() {
            return B.makeKeyRegistrationTxnWithSuggestedParams;
          },
          makeKeyRegistrationTxnWithSuggestedParamsFromObject: function makeKeyRegistrationTxnWithSuggestedParamsFromObject() {
            return B.makeKeyRegistrationTxnWithSuggestedParamsFromObject;
          },
          makePaymentTxn: function makePaymentTxn() {
            return B.makePaymentTxn;
          },
          makePaymentTxnWithSuggestedParams: function makePaymentTxnWithSuggestedParams() {
            return B.makePaymentTxnWithSuggestedParams;
          },
          makePaymentTxnWithSuggestedParamsFromObject: function makePaymentTxnWithSuggestedParamsFromObject() {
            return B.makePaymentTxnWithSuggestedParamsFromObject;
          },
          ALGORAND_MIN_TX_FEE: function ALGORAND_MIN_TX_FEE() {
            return i.ALGORAND_MIN_TX_FEE;
          },
          Transaction: function Transaction() {
            return i.Transaction;
          },
          decodeSignedTransaction: function decodeSignedTransaction() {
            return i.decodeSignedTransaction;
          },
          decodeUnsignedTransaction: function decodeUnsignedTransaction() {
            return i.decodeUnsignedTransaction;
          },
          encodeUnsignedTransaction: function encodeUnsignedTransaction() {
            return i.encodeUnsignedTransaction;
          },
          instantiateTxnIfNeeded: function instantiateTxnIfNeeded() {
            return i.instantiateTxnIfNeeded;
          },
          isTransactionWithSigner: function isTransactionWithSigner() {
            return k.Xw;
          },
          makeBasicAccountTransactionSigner: function makeBasicAccountTransactionSigner() {
            return k.x7;
          },
          makeLogicSigAccountTransactionSigner: function makeLogicSigAccountTransactionSigner() {
            return k.i1;
          },
          makeMultiSigAccountTransactionSigner: function makeMultiSigAccountTransactionSigner() {
            return k.Vj;
          },
          AtomicTransactionComposer: function AtomicTransactionComposer() {
            return I.A;
          },
          AtomicTransactionComposerStatus: function AtomicTransactionComposerStatus() {
            return I.b;
          },
          TransactionType: function TransactionType() {
            return U.i;
          },
          ABIAddressType: function ABIAddressType() {
            return C.JQ;
          },
          ABIArrayDynamicType: function ABIArrayDynamicType() {
            return C._4;
          },
          ABIArrayStaticType: function ABIArrayStaticType() {
            return C.X3;
          },
          ABIBoolType: function ABIBoolType() {
            return C.R0;
          },
          ABIByteType: function ABIByteType() {
            return C.jD;
          },
          ABIContract: function ABIContract() {
            return C.Yh;
          },
          ABIInterface: function ABIInterface() {
            return C.bL;
          },
          ABIMethod: function ABIMethod() {
            return C.Ls;
          },
          ABIReferenceType: function ABIReferenceType() {
            return C.UV;
          },
          ABIStringType: function ABIStringType() {
            return C.Ax;
          },
          ABITransactionType: function ABITransactionType() {
            return C.A9;
          },
          ABITupleType: function ABITupleType() {
            return C.w1;
          },
          ABIType: function ABIType() {
            return C.NK;
          },
          ABIUfixedType: function ABIUfixedType() {
            return C.RY;
          },
          ABIUintType: function ABIUintType() {
            return C.Pu;
          },
          ADDR_BYTE_SIZE: function ADDR_BYTE_SIZE() {
            return C.Vk;
          },
          LENGTH_ENCODE_BYTE_SIZE: function LENGTH_ENCODE_BYTE_SIZE() {
            return C.nh;
          },
          MAX_LEN: function MAX_LEN() {
            return C.kG;
          },
          SINGLE_BOOL_SIZE: function SINGLE_BOOL_SIZE() {
            return C.qH;
          },
          SINGLE_BYTE_SIZE: function SINGLE_BYTE_SIZE() {
            return C.JH;
          },
          abiCheckTransactionType: function abiCheckTransactionType() {
            return C.vJ;
          },
          abiTypeIsReference: function abiTypeIsReference() {
            return C.o5;
          },
          abiTypeIsTransaction: function abiTypeIsTransaction() {
            return C.AE;
          }
        });
        var n = r(9404),
            o = r(7116),
            s = r(3033),
            i = r(9417),
            a = r(8886),
            c = r.n(a),
            u = r(2691),
            l = r(9070),
            h = r(413),
            p = r(5922),
            f = {};

        var _loop = function _loop(_e44) {
          ["default", "MULTISIG_BAD_SENDER_ERROR_MSG", "signTransaction", "signBid", "signBytes", "verifyBytes", "encodeObj", "decodeObj", "ERROR_MULTISIG_BAD_SENDER", "ERROR_INVALID_MICROALGOS", "Algodv2", "Kmd", "IntDecoding", "Indexer", "waitForConfirmation", "isValidAddress", "encodeAddress", "decodeAddress", "getApplicationAddress", "encodeUint64", "decodeUint64", "generateAccount", "modelsv2", "mnemonicToMasterDerivationKey", "masterDerivationKeyToMnemonic", "secretKeyToMnemonic", "mnemonicToSecretKey", "seedFromMnemonic", "mnemonicFromSeed", "microalgosToAlgos", "algosToMicroalgos", "INVALID_MICROALGOS_ERROR_MSG", "computeGroupID", "assignGroupID", "LogicSigAccount", "makeLogicSig", "signLogicSigTransaction", "signLogicSigTransactionObject", "logicSigFromByte", "tealSign", "tealSignFromProgram", "signMultisigTransaction", "mergeMultisigTransactions", "appendSignMultisigTransaction", "multisigAddress", "LogicTemplates"].indexOf(_e44) < 0 && (f[_e44] = function () {
            return p[_e44];
          });
        };

        for (var _e44 in p) {
          _loop(_e44);
        }

        r.d(t, f);

        var d = r(5427),
            g = r(6477),
            y = r(7197),
            m = r(8104),
            b = r(5062),
            w = r(6963),
            A = r(7988),
            v = r(227),
            x = r(3510),
            S = r(1063),
            E = r(8800),
            T = r(4158),
            _ = r(4383),
            B = r(1988),
            k = r(834),
            I = r(3458),
            U = r(2380),
            C = r(3410),
            R = r(2486).Buffer;

        var O = R.from([77, 88]),
            D = "The transaction sender address and multisig preimage do not match.";

        function N(e, t) {
          if (void 0 === e.from) {
            var _r35 = n.keyPairFromSecretKey(t);

            e.from = o.encodeAddress(_r35.publicKey);
          }

          var r = i.instantiateTxnIfNeeded(e);
          return {
            txID: r.txID().toString(),
            blob: r.signTxn(t)
          };
        }

        function P(e, t) {
          return new u.Z(e).signBid(t);
        }

        function L(e, t) {
          var r = R.from(h.concatArrays(O, e));
          return n.sign(r, t);
        }

        function F(e, t, r) {
          var s = R.from(h.concatArrays(O, e)),
              i = o.decodeAddress(r).publicKey;
          return n.verify(s, t, i);
        }

        function j(e) {
          return new Uint8Array(s.encode(e));
        }

        function z(e) {
          return s.decode(e);
        }

        var M = new Error(D),
            H = new Error(l.rD),
            G = c();
      },
      1988: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          makePaymentTxnWithSuggestedParams: function makePaymentTxnWithSuggestedParams() {
            return i;
          },
          makePaymentTxn: function makePaymentTxn() {
            return a;
          },
          makePaymentTxnWithSuggestedParamsFromObject: function makePaymentTxnWithSuggestedParamsFromObject() {
            return c;
          },
          makeKeyRegistrationTxnWithSuggestedParams: function makeKeyRegistrationTxnWithSuggestedParams() {
            return u;
          },
          makeKeyRegistrationTxn: function makeKeyRegistrationTxn() {
            return l;
          },
          makeKeyRegistrationTxnWithSuggestedParamsFromObject: function makeKeyRegistrationTxnWithSuggestedParamsFromObject() {
            return h;
          },
          makeAssetCreateTxnWithSuggestedParams: function makeAssetCreateTxnWithSuggestedParams() {
            return p;
          },
          makeAssetCreateTxn: function makeAssetCreateTxn() {
            return f;
          },
          makeAssetCreateTxnWithSuggestedParamsFromObject: function makeAssetCreateTxnWithSuggestedParamsFromObject() {
            return d;
          },
          makeAssetConfigTxnWithSuggestedParams: function makeAssetConfigTxnWithSuggestedParams() {
            return g;
          },
          makeAssetConfigTxn: function makeAssetConfigTxn() {
            return y;
          },
          makeAssetConfigTxnWithSuggestedParamsFromObject: function makeAssetConfigTxnWithSuggestedParamsFromObject() {
            return m;
          },
          makeAssetDestroyTxnWithSuggestedParams: function makeAssetDestroyTxnWithSuggestedParams() {
            return b;
          },
          makeAssetDestroyTxn: function makeAssetDestroyTxn() {
            return w;
          },
          makeAssetDestroyTxnWithSuggestedParamsFromObject: function makeAssetDestroyTxnWithSuggestedParamsFromObject() {
            return A;
          },
          makeAssetFreezeTxnWithSuggestedParams: function makeAssetFreezeTxnWithSuggestedParams() {
            return v;
          },
          makeAssetFreezeTxn: function makeAssetFreezeTxn() {
            return x;
          },
          makeAssetFreezeTxnWithSuggestedParamsFromObject: function makeAssetFreezeTxnWithSuggestedParamsFromObject() {
            return S;
          },
          makeAssetTransferTxnWithSuggestedParams: function makeAssetTransferTxnWithSuggestedParams() {
            return E;
          },
          makeAssetTransferTxn: function makeAssetTransferTxn() {
            return T;
          },
          makeAssetTransferTxnWithSuggestedParamsFromObject: function makeAssetTransferTxnWithSuggestedParamsFromObject() {
            return _;
          },
          makeApplicationCreateTxn: function makeApplicationCreateTxn() {
            return B;
          },
          makeApplicationCreateTxnFromObject: function makeApplicationCreateTxnFromObject() {
            return k;
          },
          makeApplicationUpdateTxn: function makeApplicationUpdateTxn() {
            return I;
          },
          makeApplicationUpdateTxnFromObject: function makeApplicationUpdateTxnFromObject() {
            return U;
          },
          makeApplicationDeleteTxn: function makeApplicationDeleteTxn() {
            return C;
          },
          makeApplicationDeleteTxnFromObject: function makeApplicationDeleteTxnFromObject() {
            return R;
          },
          makeApplicationOptInTxn: function makeApplicationOptInTxn() {
            return O;
          },
          makeApplicationOptInTxnFromObject: function makeApplicationOptInTxnFromObject() {
            return D;
          },
          makeApplicationCloseOutTxn: function makeApplicationCloseOutTxn() {
            return N;
          },
          makeApplicationCloseOutTxnFromObject: function makeApplicationCloseOutTxnFromObject() {
            return P;
          },
          makeApplicationClearStateTxn: function makeApplicationClearStateTxn() {
            return L;
          },
          makeApplicationClearStateTxnFromObject: function makeApplicationClearStateTxnFromObject() {
            return F;
          },
          makeApplicationNoOpTxn: function makeApplicationNoOpTxn() {
            return j;
          },
          makeApplicationNoOpTxnFromObject: function makeApplicationNoOpTxnFromObject() {
            return z;
          },
          OnApplicationComplete: function OnApplicationComplete() {
            return o.h;
          },
          makeApplicationCallTxnFromObject: function makeApplicationCallTxnFromObject() {
            return M;
          }
        });
        var n = r(9417),
            o = r(1624),
            s = r(1824);

        function i(e, t, r, o, i, a, c) {
          var u = {
            from: e,
            to: t,
            amount: r,
            closeRemainderTo: o,
            note: i,
            suggestedParams: a,
            type: s.i.pay,
            reKeyTo: c
          };
          return new n.Transaction(u);
        }

        function a(e, t, r, n, o, s, a, c, u, l, h) {
          return i(e, t, n, o, c, {
            genesisHash: u,
            genesisID: l,
            firstRound: s,
            lastRound: a,
            fee: r
          }, h);
        }

        function c(e) {
          return i(e.from, e.to, e.amount, e.closeRemainderTo, e.note, e.suggestedParams, e.rekeyTo);
        }

        function u(e, t, r, o, i, a, c, u, l) {
          var h = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : !1;
          var p = {
            from: e,
            note: t,
            voteKey: r,
            selectionKey: o,
            voteFirst: i,
            voteLast: a,
            voteKeyDilution: c,
            suggestedParams: u,
            type: s.i.keyreg,
            reKeyTo: l,
            nonParticipation: h
          };
          return new n.Transaction(p);
        }

        function l(e, t, r, n, o, s, i, a, c, l, h, p, f) {
          var d = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : !1;
          return u(e, o, a, c, l, h, p, {
            genesisHash: s,
            genesisID: i,
            firstRound: r,
            lastRound: n,
            fee: t
          }, f, d);
        }

        function h(e) {
          return u(e.from, e.note, e.voteKey, e.selectionKey, e.voteFirst, e.voteLast, e.voteKeyDilution, e.suggestedParams, e.rekeyTo, e.nonParticipation);
        }

        function p(e, t, r, o, i, a, c, u, l, h, p, f, d, g, y) {
          var m = {
            from: e,
            note: t,
            suggestedParams: g,
            assetTotal: r,
            assetDecimals: o,
            assetDefaultFrozen: i,
            assetUnitName: h,
            assetName: p,
            assetURL: f,
            assetMetadataHash: d,
            assetManager: a,
            assetReserve: c,
            assetFreeze: u,
            assetClawback: l,
            type: s.i.acfg,
            reKeyTo: y
          };
          return new n.Transaction(m);
        }

        function f(e, t, r, n, o, s, i, a, c, u, l, h, f, d, g, y, m, b, w) {
          return p(e, o, a, c, u, l, h, f, d, g, y, m, b, {
            genesisHash: s,
            genesisID: i,
            firstRound: r,
            lastRound: n,
            fee: t
          }, w);
        }

        function d(e) {
          return p(e.from, e.note, e.total, e.decimals, e.defaultFrozen, e.manager, e.reserve, e.freeze, e.clawback, e.unitName, e.assetName, e.assetURL, e.assetMetadataHash, e.suggestedParams, e.rekeyTo);
        }

        function g(e, t, r, o, i, a, c, u) {
          var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : !0;
          var h = arguments.length > 9 ? arguments[9] : undefined;
          if (l && (void 0 === o || void 0 === i || void 0 === a || void 0 === c)) throw Error("strict empty address checking was turned on, but at least one empty address was provided");
          var p = {
            from: e,
            suggestedParams: u,
            assetIndex: r,
            assetManager: o,
            assetReserve: i,
            assetFreeze: a,
            assetClawback: c,
            type: s.i.acfg,
            note: t,
            reKeyTo: h
          };
          return new n.Transaction(p);
        }

        function y(e, t, r, n, o, s, i, a, c, u, l, h) {
          var p = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : !0;
          var f = arguments.length > 13 ? arguments[13] : undefined;
          return g(e, o, a, c, u, l, h, {
            genesisHash: s,
            genesisID: i,
            firstRound: r,
            lastRound: n,
            fee: t
          }, p, f);
        }

        function m(e) {
          return g(e.from, e.note, e.assetIndex, e.manager, e.reserve, e.freeze, e.clawback, e.suggestedParams, e.strictEmptyAddressChecking, e.rekeyTo);
        }

        function b(e, t, r, o, i) {
          var a = {
            from: e,
            suggestedParams: o,
            assetIndex: r,
            type: s.i.acfg,
            note: t,
            reKeyTo: i
          };
          return new n.Transaction(a);
        }

        function w(e, t, r, n, o, s, i, a, c) {
          return b(e, o, a, {
            genesisHash: s,
            genesisID: i,
            firstRound: r,
            lastRound: n,
            fee: t
          }, c);
        }

        function A(e) {
          return b(e.from, e.note, e.assetIndex, e.suggestedParams, e.rekeyTo);
        }

        function v(e, t, r, o, i, a, c) {
          var u = {
            from: e,
            type: s.i.afrz,
            freezeAccount: o,
            assetIndex: r,
            freezeState: i,
            note: t,
            suggestedParams: a,
            reKeyTo: c
          };
          return new n.Transaction(u);
        }

        function x(e, t, r, n, o, s, i, a, c, u, l) {
          return v(e, o, a, c, u, {
            genesisHash: s,
            genesisID: i,
            firstRound: r,
            lastRound: n,
            fee: t
          }, l);
        }

        function S(e) {
          return v(e.from, e.note, e.assetIndex, e.freezeTarget, e.freezeState, e.suggestedParams, e.rekeyTo);
        }

        function E(e, t, r, o, i, a, c, u, l) {
          var h = {
            type: s.i.axfer,
            from: e,
            to: t,
            amount: i,
            suggestedParams: u,
            assetIndex: c,
            note: a,
            assetRevocationTarget: o,
            closeRemainderTo: r,
            reKeyTo: l
          };
          return new n.Transaction(h);
        }

        function T(e, t, r, n, o, s, i, a, c, u, l, h, p) {
          return E(e, t, r, n, s, c, h, {
            genesisHash: u,
            genesisID: l,
            firstRound: i,
            lastRound: a,
            fee: o
          }, p);
        }

        function _(e) {
          return E(e.from, e.to, e.closeRemainderTo, e.revocationTarget, e.amount, e.note, e.assetIndex, e.suggestedParams, e.rekeyTo);
        }

        function B(e, t, r, o, i, a, c, u, l, h, p, f, d, g, y, m, b) {
          var w = {
            type: s.i.appl,
            from: e,
            suggestedParams: t,
            appIndex: 0,
            appOnComplete: r,
            appLocalInts: a,
            appLocalByteSlices: c,
            appGlobalInts: u,
            appGlobalByteSlices: l,
            appApprovalProgram: o,
            appClearProgram: i,
            appArgs: h,
            appAccounts: p,
            appForeignApps: f,
            appForeignAssets: d,
            note: g,
            lease: y,
            reKeyTo: m,
            extraPages: b
          };
          return new n.Transaction(w);
        }

        function k(e) {
          return B(e.from, e.suggestedParams, e.onComplete, e.approvalProgram, e.clearProgram, e.numLocalInts, e.numLocalByteSlices, e.numGlobalInts, e.numGlobalByteSlices, e.appArgs, e.accounts, e.foreignApps, e.foreignAssets, e.note, e.lease, e.rekeyTo, e.extraPages);
        }

        function I(e, t, r, i, a, c, u, l, h, p, f, d) {
          var g = {
            type: s.i.appl,
            from: e,
            suggestedParams: t,
            appIndex: r,
            appApprovalProgram: i,
            appOnComplete: o.h.UpdateApplicationOC,
            appClearProgram: a,
            appArgs: c,
            appAccounts: u,
            appForeignApps: l,
            appForeignAssets: h,
            note: p,
            lease: f,
            reKeyTo: d
          };
          return new n.Transaction(g);
        }

        function U(e) {
          return I(e.from, e.suggestedParams, e.appIndex, e.approvalProgram, e.clearProgram, e.appArgs, e.accounts, e.foreignApps, e.foreignAssets, e.note, e.lease, e.rekeyTo);
        }

        function C(e, t, r, i, a, c, u, l, h, p) {
          var f = {
            type: s.i.appl,
            from: e,
            suggestedParams: t,
            appIndex: r,
            appOnComplete: o.h.DeleteApplicationOC,
            appArgs: i,
            appAccounts: a,
            appForeignApps: c,
            appForeignAssets: u,
            note: l,
            lease: h,
            reKeyTo: p
          };
          return new n.Transaction(f);
        }

        function R(e) {
          return C(e.from, e.suggestedParams, e.appIndex, e.appArgs, e.accounts, e.foreignApps, e.foreignAssets, e.note, e.lease, e.rekeyTo);
        }

        function O(e, t, r, i, a, c, u, l, h, p) {
          var f = {
            type: s.i.appl,
            from: e,
            suggestedParams: t,
            appIndex: r,
            appOnComplete: o.h.OptInOC,
            appArgs: i,
            appAccounts: a,
            appForeignApps: c,
            appForeignAssets: u,
            note: l,
            lease: h,
            reKeyTo: p
          };
          return new n.Transaction(f);
        }

        function D(e) {
          return O(e.from, e.suggestedParams, e.appIndex, e.appArgs, e.accounts, e.foreignApps, e.foreignAssets, e.note, e.lease, e.rekeyTo);
        }

        function N(e, t, r, i, a, c, u, l, h, p) {
          var f = {
            type: s.i.appl,
            from: e,
            suggestedParams: t,
            appIndex: r,
            appOnComplete: o.h.CloseOutOC,
            appArgs: i,
            appAccounts: a,
            appForeignApps: c,
            appForeignAssets: u,
            note: l,
            lease: h,
            reKeyTo: p
          };
          return new n.Transaction(f);
        }

        function P(e) {
          return N(e.from, e.suggestedParams, e.appIndex, e.appArgs, e.accounts, e.foreignApps, e.foreignAssets, e.note, e.lease, e.rekeyTo);
        }

        function L(e, t, r, i, a, c, u, l, h, p) {
          var f = {
            type: s.i.appl,
            from: e,
            suggestedParams: t,
            appIndex: r,
            appOnComplete: o.h.ClearStateOC,
            appArgs: i,
            appAccounts: a,
            appForeignApps: c,
            appForeignAssets: u,
            note: l,
            lease: h,
            reKeyTo: p
          };
          return new n.Transaction(f);
        }

        function F(e) {
          return L(e.from, e.suggestedParams, e.appIndex, e.appArgs, e.accounts, e.foreignApps, e.foreignAssets, e.note, e.lease, e.rekeyTo);
        }

        function j(e, t, r, i, a, c, u, l, h, p) {
          var f = {
            type: s.i.appl,
            from: e,
            suggestedParams: t,
            appIndex: r,
            appOnComplete: o.h.NoOpOC,
            appArgs: i,
            appAccounts: a,
            appForeignApps: c,
            appForeignAssets: u,
            note: l,
            lease: h,
            reKeyTo: p
          };
          return new n.Transaction(f);
        }

        function z(e) {
          return j(e.from, e.suggestedParams, e.appIndex, e.appArgs, e.accounts, e.foreignApps, e.foreignAssets, e.note, e.lease, e.rekeyTo);
        }

        function M(e) {
          var t = {
            type: s.i.appl,
            from: e.from,
            suggestedParams: e.suggestedParams,
            appIndex: e.appIndex,
            appOnComplete: e.onComplete,
            appLocalInts: e.numLocalInts,
            appLocalByteSlices: e.numLocalByteSlices,
            appGlobalInts: e.numGlobalInts,
            appGlobalByteSlices: e.numGlobalByteSlices,
            appApprovalProgram: e.approvalProgram,
            appClearProgram: e.clearProgram,
            appArgs: e.appArgs,
            appAccounts: e.accounts,
            appForeignApps: e.foreignApps,
            appForeignAssets: e.foreignAssets,
            note: e.note,
            lease: e.lease,
            reKeyTo: e.rekeyTo,
            extraPages: e.extraPages
          };
          return new n.Transaction(t);
        }
      },
      3510: function _(e, t, r) {
        "use strict";

        r.d(t, {
          vC: function vC() {
            return g;
          },
          w3: function w3() {
            return l;
          },
          OF: function OF() {
            return d;
          },
          Ch: function Ch() {
            return p;
          },
          QX: function QX() {
            return f;
          },
          mE: function mE() {
            return h;
          }
        });
        var n = ["abandon", "ability", "able", "about", "above", "absent", "absorb", "abstract", "absurd", "abuse", "access", "accident", "account", "accuse", "achieve", "acid", "acoustic", "acquire", "across", "act", "action", "actor", "actress", "actual", "adapt", "add", "addict", "address", "adjust", "admit", "adult", "advance", "advice", "aerobic", "affair", "afford", "afraid", "again", "age", "agent", "agree", "ahead", "aim", "air", "airport", "aisle", "alarm", "album", "alcohol", "alert", "alien", "all", "alley", "allow", "almost", "alone", "alpha", "already", "also", "alter", "always", "amateur", "amazing", "among", "amount", "amused", "analyst", "anchor", "ancient", "anger", "angle", "angry", "animal", "ankle", "announce", "annual", "another", "answer", "antenna", "antique", "anxiety", "any", "apart", "apology", "appear", "apple", "approve", "april", "arch", "arctic", "area", "arena", "argue", "arm", "armed", "armor", "army", "around", "arrange", "arrest", "arrive", "arrow", "art", "artefact", "artist", "artwork", "ask", "aspect", "assault", "asset", "assist", "assume", "asthma", "athlete", "atom", "attack", "attend", "attitude", "attract", "auction", "audit", "august", "aunt", "author", "auto", "autumn", "average", "avocado", "avoid", "awake", "aware", "away", "awesome", "awful", "awkward", "axis", "baby", "bachelor", "bacon", "badge", "bag", "balance", "balcony", "ball", "bamboo", "banana", "banner", "bar", "barely", "bargain", "barrel", "base", "basic", "basket", "battle", "beach", "bean", "beauty", "because", "become", "beef", "before", "begin", "behave", "behind", "believe", "below", "belt", "bench", "benefit", "best", "betray", "better", "between", "beyond", "bicycle", "bid", "bike", "bind", "biology", "bird", "birth", "bitter", "black", "blade", "blame", "blanket", "blast", "bleak", "bless", "blind", "blood", "blossom", "blouse", "blue", "blur", "blush", "board", "boat", "body", "boil", "bomb", "bone", "bonus", "book", "boost", "border", "boring", "borrow", "boss", "bottom", "bounce", "box", "boy", "bracket", "brain", "brand", "brass", "brave", "bread", "breeze", "brick", "bridge", "brief", "bright", "bring", "brisk", "broccoli", "broken", "bronze", "broom", "brother", "brown", "brush", "bubble", "buddy", "budget", "buffalo", "build", "bulb", "bulk", "bullet", "bundle", "bunker", "burden", "burger", "burst", "bus", "business", "busy", "butter", "buyer", "buzz", "cabbage", "cabin", "cable", "cactus", "cage", "cake", "call", "calm", "camera", "camp", "can", "canal", "cancel", "candy", "cannon", "canoe", "canvas", "canyon", "capable", "capital", "captain", "car", "carbon", "card", "cargo", "carpet", "carry", "cart", "case", "cash", "casino", "castle", "casual", "cat", "catalog", "catch", "category", "cattle", "caught", "cause", "caution", "cave", "ceiling", "celery", "cement", "census", "century", "cereal", "certain", "chair", "chalk", "champion", "change", "chaos", "chapter", "charge", "chase", "chat", "cheap", "check", "cheese", "chef", "cherry", "chest", "chicken", "chief", "child", "chimney", "choice", "choose", "chronic", "chuckle", "chunk", "churn", "cigar", "cinnamon", "circle", "citizen", "city", "civil", "claim", "clap", "clarify", "claw", "clay", "clean", "clerk", "clever", "click", "client", "cliff", "climb", "clinic", "clip", "clock", "clog", "close", "cloth", "cloud", "clown", "club", "clump", "cluster", "clutch", "coach", "coast", "coconut", "code", "coffee", "coil", "coin", "collect", "color", "column", "combine", "come", "comfort", "comic", "common", "company", "concert", "conduct", "confirm", "congress", "connect", "consider", "control", "convince", "cook", "cool", "copper", "copy", "coral", "core", "corn", "correct", "cost", "cotton", "couch", "country", "couple", "course", "cousin", "cover", "coyote", "crack", "cradle", "craft", "cram", "crane", "crash", "crater", "crawl", "crazy", "cream", "credit", "creek", "crew", "cricket", "crime", "crisp", "critic", "crop", "cross", "crouch", "crowd", "crucial", "cruel", "cruise", "crumble", "crunch", "crush", "cry", "crystal", "cube", "culture", "cup", "cupboard", "curious", "current", "curtain", "curve", "cushion", "custom", "cute", "cycle", "dad", "damage", "damp", "dance", "danger", "daring", "dash", "daughter", "dawn", "day", "deal", "debate", "debris", "decade", "december", "decide", "decline", "decorate", "decrease", "deer", "defense", "define", "defy", "degree", "delay", "deliver", "demand", "demise", "denial", "dentist", "deny", "depart", "depend", "deposit", "depth", "deputy", "derive", "describe", "desert", "design", "desk", "despair", "destroy", "detail", "detect", "develop", "device", "devote", "diagram", "dial", "diamond", "diary", "dice", "diesel", "diet", "differ", "digital", "dignity", "dilemma", "dinner", "dinosaur", "direct", "dirt", "disagree", "discover", "disease", "dish", "dismiss", "disorder", "display", "distance", "divert", "divide", "divorce", "dizzy", "doctor", "document", "dog", "doll", "dolphin", "domain", "donate", "donkey", "donor", "door", "dose", "double", "dove", "draft", "dragon", "drama", "drastic", "draw", "dream", "dress", "drift", "drill", "drink", "drip", "drive", "drop", "drum", "dry", "duck", "dumb", "dune", "during", "dust", "dutch", "duty", "dwarf", "dynamic", "eager", "eagle", "early", "earn", "earth", "easily", "east", "easy", "echo", "ecology", "economy", "edge", "edit", "educate", "effort", "egg", "eight", "either", "elbow", "elder", "electric", "elegant", "element", "elephant", "elevator", "elite", "else", "embark", "embody", "embrace", "emerge", "emotion", "employ", "empower", "empty", "enable", "enact", "end", "endless", "endorse", "enemy", "energy", "enforce", "engage", "engine", "enhance", "enjoy", "enlist", "enough", "enrich", "enroll", "ensure", "enter", "entire", "entry", "envelope", "episode", "equal", "equip", "era", "erase", "erode", "erosion", "error", "erupt", "escape", "essay", "essence", "estate", "eternal", "ethics", "evidence", "evil", "evoke", "evolve", "exact", "example", "excess", "exchange", "excite", "exclude", "excuse", "execute", "exercise", "exhaust", "exhibit", "exile", "exist", "exit", "exotic", "expand", "expect", "expire", "explain", "expose", "express", "extend", "extra", "eye", "eyebrow", "fabric", "face", "faculty", "fade", "faint", "faith", "fall", "false", "fame", "family", "famous", "fan", "fancy", "fantasy", "farm", "fashion", "fat", "fatal", "father", "fatigue", "fault", "favorite", "feature", "february", "federal", "fee", "feed", "feel", "female", "fence", "festival", "fetch", "fever", "few", "fiber", "fiction", "field", "figure", "file", "film", "filter", "final", "find", "fine", "finger", "finish", "fire", "firm", "first", "fiscal", "fish", "fit", "fitness", "fix", "flag", "flame", "flash", "flat", "flavor", "flee", "flight", "flip", "float", "flock", "floor", "flower", "fluid", "flush", "fly", "foam", "focus", "fog", "foil", "fold", "follow", "food", "foot", "force", "forest", "forget", "fork", "fortune", "forum", "forward", "fossil", "foster", "found", "fox", "fragile", "frame", "frequent", "fresh", "friend", "fringe", "frog", "front", "frost", "frown", "frozen", "fruit", "fuel", "fun", "funny", "furnace", "fury", "future", "gadget", "gain", "galaxy", "gallery", "game", "gap", "garage", "garbage", "garden", "garlic", "garment", "gas", "gasp", "gate", "gather", "gauge", "gaze", "general", "genius", "genre", "gentle", "genuine", "gesture", "ghost", "giant", "gift", "giggle", "ginger", "giraffe", "girl", "give", "glad", "glance", "glare", "glass", "glide", "glimpse", "globe", "gloom", "glory", "glove", "glow", "glue", "goat", "goddess", "gold", "good", "goose", "gorilla", "gospel", "gossip", "govern", "gown", "grab", "grace", "grain", "grant", "grape", "grass", "gravity", "great", "green", "grid", "grief", "grit", "grocery", "group", "grow", "grunt", "guard", "guess", "guide", "guilt", "guitar", "gun", "gym", "habit", "hair", "half", "hammer", "hamster", "hand", "happy", "harbor", "hard", "harsh", "harvest", "hat", "have", "hawk", "hazard", "head", "health", "heart", "heavy", "hedgehog", "height", "hello", "helmet", "help", "hen", "hero", "hidden", "high", "hill", "hint", "hip", "hire", "history", "hobby", "hockey", "hold", "hole", "holiday", "hollow", "home", "honey", "hood", "hope", "horn", "horror", "horse", "hospital", "host", "hotel", "hour", "hover", "hub", "huge", "human", "humble", "humor", "hundred", "hungry", "hunt", "hurdle", "hurry", "hurt", "husband", "hybrid", "ice", "icon", "idea", "identify", "idle", "ignore", "ill", "illegal", "illness", "image", "imitate", "immense", "immune", "impact", "impose", "improve", "impulse", "inch", "include", "income", "increase", "index", "indicate", "indoor", "industry", "infant", "inflict", "inform", "inhale", "inherit", "initial", "inject", "injury", "inmate", "inner", "innocent", "input", "inquiry", "insane", "insect", "inside", "inspire", "install", "intact", "interest", "into", "invest", "invite", "involve", "iron", "island", "isolate", "issue", "item", "ivory", "jacket", "jaguar", "jar", "jazz", "jealous", "jeans", "jelly", "jewel", "job", "join", "joke", "journey", "joy", "judge", "juice", "jump", "jungle", "junior", "junk", "just", "kangaroo", "keen", "keep", "ketchup", "key", "kick", "kid", "kidney", "kind", "kingdom", "kiss", "kit", "kitchen", "kite", "kitten", "kiwi", "knee", "knife", "knock", "know", "lab", "label", "labor", "ladder", "lady", "lake", "lamp", "language", "laptop", "large", "later", "latin", "laugh", "laundry", "lava", "law", "lawn", "lawsuit", "layer", "lazy", "leader", "leaf", "learn", "leave", "lecture", "left", "leg", "legal", "legend", "leisure", "lemon", "lend", "length", "lens", "leopard", "lesson", "letter", "level", "liar", "liberty", "library", "license", "life", "lift", "light", "like", "limb", "limit", "link", "lion", "liquid", "list", "little", "live", "lizard", "load", "loan", "lobster", "local", "lock", "logic", "lonely", "long", "loop", "lottery", "loud", "lounge", "love", "loyal", "lucky", "luggage", "lumber", "lunar", "lunch", "luxury", "lyrics", "machine", "mad", "magic", "magnet", "maid", "mail", "main", "major", "make", "mammal", "man", "manage", "mandate", "mango", "mansion", "manual", "maple", "marble", "march", "margin", "marine", "market", "marriage", "mask", "mass", "master", "match", "material", "math", "matrix", "matter", "maximum", "maze", "meadow", "mean", "measure", "meat", "mechanic", "medal", "media", "melody", "melt", "member", "memory", "mention", "menu", "mercy", "merge", "merit", "merry", "mesh", "message", "metal", "method", "middle", "midnight", "milk", "million", "mimic", "mind", "minimum", "minor", "minute", "miracle", "mirror", "misery", "miss", "mistake", "mix", "mixed", "mixture", "mobile", "model", "modify", "mom", "moment", "monitor", "monkey", "monster", "month", "moon", "moral", "more", "morning", "mosquito", "mother", "motion", "motor", "mountain", "mouse", "move", "movie", "much", "muffin", "mule", "multiply", "muscle", "museum", "mushroom", "music", "must", "mutual", "myself", "mystery", "myth", "naive", "name", "napkin", "narrow", "nasty", "nation", "nature", "near", "neck", "need", "negative", "neglect", "neither", "nephew", "nerve", "nest", "net", "network", "neutral", "never", "news", "next", "nice", "night", "noble", "noise", "nominee", "noodle", "normal", "north", "nose", "notable", "note", "nothing", "notice", "novel", "now", "nuclear", "number", "nurse", "nut", "oak", "obey", "object", "oblige", "obscure", "observe", "obtain", "obvious", "occur", "ocean", "october", "odor", "off", "offer", "office", "often", "oil", "okay", "old", "olive", "olympic", "omit", "once", "one", "onion", "online", "only", "open", "opera", "opinion", "oppose", "option", "orange", "orbit", "orchard", "order", "ordinary", "organ", "orient", "original", "orphan", "ostrich", "other", "outdoor", "outer", "output", "outside", "oval", "oven", "over", "own", "owner", "oxygen", "oyster", "ozone", "pact", "paddle", "page", "pair", "palace", "palm", "panda", "panel", "panic", "panther", "paper", "parade", "parent", "park", "parrot", "party", "pass", "patch", "path", "patient", "patrol", "pattern", "pause", "pave", "payment", "peace", "peanut", "pear", "peasant", "pelican", "pen", "penalty", "pencil", "people", "pepper", "perfect", "permit", "person", "pet", "phone", "photo", "phrase", "physical", "piano", "picnic", "picture", "piece", "pig", "pigeon", "pill", "pilot", "pink", "pioneer", "pipe", "pistol", "pitch", "pizza", "place", "planet", "plastic", "plate", "play", "please", "pledge", "pluck", "plug", "plunge", "poem", "poet", "point", "polar", "pole", "police", "pond", "pony", "pool", "popular", "portion", "position", "possible", "post", "potato", "pottery", "poverty", "powder", "power", "practice", "praise", "predict", "prefer", "prepare", "present", "pretty", "prevent", "price", "pride", "primary", "print", "priority", "prison", "private", "prize", "problem", "process", "produce", "profit", "program", "project", "promote", "proof", "property", "prosper", "protect", "proud", "provide", "public", "pudding", "pull", "pulp", "pulse", "pumpkin", "punch", "pupil", "puppy", "purchase", "purity", "purpose", "purse", "push", "put", "puzzle", "pyramid", "quality", "quantum", "quarter", "question", "quick", "quit", "quiz", "quote", "rabbit", "raccoon", "race", "rack", "radar", "radio", "rail", "rain", "raise", "rally", "ramp", "ranch", "random", "range", "rapid", "rare", "rate", "rather", "raven", "raw", "razor", "ready", "real", "reason", "rebel", "rebuild", "recall", "receive", "recipe", "record", "recycle", "reduce", "reflect", "reform", "refuse", "region", "regret", "regular", "reject", "relax", "release", "relief", "rely", "remain", "remember", "remind", "remove", "render", "renew", "rent", "reopen", "repair", "repeat", "replace", "report", "require", "rescue", "resemble", "resist", "resource", "response", "result", "retire", "retreat", "return", "reunion", "reveal", "review", "reward", "rhythm", "rib", "ribbon", "rice", "rich", "ride", "ridge", "rifle", "right", "rigid", "ring", "riot", "ripple", "risk", "ritual", "rival", "river", "road", "roast", "robot", "robust", "rocket", "romance", "roof", "rookie", "room", "rose", "rotate", "rough", "round", "route", "royal", "rubber", "rude", "rug", "rule", "run", "runway", "rural", "sad", "saddle", "sadness", "safe", "sail", "salad", "salmon", "salon", "salt", "salute", "same", "sample", "sand", "satisfy", "satoshi", "sauce", "sausage", "save", "say", "scale", "scan", "scare", "scatter", "scene", "scheme", "school", "science", "scissors", "scorpion", "scout", "scrap", "screen", "script", "scrub", "sea", "search", "season", "seat", "second", "secret", "section", "security", "seed", "seek", "segment", "select", "sell", "seminar", "senior", "sense", "sentence", "series", "service", "session", "settle", "setup", "seven", "shadow", "shaft", "shallow", "share", "shed", "shell", "sheriff", "shield", "shift", "shine", "ship", "shiver", "shock", "shoe", "shoot", "shop", "short", "shoulder", "shove", "shrimp", "shrug", "shuffle", "shy", "sibling", "sick", "side", "siege", "sight", "sign", "silent", "silk", "silly", "silver", "similar", "simple", "since", "sing", "siren", "sister", "situate", "six", "size", "skate", "sketch", "ski", "skill", "skin", "skirt", "skull", "slab", "slam", "sleep", "slender", "slice", "slide", "slight", "slim", "slogan", "slot", "slow", "slush", "small", "smart", "smile", "smoke", "smooth", "snack", "snake", "snap", "sniff", "snow", "soap", "soccer", "social", "sock", "soda", "soft", "solar", "soldier", "solid", "solution", "solve", "someone", "song", "soon", "sorry", "sort", "soul", "sound", "soup", "source", "south", "space", "spare", "spatial", "spawn", "speak", "special", "speed", "spell", "spend", "sphere", "spice", "spider", "spike", "spin", "spirit", "split", "spoil", "sponsor", "spoon", "sport", "spot", "spray", "spread", "spring", "spy", "square", "squeeze", "squirrel", "stable", "stadium", "staff", "stage", "stairs", "stamp", "stand", "start", "state", "stay", "steak", "steel", "stem", "step", "stereo", "stick", "still", "sting", "stock", "stomach", "stone", "stool", "story", "stove", "strategy", "street", "strike", "strong", "struggle", "student", "stuff", "stumble", "style", "subject", "submit", "subway", "success", "such", "sudden", "suffer", "sugar", "suggest", "suit", "summer", "sun", "sunny", "sunset", "super", "supply", "supreme", "sure", "surface", "surge", "surprise", "surround", "survey", "suspect", "sustain", "swallow", "swamp", "swap", "swarm", "swear", "sweet", "swift", "swim", "swing", "switch", "sword", "symbol", "symptom", "syrup", "system", "table", "tackle", "tag", "tail", "talent", "talk", "tank", "tape", "target", "task", "taste", "tattoo", "taxi", "teach", "team", "tell", "ten", "tenant", "tennis", "tent", "term", "test", "text", "thank", "that", "theme", "then", "theory", "there", "they", "thing", "this", "thought", "three", "thrive", "throw", "thumb", "thunder", "ticket", "tide", "tiger", "tilt", "timber", "time", "tiny", "tip", "tired", "tissue", "title", "toast", "tobacco", "today", "toddler", "toe", "together", "toilet", "token", "tomato", "tomorrow", "tone", "tongue", "tonight", "tool", "tooth", "top", "topic", "topple", "torch", "tornado", "tortoise", "toss", "total", "tourist", "toward", "tower", "town", "toy", "track", "trade", "traffic", "tragic", "train", "transfer", "trap", "trash", "travel", "tray", "treat", "tree", "trend", "trial", "tribe", "trick", "trigger", "trim", "trip", "trophy", "trouble", "truck", "true", "truly", "trumpet", "trust", "truth", "try", "tube", "tuition", "tumble", "tuna", "tunnel", "turkey", "turn", "turtle", "twelve", "twenty", "twice", "twin", "twist", "two", "type", "typical", "ugly", "umbrella", "unable", "unaware", "uncle", "uncover", "under", "undo", "unfair", "unfold", "unhappy", "uniform", "unique", "unit", "universe", "unknown", "unlock", "until", "unusual", "unveil", "update", "upgrade", "uphold", "upon", "upper", "upset", "urban", "urge", "usage", "use", "used", "useful", "useless", "usual", "utility", "vacant", "vacuum", "vague", "valid", "valley", "valve", "van", "vanish", "vapor", "various", "vast", "vault", "vehicle", "velvet", "vendor", "venture", "venue", "verb", "verify", "version", "very", "vessel", "veteran", "viable", "vibrant", "vicious", "victory", "video", "view", "village", "vintage", "violin", "virtual", "virus", "visa", "visit", "visual", "vital", "vivid", "vocal", "voice", "void", "volcano", "volume", "vote", "voyage", "wage", "wagon", "wait", "walk", "wall", "walnut", "want", "warfare", "warm", "warrior", "wash", "wasp", "waste", "water", "wave", "way", "wealth", "weapon", "wear", "weasel", "weather", "web", "wedding", "weekend", "weird", "welcome", "west", "wet", "whale", "what", "wheat", "wheel", "when", "where", "whip", "whisper", "wide", "width", "wife", "wild", "will", "win", "window", "wine", "wing", "wink", "winner", "winter", "wire", "wisdom", "wise", "wish", "witness", "wolf", "woman", "wonder", "wood", "wool", "word", "work", "world", "worry", "worth", "wrap", "wreck", "wrestle", "wrist", "write", "wrong", "yard", "year", "yellow", "you", "young", "youth", "zebra", "zero", "zone", "zoo"];
        var o = r(9404),
            s = r(7116);
        var i = "failed to decode mnemonic";

        function a(e) {
          var t = [];
          var r = 0,
              n = 0;
          return e.forEach(function (e) {
            r |= e << n, n += 8, n >= 11 && (t.push(2047 & r), r >>= 11, n -= 11);
          }), n && t.push(r), t;
        }

        function c(e) {
          return e.map(function (e) {
            return n[e];
          });
        }

        function u(e) {
          return c(a(o.genericHash(e)))[0];
        }

        function l(e) {
          if (e.length !== o.SEED_BTYES_LENGTH) throw new RangeError("Seed length must be ".concat(o.SEED_BTYES_LENGTH));
          var t = c(a(e)),
              r = u(e);
          return "".concat(t.join(" "), " ").concat(r);
        }

        function h(e) {
          var t = e.split(" "),
              r = t.slice(0, 24);

          var _iterator11 = _createForOfIteratorHelper(r),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _e45 = _step11.value;
              if (-1 === n.indexOf(_e45)) throw new Error("the mnemonic contains a word that is not in the wordlist");
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }

          var o = t[t.length - 1];

          var s = function (e) {
            var t = [];
            var r = 0,
                n = 0;
            return e.forEach(function (e) {
              for (r |= e << n, n += 11; n >= 8;) {
                t.push(255 & r), r >>= 8, n -= 8;
              }
            }), n && t.push(r), new Uint8Array(t);
          }(r.map(function (e) {
            return n.indexOf(e);
          }));

          if (33 !== s.length) throw new Error(i);
          if (0 !== s[s.length - 1]) throw new Error(i);
          if (s = s.slice(0, s.length - 1), u(s) === o) return s;
          throw new Error(i);
        }

        function p(e) {
          var t = h(e),
              r = o.keyPairFromSeed(t);
          return {
            addr: s.encodeAddress(r.publicKey),
            sk: r.secretKey
          };
        }

        function f(e) {
          return l(e.slice(0, o.SEED_BTYES_LENGTH));
        }

        function d(e) {
          return h(e);
        }

        function g(e) {
          return l(e);
        }
      },
      4158: function _(e, t, r) {
        "use strict";

        r.d(t, {
          J6: function J6() {
            return p;
          },
          F2: function F2() {
            return f;
          },
          PU: function PU() {
            return d;
          },
          PO: function PO() {
            return g;
          },
          vH: function vH() {
            return y;
          }
        });
        var n = r(9404),
            o = r(7116),
            s = r(3033),
            i = r(9417),
            a = r(413),
            c = r(2486).Buffer;
        var u = "Cannot merge txs. Multisig preimages differ",
            l = "Cannot mutate a multisig field as it would invalidate all existing signatures.";

        var h = /*#__PURE__*/function (_i$Transaction) {
          _inherits(h, _i$Transaction);

          var _super79 = _createSuper(h);

          function h() {
            _classCallCheck(this, h);

            return _super79.apply(this, arguments);
          }

          _createClass(h, [{
            key: "addLease",
            value: function addLease() {
              throw new Error(l);
            }
          }, {
            key: "addRekey",
            value: function addRekey() {
              throw new Error(l);
            }
          }, {
            key: "signTxn",
            value: function signTxn(e) {
              throw new Error("Cannot sign a multisig transaction using `signTxn`. Use `partialSignTxn` instead.");
            }
          }, {
            key: "partialSignTxn",
            value: function partialSignTxn(_ref42, i) {
              var e = _ref42.version,
                  t = _ref42.threshold,
                  r = _ref42.pks;
              var a = n.keyPairFromSecretKey(i).publicKey;
              return function (e, _ref43, _ref44) {
                var t = _ref43.rawSig,
                    r = _ref43.myPk;
                var i = _ref44.version,
                    a = _ref44.threshold,
                    u = _ref44.pks;
                var l = !1;
                var h = u.map(function (e) {
                  return n.bytesEqual(e, r) ? (l = !0, {
                    pk: c.from(e),
                    s: t
                  }) : {
                    pk: c.from(e)
                  };
                });
                if (!1 === l) throw new Error("Key does not exist");
                var p = {
                  msig: {
                    v: i,
                    thr: a,
                    subsig: h
                  },
                  txn: e
                },
                    f = o.fromMultisigPreImg({
                  version: i,
                  threshold: a,
                  pks: u
                });
                return o.encodeAddress(e.snd) !== o.encodeAddress(f) && (p.sgnr = c.from(f)), new Uint8Array(s.encode(p));
              }(this.get_obj_for_encoding(), {
                rawSig: this.rawSignTxn(i),
                myPk: a
              }, {
                version: e,
                threshold: t,
                pks: r
              });
            }
          }], [{
            key: "from_obj_for_encoding",
            value: function from_obj_for_encoding(e) {
              return _get3(_getPrototypeOf(h), "from_obj_for_encoding", this).call(this, e);
            }
          }]);

          return h;
        }(i.Transaction);

        function p(e) {
          if (e.length < 2) throw new Error("Not enough multisig transactions to merge. Need at least two");
          var t = s.decode(e[0]),
              r = h.from_obj_for_encoding(t.txn).txID(),
              n = t.sgnr ? o.encodeAddress(t.sgnr) : void 0,
              i = {
            version: t.msig.v,
            threshold: t.msig.thr,
            pks: t.msig.subsig.map(function (e) {
              return e.pk;
            })
          },
              a = o.encodeAddress(o.fromMultisigPreImg(i));
          var l = t.msig.subsig;

          for (var _i21 = 0; _i21 < e.length; _i21++) {
            var _p = s.decode(e[_i21]);

            if (h.from_obj_for_encoding(_p.txn).txID() !== r) throw new Error("Cannot merge txs. txIDs differ");
            if (n !== (_p.sgnr ? o.encodeAddress(_p.sgnr) : void 0)) throw new Error("Cannot merge txs. Auth addrs differ");
            if (_p.msig.subsig.length !== t.msig.subsig.length) throw new Error(u);
            var _f = {
              version: _p.msig.v,
              threshold: _p.msig.thr,
              pks: _p.msig.subsig.map(function (e) {
                return e.pk;
              })
            };
            if (a !== o.encodeAddress(o.fromMultisigPreImg(_f))) throw new Error(u);
            l = _p.msig.subsig.map(function (e, r) {
              var n = t.msig.subsig[r];

              if (n.s) {
                if (e.s && 0 !== c.compare(c.from(e.s), c.from(n.s))) throw new Error("Cannot merge txs. subsigs are mismatched.");
                return {
                  pk: n.pk,
                  s: n.s
                };
              }

              return e.s ? {
                pk: n.pk,
                s: e.s
              } : n;
            });
          }

          var p = {
            msig: {
              v: t.msig.v,
              thr: t.msig.thr,
              subsig: l
            },
            txn: t.txn
          };
          return void 0 !== n && (p.sgnr = c.from(o.decodeAddress(n).publicKey)), new Uint8Array(s.encode(p));
        }

        function f(e, t, r) {
          var s = t.v,
              i = t.thr,
              c = t.subsig,
              u = c.map(function (e) {
            return e.pk;
          });
          if (t.subsig.length < i) return !1;
          var l;

          try {
            l = o.fromMultisigPreImg({
              version: s,
              threshold: i,
              pks: u
            });
          } catch (e) {
            return !1;
          }

          if (!a.arrayEqual(l, r)) return !1;
          var h = 0;

          var _iterator12 = _createForOfIteratorHelper(c),
              _step12;

          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var _e46 = _step12.value;
              void 0 !== _e46.s && (h += 1);
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }

          if (h < i) return !1;
          var p = 0;

          var _iterator13 = _createForOfIteratorHelper(c),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var _t45 = _step13.value;
              void 0 !== _t45.s && n.verify(e, _t45.s, _t45.pk) && (p += 1);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }

          return !(p < i);
        }

        function d(e, _ref45, s) {
          var t = _ref45.version,
              r = _ref45.threshold,
              n = _ref45.addrs;
          var a = o.fromMultisigPreImgAddrs({
            version: t,
            threshold: r,
            addrs: n
          });
          Object.prototype.hasOwnProperty.call(e, "from") || (e.from = a);
          var c = n.map(function (e) {
            return o.decodeAddress(e).publicKey;
          });
          var u, l;
          return e instanceof i.Transaction ? (u = e, l = h.prototype.partialSignTxn.call(u, {
            version: t,
            threshold: r,
            pks: c
          }, s)) : (u = new h(e), l = u.partialSignTxn({
            version: t,
            threshold: r,
            pks: c
          }, s)), {
            txID: u.txID().toString(),
            blob: l
          };
        }

        function g(e, _ref46, i) {
          var t = _ref46.version,
              r = _ref46.threshold,
              n = _ref46.addrs;
          var a = n.map(function (e) {
            return o.decodeAddress(e).publicKey;
          }),
              c = s.decode(e),
              u = h.from_obj_for_encoding(c.txn),
              l = u.partialSignTxn({
            version: t,
            threshold: r,
            pks: a
          }, i);
          return {
            txID: u.txID().toString(),
            blob: p([e, l])
          };
        }

        function y(_ref47) {
          var e = _ref47.version,
              t = _ref47.threshold,
              r = _ref47.addrs;
          return o.fromMultisigPreImgAddrs({
            version: e,
            threshold: t,
            addrs: r
          });
        }
      },
      9404: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          genericHash: function genericHash() {
            return a;
          },
          randomBytes: function randomBytes() {
            return c;
          },
          keyPairFromSeed: function keyPairFromSeed() {
            return u;
          },
          keyPair: function keyPair() {
            return l;
          },
          keyPairFromSecretKey: function keyPairFromSecretKey() {
            return h;
          },
          sign: function sign() {
            return p;
          },
          bytesEqual: function bytesEqual() {
            return f;
          },
          verify: function verify() {
            return d;
          },
          PUBLIC_KEY_LENGTH: function PUBLIC_KEY_LENGTH() {
            return g;
          },
          SECRET_KEY_LENGTH: function SECRET_KEY_LENGTH() {
            return y;
          },
          HASH_BYTES_LENGTH: function HASH_BYTES_LENGTH() {
            return m;
          },
          SEED_BTYES_LENGTH: function SEED_BTYES_LENGTH() {
            return b;
          }
        });
        var n = r(7765),
            o = r.n(n),
            s = r(9757),
            i = r.n(s);

        function a(e) {
          return i().sha512_256.array(e);
        }

        function c(e) {
          return o().randomBytes(e);
        }

        function u(e) {
          return o().sign.keyPair.fromSeed(e);
        }

        function l() {
          return u(c(o().box.secretKeyLength));
        }

        function h(e) {
          return o().sign.keyPair.fromSecretKey(e);
        }

        function p(e, t) {
          return o().sign.detached(e, t);
        }

        function f(e, t) {
          return o().verify(e, t);
        }

        function d(e, t, r) {
          return o().sign.detached.verify(e, t, r);
        }

        var g = o().sign.publicKeyLength,
            y = o().sign.secretKeyLength,
            m = 32,
            b = 32;
      },
      834: function _(e, t, r) {
        "use strict";

        r.d(t, {
          x7: function x7() {
            return s;
          },
          i1: function i1() {
            return i;
          },
          Vj: function Vj() {
            return a;
          },
          Xw: function Xw() {
            return c;
          }
        });
        var n = r(8800),
            o = r(4158);

        function s(e) {
          return function (t, r) {
            var n = [];

            var _iterator14 = _createForOfIteratorHelper(r),
                _step14;

            try {
              for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                var _o19 = _step14.value;
                n.push(t[_o19].signTxn(e.sk));
              }
            } catch (err) {
              _iterator14.e(err);
            } finally {
              _iterator14.f();
            }

            return Promise.resolve(n);
          };
        }

        function i(e) {
          return function (t, r) {
            var o = [];

            var _iterator15 = _createForOfIteratorHelper(r),
                _step15;

            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var _s54 = _step15.value;

                var _ref48 = (0, n.signLogicSigTransactionObject)(t[_s54], e),
                    _r36 = _ref48.blob;

                o.push(_r36);
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }

            return Promise.resolve(o);
          };
        }

        function a(e, t) {
          return function (r, n) {
            var s = [];

            var _iterator16 = _createForOfIteratorHelper(n),
                _step16;

            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var _i22 = _step16.value;
                var _n29 = r[_i22],
                    _a10 = [];

                var _iterator17 = _createForOfIteratorHelper(t),
                    _step17;

                try {
                  for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                    var _r37 = _step17.value;

                    var _ref49 = (0, o.PU)(_n29, e, _r37),
                        _t46 = _ref49.blob;

                    _a10.push(_t46);
                  }
                } catch (err) {
                  _iterator17.e(err);
                } finally {
                  _iterator17.f();
                }

                s.push((0, o.J6)(_a10));
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }

            return Promise.resolve(s);
          };
        }

        function c(e) {
          return "object" == typeof e && 2 === Object.keys(e).length && "object" == typeof e.txn && "function" == typeof e.signer;
        }
      },
      9417: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          ALGORAND_MIN_TX_FEE: function ALGORAND_MIN_TX_FEE() {
            return h;
          },
          Transaction: function Transaction() {
            return p;
          },
          encodeUnsignedTransaction: function encodeUnsignedTransaction() {
            return f;
          },
          decodeUnsignedTransaction: function decodeUnsignedTransaction() {
            return d;
          },
          decodeSignedTransaction: function decodeSignedTransaction() {
            return g;
          },
          instantiateTxnIfNeeded: function instantiateTxnIfNeeded() {
            return y;
          },
          default: function _default() {
            return m;
          }
        });
        var n = r(7267),
            o = r.n(n),
            s = r(7116),
            i = r(3033),
            a = r(9404),
            c = r(413),
            u = r(1624),
            l = r(2486).Buffer;
        var h = 1e3;

        var p = /*#__PURE__*/function () {
          function p(_ref50) {
            var e = Object.assign({}, _ref50);

            _classCallCheck(this, p);

            this.name = "Transaction", this.tag = l.from("TX");
            var t = {
              type: u.i.pay,
              flatFee: !1,
              nonParticipation: !1
            };

            if (void 0 === e.type && (e.type = t.type), void 0 === e.flatFee && (e.flatFee = t.flatFee), e.type === u.i.keyreg && void 0 !== e.voteKey && void 0 === e.nonParticipation && (e.nonParticipation = t.nonParticipation), void 0 !== e.suggestedParams) {
              var _t47 = e;
              _t47.genesisHash = _t47.suggestedParams.genesisHash, _t47.fee = _t47.suggestedParams.fee, void 0 !== _t47.suggestedParams.flatFee && (_t47.flatFee = _t47.suggestedParams.flatFee), _t47.firstRound = _t47.suggestedParams.firstRound, _t47.lastRound = _t47.suggestedParams.lastRound, _t47.genesisID = _t47.suggestedParams.genesisID;
            }

            var r = e;
            if (r.from = s.decodeAddress(r.from), void 0 !== r.to && (r.to = s.decodeAddress(r.to)), void 0 !== r.closeRemainderTo && (r.closeRemainderTo = s.decodeAddress(r.closeRemainderTo)), void 0 !== r.assetManager && (r.assetManager = s.decodeAddress(r.assetManager)), void 0 !== r.assetReserve && (r.assetReserve = s.decodeAddress(r.assetReserve)), void 0 !== r.assetFreeze && (r.assetFreeze = s.decodeAddress(r.assetFreeze)), void 0 !== r.assetClawback && (r.assetClawback = s.decodeAddress(r.assetClawback)), void 0 !== r.assetRevocationTarget && (r.assetRevocationTarget = s.decodeAddress(r.assetRevocationTarget)), void 0 !== r.freezeAccount && (r.freezeAccount = s.decodeAddress(r.freezeAccount)), void 0 !== r.reKeyTo && (r.reKeyTo = s.decodeAddress(r.reKeyTo)), void 0 === r.genesisHash) throw Error("genesis hash must be specified and in a base64 string.");
            if (r.genesisHash = l.from(r.genesisHash, "base64"), void 0 !== r.amount && (!(Number.isSafeInteger(r.amount) || "bigint" == typeof r.amount && r.amount <= BigInt("0xffffffffffffffff")) || r.amount < 0)) throw Error("Amount must be a positive number and smaller than 2^64-1. If the number is larger than 2^53-1, use bigint.");
            if (!Number.isSafeInteger(r.fee) || r.fee < 0) throw Error("fee must be a positive number and smaller than 2^53-1");
            if (!Number.isSafeInteger(r.firstRound) || r.firstRound < 0) throw Error("firstRound must be a positive number");
            if (!Number.isSafeInteger(r.lastRound) || r.lastRound < 0) throw Error("lastRound must be a positive number");
            if (void 0 !== r.extraPages && (!Number.isInteger(r.extraPages) || r.extraPages < 0 || r.extraPages > 3)) throw Error("extraPages must be an Integer between and including 0 to 3");
            if (void 0 !== r.assetTotal && (!(Number.isSafeInteger(r.assetTotal) || "bigint" == typeof r.assetTotal && r.assetTotal <= BigInt("0xffffffffffffffff")) || r.assetTotal < 0)) throw Error("Total asset issuance must be a positive number and smaller than 2^64-1. If the number is larger than 2^53-1, use bigint.");
            if (void 0 !== r.assetDecimals && (!Number.isSafeInteger(r.assetDecimals) || r.assetDecimals < 0 || r.assetDecimals > 19)) throw Error("assetDecimals must be a positive number and smaller than ".concat(19..toString()));
            if (void 0 !== r.assetIndex && (!Number.isSafeInteger(r.assetIndex) || r.assetIndex < 0)) throw Error("Asset index must be a positive number and smaller than 2^53-1");
            if (void 0 !== r.appIndex && (!Number.isSafeInteger(r.appIndex) || r.appIndex < 0)) throw Error("Application index must be a positive number and smaller than 2^53-1");
            if (void 0 !== r.appLocalInts && (!Number.isSafeInteger(r.appLocalInts) || r.appLocalInts < 0)) throw Error("Application local ints count must be a positive number and smaller than 2^53-1");
            if (void 0 !== r.appLocalByteSlices && (!Number.isSafeInteger(r.appLocalByteSlices) || r.appLocalByteSlices < 0)) throw Error("Application local byte slices count must be a positive number and smaller than 2^53-1");
            if (void 0 !== r.appGlobalInts && (!Number.isSafeInteger(r.appGlobalInts) || r.appGlobalInts < 0)) throw Error("Application global ints count must be a positive number and smaller than 2^53-1");
            if (void 0 !== r.appGlobalByteSlices && (!Number.isSafeInteger(r.appGlobalByteSlices) || r.appGlobalByteSlices < 0)) throw Error("Application global byte slices count must be a positive number and smaller than 2^53-1");
            if (void 0 !== r.appApprovalProgram && r.appApprovalProgram.constructor !== Uint8Array) throw Error("appApprovalProgram must be a Uint8Array.");
            if (void 0 !== r.appClearProgram && r.appClearProgram.constructor !== Uint8Array) throw Error("appClearProgram must be a Uint8Array.");

            if (void 0 !== r.appArgs) {
              if (!Array.isArray(r.appArgs)) throw Error("appArgs must be an Array of Uint8Array.");
              r.appArgs = r.appArgs.slice(), r.appArgs.forEach(function (e) {
                if (e.constructor !== Uint8Array) throw Error("each element of AppArgs must be a Uint8Array.");
              });
            } else r.appArgs = [];

            if (void 0 !== r.appAccounts) {
              if (!Array.isArray(r.appAccounts)) throw Error("appAccounts must be an Array of addresses.");
              r.appAccounts = r.appAccounts.map(function (e) {
                return s.decodeAddress(e);
              });
            }

            if (void 0 !== r.appForeignApps) {
              if (!Array.isArray(r.appForeignApps)) throw Error("appForeignApps must be an Array of integers.");
              r.appForeignApps = r.appForeignApps.slice(), r.appForeignApps.forEach(function (e) {
                if (!Number.isSafeInteger(e) || e < 0) throw Error("each foreign application index must be a positive number and smaller than 2^53-1");
              });
            }

            if (void 0 !== r.appForeignAssets) {
              if (!Array.isArray(r.appForeignAssets)) throw Error("appForeignAssets must be an Array of integers.");
              r.appForeignAssets = r.appForeignAssets.slice(), r.appForeignAssets.forEach(function (e) {
                if (!Number.isSafeInteger(e) || e < 0) throw Error("each foreign asset index must be a positive number and smaller than 2^53-1");
              });
            }

            if (void 0 !== r.assetMetadataHash && 0 !== r.assetMetadataHash.length) {
              if ("string" == typeof r.assetMetadataHash && (r.assetMetadataHash = new Uint8Array(l.from(r.assetMetadataHash))), r.assetMetadataHash.constructor !== Uint8Array || 32 !== r.assetMetadataHash.byteLength) throw Error("assetMetadataHash must be a 32 byte Uint8Array or string.");
              r.assetMetadataHash.every(function (e) {
                return 0 === e;
              }) && (r.assetMetadataHash = void 0);
            } else r.assetMetadataHash = void 0;

            if (void 0 !== r.note) {
              if (r.note.constructor !== Uint8Array) throw Error("note must be a Uint8Array.");
            } else r.note = new Uint8Array(0);

            if (void 0 !== r.lease) {
              if (r.lease.constructor !== Uint8Array) throw Error("lease must be a Uint8Array.");
              if (32 !== r.lease.length) throw Error("lease must be of length ".concat(32..toString(), "."));
              r.lease.every(function (e) {
                return 0 === e;
              }) && (r.lease = new Uint8Array(0));
            } else r.lease = new Uint8Array(0);

            if (void 0 !== r.voteKey && (r.voteKey = l.from(r.voteKey, "base64")), void 0 !== r.selectionKey && (r.selectionKey = l.from(r.selectionKey, "base64")), r.nonParticipation && (r.voteKey || r.selectionKey || r.voteFirst || r.voteLast || r.voteKeyDilution)) throw new Error("nonParticipation is true but participation params are present.");
            if (!r.nonParticipation && (r.voteKey || r.selectionKey || r.voteFirst || r.voteLast || r.voteKeyDilution) && !(r.voteKey && r.selectionKey && r.voteFirst && r.voteLast && r.voteKeyDilution)) throw new Error("online key registration missing at least one of the following fields: voteKey, selectionKey, voteFirst, voteLast, voteKeyDilution");
            delete r.suggestedParams, Object.assign(this, c.removeUndefinedProperties(r)), r.flatFee || (this.fee *= this.estimateSize(), this.fee < h && (this.fee = h)), this.group = void 0;
          }

          _createClass(p, [{
            key: "get_obj_for_encoding",
            value: function get_obj_for_encoding() {
              if ("pay" === this.type) {
                var _e47 = {
                  amt: this.amount,
                  fee: this.fee,
                  fv: this.firstRound,
                  lv: this.lastRound,
                  note: l.from(this.note),
                  snd: l.from(this.from.publicKey),
                  type: "pay",
                  gen: this.genesisID,
                  gh: this.genesisHash,
                  lx: l.from(this.lease),
                  grp: this.group
                };
                return void 0 !== this.closeRemainderTo && s.encodeAddress(this.closeRemainderTo.publicKey) !== s.ALGORAND_ZERO_ADDRESS_STRING && (_e47.close = l.from(this.closeRemainderTo.publicKey)), void 0 !== this.reKeyTo && (_e47.rekey = l.from(this.reKeyTo.publicKey)), void 0 !== this.to && (_e47.rcv = l.from(this.to.publicKey)), _e47.note.length || delete _e47.note, _e47.amt || delete _e47.amt, _e47.fee || delete _e47.fee, _e47.fv || delete _e47.fv, _e47.gen || delete _e47.gen, void 0 === _e47.grp && delete _e47.grp, _e47.lx.length || delete _e47.lx, _e47.rekey || delete _e47.rekey, _e47;
              }

              if ("keyreg" === this.type) {
                var _e48 = {
                  fee: this.fee,
                  fv: this.firstRound,
                  lv: this.lastRound,
                  note: l.from(this.note),
                  snd: l.from(this.from.publicKey),
                  type: this.type,
                  gen: this.genesisID,
                  gh: this.genesisHash,
                  lx: l.from(this.lease),
                  grp: this.group,
                  votekey: this.voteKey,
                  selkey: this.selectionKey,
                  votefst: this.voteFirst,
                  votelst: this.voteLast,
                  votekd: this.voteKeyDilution
                };
                return _e48.note.length || delete _e48.note, _e48.lx.length || delete _e48.lx, _e48.fee || delete _e48.fee, _e48.fv || delete _e48.fv, _e48.gen || delete _e48.gen, void 0 === _e48.grp && delete _e48.grp, void 0 !== this.reKeyTo && (_e48.rekey = l.from(this.reKeyTo.publicKey)), this.nonParticipation && (_e48.nonpart = !0), _e48.selkey || delete _e48.selkey, _e48.votekey || delete _e48.votekey, _e48.votefst || delete _e48.votefst, _e48.votelst || delete _e48.votelst, _e48.votekd || delete _e48.votekd, _e48;
              }

              if ("acfg" === this.type) {
                var _e49 = {
                  fee: this.fee,
                  fv: this.firstRound,
                  lv: this.lastRound,
                  note: l.from(this.note),
                  snd: l.from(this.from.publicKey),
                  type: this.type,
                  gen: this.genesisID,
                  gh: this.genesisHash,
                  lx: l.from(this.lease),
                  grp: this.group,
                  caid: this.assetIndex,
                  apar: {
                    t: this.assetTotal,
                    df: this.assetDefaultFrozen,
                    dc: this.assetDecimals
                  }
                };
                return void 0 !== this.assetManager && (_e49.apar.m = l.from(this.assetManager.publicKey)), void 0 !== this.assetReserve && (_e49.apar.r = l.from(this.assetReserve.publicKey)), void 0 !== this.assetFreeze && (_e49.apar.f = l.from(this.assetFreeze.publicKey)), void 0 !== this.assetClawback && (_e49.apar.c = l.from(this.assetClawback.publicKey)), void 0 !== this.assetName && (_e49.apar.an = this.assetName), void 0 !== this.assetUnitName && (_e49.apar.un = this.assetUnitName), void 0 !== this.assetURL && (_e49.apar.au = this.assetURL), void 0 !== this.assetMetadataHash && (_e49.apar.am = l.from(this.assetMetadataHash)), _e49.note.length || delete _e49.note, _e49.lx.length || delete _e49.lx, _e49.amt || delete _e49.amt, _e49.fee || delete _e49.fee, _e49.fv || delete _e49.fv, _e49.gen || delete _e49.gen, void 0 !== this.reKeyTo && (_e49.rekey = l.from(this.reKeyTo.publicKey)), _e49.caid || delete _e49.caid, _e49.apar.t || _e49.apar.un || _e49.apar.an || _e49.apar.df || _e49.apar.m || _e49.apar.r || _e49.apar.f || _e49.apar.c || _e49.apar.au || _e49.apar.am || _e49.apar.dc ? (_e49.apar.t || delete _e49.apar.t, _e49.apar.dc || delete _e49.apar.dc, _e49.apar.un || delete _e49.apar.un, _e49.apar.an || delete _e49.apar.an, _e49.apar.df || delete _e49.apar.df, _e49.apar.m || delete _e49.apar.m, _e49.apar.r || delete _e49.apar.r, _e49.apar.f || delete _e49.apar.f, _e49.apar.c || delete _e49.apar.c, _e49.apar.au || delete _e49.apar.au, _e49.apar.am || delete _e49.apar.am) : delete _e49.apar, void 0 === _e49.grp && delete _e49.grp, _e49;
              }

              if ("axfer" === this.type) {
                var _e50 = {
                  aamt: this.amount,
                  fee: this.fee,
                  fv: this.firstRound,
                  lv: this.lastRound,
                  note: l.from(this.note),
                  snd: l.from(this.from.publicKey),
                  arcv: l.from(this.to.publicKey),
                  type: this.type,
                  gen: this.genesisID,
                  gh: this.genesisHash,
                  lx: l.from(this.lease),
                  grp: this.group,
                  xaid: this.assetIndex
                };
                return void 0 !== this.closeRemainderTo && (_e50.aclose = l.from(this.closeRemainderTo.publicKey)), void 0 !== this.assetRevocationTarget && (_e50.asnd = l.from(this.assetRevocationTarget.publicKey)), _e50.note.length || delete _e50.note, _e50.lx.length || delete _e50.lx, _e50.aamt || delete _e50.aamt, _e50.amt || delete _e50.amt, _e50.fee || delete _e50.fee, _e50.fv || delete _e50.fv, _e50.gen || delete _e50.gen, void 0 === _e50.grp && delete _e50.grp, _e50.aclose || delete _e50.aclose, _e50.asnd || delete _e50.asnd, _e50.rekey || delete _e50.rekey, void 0 !== this.reKeyTo && (_e50.rekey = l.from(this.reKeyTo.publicKey)), _e50;
              }

              if ("afrz" === this.type) {
                var _e51 = {
                  fee: this.fee,
                  fv: this.firstRound,
                  lv: this.lastRound,
                  note: l.from(this.note),
                  snd: l.from(this.from.publicKey),
                  type: this.type,
                  gen: this.genesisID,
                  gh: this.genesisHash,
                  lx: l.from(this.lease),
                  grp: this.group,
                  faid: this.assetIndex,
                  afrz: this.freezeState
                };
                return void 0 !== this.freezeAccount && (_e51.fadd = l.from(this.freezeAccount.publicKey)), _e51.note.length || delete _e51.note, _e51.lx.length || delete _e51.lx, _e51.amt || delete _e51.amt, _e51.fee || delete _e51.fee, _e51.fv || delete _e51.fv, _e51.gen || delete _e51.gen, _e51.afrz || delete _e51.afrz, void 0 === _e51.grp && delete _e51.grp, void 0 !== this.reKeyTo && (_e51.rekey = l.from(this.reKeyTo.publicKey)), _e51;
              }

              if ("appl" === this.type) {
                var _e52 = {
                  fee: this.fee,
                  fv: this.firstRound,
                  lv: this.lastRound,
                  note: l.from(this.note),
                  snd: l.from(this.from.publicKey),
                  type: this.type,
                  gen: this.genesisID,
                  gh: this.genesisHash,
                  lx: l.from(this.lease),
                  grp: this.group,
                  apid: this.appIndex,
                  apan: this.appOnComplete,
                  apls: {
                    nui: this.appLocalInts,
                    nbs: this.appLocalByteSlices
                  },
                  apgs: {
                    nui: this.appGlobalInts,
                    nbs: this.appGlobalByteSlices
                  },
                  apfa: this.appForeignApps,
                  apas: this.appForeignAssets,
                  apep: this.extraPages
                };
                return void 0 !== this.reKeyTo && (_e52.rekey = l.from(this.reKeyTo.publicKey)), void 0 !== this.appApprovalProgram && (_e52.apap = l.from(this.appApprovalProgram)), void 0 !== this.appClearProgram && (_e52.apsu = l.from(this.appClearProgram)), void 0 !== this.appArgs && (_e52.apaa = this.appArgs.map(function (e) {
                  return l.from(e);
                })), void 0 !== this.appAccounts && (_e52.apat = this.appAccounts.map(function (e) {
                  return l.from(e.publicKey);
                })), _e52.note.length || delete _e52.note, _e52.lx.length || delete _e52.lx, _e52.amt || delete _e52.amt, _e52.fee || delete _e52.fee, _e52.fv || delete _e52.fv, _e52.gen || delete _e52.gen, _e52.apid || delete _e52.apid, _e52.apls.nui || delete _e52.apls.nui, _e52.apls.nbs || delete _e52.apls.nbs, _e52.apls.nui || _e52.apls.nbs || delete _e52.apls, _e52.apgs.nui || delete _e52.apgs.nui, _e52.apgs.nbs || delete _e52.apgs.nbs, _e52.apaa && _e52.apaa.length || delete _e52.apaa, _e52.apgs.nui || _e52.apgs.nbs || delete _e52.apgs, _e52.apap || delete _e52.apap, _e52.apsu || delete _e52.apsu, _e52.apan || delete _e52.apan, _e52.apfa && _e52.apfa.length || delete _e52.apfa, _e52.apas && _e52.apas.length || delete _e52.apas, _e52.apat && _e52.apat.length || delete _e52.apat, _e52.apep || delete _e52.apep, void 0 === _e52.grp && delete _e52.grp, _e52;
              }
            }
          }, {
            key: "estimateSize",
            value: function estimateSize() {
              return this.toByte().length + 75;
            }
          }, {
            key: "bytesToSign",
            value: function bytesToSign() {
              var e = this.toByte();
              return l.from(c.concatArrays(this.tag, e));
            }
          }, {
            key: "toByte",
            value: function toByte() {
              return i.encode(this.get_obj_for_encoding());
            }
          }, {
            key: "rawSignTxn",
            value: function rawSignTxn(e) {
              var t = this.bytesToSign(),
                  r = a.sign(t, e);
              return l.from(r);
            }
          }, {
            key: "signTxn",
            value: function signTxn(e) {
              var t = {
                sig: this.rawSignTxn(e),
                txn: this.get_obj_for_encoding()
              },
                  r = a.keyPairFromSecretKey(e).publicKey;
              return s.encodeAddress(r) !== s.encodeAddress(this.from.publicKey) && (t.sgnr = l.from(r)), new Uint8Array(i.encode(t));
            }
          }, {
            key: "rawTxID",
            value: function rawTxID() {
              var e = this.toByte(),
                  t = l.from(c.concatArrays(this.tag, e));
              return l.from(a.genericHash(t));
            }
          }, {
            key: "txID",
            value: function txID() {
              var e = this.rawTxID();
              return o().encode(e).slice(0, 52);
            }
          }, {
            key: "addLease",
            value: function addLease(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var r;

              if (void 0 !== e) {
                if (e.constructor !== Uint8Array) throw Error("lease must be a Uint8Array.");
                if (32 !== e.length) throw Error("lease must be of length ".concat(32..toString(), "."));
                r = new Uint8Array(e);
              } else r = new Uint8Array(0);

              this.lease = r, 0 !== t && (this.fee += 37 * t);
            }
          }, {
            key: "addRekey",
            value: function addRekey(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              void 0 !== e && (this.reKeyTo = s.decodeAddress(e)), 0 !== t && (this.fee += 37 * t);
            }
          }, {
            key: "_getDictForDisplay",
            value: function _getDictForDisplay() {
              var e = _objectSpread({}, this);

              return e.tag = e.tag.toString(), e.from = s.encodeAddress(e.from.publicKey), void 0 !== e.to && (e.to = s.encodeAddress(e.to.publicKey)), void 0 !== e.freezeAccount && (e.freezeAccount = s.encodeAddress(e.freezeAccount.publicKey)), void 0 !== e.closeRemainderTo && (e.closeRemainderTo = s.encodeAddress(e.closeRemainderTo.publicKey)), void 0 !== e.assetManager && (e.assetManager = s.encodeAddress(e.assetManager.publicKey)), void 0 !== e.assetReserve && (e.assetReserve = s.encodeAddress(e.assetReserve.publicKey)), void 0 !== e.assetFreeze && (e.assetFreeze = s.encodeAddress(e.assetFreeze.publicKey)), void 0 !== e.assetClawback && (e.assetClawback = s.encodeAddress(e.assetClawback.publicKey)), void 0 !== e.assetRevocationTarget && (e.assetRevocationTarget = s.encodeAddress(e.assetRevocationTarget.publicKey)), void 0 !== e.reKeyTo && (e.reKeyTo = s.encodeAddress(e.reKeyTo.publicKey)), e.genesisHash = e.genesisHash.toString("base64"), e;
            }
          }, {
            key: "prettyPrint",
            value: function prettyPrint() {
              console.log(this._getDictForDisplay());
            }
          }, {
            key: "toString",
            value: function toString() {
              return JSON.stringify(this._getDictForDisplay());
            }
          }], [{
            key: "from_obj_for_encoding",
            value: function from_obj_for_encoding(e) {
              var t = Object.create(this.prototype);
              return t.name = "Transaction", t.tag = l.from("TX"), t.genesisID = e.gen, t.genesisHash = l.from(e.gh), t.type = e.type, t.fee = e.fee, t.firstRound = e.fv, t.lastRound = e.lv, t.note = new Uint8Array(e.note), t.lease = new Uint8Array(e.lx), t.from = s.decodeAddress(s.encodeAddress(new Uint8Array(e.snd))), void 0 !== e.grp && (t.group = l.from(e.grp)), void 0 !== e.rekey && (t.reKeyTo = s.decodeAddress(s.encodeAddress(new Uint8Array(e.rekey)))), "pay" === e.type ? (t.amount = e.amt, t.to = s.decodeAddress(s.encodeAddress(new Uint8Array(e.rcv))), void 0 !== e.close && (t.closeRemainderTo = s.decodeAddress(s.encodeAddress(e.close)))) : "keyreg" === e.type ? (void 0 !== e.votekey && (t.voteKey = l.from(e.votekey)), void 0 !== e.selkey && (t.selectionKey = l.from(e.selkey)), void 0 !== e.votekd && (t.voteKeyDilution = e.votekd), void 0 !== e.votefst && (t.voteFirst = e.votefst), void 0 !== e.votelst && (t.voteLast = e.votelst), void 0 !== e.nonpart && (t.nonParticipation = e.nonpart)) : "acfg" === e.type ? (void 0 !== e.caid && (t.assetIndex = e.caid), void 0 !== e.apar && (t.assetTotal = e.apar.t, t.assetDefaultFrozen = e.apar.df, void 0 !== e.apar.dc && (t.assetDecimals = e.apar.dc), void 0 !== e.apar.m && (t.assetManager = s.decodeAddress(s.encodeAddress(new Uint8Array(e.apar.m)))), void 0 !== e.apar.r && (t.assetReserve = s.decodeAddress(s.encodeAddress(new Uint8Array(e.apar.r)))), void 0 !== e.apar.f && (t.assetFreeze = s.decodeAddress(s.encodeAddress(new Uint8Array(e.apar.f)))), void 0 !== e.apar.c && (t.assetClawback = s.decodeAddress(s.encodeAddress(new Uint8Array(e.apar.c)))), void 0 !== e.apar.un && (t.assetUnitName = e.apar.un), void 0 !== e.apar.an && (t.assetName = e.apar.an), void 0 !== e.apar.au && (t.assetURL = e.apar.au), void 0 !== e.apar.am && (t.assetMetadataHash = e.apar.am))) : "axfer" === e.type ? (void 0 !== e.xaid && (t.assetIndex = e.xaid), void 0 !== e.aamt && (t.amount = e.aamt), void 0 !== e.aclose && (t.closeRemainderTo = s.decodeAddress(s.encodeAddress(new Uint8Array(e.aclose)))), void 0 !== e.asnd && (t.assetRevocationTarget = s.decodeAddress(s.encodeAddress(new Uint8Array(e.asnd)))), t.to = s.decodeAddress(s.encodeAddress(new Uint8Array(e.arcv)))) : "afrz" === e.type ? (void 0 !== e.afrz && (t.freezeState = e.afrz), void 0 !== e.faid && (t.assetIndex = e.faid), t.freezeAccount = s.decodeAddress(s.encodeAddress(new Uint8Array(e.fadd)))) : "appl" === e.type && (void 0 !== e.apid && (t.appIndex = e.apid), void 0 !== e.apan && (t.appOnComplete = e.apan), void 0 !== e.apls && (void 0 !== e.apls.nui && (t.appLocalInts = e.apls.nui), void 0 !== e.apls.nbs && (t.appLocalByteSlices = e.apls.nbs)), void 0 !== e.apgs && (void 0 !== e.apgs.nui && (t.appGlobalInts = e.apgs.nui), void 0 !== e.apgs.nbs && (t.appGlobalByteSlices = e.apgs.nbs)), void 0 !== e.apep && (t.extraPages = e.apep), void 0 !== e.apap && (t.appApprovalProgram = new Uint8Array(e.apap)), void 0 !== e.apsu && (t.appClearProgram = new Uint8Array(e.apsu)), void 0 !== e.apaa && (t.appArgs = e.apaa.map(function (e) {
                return new Uint8Array(e);
              })), void 0 !== e.apat && (t.appAccounts = e.apat.map(function (e) {
                return s.decodeAddress(s.encodeAddress(new Uint8Array(e)));
              })), void 0 !== e.apfa && (t.appForeignApps = e.apfa), void 0 !== e.apas && (t.appForeignAssets = e.apas)), t;
            }
          }]);

          return p;
        }();

        function f(e) {
          var t = e.get_obj_for_encoding();
          return i.encode(t);
        }

        function d(e) {
          var t = i.decode(e);
          return p.from_obj_for_encoding(t);
        }

        function g(e) {
          var t = i.decode(e);
          return _objectSpread(_objectSpread({}, t), {}, {
            txn: p.from_obj_for_encoding(t.txn)
          });
        }

        function y(e) {
          return e instanceof p ? e : new p(e);
        }

        var m = p;
      },
      2380: function _(e, t, r) {
        "use strict";

        r.d(t, {
          i: function i() {
            return n.i;
          }
        });
        var n = r(1824);
      },
      7197: function _(e, t, r) {
        "use strict";

        var n;
        r.d(t, {
          Z: function Z() {
            return o;
          }
        }), function (e) {
          e.DEFAULT = "default", e.SAFE = "safe", e.MIXED = "mixed", e.BIGINT = "bigint";
        }(n || (n = {}));
        var o = n;
      },
      1624: function _(e, t, r) {
        "use strict";

        var n, o;
        r.d(t, {
          i: function i() {
            return n;
          },
          h: function h() {
            return o;
          }
        }), function (e) {
          e.pay = "pay", e.keyreg = "keyreg", e.acfg = "acfg", e.axfer = "axfer", e.afrz = "afrz", e.appl = "appl";
        }(n || (n = {})), function (e) {
          e[e.NoOpOC = 0] = "NoOpOC", e[e.OptInOC = 1] = "OptInOC", e[e.CloseOutOC = 2] = "CloseOutOC", e[e.ClearStateOC = 3] = "ClearStateOC", e[e.UpdateApplicationOC = 4] = "UpdateApplicationOC", e[e.DeleteApplicationOC = 5] = "DeleteApplicationOC";
        }(o || (o = {}));
      },
      1824: function _(e, t, r) {
        "use strict";

        r.d(t, {
          i: function i() {
            return n.i;
          }
        });
        var n = r(1624);
      },
      413: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          parseJSON: function parseJSON() {
            return a;
          },
          arrayEqual: function arrayEqual() {
            return c;
          },
          concatArrays: function concatArrays() {
            return u;
          },
          removeUndefinedProperties: function removeUndefinedProperties() {
            return l;
          },
          isNode: function isNode() {
            return h;
          }
        });
        var n = r(4360),
            o = r.n(n),
            s = r(7197);
        var i = o()({
          useNativeBigInt: !0,
          strict: !0
        });

        function a(e, t) {
          var r = t && t.intDecoding ? t.intDecoding : s.Z.DEFAULT;
          return i.parse(e, function (e, t) {
            if (null != t && "object" == typeof t && null == Object.getPrototypeOf(t) && Object.setPrototypeOf(t, Object.prototype), "bigint" == typeof t) {
              if ("bigint" === r || "mixed" === r && t > Number.MAX_SAFE_INTEGER) return t;
              if ("default" === r || "mixed" === r) return Number(t);
              throw new Error("Integer exceeds maximum safe integer: ".concat(t.toString(), ". Try parsing with a different intDecoding option."));
            }

            return "number" == typeof t && "bigint" === r && Number.isInteger(t) ? BigInt(t) : t;
          });
        }

        function c(e, t) {
          return e.length === t.length && Array.from(e).every(function (e, r) {
            return e === t[r];
          });
        }

        function u() {
          for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
            e[_key] = arguments[_key];
          }

          var t = e.reduce(function (e, t) {
            return e + t.length;
          }, 0),
              r = new Uint8Array(t);
          var n = 0;

          for (var _t48 = 0; _t48 < e.length; _t48++) {
            r.set(e[_t48], n), n += e[_t48].length;
          }

          return r;
        }

        function l(e) {
          var t = _objectSpread({}, e);

          return Object.keys(t).forEach(function (e) {
            void 0 === t[e] && delete t[e];
          }), t;
        }

        function h() {
          return "object" == typeof process && "object" == typeof process.versions && void 0 !== process.versions.node;
        }
      },
      5062: function _(e, t, r) {
        "use strict";

        function n(_x78, _x79, _x80) {
          return _n30.apply(this, arguments);
        }

        function _n30() {
          _n30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(e, t, r) {
            var n, o, s, _r38, _n31;

            return _regeneratorRuntime.wrap(function _callee56$(_context56) {
              while (1) {
                switch (_context56.prev = _context56.next) {
                  case 0:
                    _context56.next = 2;
                    return e.status().do();

                  case 2:
                    n = _context56.sent;

                    if (!(void 0 === n)) {
                      _context56.next = 5;
                      break;
                    }

                    throw new Error("Unable to get node status");

                  case 5:
                    o = n["last-round"] + 1;
                    s = o;

                  case 7:
                    if (!(s < o + r)) {
                      _context56.next = 28;
                      break;
                    }

                    _r38 = !1;
                    _context56.prev = 9;
                    _context56.next = 12;
                    return e.pendingTransactionInformation(t).do();

                  case 12:
                    _n31 = _context56.sent;

                    if (!_n31["confirmed-round"]) {
                      _context56.next = 15;
                      break;
                    }

                    return _context56.abrupt("return", _n31);

                  case 15:
                    if (!_n31["pool-error"]) {
                      _context56.next = 17;
                      break;
                    }

                    throw _r38 = !0, new Error("Transaction Rejected: ".concat(_n31["pool-error"]));

                  case 17:
                    _context56.next = 23;
                    break;

                  case 19:
                    _context56.prev = 19;
                    _context56.t0 = _context56["catch"](9);

                    if (!_r38) {
                      _context56.next = 23;
                      break;
                    }

                    throw _context56.t0;

                  case 23:
                    _context56.next = 25;
                    return e.statusAfterBlock(s).do();

                  case 25:
                    s += 1;

                  case 26:
                    _context56.next = 7;
                    break;

                  case 28:
                    throw new Error("Transaction not confirmed after ".concat(r, " rounds"));

                  case 29:
                  case "end":
                    return _context56.stop();
                }
              }
            }, _callee56, null, [[9, 19]]);
          }));
          return _n30.apply(this, arguments);
        }

        r.d(t, {
          K: function K() {
            return n;
          }
        });
      },
      4654: function _() {}
    },
        __webpack_module_cache__ = {};

    function __webpack_require__(e) {
      var t = __webpack_module_cache__[e];
      if (void 0 !== t) return t.exports;
      var r = __webpack_module_cache__[e] = {
        exports: {}
      };
      return __webpack_modules__[e].call(r.exports, r, r.exports, __webpack_require__), r.exports;
    }

    __webpack_require__.amdO = {}, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return __webpack_require__.d(t, {
        a: t
      }), t;
    }, __webpack_require__.d = function (e, t) {
      for (var r in t) {
        __webpack_require__.o(t, r) && !__webpack_require__.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, __webpack_require__.g = function () {
      if ("object" == typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var __webpack_exports__ = {};
    return function () {
      "use strict";

      __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, {
        default: function _default() {
          return r;
        }
      });

      var e = __webpack_require__(6608),
          t = {};

      var _loop2 = function _loop2(_r39) {
        "default" !== _r39 && (t[_r39] = function () {
          return e[_r39];
        });
      };

      for (var _r39 in e) {
        _loop2(_r39);
      }

      __webpack_require__.d(__webpack_exports__, t);

      var r = e;
    }(), __webpack_exports__;
  }();
});